/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(242);
	module.exports = __webpack_require__(131);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(30);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMProperty = __webpack_require__(24);
	var ReactDOMComponentFlags = __webpack_require__(86);
	
	var invariant = __webpack_require__(1);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 7 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var CallbackQueue = __webpack_require__(84);
	var PooledClass = __webpack_require__(20);
	var ReactFeatureFlags = __webpack_require__(89);
	var ReactReconciler = __webpack_require__(25);
	var Transaction = __webpack_require__(43);
	
	var invariant = __webpack_require__(1);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
12,
/* 14 */
12,
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var PooledClass = __webpack_require__(20);
	
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(3);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path);
	
	  var pathname = _parsePath.pathname;
	  var search = _parsePath.search;
	  var hash = _parsePath.hash;
	
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path);
	
	  var pathname = _parsePath2.pathname;
	  var search = _parsePath2.search;
	  var hash = _parsePath2.hash;
	
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path);
	
	  var search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename;
	  var pathname = location.pathname;
	  var search = location.search;
	  var hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 20 */
[264, 4],
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(17);
	
	var _Actions = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(116)(module)))

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(53);
	var setInnerHTML = __webpack_require__(45);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(61);
	var setTextContent = __webpack_require__(101);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(199);
	var ReactInstrumentation = __webpack_require__(10);
	
	var warning = __webpack_require__(3);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbstractWidget = function (_React$Component) {
	  _inherits(AbstractWidget, _React$Component);
	
	  function AbstractWidget() {
	    _classCallCheck(this, AbstractWidget);
	
	    return _possibleConstructorReturn(this, (AbstractWidget.__proto__ || Object.getPrototypeOf(AbstractWidget)).apply(this, arguments));
	  }
	
	  _createClass(AbstractWidget, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.willUnmount = false;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadWidget();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.loadWidget();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.willUnmount = true;
	    }
	  }, {
	    key: 'loadWidget',
	    value: function loadWidget() {
	      var _this2 = this;
	
	      var widgetWrapper = this.refs.widgetWrapper;
	
	      var $script = __webpack_require__(115);
	
	      $script.ready('twitter-widgets', function () {
	        if (!window.twttr) {
	          // If the script tag fails to load, scriptjs.ready() will still trigger.
	          // Let's avoid the JS exceptions when that happens.
	          console.error('Failure to load window.twttr, aborting load.');
	          return;
	        }
	
	        // Delete existing
	        _this2.removeChildren(widgetWrapper);
	
	        // Create widget
	        _this2.props.ready(window.twttr, widgetWrapper, _this2.done.bind(_this2));
	      });
	    }
	  }, {
	    key: 'done',
	    value: function done() {
	      if (this.willUnmount) {
	        this.removeChildrenExceptLast(this.refs.widgetWrapper);
	      }
	    }
	  }, {
	    key: 'removeChildren',
	    value: function removeChildren(node) {
	      if (node) {
	        while (node.firstChild) {
	          node.removeChild(node.firstChild);
	        }
	      }
	    }
	  }, {
	    key: 'removeChildrenExceptLast',
	    value: function removeChildrenExceptLast(node) {
	      if (node) {
	        while (node.childNodes.length > 1) {
	          node.removeChild(node.firstChild);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { ref: 'widgetWrapper' });
	    }
	  }]);
	
	  return AbstractWidget;
	}(_react2.default.Component);
	
	AbstractWidget.propTypes = {
	  ready: _react2.default.PropTypes.func.isRequired
	};
	exports.default = AbstractWidget;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = cloneDeep;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(116)(module)))

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var ReactChildren = __webpack_require__(251);
	var ReactComponent = __webpack_require__(72);
	var ReactPureComponent = __webpack_require__(256);
	var ReactClass = __webpack_require__(252);
	var ReactDOMFactories = __webpack_require__(253);
	var ReactElement = __webpack_require__(31);
	var ReactPropTypes = __webpack_require__(255);
	var ReactVersion = __webpack_require__(257);
	
	var onlyChild = __webpack_require__(260);
	var warning = __webpack_require__(3);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(16);
	
	var warning = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(114);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(113);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 32 */
4,
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(54);
	var EventPluginUtils = __webpack_require__(55);
	var ReactErrorUtils = __webpack_require__(59);
	
	var accumulateInto = __webpack_require__(95);
	var forEachAccumulated = __webpack_require__(96);
	var invariant = __webpack_require__(1);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(34);
	var EventPluginUtils = __webpack_require__(55);
	
	var accumulateInto = __webpack_require__(95);
	var forEachAccumulated = __webpack_require__(96);
	var warning = __webpack_require__(3);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(15);
	
	var getEventTarget = __webpack_require__(64);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(2);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    arrayOf = _react.PropTypes.arrayOf,
	    oneOfType = _react.PropTypes.oneOfType,
	    element = _react.PropTypes.element,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var EventPluginRegistry = __webpack_require__(54);
	var ReactEventEmitterMixin = __webpack_require__(191);
	var ViewportMetrics = __webpack_require__(94);
	
	var getVendorPrefixedEventName = __webpack_require__(223);
	var isEventSupported = __webpack_require__(65);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(37);
	var ViewportMetrics = __webpack_require__(94);
	
	var getEventModifierState = __webpack_require__(63);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(7);
	var DOMNamespaces = __webpack_require__(53);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(61);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(18);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(70);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(26);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(230);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(103);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(226);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(241);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(227);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(228);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(105);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(229);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(71);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(239);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(110);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(232);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(233);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(237);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(107);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(21);
	
	var _DOMUtils = __webpack_require__(40);
	
	var _DOMStateStorage = __webpack_require__(77);
	
	var _PathUtils = __webpack_require__(17);
	
	var _ExecutionEnvironment = __webpack_require__(49);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if (event.state !== undefined) // Ignore extraneous popstate events in WebKit
	      listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state;
	  var key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(149);
	
	var _PathUtils = __webpack_require__(17);
	
	var _runTransitionHook = __webpack_require__(51);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(39);
	
	var _LocationUtils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var getUserConfirmation = options.getUserConfirmation;
	  var pushLocation = options.pushLocation;
	  var replaceLocation = options.replaceLocation;
	  var go = options.go;
	  var keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(23);
	var Danger = __webpack_require__(168);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(10);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(61);
	var setInnerHTML = __webpack_require__(45);
	var setTextContent = __webpack_require__(101);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactErrorUtils = __webpack_require__(59);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactPropTypesSecret = __webpack_require__(197);
	var propTypesFactory = __webpack_require__(82);
	
	var React = __webpack_require__(30);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(16);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(11);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 64 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(7);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 66 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(3);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(2);
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  eventIndex: _react.PropTypes.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(2);
	
	var func = _react.PropTypes.func,
	    object = _react.PropTypes.object,
	    shape = _react.PropTypes.shape,
	    string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getRouteParams = __webpack_require__(236);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(69);
	
	var _RouteUtils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    array = _React$PropTypes.array,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactNoopUpdateQueue = __webpack_require__(73);
	
	var canDefineProperty = __webpack_require__(114);
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(51);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(161);
	
	var _runTransitionHook = __webpack_require__(51);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(21);
	
	var _PathUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 80 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(117);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(159);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(20);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(10);
	
	var quoteAttributeValueForBrowser = __webpack_require__(224);
	var warning = __webpack_require__(3);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 86 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(11);
	
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 88 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(184);
	
	var containsNode = __webpack_require__(139);
	var focusNode = __webpack_require__(75);
	var getActiveElement = __webpack_require__(76);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(23);
	var DOMProperty = __webpack_require__(24);
	var React = __webpack_require__(30);
	var ReactBrowserEventEmitter = __webpack_require__(41);
	var ReactCurrentOwner = __webpack_require__(16);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMContainerInfo = __webpack_require__(178);
	var ReactDOMFeatureFlags = __webpack_require__(180);
	var ReactFeatureFlags = __webpack_require__(89);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(10);
	var ReactMarkupChecksum = __webpack_require__(194);
	var ReactReconciler = __webpack_require__(25);
	var ReactUpdateQueue = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(11);
	
	var emptyObject = __webpack_require__(33);
	var instantiateReactComponent = __webpack_require__(99);
	var invariant = __webpack_require__(1);
	var setInnerHTML = __webpack_require__(45);
	var shouldUpdateReactComponent = __webpack_require__(66);
	var warning = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var React = __webpack_require__(30);
	
	var invariant = __webpack_require__(1);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(93);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(7);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var ReactCompositeComponent = __webpack_require__(175);
	var ReactEmptyComponent = __webpack_require__(88);
	var ReactHostComponent = __webpack_require__(90);
	
	var getNextDebugID = __webpack_require__(259);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(7);
	var escapeTextContentForBrowser = __webpack_require__(44);
	var setInnerHTML = __webpack_require__(45);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(16);
	var REACT_ELEMENT_TYPE = __webpack_require__(190);
	
	var getIteratorFn = __webpack_require__(221);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(56);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(70);
	
	var _ContextUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    bool = _React$PropTypes.bool,
	    object = _React$PropTypes.object,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func,
	    oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object, func]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _PatternUtils = __webpack_require__(26);
	
	var _InternalPropTypes = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 106 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(79);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(78);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(154);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(110);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(234);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(231);
	
	var _isActive2 = __webpack_require__(238);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(235);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(240);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(79);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(78);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tweet = exports.Timeline = exports.Share = exports.Mention = exports.Hashtag = exports.Follow = undefined;
	
	var _exenv = __webpack_require__(135);
	
	var _Follow2 = __webpack_require__(243);
	
	var _Follow3 = _interopRequireDefault(_Follow2);
	
	var _Hashtag2 = __webpack_require__(244);
	
	var _Hashtag3 = _interopRequireDefault(_Hashtag2);
	
	var _Mention2 = __webpack_require__(245);
	
	var _Mention3 = _interopRequireDefault(_Mention2);
	
	var _Share2 = __webpack_require__(246);
	
	var _Share3 = _interopRequireDefault(_Share2);
	
	var _Timeline2 = __webpack_require__(247);
	
	var _Timeline3 = _interopRequireDefault(_Timeline2);
	
	var _Tweet2 = __webpack_require__(248);
	
	var _Tweet3 = _interopRequireDefault(_Tweet2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (_exenv.canUseDOM) {
	  var $script = __webpack_require__(115);
	  $script('//platform.twitter.com/widgets.js', 'twitter-widgets');
	}
	
	exports.Follow = _Follow3.default;
	exports.Hashtag = _Hashtag3.default;
	exports.Mention = _Mention3.default;
	exports.Share = _Share3.default;
	exports.Timeline = _Timeline3.default;
	exports.Tweet = _Tweet3.default;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(16);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 113 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 117 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
		_inherits(About, _React$Component);
	
		function About() {
			_classCallCheck(this, About);
	
			return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
		}
	
		_createClass(About, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'About' },
					_react2.default.createElement(
						'div',
						{ className: 'Content' },
						_react2.default.createElement('img', { style: { 'float': 'right' }, src: './images/bld5.png', role: 'presentation' }),
						_react2.default.createElement(
							'p',
							null,
							' Archmixes is a project by ',
							_react2.default.createElement(
								'a',
								{ href: 'http://samtous.wtf/', target: '_blank' },
								' Sam Ghantous'
							),
							'. '
						),
						_react2.default.createElement(
							'p',
							null,
							' In 2017 it was exhibited at YveYang in New York and the Keller Gallery at MIT, while having lived online since 2016. '
						),
						_react2.default.createElement(
							'p',
							null,
							' Its subject is architecture in a post-net condition. The archmixes twitter bot opens up restrictive form of architectural authorship through the production of images, an everyday act, leaving the objects that are created in this process to become domestic debris. '
						),
						_react2.default.createElement(
							'p',
							null,
							' Archmix.es is a website made by ',
							_react2.default.createElement(
								'a',
								{ href: 'http://kalli.website/', target: '_blank' },
								'Kalli Retzepi.'
							),
							' '
						),
						_react2.default.createElement(
							'p',
							null,
							' Archmixes would not have existed without the help of many people. Some of them are listed below. '
						),
						_react2.default.createElement(
							'p',
							null,
							'Archmixes would not have existed without the the direct assistance and otherwise guidance of many people; some of them are listed below.'
						),
						_react2.default.createElement('img', { style: { 'float': 'right' }, src: './images/bld1.png', role: 'presentation' }),
						_react2.default.createElement(
							'p',
							null,
							'Xhulio Binjaku, Kristina Eldrenkamp, Grisha Enikolopov, Alex Kobald, Anran Li, Jason Minor, Kalli Retzepi, Michael Rosada, Austin Smith'
						)
					)
				);
			}
		}]);
	
		return About;
	}(_react2.default.Component);
	
	exports.default = About;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(46);
	
	var _Title = __webpack_require__(130);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Links Connect' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { activeStyle: { 'textDecoration': 'underline', 'fontWeight': '700' }, to: '/' },
	            'Connect'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Links Instruction' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { activeStyle: { 'textDecoration': 'underline' }, to: '/instruction' },
	            'Instruction'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Links About' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { activeStyle: { 'textDecoration': 'underline' }, to: '/about' },
	            'About'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Links Event' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { activeStyle: { 'textDecoration': 'underline' }, to: '/event' },
	            'Event'
	          )
	        ),
	        _react2.default.createElement(_Title2.default, null),
	        this.props.children
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d = __webpack_require__(133);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _Shapes = __webpack_require__(129);
	
	var _Shapes2 = _interopRequireDefault(_Shapes);
	
	var _helpers = __webpack_require__(132);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import FrameElement from './FrameElement';
	
	
	var SvgRenderer = function (_Component) {
		_inherits(SvgRenderer, _Component);
	
		function SvgRenderer() {
			_classCallCheck(this, SvgRenderer);
	
			var _this = _possibleConstructorReturn(this, (SvgRenderer.__proto__ || Object.getPrototypeOf(SvgRenderer)).call(this));
	
			_this.onRef = function (ref) {
				return _this.ref = ref;
			};
			_this.renderSvg = _this.renderSvg.bind(_this);
			_this.renderFrame = _this.renderFrame.bind(_this);
			return _this;
		}
	
		_createClass(SvgRenderer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.renderSvg();
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: this.props.className },
					_react2.default.createElement('svg', { width: this.props.width, height: this.props.height, ref: this.onRef })
				);
			}
		}, {
			key: 'renderFrame',
			value: function renderFrame(d) {
				// console.log(d);
				window.open(d.url);
			}
		}, {
			key: 'renderSvg',
			value: function renderSvg() {
				var _this2 = this;
	
				if (!this.ref) {
					return;
				}
	
				/*----------------------------- SVG parameters --------------------*/
				var width = this.props.width;
				var height = this.props.height;
				var svg = d3.select(this.ref).attr("width", width).attr("height", height);
	
				/*----------------------------- Vis parameters --------------------*/
				var padding = this.props.className === "Icons" ? 10 : 15;
				var m = 1; // number of distinct clusters
				var clusters = new Array(m);
	
				/*----------------------------- Shapes object--------------------*/
				var ShapesSubset = _Shapes2.default.filter(function (element) {
					return element.className === _this2.props.className;
				});
				var nodes = ShapesSubset.map(function (element) {
					var i = 1,
					    r = element.className === "Icons" ? 40 : 90,
					    d = {
						url: element.url,
						className: element.className,
						cluster: i,
						radius: r,
						pathToImage: element.pathToImage,
						x: element.className === "Icons" ? width * 0.4 + 10 * (Math.random() - 0.5) : width / 2 + width * (Math.random() - 0.5),
						y: element.className === "Icons" ? height * 0.25 + 10 * (Math.random() - 0.5) : height / 2 + height * (Math.random() - 0.5)
					};
	
					if (!clusters[i] || r > clusters[i].radius) clusters[i] = d;
	
					return d;
				});
	
				/*----------------------------- Force --------------------*/
				var force = d3.forceSimulation().force('cluster', cluster().strength(0)).force('collide', d3.forceCollide(function (d) {
					return d.radius + padding;
				}).strength(0)).force('iconsY', (0, _helpers.isolate)(nodes, d3.forceY(function (d) {
					return height / 2 * (Math.random() - 0.5);
				}), function (d) {
					return d.className === "Icons";
				}))
				// .force('imagesX', isolate(nodes, d3.forceX((d) => (Math.random() - 0.5)* width), function(d) {return d.className==="Images"; }))
				.force('repel', d3.forceManyBody().strength(-90)).on('tick', layoutTick).nodes(nodes);
	
				var node = svg.selectAll("image").data(nodes).enter().append("svg:image").attr('xlink:href', function (d) {
					return d.pathToImage;
				}).attr('height', '10em').attr('width', '10em').attr('z-index', '100').style("fill", "#00f").call(d3.drag().on("start", dragstarted).on("drag", dragged).on("end", dragended));
	
				/*----------------------------- SVG manipulations --------------------*/
	
				svg.selectAll("image").filter(function (d) {
					return d.className === "Icons";
				}).classed("icons", true).append("a").attr("xlink:href", function (d) {
					return d.url;
				});
	
				svg.selectAll("image").filter(function (d) {
					return d.className === "Images";
				}).style("opacity", "0.9");
	
				svg.selectAll('image.icons').on('click', function (d) {
					return _this2.renderFrame(d);
				});
	
				svg.selectAll("circle").data(nodes.slice(1)).enter().append("svg:circle").attr("r", "2");
	
				/*----------------------------- Tick functions --------------------*/
	
				function layoutTick(e) {
					node.attr("transform", function (d) {
						var dx = d.x > width || d.x < 0 ? width * 0.2 : d.x;
						var dy = d.y > height || d.y < 0 ? height * 0.4 : d.y;
						var scale = d.className === "Icons" ? 0.25 : 2.4;
						return d.className === "Icons" ? 'translate(' + dx + ',' + dy + ') scale(' + scale + ')' : 'translate(' + dx + ',' + d.y + ') scale(' + scale + ')';
					});
	
					force.force('collide').strength(1);
				}
	
				/*----------------------------- Helper functions --------------------*/
	
				function cluster() {
					var nodes = void 0,
					    strength = 0.01;
	
					function force(alpha) {
	
						// scale + curve alpha value
						alpha *= strength * alpha;
	
						nodes.forEach(function (d) {
							var cluster = clusters[d.cluster];
							if (cluster === d) return;
	
							var x = d.x - cluster.x,
							    y = d.y - cluster.y,
							    l = Math.sqrt(x * x + y * y),
							    r = d.radius + cluster.radius;
	
							if (l !== r) {
								l = (l - r) / l * alpha;
								d.x -= x *= l;
								d.y -= y *= l;
								cluster.x += x;
								cluster.y += y;
							}
						});
					}
	
					force.initialize = function (_) {
						nodes = _;
					};
	
					force.strength = function (_) {
						strength = _ == null ? strength : _;
						return force;
					};
	
					return force;
				}
	
				function dragstarted(d) {
					if (!d3.event.active) force.alphaTarget(0.3).restart();
					d3.select(this).raise().classed("active", true);
					force.force('collide').strength(1);
				}
	
				function dragged(d) {
					d3.select(this).attr("cx", d.x = d3.event.x).attr("cy", d.y = d3.event.y);
					force.force('collide').strength(1);
				}
	
				function dragended(d) {
					if (!d3.event.active) force.alphaTarget(0);
					d3.select(this).classed("active", false);
					force.force('collide').strength();
				}
			}
		}]);
	
		return SvgRenderer;
	}(_react.Component);
	
	exports.default = SvgRenderer;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Chart = __webpack_require__(120);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Grid = __webpack_require__(125);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Connect = function (_React$Component) {
		_inherits(Connect, _React$Component);
	
		function Connect() {
			_classCallCheck(this, Connect);
	
			return _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).apply(this, arguments));
		}
	
		_createClass(Connect, [{
			key: 'render',
			value: function render() {
				var windowWidth = window.innerWidth;
				var windowHeight = window.innerHeight;
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_Grid2.default, { className: "Grid" }),
					_react2.default.createElement(_Chart2.default, { className: "Icons", width: windowWidth, height: windowHeight }),
					_react2.default.createElement(_Chart2.default, { className: "Images", width: windowWidth, height: windowHeight })
				);
			}
		}]);
	
		return Connect;
	}(_react2.default.Component);
	
	exports.default = Connect;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emojiMart = __webpack_require__(134);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Event = function (_React$Component) {
		_inherits(Event, _React$Component);
	
		function Event() {
			_classCallCheck(this, Event);
	
			return _possibleConstructorReturn(this, (Event.__proto__ || Object.getPrototypeOf(Event)).apply(this, arguments));
		}
	
		_createClass(Event, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'Event' },
					_react2.default.createElement(
						'div',
						{ className: 'Content' },
						_react2.default.createElement('img', { style: { 'transform': 'rotate(-90deg)' }, src: './images/event.png', role: 'presentation' }),
						_react2.default.createElement(
							'p',
							{ style: { 'fontSize': '1.5em' } },
							'Sam Ghantous '
						),
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(_emojiMart.Emoji, { emoji: { id: 'classical_building' }, size: 24 }),
							_react2.default.createElement(_emojiMart.Emoji, { emoji: { id: 'repeat' }, size: 24 }),
							' ',
							_react2.default.createElement('br', null),
							'04.28.2017-05.11.2017 ',
							_react2.default.createElement('br', null),
							'Opening: 04.28.2017 5PM-9PM '
						),
						_react2.default.createElement(
							'p',
							null,
							'Yve YANG Gallery is pleased to announce \u201C',
							_react2.default.createElement(_emojiMart.Emoji, { emoji: { id: 'classical_building' }, size: 24 }),
							_react2.default.createElement(_emojiMart.Emoji, { emoji: { id: 'repeat' }, size: 24 }),
							' \u201D, a solo exhibition by Sam Ghantous.'
						),
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(_emojiMart.Emoji, { emoji: { id: 'classical_building' }, size: 24 }),
							_react2.default.createElement(_emojiMart.Emoji, { emoji: { id: 'repeat' }, size: 24 }),
							' will be featured at an experimental environment at Yve YANG Loft. Exhibition dates are from April 28th through May 11th, 2017. The opening reception will be Friday April 28th, 5pm to 9pm.'
						),
						_react2.default.createElement(
							'p',
							null,
							'Tweeting from your couch, in your sweats, can be an architectural act '
						),
						_react2.default.createElement(
							'p',
							null,
							'Hope for architecture today is found, instead, in its ability to be shared online. There, its value is in its velocity, intensity, and spread - an ability to \u201Cget around,\u201D a newfound promiscuity. Attention is a currency and the image, a visual byte that circulates, has already replaced the building in space. Architecture exists today as images -it is on and of the web, and it can shape public there.'
						),
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(_emojiMart.Emoji, { emoji: { id: 'classical_building' }, size: 24 }),
							_react2.default.createElement(_emojiMart.Emoji, { emoji: { id: 'repeat' }, size: 24 }),
							' emphasizes a collective experience of architecture through its circulation at a time when the image has killed the building. By shedding the cloak of representation, this exhibit depends on the presentation of \u201Creal things\u201D: Twitter bots, YouTube tutorials, and screen captures, becoming domesticated objects. It distributes authorship in the making of new architectures by harvesting open source image debris found online and creating a platform for anyone to participate.'
						),
						_react2.default.createElement(
							'p',
							null,
							'This is a call to speed up and broadcast architecture made of the web, for the web. Creativity has been democratized: now anyone with a phone and repost button can sculpt their own aesthetic universes, be it on Instagram, YouTube, or SoundCloud. Through recycling the pixel, vector, and mesh-waste that lives online, architecture has the opportunity to sustain the archive of its disciplinary history; it stands the chance to engage publics, and it might even sustain an economy of attention in an era of perpetual distraction. '
						),
						_react2.default.createElement(
							'p',
							{ style: { 'text-decoration': 'underline' } },
							'About the artist'
						),
						_react2.default.createElement(
							'p',
							null,
							'Sam Ghantous (b. 1989) explores architecture\u2019s tension with technology and its effects on cultural production. His work exists both online and in real life as objects, images, videos, situations, and installations. He recently graduated from the MIT Department of Architecture where he has also taught and researched. Sam has contributed to exhibitions in Toronto, Canada; Cambridge, USA; and Venice, Italy. '
						),
						_react2.default.createElement(
							'p',
							{ style: { 'text-decoration': 'underline' } },
							'About Yve YANG Gallery '
						),
						_react2.default.createElement(
							'p',
							null,
							'YveYANG is a gallery that presents emerging and newly established artists from all over the world. It is committed to carefully tracking the ever emerging technological moment alongside artists who wrestle with the conditions that this moment presents. This task requires a constant reconsideration of disciplinarity, forms of knowledge and representational modes. Yve YANG is eager to see the practice of art in turn generate its own technologies that shape the world and our perception of it. We believe great art is not just embellishment, but rather is an essential act that inspires the progression of human history.'
						),
						_react2.default.createElement(
							'p',
							{ style: { 'text-decoration': 'underline' } },
							'Exhibition Team'
						),
						_react2.default.createElement(
							'p',
							null,
							' Crucial contributions in mounting this exhibition were generously provided by the following: ',
							_react2.default.createElement('br', null),
							'Kristina Eldrenkamp ',
							_react2.default.createElement('br', null),
							'Grigori Enikolopov ',
							_react2.default.createElement('br', null),
							'Anran Li ',
							_react2.default.createElement('br', null),
							'Jason Minor ',
							_react2.default.createElement('br', null),
							'Kallirroi Retzepi ',
							_react2.default.createElement('br', null),
							'Austin Wade Smith'
						)
					)
				);
			}
		}]);
	
		return Event;
	}(_react2.default.Component);
	
	exports.default = Event;

/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = [{
		name: "twitter",
		url: "https://twitter.com/archmixes",
		path: 'M98.4,9.4c0.7-2.6-0.2-5.3-2.3-7c-1.2-0.9-2.6-1.4-4.1-1.4c-1.2,0-2.3,0.3-3.3,1c-2,1.2-4.2,2.2-6.4,2.9C78,1.7,72.7-0.1,67.2,0C54.7,0.1,44.4,9.6,42.9,21.7c-10-2-19.1-7.4-25.8-15.4C15.9,4.7,14,3.9,12,3.9c-0.2,0-0.3,0-0.5,0c-2.1,0.2-4,1.4-5.1,3.3C4.2,11,3.1,15.3,3.2,19.7c0,3,0.6,5.8,1.6,8.5c-1,1.2-1.6,2.7-1.6,4.4C3.2,39.1,5.7,45,9.9,49.4c-0.2,1.1-0.2,2.3,0.2,3.4c1.5,4.4,4.1,8.2,7.5,11.1c-2.2,0.5-4.4,0.8-6.7,0.8c-1.2,0-2.4-0.1-3.6-0.2c-0.3,0-0.5,0-0.8,0c-2.7,0-5.2,1.8-6.1,4.4c-1,2.9,0.1,6.1,2.7,7.7c9.5,5.9,20.4,9,31.5,8.9c36.2-0.4,57.6-29.7,57.7-58.1c2.9-2.5,5.5-5.5,7.6-8.7c0.8-1.1,1.3-2.5,1.3-4C101.2,12.5,100.1,10.6,98.4,9.4z M85.7,24.3c0,0.8,0.1,1.6,0.1,2.4C86,50.7,68,78.6,34.5,79c-10.3,0.1-19.9-2.8-28-7.9c1.4,0.1,2.9,0.2,4.3,0.2c8.5-0.1,16.3-3.1,22.5-8c-8-0.1-14.7-5.3-17.1-12.5c1.1,0.2,2.3,0.3,3.4,0.3c1.7,0,3.3-0.3,4.8-0.7c-8.3-1.6-14.7-8.9-14.8-17.7c0-0.1,0-0.2,0-0.2c2.5,1.3,5.3,2.1,8.3,2.2c-4.9-3.2-8.2-8.8-8.2-15.1c0-3.3,0.8-6.5,2.4-9.2c9.1,10.9,22.6,18,37.7,18.6c-0.3-1.3-0.5-2.7-0.5-4.1c-0.1-10,8-18.3,18-18.4c5.2-0.1,10,2.1,13.3,5.6c4.1-0.9,8-2.4,11.5-4.5c-1.3,4.3-4.2,7.9-7.9,10.1c3.7-0.5,7.2-1.5,10.4-3C92.3,18.5,89.2,21.7,85.7,24.3z',
		className: "Icons",
		pathToImage: './images/icons_png/twitter.png'
	}, {
		name: "ebay",
		url: "http://www.ebay.com/usr/arcmixe_0",
		path: 'M135.5,69.7c2.3-4.4,4.7-8.8,6.9-13.2c0.3-0.5,0.3-1.5,0-2c-4.6-8.8-9.4-17.5-14.1-26.3c-0.1-0.2-0.3-0.4-0.3-0.5c0.1,8.7,0.2,17.6,0.3,26.4c0,1.2-0.3,1.8-1.6,1.7c-1.5-0.1-3.1-0.1-4.6,0c-1.4,0.1-1.9-0.6-1.9-1.9c0-0.9,0-1.8,0-3c-0.5,0.3-0.7,0.4-0.9,0.5c-5.1,5-11.4,6-18.1,5.6c-3-0.2-5.9-1-8.4-2.8c-3.3-2.2-4.8-5.4-5.2-9.8c-3,7.2-8.1,11.3-15.4,12.4c-7,1-13.5-0.3-18.9-5.7c-0.1,1.2-0.1,2.1-0.2,3c0,1.2-0.5,1.8-1.9,1.8c-1.7-0.1-3.5-0.1-5.2,0c-1.2,0-1.7-0.4-1.7-1.7c0.1-4.3,0-8.6,0.1-12.9c0-1.6-0.5-2-2.1-2c-9.9,0.1-19.8,0.1-29.6,0.1c-1.5,0-2,0.3-1.7,1.9c1,5.5,5.2,9.5,10.8,9.8c2.1,0.1,4.2,0,6.2-0.4c2.7-0.6,4.7-2.2,6.2-4.6c0.4-0.6,1.4-1.2,2.1-1.2c2.4-0.2,4.8-0.1,7.4-0.1c-0.5,3.6-2.2,6-4.6,8c-3,2.5-6.6,3.7-10.4,4.1c-4.7,0.5-9.4,0.4-13.9-0.9C6.9,53.6,2.3,47.7,2,39.2c-0.1-2.7,0.1-5.4,0.6-8.1C3.9,24.7,7.8,20.4,14,18.4c5.8-1.9,11.6-2.1,17.5-0.5c6,1.6,10.1,5.3,12.2,11.2c0.1,0.3,0.2,0.6,0.7,0.8c0-0.6,0-1.2,0-1.8c0-7.9-0.1-15.8-0.1-23.7c0-2.3,0-2.3,2.4-2.4c1.6,0,3.2,0.1,4.7,0c1.4-0.1,1.8,0.5,1.7,1.8c0,5.7,0,11.4,0,17.1c0,0.5,0.1,1.1,0.1,1.7c7.6-6.5,16-7.4,24.9-3.6c7,3,9.8,8.7,10.7,19.8c1.5-1.2,2.9-2.6,4.6-3.6c3.1-1.9,6.6-2.6,10.2-2.8c4.6-0.2,9.2-0.3,13.9-0.4c1.9,0,2.1-0.3,1.9-2.2c-0.3-3-1.8-5.1-4.5-6.2c-3.6-1.5-7.4-1.5-11.1-0.2c-1.8,0.6-3.1,1.9-4,3.7c-0.3,0.6-1.1,1.2-1.7,1.2c-2.1,0.2-4.2,0-6.3,0.1c-1.2,0-1.5-0.5-1.2-1.6c0.9-3.8,3.3-6.4,6.8-7.7c9-3.3,17.9-3.9,26.4,1.6c0.1,0.1,0.3,0.1,0.6,0.2c-0.4-0.9-0.7-1.6-1.1-2.7c3.3,0,6.4-0.1,9.4,0c0.5,0,1.1,0.9,1.4,1.5c4.2,8.4,8.4,16.7,12.6,25.1c0.3,0.5,0.6,1.1,1,1.9c0.4-0.7,0.7-1.2,1-1.8c4.1-8.3,8.3-16.7,12.4-25.1c0.7-1.5,1.6-2.1,3.2-2c2.3,0.1,4.6,0,6.9,0c0,0.1,0,0.2,0,0.3c-0.2,0.2-0.3,0.5-0.4,0.7c-8.5,16.8-17,33.7-25.5,50.5C142,69.7,138.8,69.7,135.5,69.7z M79.7,37c-0.3-1.7-0.5-3.5-1-5.1c-1.4-4.8-5.7-8.3-10.4-8.7c-5.7-0.5-10.4,1.2-13.3,6.4c-1.8,3.2-2,6.7-1.6,10.4c1.1,7.7,8.2,12.7,15.8,10.9C75.6,49.5,79.5,44.2,79.7,37z M113.6,37.9C113.6,37.9,113.6,38,113.6,37.9c-1,0-1.9-0.1-2.9,0.1c-3.4,0.5-6.9,0.7-10.1,1.6c-3.8,1.1-5,4.9-3.1,8.2c1.1,1.9,2.8,2.9,4.9,3.3c3.2,0.7,6.3,0.5,9.3-0.5c4.8-1.6,7.7-5.7,7.7-10.8c0-1.3-0.4-2-1.8-1.9C116.3,38,114.9,37.9,113.6,37.9z M23.2,33.7c3.5,0,7-0.1,10.5,0c1.5,0,1.9-0.6,1.6-1.9C34.7,28.6,33,26,30,24.5c-5.2-2.5-10.3-2.1-15,1.3c-1.9,1.4-3.2,3.3-3.7,5.7c-0.5,2-0.3,2.3,1.8,2.3C16.5,33.7,19.9,33.7,23.2,33.7z',
		className: "Icons",
		pathToImage: './images/icons_png/ebay.png'
	}, {
		name: "ello",
		url: "https://ello.co/archmixes",
		path: 'M43.7,9l2.1,0l2.1,0l0.6,0.1c0.8,0.1,1.6,0.3,2.3,0.4c9.6,1.5,18,6.6,23.8,14.3c5.7,7.8,8.1,17.3,6.6,26.9c-1.3,8.6-5.7,16.5-12.3,22.1c-6.5,5.6-14.9,8.7-23.4,8.7c-1.5,0-3.1-0.1-4.7-0.3c-15.4-2-27.8-13.5-30.9-28.8c-0.3-1.3-0.4-2.6-0.6-4C9.2,48,9.1,47.5,9,46.9l0-1.2l0-2.5c0.1-0.4,0.2-0.8,0.2-1.3c1.5-16,13.1-28.9,28.9-32.1c1.2-0.3,2.6-0.4,3.9-0.6C42.6,9.2,43.2,9.1,43.7,9 M45.3,76.7c14.1,0,26.2-9,30.1-22.5c1.4-4.8-0.9-9.5-5.5-10.9c-0.8-0.3-1.7-0.4-2.5-0.4c-3.6,0-6.7,2.3-8.1,6.1l-0.2,0.5c-0.4,1.1-0.7,2.1-1.1,2.7c-3.1,5.1-7.1,7.5-12.6,7.5c-0.7,0-1.4,0-2.1-0.1c-5.3-0.5-10.1-4.8-11.9-10.6c-1.9-6.2-6.7-6.7-8.2-6.7c-0.8,0-1.5,0.1-2.3,0.3c-2.1,0.6-3.9,1.9-5,3.8c-1.2,2-1.5,4.6-0.8,7.2C18.7,67,30.9,76.5,44.9,76.7L45.3,76.7 M43.3,3c-2.1,0.3-4.3,0.5-6.4,1C18.6,7.7,5.1,22.8,3.3,41.4c0,0.3-0.2,0.6-0.2,0.9C3,44,3,45.7,3,47.4c0.3,2.1,0.6,4.3,1,6.4c3.6,17.7,18,31.2,36,33.5c1.8,0.2,3.6,0.4,5.4,0.4c20.5,0,38.4-15,41.6-35.9c3.5-23-12.3-44.5-35.4-48.1c-1.1-0.2-2.2-0.4-3.3-0.5C46.7,3,45,3,43.3,3L43.3,3z M45.3,70.7c-0.1,0-0.2,0-0.3,0c-11.3-0.1-21.1-7.8-24-18.7c-0.5-1.8,0.1-3.2,1.5-3.6c0.3-0.1,0.5-0.1,0.8-0.1c1.2,0,2,0.8,2.4,2.4c2.4,8.1,9.2,14.1,17,14.9c0.9,0.1,1.8,0.1,2.7,0.1c7.6,0,13.6-3.5,17.8-10.4c0.8-1.3,1.3-2.8,1.8-4.3c0.5-1.4,1.4-2.2,2.5-2.2c0.3,0,0.5,0,0.8,0.1c1.4,0.4,1.9,1.8,1.4,3.5C66.5,63.3,56.6,70.7,45.3,70.7L45.3,70.7z',
		className: "Icons",
		pathToImage: './images/icons_png/ello.png'
	
	}, {
		name: "etsy",
		url: "https://etsy.com/archmixes",
		path: 'M2,72.5c0-1.2,0-2.5,0-3.7c0-0.4,0.2-0.5,0.5-0.6c1.9-0.4,3.8-0.7,5.7-1.2	c0.8-0.2,1.6-0.5,2.2-1c1-0.7,1.2-1.9,1.2-3.1c0.1-2.3,0.1-4.7,0.1-7c0.1-11.5,0.2-23,0.2-34.5c0-2.9-0.1-5.9-0.1-8.8	c0-0.7-0.2-1.5-0.3-2.2c-0.3-1.2-1.2-2-2.4-2.3C7.3,7.7,5.3,7.3,3.3,6.9C2.5,6.8,2.2,6.4,2.2,5.6c0-1,0-2,0-3.1	c19.5,0.4,39,1.3,58.5-0.3c-0.1,1.2-0.1,2.3-0.2,3.4c-0.3,5.3-0.7,10.6-1,16c0,0.5-0.2,0.7-0.7,0.7c-0.7,0-1.4,0-2.1,0	c-0.9-0.1-1.3-0.4-1.5-1.3c-0.5-1.9-1-3.9-1.6-5.8c-0.5-1.5-1.1-2.9-1.8-4.2C50.4,8.8,48.4,8,46,8C40,8,34,8,27.9,8	c-1.1,0-2.3,0-3.4,0c-1,0-1.2,0.2-1.2,1.2c0,1.5,0,3,0,4.5c0,6.8-0.1,13.6-0.1,20.3c0,0.2,0,0.4,0,0.7c0.2,0,0.3,0.1,0.5,0.1	c3.8,0,7.7,0,11.5-0.1c1.3,0,2.7-0.2,4-0.4c1.3-0.2,2.1-1,2.5-2.2c0.5-1.6,0.9-3.3,1.3-4.9c0.2-0.7,0.3-1.3,0.5-2	c0.1-0.6,0.5-0.9,1.1-0.8c1.1,0,2.2,0,3.4,0c0,0.2,0,0.4,0,0.6c-0.1,7.7-0.2,15.5-0.3,23.2c0,0.3,0,0.5-0.1,0.8	c-0.1,0.4-0.3,0.7-0.8,0.7c-0.9,0-1.8,0-2.7-0.1c-0.5,0-0.9-0.4-1-0.9c-0.3-1.2-0.6-2.4-1-3.5c-0.3-0.9-0.5-1.9-0.9-2.8	c-0.7-1.6-2.2-2.2-3.9-2.3c-2.5-0.1-5.1-0.2-7.7-0.3c-1.9-0.1-3.8-0.1-5.6-0.1c-0.9,0-1,0-1,0.9c0,7.2-0.1,14.3-0.1,21.5	c0,1.5,0.4,2.9,1.7,4c0.8,0.6,1.7,1,2.7,1.1c2,0.1,3.9,0.2,5.9,0.2c4.7,0,9.4-0.1,14.1-0.2c3.5-0.1,6-1.8,7.6-4.8	c1.5-2.9,2.8-6,4.2-9c0.2-0.4,0.4-0.9,0.7-1.2c0.3-0.3,0.7-0.5,1-0.5c0.9-0.1,1.8,0,2.7,0c-0.1,0.7-0.1,1.2-0.2,1.8	c-0.6,4.7-1.2,9.4-1.7,14c-0.2,1.5-0.4,3-0.6,4.5c0,0.3-0.4,0.5-0.5,0.8c-2.1,0-4.2,0-6.3,0c-0.2,0-0.4-0.1-0.6-0.1	c-5.7-0.1-11.5-0.2-17.2-0.3c-2.5,0-5-0.1-7.6-0.1c-7.2-0.1-14.3-0.3-21.5,0.1c-0.7,0-1.5,0.1-2.2,0.2C4.2,72.5,3.1,72.5,2,72.5z',
		className: "Icons",
		pathToImage: './images/icons_png/etsy.png'
	
	}, {
		name: "facebook",
		url: "https://facebook.com",
		path: 'M50.2,3.1L37.1,3c0,0-14.7-1.1-18.5,13.7c0,0-1.4,3.9-1.2,13.5L3.1,30.2l0,11.3l15.4,0.1l-0.2,42.6l15.4,0.1l0.2-42.6l15.4,0.1l0-11.4l-15.4-0.1c0,0,0-2.4,0-6.8c0-4.4,3-8.7,9.8-8.6l6.4,0L50.2,3.1z',
		className: "Icons",
		pathToImage: './images/icons_png/facebook.png'
	
	}, {
		name: "insta",
		url: "http://www.instagram.com/archmixes/",
		path: 'M70.8588059,35.9007954 L100.07,35.9007954 L100.07,80.7441565 C100.07,91.6673986 91.2152691,100.52213 80.292027,100.52213 L19.848217,100.52213 C8.92521886,100.52213 0.0702439858,91.6671546 0.0702439858,80.7441565 L0.0702439858,35.9007954 L29.1506617,35.9007954 C26.1740355,40.0829552 24.4175821,45.1934807 24.4175821,50.7178061 C24.4175821,64.8492168 35.8734451,76.3050798 50.0050998,76.3050798 C64.1365105,76.3050798 75.5923735,64.8492168 75.5923735,50.7178061 C75.5921295,45.1932367 73.8354321,40.0827112 70.8588059,35.9007954 Z M100.07,19.777973 L100.07,32.7675304 L68.2340072,32.7675304 C63.5929103,28.0549456 57.141195,25.1302884 50.0048558,25.1302884 C42.8680286,25.1302884 36.4165574,28.0547016 31.7757044,32.7675304 L0.07,32.7675304 L0.07,19.777973 C0.07,13.1117943 3.37161519,7.22027034 8.42529205,3.63733958 L8.42529205,24.9346118 L12.4803352,24.9346118 L12.4803352,1.42414483 C13.4001615,1.05426243 14.3539018,0.752696043 15.3359445,0.523593422 L15.3359445,24.9348558 L19.3912316,24.9348558 L19.3912316,0.0114673303 C19.5437227,0.00780754404 19.6949939,0 19.848217,0 L22.1899922,0 L22.1899922,24.9343678 L26.2450354,24.9343678 L26.2450354,0 L80.292027,0 C91.2152691,0 100.07,8.85473088 100.07,19.777973 Z M91.0300839,11.4421998 C91.0300839,9.6901381 89.6095989,8.26989704 87.8575372,8.26989704 L77.1658376,8.26989704 C75.413288,8.26989704 73.9932909,9.6901381 73.9932909,11.4421998 L73.9932909,22.3691016 C73.9932909,24.1211633 75.413288,25.5414044 77.1658376,25.5414044 L87.8575372,25.5414044 C89.6095989,25.5414044 91.0300839,24.1211633 91.0300839,22.3691016 L91.0300839,11.4421998 L91.0300839,11.4421998 Z M30.292027,50.7178061 C30.292027,44.8162787 32.9021866,39.5166642 37.0243259,35.9007954 C38.4701854,34.6328014 40.1017181,33.5734153 41.8735427,32.7675304 C44.3546338,31.6390963 47.1063051,31.0049773 50.0048558,31.0049773 C52.9036505,31.0049773 55.6548338,31.6390963 58.1359249,32.7675304 C59.9079935,33.5734153 61.5395262,34.6328014 62.9853857,35.9007954 C67.107525,39.5166642 69.7174406,44.8165227 69.7174406,50.7178061 C69.7174406,61.5873713 60.874665,70.4303909 50.0048558,70.4303909 C39.1352906,70.4303909 30.292027,61.5873713 30.292027,50.7178061 Z M35.5006349,50.7178061 C35.5006349,58.7642122 42.0235939,65.2866833 50.07,65.2866833 C58.1164061,65.2866833 64.6391212,58.7642122 64.6391212,50.7178061 C64.6391212,42.671156 58.1166501,36.1486849 50.07,36.1486849 C42.0235939,36.1486849 35.5006349,42.671156 35.5006349,50.7178061 Z',
		className: "Icons",
		pathToImage: './images/icons_png/insta.png'
	
	}, {
		name: "pinterest",
		url: "https://www.pinterest.com/amixes/?etslf=2407&eq=arc",
		path: 'M32.6,62.9c-0.8,3-1.6,6.1-2.4,9.2c-0.8,3-1.5,6.1-2.7,8.9c-1.9,4.6-4.4,9-7.6,12.6c-2.1,2.4-1.7,1.4-2.3,1.3c-0.5-0.1-0.5-0.6-0.6-1.2c-0.5-3.7-0.1-7.9,0.1-12c0.3-4.7,1.3-8.6,2.3-12.5c1.8-7.4,3.6-14.7,5.5-22.1c0.1-0.5,0.5-1.3,0.3-1.6c-0.8-2.1-1.3-4-1.5-6.1c-0.2-2.5,0-4.8,0.6-7c1-3.8,3.4-7.2,7-8.4c2.3-0.8,4.8-0.4,6.3,0.5c1.6,0.9,2.6,2.4,3.1,4.5c0.5,2.2,0.1,4.9-0.4,6.8c-1,4.4-2.3,7.7-3.5,11.9c-0.6,2.1-1.3,4.2-0.7,6.5c0.5,2.1,1.6,3.5,3.1,4.6c1.5,1.1,3.4,1.8,5.9,1.7c4.5-0.1,7.6-2.9,9.7-5.6c3.4-4.2,5.4-10,6.3-16.8c0.3-2.2,0.5-4.7,0.3-7.2c-0.3-4.6-1.7-8.4-4-11.3c-2.2-2.8-5.3-5-9.1-6.2c-3.8-1.3-9-1.7-13.7-1c-8.5,1.4-14.5,6-18.1,12.6c-1.9,3.4-3.1,7.3-3.2,12.3c0,3.8,0.9,6.7,2.4,9c0.5,0.7,1.2,1.3,1.7,2.2c0.7,1.2-0.1,2.9-0.5,4.2c-0.4,1.5-0.5,3.6-2.3,3.7c-0.8,0-2.4-1-3-1.4c-3.7-2.8-5.1-4.7-7-9.3c-1.4-3.5-2-10.1-1.3-13.7c0.7-3.5,2.3-8.3,3.8-10.9c3-5.4,7.4-9.7,12.8-12.7c4.1-2.3,8.7-4,14.3-4.7C36.1,3.2,38,3.1,40.1,3c6.1-0.2,11.6,1.2,15.8,3.1c4.4,2,7.9,4.6,10.8,7.8c3,3.3,5.2,7.2,6.6,12c0.7,2.5,1,5.3,1,8.4c0,3.1-0.3,5.7-0.8,8.4c-1.8,10.2-6.8,18.4-14.2,23.1c-1.8,1.1-4,2.2-6.4,2.9c-2.4,0.7-5.2,1.2-8.2,0.9c-2.9-0.2-5.2-1-7.2-2.1C35.4,66.3,33.7,64.9,32.6,62.9z',
		className: "Icons",
		pathToImage: './images/icons_png/pinterest.png'
	
	}, {
		name: "reddit",
		url: "https://www.reddit.com/user/archmixes/",
		path: 'M85.6212529,54.5880278 C85.9303016,55.3781903 86.0706265,56.1942459 86.0706265,57.0050116 C86.0706265,58.637123 85.5068213,60.2224594 84.5607425,61.5165661 C83.6252436,62.7953596 82.2996752,63.787935 80.740232,64.2247796 L80.7430162,64.2247796 C80.7299304,64.2300696 80.7168445,64.2300696 80.7104408,64.2350812 C80.7040371,64.2350812 80.6934571,64.2403712 80.6884455,64.2403712 C79.9581439,64.4898376 79.2094664,64.6067749 78.4666357,64.6067749 C76.7253828,64.6067749 75.0153132,63.9792111 73.6482599,62.9095128 C72.2917865,61.8442691 71.2649652,60.3135035 70.9428306,58.4979118 L70.9400464,58.4979118 C70.9400464,58.4926218 70.9400464,58.4862181 70.9375406,58.4787007 C70.9375406,58.4734107 70.9375406,58.4681206 70.9322506,58.4606032 L70.9375406,58.4606032 C70.8361949,57.9925754 70.7841299,57.5251044 70.7841299,57.062645 C70.7841299,55.4903944 71.319536,53.9805104 72.2032483,52.7329002 C73.0841763,51.4930858 74.3264965,50.5083063 75.7804176,50.0012993 C75.7857077,50.0012993 75.7909977,49.9985151 75.7909977,49.9985151 C75.7985151,49.9985151 75.7985151,49.9909977 75.8051972,49.9909977 C76.6276566,49.6869606 77.4957773,49.5346636 78.35471,49.5346636 C79.9191647,49.5346636 81.460232,50.0090951 82.7596288,50.8769374 C84.0434339,51.73058 85.0855684,52.9820882 85.6078886,54.5362413 C85.6131787,54.5465429 85.6131787,54.5557309 85.6181903,54.5649188 C85.6181903,54.5752204 85.6234803,54.5807889 85.6284919,54.5883063 L85.6212529,54.5883063 L85.6212529,54.5880278 Z M80.8340603,73.8790719 C80.2209745,73.4814849 79.5112761,73.2412065 78.7603712,73.2412065 C78.1548028,73.2412065 77.5258469,73.4141067 76.9659397,73.785522 L76.9659397,73.785522 C71.6748028,76.9433875 65.4517865,78.6740603 59.2730394,78.6740603 C54.6373086,78.6740603 50.0296984,77.6956845 45.8553132,75.6451044 L45.8338747,75.6348028 L45.812993,75.627007 C45.1834803,75.3697448 44.4662645,74.822645 43.6838979,74.3017169 C43.2863109,74.0441763 42.8711833,73.7883063 42.4103944,73.5998144 C41.9557309,73.4063109 41.4506729,73.2709977 40.9108121,73.2709977 C40.4639443,73.2709977 39.9942459,73.3709513 39.5306729,73.5814385 C39.5067285,73.5906265 39.4838979,73.599536 39.4605104,73.6087239 L39.4630162,73.6087239 C38.7346636,73.8868677 38.1655684,74.3963805 37.7997216,74.9991647 C37.4177262,75.6200464 37.2300696,76.3428306 37.2300696,77.0625522 C37.2300696,77.7123898 37.3834803,78.361949 37.7008817,78.9519258 C38.0029698,79.5107193 38.4676566,79.9993503 39.0757309,80.3267749 C45.0420418,84.3510905 52.067471,86.1741995 59.1199072,86.1677958 C65.4785151,86.1677958 71.8755452,84.6957773 77.5709513,82.0162413 L77.6007425,81.9981439 L77.62942,81.9825522 C78.3803248,81.5379118 79.3784687,81.1392111 80.3192575,80.5584223 C80.7845012,80.262181 81.2391647,79.9191647 81.6289559,79.4734107 C82.0187471,79.0304408 82.3319722,78.4847332 82.5087703,77.8376798 L82.5087703,77.8348956 C82.5828306,77.5492343 82.6179118,77.2710905 82.6179118,76.9929466 C82.6179118,76.4642227 82.4878886,75.9625058 82.2723898,75.5117401 C81.9566589,74.8329466 81.4396288,74.2769374 80.8340603,73.8790719 Z M38.9443155,64.2011137 C38.9546172,64.2011137 38.9682599,64.2050116 38.9799536,64.2114153 C39.7414385,64.4895592 40.5263109,64.6270998 41.3033875,64.6270998 C43.2420418,64.6270998 45.1261253,63.8330394 46.5524826,62.5389327 C47.9766125,61.2409281 48.9519258,59.4047332 48.9519258,57.3115545 C48.9519258,57.2569838 48.9519258,57.202413 48.94942,57.1375406 C48.95471,57.0439907 48.9572158,56.9412529 48.9572158,56.8360093 C48.9572158,54.759536 47.9949884,52.9158237 46.5845012,51.6122506 C45.1687239,50.3075638 43.2890951,49.509884 41.3432019,49.509884 C40.8233875,49.509884 40.2938283,49.5708585 39.7762413,49.6916937 C39.7684455,49.6916937 39.7625986,49.6941995 39.7548028,49.6941995 L39.747007,49.6941995 C37.1710441,50.2335035 34.9099768,52.1451508 34.0755452,54.7748492 L34.0755452,54.7748492 L34.0755452,54.7776334 C34.0755452,54.7829234 34.0730394,54.787935 34.0730394,54.787935 C33.8333179,55.507935 33.7216705,56.2510441 33.7216705,56.9863573 C33.7216705,58.597587 34.2542923,60.1676102 35.172529,61.4589327 C36.0826914,62.7285383 37.3703944,63.7266821 38.9167517,64.192761 C38.9278886,64.1933179 38.9331787,64.1961021 38.9443155,64.2011137 Z M119.730766,45.4090023 L119.730766,45.4195824 C119.749142,45.6812993 119.754153,45.9424594 119.754153,46.201949 C119.754153,49.1106265 118.82116,51.9076566 117.26478,54.2806497 C115.811972,56.5013457 113.808445,58.3592575 111.500603,59.6199536 C111.648724,60.7776334 111.734478,61.9445012 111.734478,63.107471 C111.731694,69.37058 109.572251,75.5270534 105.811879,80.4612529 L105.811879,80.4637587 L105.804084,80.4637587 C98.8521578,89.7118329 88.1763341,95.1655684 77.3963805,97.9163805 L77.3935963,97.9163805 L77.3860789,97.9227842 C71.6374942,99.3185151 65.7096056,100.031555 59.7833875,100.031555 C50.9493271,100.031555 42.1222274,98.4384223 33.8851044,95.1354988 L33.8825986,95.127703 L33.8748028,95.127703 C25.3350348,91.6076102 17.1981439,86.0124362 12.2082599,77.8142923 C9.5237123,73.4402784 8.0500232,68.3086775 8.0500232,63.1528538 C8.0500232,61.9862645 8.12881671,60.8177262 8.28473318,59.6625522 C6.03730858,58.397123 4.09085847,56.6026914 2.64529002,54.4596752 C1.10227378,52.1582367 0.123897912,49.4619954 0.000278422274,46.6117865 L0.000278422274,46.6006497 L0.000278422274,46.590348 L0.000278422274,46.5675174 C0.00278422274,42.5757773 1.73679814,38.7945244 4.43136891,36.0064037 C7.12566125,33.2191183 10.8061253,31.3974014 14.7538747,31.3974014 L14.917587,31.3974014 C15.3316009,31.3692807 15.7492343,31.3531323 16.1671462,31.3531323 C18.1500696,31.3531323 20.1374478,31.6741531 22.0248724,32.3977726 L22.035174,32.4055684 L22.0457541,32.4089095 C23.6569838,33.0874246 25.2579118,33.9059861 26.684826,35.0397216 C27.1472854,34.7972158 27.6515081,34.5243619 28.2172622,34.3088631 C36.8661717,29.1872854 46.9191647,27.2116009 56.7160093,26.6416705 C56.8012065,21.7884919 57.397587,16.7075638 59.7644548,12.2611601 C61.7356845,8.56677494 65.1572158,5.69067285 69.2308121,4.69392111 L69.2477958,4.68556845 L69.2697912,4.68306265 C70.8214385,4.38292343 72.3858933,4.24454756 73.9400464,4.24454756 C78.0799072,4.24454756 82.1704872,5.22487239 85.9985151,6.75508121 C87.692993,4.19777262 90.1124826,2.20176334 92.9507193,1.08222738 L92.9780046,1.06663573 L93.00529,1.05633411 C94.6710905,0.537354988 96.4307193,0.23387471 98.1967517,0.23387471 C100.059954,0.23387471 101.937912,0.574385151 103.697262,1.36037123 L103.697262,1.35396752 C103.699768,1.36037123 103.702552,1.36037123 103.702552,1.36037123 C103.715638,1.36482599 103.72594,1.37262181 103.734849,1.37262181 C106.257077,2.34403712 108.392019,4.13930394 109.9058,6.37030162 C111.420974,8.61104408 112.312483,11.2950348 112.312483,14.054478 C112.312483,14.5631555 112.283805,15.0726682 112.224223,15.5827378 L112.218933,15.5930394 C112.218933,15.6008353 112.218933,15.6119722 112.216148,15.619768 C111.920186,19.1860789 110.113782,22.3149884 107.556473,24.5468213 C104.983852,26.7875638 101.651972,28.1409745 98.2321114,28.1409745 C97.6836195,28.1409745 97.130116,28.110348 96.5791183,28.0368445 C93.1873782,27.7776334 90.0247796,26.1363341 87.7013457,23.6948492 C85.370116,21.2572622 83.8680278,18.0002784 83.8680278,14.4846404 C83.8680278,14.3145244 83.8836195,14.140232 83.8886311,13.9715081 C80.7048724,12.5537819 77.3239907,11.3777262 73.9639907,11.3805104 C73.4778654,11.3805104 72.9920186,11.407239 72.5058933,11.4565197 L72.5006032,11.4565197 C69.985058,11.6990255 67.6460325,13.2846404 66.5128538,15.5651972 L66.5128538,15.567703 L66.5128538,15.5754988 C64.7924826,18.9260325 64.4494664,22.8425986 64.3974014,26.7302088 C74.0416705,27.3591647 83.7430162,29.6734107 92.2516009,34.5644548 L92.2646868,34.5644548 L92.3866357,34.6365661 C92.5478422,34.732065 92.8465893,34.8957773 93.1169374,35.04 C93.7019026,34.5655684 94.3202784,34.0777726 95.0258005,33.657355 C97.6051044,31.9394896 100.661346,31.08529 103.718979,31.08529 C105.075452,31.08529 106.433318,31.2581903 107.750812,31.5959165 L107.756102,31.5959165 L107.810673,31.612065 C107.830162,31.6148492 107.844362,31.6212529 107.860232,31.6212529 L107.860232,31.6237587 C110.973828,32.4158701 113.790626,34.2038979 115.911369,36.6150348 C118.030719,39.0300696 119.455963,42.0854756 119.734107,45.4023202 L119.734107,45.4092807 L119.730766,45.4092807 L119.730766,45.4090023 Z M91.3230626,13.8467749 C91.3230626,13.977355 91.3258469,14.1112761 91.3389327,14.247703 L91.3389327,14.2554988 L91.3389327,14.2710905 C91.4012993,15.9466357 92.192297,17.5060789 93.3945244,18.6579118 C94.602877,19.81058 96.2065893,20.5238979 97.8331323,20.5303016 L97.855406,20.5303016 L97.8774014,20.5303016 C97.9943387,20.5394896 98.1140603,20.5394896 98.2282135,20.5394896 C99.8706265,20.5419954 101.500232,19.8345244 102.724176,18.6865893 C103.950626,17.5328074 104.759165,15.9636195 104.824037,14.2738747 L104.826543,14.2660789 L104.826543,14.2557773 C104.837123,14.1265893 104.842413,14.0043619 104.842413,13.8723898 C104.842413,12.1330858 104.028863,10.4750812 102.75536,9.24723898 C101.487146,8.02051044 99.7795824,7.26041763 98.0959629,7.26487239 C97.552761,7.26487239 97.0145708,7.33893271 96.487239,7.50264501 L96.4691415,7.50403712 L96.4535499,7.51044084 C95.0658933,7.87099768 93.7651044,8.72658933 92.8307193,9.86283063 C91.8921578,10.9937819 91.3230626,12.3920186 91.3230626,13.8467749 Z M20.1332715,39.696891 C18.8441763,39.0966125 17.5110905,38.6678422 16.1935963,38.6734107 C15.972529,38.6734107 15.7489559,38.6864965 15.5281671,38.7104408 L15.4975406,38.7104408 L15.4669142,38.7143387 C13.5750348,38.7664037 11.6656148,39.5913689 10.232297,40.9135963 C8.79786543,42.2310905 7.84928074,44.0102088 7.77633411,45.9716937 L7.77633411,45.9897912 L7.77299304,46.0059397 C7.76018561,46.1646404 7.75489559,46.3225058 7.75489559,46.4745244 C7.75489559,47.6842691 8.12603248,48.8536427 8.75526682,49.918051 C9.22106729,50.7107193 9.83192575,51.4329466 10.5226914,52.062181 C12.7336427,47.2209745 16.1880278,43.112297 20.1332715,39.696891 Z M104.148306,63.3786543 C104.148306,59.063109 102.591369,54.7283527 100.070534,51.2383295 C95.0441763,44.2446404 87.2477958,39.6832483 79.1367981,37.1401392 L79.0797216,37.1200928 C77.5227842,36.6425986 75.9508121,36.2196752 74.3651972,35.8577262 C69.625058,34.7785615 64.7651972,34.2412065 59.910348,34.2412065 C53.3913689,34.2412065 46.8726682,35.2059397 40.6309977,37.1309513 C32.521949,39.7044084 24.6993968,44.2335035 19.6844548,51.2497448 L19.6844548,51.2550348 C17.1427378,54.759536 15.6542923,59.1087703 15.6542923,63.4396288 C15.6542923,65.0341531 15.8536427,66.6283991 16.275174,68.179768 L16.280464,68.1825522 C17.1931323,71.665058 18.9780974,74.7730858 21.2890023,77.4799072 C23.5985151,80.1931323 26.4320186,82.5076566 29.4122506,84.3956381 C30.0723898,84.8049188 30.7350348,85.19471 31.4132715,85.5753132 C40.0705336,90.4076102 50.0391647,92.5258469 59.9362413,92.5258469 C61.610116,92.5258469 63.2940139,92.4662645 64.9570302,92.3465429 C74.9237123,91.5226914 84.9316009,88.5808817 93.0219954,82.5697448 L93.0247796,82.5633411 C95.6001856,80.659768 97.9857077,78.3558237 99.8725754,75.7350348 C101.767239,73.1128538 103.154896,70.1813457 103.771044,66.997587 L103.771044,66.9883991 L103.77355,66.9856148 C104.026079,65.7967517 104.148306,64.5897912 104.148306,63.3786543 Z M112.014849,46.2041763 C112.012343,45.1567517 111.773179,44.1140603 111.248353,43.1415313 L111.235267,43.1292807 L111.229977,43.1136891 C110.528074,41.6686775 109.426079,40.5772622 108.098283,39.8333179 C106.770209,39.0843619 105.216056,38.7040371 103.656891,38.7040371 C102.247239,38.7040371 100.844826,39.0192111 99.6002784,39.644826 C103.558329,43.0816705 107.030534,47.212065 109.274339,52.0724826 C109.996845,51.4435267 110.612993,50.6753596 111.07406,49.8217169 C111.674617,48.7016241 112.014849,47.4445476 112.014849,46.2041763 Z',
		className: "Icons",
		pathToImage: './images/icons_png/reddit.png'
	
	}, {
		name: "tumblr",
		url: "http://archmixes.tumblr.com/",
		path: 'M20.7,3l11.6,0.1L32.1,26l21,0.1l-0.1,14L32.5,40l-0.1,23.2c0,0-1,8.9,8.9,8c3.5-0.3,9.3-1.6,12.7-6l-0.1,14.2c0,0-4.6,4.7-13.5,6c-3.4,0.5-10,0.6-13.5,0.2c-6.5-0.9-15.2-4.1-15.1-21.3l0.2-24.2L3,39.8l0.1-14.4C3.1,25.4,20.5,24.9,20.7,3z',
		className: "Icons",
		pathToImage: './images/icons_png/tumblr.png'
	}, {
		name: "youtube",
		url: "https://www.youtube.com/channel/UC5hDO86UUlnEsX2c6c3b1ZA",
		path: 'M19.9,956.4c-8.8,0-15.9,7-15.9,15.8L4,999.9c0,8.8,7,15.9,15.8,15.9l51.5,0.1c8.8,0,15.9-7,15.9-15.8l0.1-27.7c0-8.8-7-15.9-15.8-15.9L19.9,956.4L19.9,956.4z M35.7,972.2l21.8,13.9L35.7,1000L35.7,972.2z',
		className: "Icons",
		pathToImage: './images/icons_png/youtube.png'
	}, {
		name: "sketchfab",
		url: "https://sketchfab.com/samtous/models",
		path: 'M19.9,956.4c-8.8,0-15.9,7-15.9,15.8L4,999.9c0,8.8,7,15.9,15.8,15.9l51.5,0.1c8.8,0,15.9-7,15.9-15.8l0.1-27.7c0-8.8-7-15.9-15.8-15.9L19.9,956.4L19.9,956.4z M35.7,972.2l21.8,13.9L35.7,1000L35.7,972.2z',
		className: "Icons",
		pathToImage: './images/icons_png/sketchfab.png'
	}];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrameElement = function (_React$Component) {
		_inherits(FrameElement, _React$Component);
	
		function FrameElement() {
			_classCallCheck(this, FrameElement);
	
			var _this = _possibleConstructorReturn(this, (FrameElement.__proto__ || Object.getPrototypeOf(FrameElement)).call(this));
	
			_this.renderFrame = _this.renderFrame.bind(_this);
			return _this;
		}
	
		_createClass(FrameElement, [{
			key: 'renderFrame',
			value: function renderFrame(url) {
				// console.log(url);
				window.open(url);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'FrameElement', onClick: function onClick() {
							return _this2.renderFrame(_this2.props.url);
						} },
					_react2.default.createElement('img', { style: { 'width': '10vw' }, src: this.props.pathToImage, role: 'presentation' })
				);
			}
		}]);
	
		return FrameElement;
	}(_react2.default.Component);
	
	exports.default = FrameElement;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FrameContent = __webpack_require__(123);
	
	var _FrameContent2 = _interopRequireDefault(_FrameContent);
	
	var _FrameElement = __webpack_require__(124);
	
	var _FrameElement2 = _interopRequireDefault(_FrameElement);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Grid = function (_React$Component) {
		_inherits(Grid, _React$Component);
	
		function Grid() {
			_classCallCheck(this, Grid);
	
			return _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).apply(this, arguments));
		}
	
		_createClass(Grid, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'Grid' },
					_FrameContent2.default.map(function (d, i) {
						return _react2.default.createElement(_FrameElement2.default, { key: i, id: i, url: d.url, pathToImage: d.pathToImage });
					})
				);
			}
		}]);
	
		return Grid;
	}(_react2.default.Component);
	
	exports.default = Grid;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTwitterWidgets = __webpack_require__(111);
	
	var _InstructionMobile = __webpack_require__(127);
	
	var _InstructionMobile2 = _interopRequireDefault(_InstructionMobile);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Instruction = function (_React$Component) {
		_inherits(Instruction, _React$Component);
	
		function Instruction() {
			_classCallCheck(this, Instruction);
	
			return _possibleConstructorReturn(this, (Instruction.__proto__ || Object.getPrototypeOf(Instruction)).apply(this, arguments));
		}
	
		_createClass(Instruction, [{
			key: 'render',
			value: function render() {
	
				return _react2.default.createElement(
					'div',
					{ className: 'Instruction' },
					_react2.default.createElement(
						'div',
						{ className: 'Content' },
						_react2.default.createElement(_reactTwitterWidgets.Share, { className: 'Share', url: '_', text: '_', size: 'large' }),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(_InstructionMobile2.default, null),
						_react2.default.createElement(_reactTwitterWidgets.Timeline, { dataSource: { sourceType: 'profile', screenName: 'archmixes' }, options: { username: 'Archmixes', height: '10vh' } }),
						_react2.default.createElement('iframe', { src: 'https://docs.google.com/spreadsheets/d/1RrZKh8pdTDijKsjTITJU33WQLNjhkjU3Z5hGIVUYIO8/pubhtml?gid=211184092&single=true&widget=true&headers=false', allowFullScreen: true }),
						_react2.default.createElement('iframe', { src: 'https://www.youtube.com/embed/GuQJ-B7MezA', allowFullScreen: true })
					)
				);
			}
		}]);
	
		return Instruction;
	}(_react2.default.Component);
	
	exports.default = Instruction;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTwitterWidgets = __webpack_require__(111);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InstructionMobile = function (_React$Component) {
		_inherits(InstructionMobile, _React$Component);
	
		function InstructionMobile() {
			_classCallCheck(this, InstructionMobile);
	
			return _possibleConstructorReturn(this, (InstructionMobile.__proto__ || Object.getPrototypeOf(InstructionMobile)).apply(this, arguments));
		}
	
		_createClass(InstructionMobile, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'InstructionMobile' },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'a',
							{ href: 'https://www.youtube.com/embed/GuQJ-B7MezA', target: '_blank' },
							' 1. Read the instructions '
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'a',
							{ href: 'https://archmixlist.tumblr.com/', target: '_blank' },
							' 2. Choose a #'
						)
					),
					_react2.default.createElement(_reactTwitterWidgets.Share, { url: '_', text: '_' })
				);
			}
		}]);
	
		return InstructionMobile;
	}(_react2.default.Component);
	
	exports.default = InstructionMobile;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(46);
	
	var _App = __webpack_require__(119);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Connect = __webpack_require__(121);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _About = __webpack_require__(118);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Instruction = __webpack_require__(126);
	
	var _Instruction2 = _interopRequireDefault(_Instruction);
	
	var _Event = __webpack_require__(122);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Routes = function Routes(props) {
	    return _react2.default.createElement(
	        _reactRouter.Router,
	        props,
	        _react2.default.createElement(
	            _reactRouter.Route,
	            { component: _App2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: '/', component: _Connect2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/instruction', component: _Instruction2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/about', component: _About2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: '/event', component: _Event2.default })
	        )
	    );
	};
	exports.default = Routes;

/***/ },
/* 129 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = [{
		name: "email",
		url: "mailto:archmixes@gmail.com?Subject=Hello",
		path: 'M80.4,0.1L9.2,0c-5,0-9.1,4-9.1,9.1L0,62.2c0,5,4,9.1,9.1,9.1l71.3,0.1c5,0,9.1-4,9.1-9.1l0.1-53.1C89.5,4.2,85.5,0.1,80.4,0.1z M79.2,7.1L49.1,38.5c-2.7,1.8-6.2,1.8-8.8,0L10.4,7L79.2,7.1z M80.3,64.4L9.1,64.3c-1.1,0-2.1-1-2.1-2.1l0-48.6l28.5,29.9l0.4,0.4c2.5,2,5.7,2.9,8.8,2.9s6.1-1,8.8-2.9l0.3-0.1l28.7-30.1l-0.1,48.6C82.4,63.4,81.5,64.4,80.3,64.4z',
		className: "Icons",
		pathToImage: './images/icons_png/email.png'
	}, {
		name: "twitter",
		url: "https://twitter.com/archmixes",
		path: 'M98.4,9.4c0.7-2.6-0.2-5.3-2.3-7c-1.2-0.9-2.6-1.4-4.1-1.4c-1.2,0-2.3,0.3-3.3,1c-2,1.2-4.2,2.2-6.4,2.9C78,1.7,72.7-0.1,67.2,0C54.7,0.1,44.4,9.6,42.9,21.7c-10-2-19.1-7.4-25.8-15.4C15.9,4.7,14,3.9,12,3.9c-0.2,0-0.3,0-0.5,0c-2.1,0.2-4,1.4-5.1,3.3C4.2,11,3.1,15.3,3.2,19.7c0,3,0.6,5.8,1.6,8.5c-1,1.2-1.6,2.7-1.6,4.4C3.2,39.1,5.7,45,9.9,49.4c-0.2,1.1-0.2,2.3,0.2,3.4c1.5,4.4,4.1,8.2,7.5,11.1c-2.2,0.5-4.4,0.8-6.7,0.8c-1.2,0-2.4-0.1-3.6-0.2c-0.3,0-0.5,0-0.8,0c-2.7,0-5.2,1.8-6.1,4.4c-1,2.9,0.1,6.1,2.7,7.7c9.5,5.9,20.4,9,31.5,8.9c36.2-0.4,57.6-29.7,57.7-58.1c2.9-2.5,5.5-5.5,7.6-8.7c0.8-1.1,1.3-2.5,1.3-4C101.2,12.5,100.1,10.6,98.4,9.4z M85.7,24.3c0,0.8,0.1,1.6,0.1,2.4C86,50.7,68,78.6,34.5,79c-10.3,0.1-19.9-2.8-28-7.9c1.4,0.1,2.9,0.2,4.3,0.2c8.5-0.1,16.3-3.1,22.5-8c-8-0.1-14.7-5.3-17.1-12.5c1.1,0.2,2.3,0.3,3.4,0.3c1.7,0,3.3-0.3,4.8-0.7c-8.3-1.6-14.7-8.9-14.8-17.7c0-0.1,0-0.2,0-0.2c2.5,1.3,5.3,2.1,8.3,2.2c-4.9-3.2-8.2-8.8-8.2-15.1c0-3.3,0.8-6.5,2.4-9.2c9.1,10.9,22.6,18,37.7,18.6c-0.3-1.3-0.5-2.7-0.5-4.1c-0.1-10,8-18.3,18-18.4c5.2-0.1,10,2.1,13.3,5.6c4.1-0.9,8-2.4,11.5-4.5c-1.3,4.3-4.2,7.9-7.9,10.1c3.7-0.5,7.2-1.5,10.4-3C92.3,18.5,89.2,21.7,85.7,24.3z',
		className: "Icons",
		pathToImage: './images/icons_png/twitter.png'
	}, {
		name: "ebay",
		url: "http://www.ebay.com/usr/arcmixe_0",
		path: 'M135.5,69.7c2.3-4.4,4.7-8.8,6.9-13.2c0.3-0.5,0.3-1.5,0-2c-4.6-8.8-9.4-17.5-14.1-26.3c-0.1-0.2-0.3-0.4-0.3-0.5c0.1,8.7,0.2,17.6,0.3,26.4c0,1.2-0.3,1.8-1.6,1.7c-1.5-0.1-3.1-0.1-4.6,0c-1.4,0.1-1.9-0.6-1.9-1.9c0-0.9,0-1.8,0-3c-0.5,0.3-0.7,0.4-0.9,0.5c-5.1,5-11.4,6-18.1,5.6c-3-0.2-5.9-1-8.4-2.8c-3.3-2.2-4.8-5.4-5.2-9.8c-3,7.2-8.1,11.3-15.4,12.4c-7,1-13.5-0.3-18.9-5.7c-0.1,1.2-0.1,2.1-0.2,3c0,1.2-0.5,1.8-1.9,1.8c-1.7-0.1-3.5-0.1-5.2,0c-1.2,0-1.7-0.4-1.7-1.7c0.1-4.3,0-8.6,0.1-12.9c0-1.6-0.5-2-2.1-2c-9.9,0.1-19.8,0.1-29.6,0.1c-1.5,0-2,0.3-1.7,1.9c1,5.5,5.2,9.5,10.8,9.8c2.1,0.1,4.2,0,6.2-0.4c2.7-0.6,4.7-2.2,6.2-4.6c0.4-0.6,1.4-1.2,2.1-1.2c2.4-0.2,4.8-0.1,7.4-0.1c-0.5,3.6-2.2,6-4.6,8c-3,2.5-6.6,3.7-10.4,4.1c-4.7,0.5-9.4,0.4-13.9-0.9C6.9,53.6,2.3,47.7,2,39.2c-0.1-2.7,0.1-5.4,0.6-8.1C3.9,24.7,7.8,20.4,14,18.4c5.8-1.9,11.6-2.1,17.5-0.5c6,1.6,10.1,5.3,12.2,11.2c0.1,0.3,0.2,0.6,0.7,0.8c0-0.6,0-1.2,0-1.8c0-7.9-0.1-15.8-0.1-23.7c0-2.3,0-2.3,2.4-2.4c1.6,0,3.2,0.1,4.7,0c1.4-0.1,1.8,0.5,1.7,1.8c0,5.7,0,11.4,0,17.1c0,0.5,0.1,1.1,0.1,1.7c7.6-6.5,16-7.4,24.9-3.6c7,3,9.8,8.7,10.7,19.8c1.5-1.2,2.9-2.6,4.6-3.6c3.1-1.9,6.6-2.6,10.2-2.8c4.6-0.2,9.2-0.3,13.9-0.4c1.9,0,2.1-0.3,1.9-2.2c-0.3-3-1.8-5.1-4.5-6.2c-3.6-1.5-7.4-1.5-11.1-0.2c-1.8,0.6-3.1,1.9-4,3.7c-0.3,0.6-1.1,1.2-1.7,1.2c-2.1,0.2-4.2,0-6.3,0.1c-1.2,0-1.5-0.5-1.2-1.6c0.9-3.8,3.3-6.4,6.8-7.7c9-3.3,17.9-3.9,26.4,1.6c0.1,0.1,0.3,0.1,0.6,0.2c-0.4-0.9-0.7-1.6-1.1-2.7c3.3,0,6.4-0.1,9.4,0c0.5,0,1.1,0.9,1.4,1.5c4.2,8.4,8.4,16.7,12.6,25.1c0.3,0.5,0.6,1.1,1,1.9c0.4-0.7,0.7-1.2,1-1.8c4.1-8.3,8.3-16.7,12.4-25.1c0.7-1.5,1.6-2.1,3.2-2c2.3,0.1,4.6,0,6.9,0c0,0.1,0,0.2,0,0.3c-0.2,0.2-0.3,0.5-0.4,0.7c-8.5,16.8-17,33.7-25.5,50.5C142,69.7,138.8,69.7,135.5,69.7z M79.7,37c-0.3-1.7-0.5-3.5-1-5.1c-1.4-4.8-5.7-8.3-10.4-8.7c-5.7-0.5-10.4,1.2-13.3,6.4c-1.8,3.2-2,6.7-1.6,10.4c1.1,7.7,8.2,12.7,15.8,10.9C75.6,49.5,79.5,44.2,79.7,37z M113.6,37.9C113.6,37.9,113.6,38,113.6,37.9c-1,0-1.9-0.1-2.9,0.1c-3.4,0.5-6.9,0.7-10.1,1.6c-3.8,1.1-5,4.9-3.1,8.2c1.1,1.9,2.8,2.9,4.9,3.3c3.2,0.7,6.3,0.5,9.3-0.5c4.8-1.6,7.7-5.7,7.7-10.8c0-1.3-0.4-2-1.8-1.9C116.3,38,114.9,37.9,113.6,37.9z M23.2,33.7c3.5,0,7-0.1,10.5,0c1.5,0,1.9-0.6,1.6-1.9C34.7,28.6,33,26,30,24.5c-5.2-2.5-10.3-2.1-15,1.3c-1.9,1.4-3.2,3.3-3.7,5.7c-0.5,2-0.3,2.3,1.8,2.3C16.5,33.7,19.9,33.7,23.2,33.7z',
		className: "Icons",
		pathToImage: './images/icons_png/ebay.png'
	}, {
		name: "ello",
		url: "https://ello.co/archmixes",
		path: 'M43.7,9l2.1,0l2.1,0l0.6,0.1c0.8,0.1,1.6,0.3,2.3,0.4c9.6,1.5,18,6.6,23.8,14.3c5.7,7.8,8.1,17.3,6.6,26.9c-1.3,8.6-5.7,16.5-12.3,22.1c-6.5,5.6-14.9,8.7-23.4,8.7c-1.5,0-3.1-0.1-4.7-0.3c-15.4-2-27.8-13.5-30.9-28.8c-0.3-1.3-0.4-2.6-0.6-4C9.2,48,9.1,47.5,9,46.9l0-1.2l0-2.5c0.1-0.4,0.2-0.8,0.2-1.3c1.5-16,13.1-28.9,28.9-32.1c1.2-0.3,2.6-0.4,3.9-0.6C42.6,9.2,43.2,9.1,43.7,9 M45.3,76.7c14.1,0,26.2-9,30.1-22.5c1.4-4.8-0.9-9.5-5.5-10.9c-0.8-0.3-1.7-0.4-2.5-0.4c-3.6,0-6.7,2.3-8.1,6.1l-0.2,0.5c-0.4,1.1-0.7,2.1-1.1,2.7c-3.1,5.1-7.1,7.5-12.6,7.5c-0.7,0-1.4,0-2.1-0.1c-5.3-0.5-10.1-4.8-11.9-10.6c-1.9-6.2-6.7-6.7-8.2-6.7c-0.8,0-1.5,0.1-2.3,0.3c-2.1,0.6-3.9,1.9-5,3.8c-1.2,2-1.5,4.6-0.8,7.2C18.7,67,30.9,76.5,44.9,76.7L45.3,76.7 M43.3,3c-2.1,0.3-4.3,0.5-6.4,1C18.6,7.7,5.1,22.8,3.3,41.4c0,0.3-0.2,0.6-0.2,0.9C3,44,3,45.7,3,47.4c0.3,2.1,0.6,4.3,1,6.4c3.6,17.7,18,31.2,36,33.5c1.8,0.2,3.6,0.4,5.4,0.4c20.5,0,38.4-15,41.6-35.9c3.5-23-12.3-44.5-35.4-48.1c-1.1-0.2-2.2-0.4-3.3-0.5C46.7,3,45,3,43.3,3L43.3,3z M45.3,70.7c-0.1,0-0.2,0-0.3,0c-11.3-0.1-21.1-7.8-24-18.7c-0.5-1.8,0.1-3.2,1.5-3.6c0.3-0.1,0.5-0.1,0.8-0.1c1.2,0,2,0.8,2.4,2.4c2.4,8.1,9.2,14.1,17,14.9c0.9,0.1,1.8,0.1,2.7,0.1c7.6,0,13.6-3.5,17.8-10.4c0.8-1.3,1.3-2.8,1.8-4.3c0.5-1.4,1.4-2.2,2.5-2.2c0.3,0,0.5,0,0.8,0.1c1.4,0.4,1.9,1.8,1.4,3.5C66.5,63.3,56.6,70.7,45.3,70.7L45.3,70.7z',
		className: "Icons",
		pathToImage: './images/icons_png/ello.png'
	
	}, {
		name: "etsy",
		url: "https://etsy.com/archmixes",
		path: 'M2,72.5c0-1.2,0-2.5,0-3.7c0-0.4,0.2-0.5,0.5-0.6c1.9-0.4,3.8-0.7,5.7-1.2	c0.8-0.2,1.6-0.5,2.2-1c1-0.7,1.2-1.9,1.2-3.1c0.1-2.3,0.1-4.7,0.1-7c0.1-11.5,0.2-23,0.2-34.5c0-2.9-0.1-5.9-0.1-8.8	c0-0.7-0.2-1.5-0.3-2.2c-0.3-1.2-1.2-2-2.4-2.3C7.3,7.7,5.3,7.3,3.3,6.9C2.5,6.8,2.2,6.4,2.2,5.6c0-1,0-2,0-3.1	c19.5,0.4,39,1.3,58.5-0.3c-0.1,1.2-0.1,2.3-0.2,3.4c-0.3,5.3-0.7,10.6-1,16c0,0.5-0.2,0.7-0.7,0.7c-0.7,0-1.4,0-2.1,0	c-0.9-0.1-1.3-0.4-1.5-1.3c-0.5-1.9-1-3.9-1.6-5.8c-0.5-1.5-1.1-2.9-1.8-4.2C50.4,8.8,48.4,8,46,8C40,8,34,8,27.9,8	c-1.1,0-2.3,0-3.4,0c-1,0-1.2,0.2-1.2,1.2c0,1.5,0,3,0,4.5c0,6.8-0.1,13.6-0.1,20.3c0,0.2,0,0.4,0,0.7c0.2,0,0.3,0.1,0.5,0.1	c3.8,0,7.7,0,11.5-0.1c1.3,0,2.7-0.2,4-0.4c1.3-0.2,2.1-1,2.5-2.2c0.5-1.6,0.9-3.3,1.3-4.9c0.2-0.7,0.3-1.3,0.5-2	c0.1-0.6,0.5-0.9,1.1-0.8c1.1,0,2.2,0,3.4,0c0,0.2,0,0.4,0,0.6c-0.1,7.7-0.2,15.5-0.3,23.2c0,0.3,0,0.5-0.1,0.8	c-0.1,0.4-0.3,0.7-0.8,0.7c-0.9,0-1.8,0-2.7-0.1c-0.5,0-0.9-0.4-1-0.9c-0.3-1.2-0.6-2.4-1-3.5c-0.3-0.9-0.5-1.9-0.9-2.8	c-0.7-1.6-2.2-2.2-3.9-2.3c-2.5-0.1-5.1-0.2-7.7-0.3c-1.9-0.1-3.8-0.1-5.6-0.1c-0.9,0-1,0-1,0.9c0,7.2-0.1,14.3-0.1,21.5	c0,1.5,0.4,2.9,1.7,4c0.8,0.6,1.7,1,2.7,1.1c2,0.1,3.9,0.2,5.9,0.2c4.7,0,9.4-0.1,14.1-0.2c3.5-0.1,6-1.8,7.6-4.8	c1.5-2.9,2.8-6,4.2-9c0.2-0.4,0.4-0.9,0.7-1.2c0.3-0.3,0.7-0.5,1-0.5c0.9-0.1,1.8,0,2.7,0c-0.1,0.7-0.1,1.2-0.2,1.8	c-0.6,4.7-1.2,9.4-1.7,14c-0.2,1.5-0.4,3-0.6,4.5c0,0.3-0.4,0.5-0.5,0.8c-2.1,0-4.2,0-6.3,0c-0.2,0-0.4-0.1-0.6-0.1	c-5.7-0.1-11.5-0.2-17.2-0.3c-2.5,0-5-0.1-7.6-0.1c-7.2-0.1-14.3-0.3-21.5,0.1c-0.7,0-1.5,0.1-2.2,0.2C4.2,72.5,3.1,72.5,2,72.5z',
		className: "Icons",
		pathToImage: './images/icons_png/etsy.png'
	
	}, {
		name: "facebook",
		url: "https://www.facebook.com/profile.php?id=100013989014757",
		path: 'M50.2,3.1L37.1,3c0,0-14.7-1.1-18.5,13.7c0,0-1.4,3.9-1.2,13.5L3.1,30.2l0,11.3l15.4,0.1l-0.2,42.6l15.4,0.1l0.2-42.6l15.4,0.1l0-11.4l-15.4-0.1c0,0,0-2.4,0-6.8c0-4.4,3-8.7,9.8-8.6l6.4,0L50.2,3.1z',
		className: "Icons",
		pathToImage: './images/icons_png/facebook.png'
	
	}, {
		name: "insta",
		url: "http://www.instagram.com/archmixes/",
		path: 'M70.8588059,35.9007954 L100.07,35.9007954 L100.07,80.7441565 C100.07,91.6673986 91.2152691,100.52213 80.292027,100.52213 L19.848217,100.52213 C8.92521886,100.52213 0.0702439858,91.6671546 0.0702439858,80.7441565 L0.0702439858,35.9007954 L29.1506617,35.9007954 C26.1740355,40.0829552 24.4175821,45.1934807 24.4175821,50.7178061 C24.4175821,64.8492168 35.8734451,76.3050798 50.0050998,76.3050798 C64.1365105,76.3050798 75.5923735,64.8492168 75.5923735,50.7178061 C75.5921295,45.1932367 73.8354321,40.0827112 70.8588059,35.9007954 Z M100.07,19.777973 L100.07,32.7675304 L68.2340072,32.7675304 C63.5929103,28.0549456 57.141195,25.1302884 50.0048558,25.1302884 C42.8680286,25.1302884 36.4165574,28.0547016 31.7757044,32.7675304 L0.07,32.7675304 L0.07,19.777973 C0.07,13.1117943 3.37161519,7.22027034 8.42529205,3.63733958 L8.42529205,24.9346118 L12.4803352,24.9346118 L12.4803352,1.42414483 C13.4001615,1.05426243 14.3539018,0.752696043 15.3359445,0.523593422 L15.3359445,24.9348558 L19.3912316,24.9348558 L19.3912316,0.0114673303 C19.5437227,0.00780754404 19.6949939,0 19.848217,0 L22.1899922,0 L22.1899922,24.9343678 L26.2450354,24.9343678 L26.2450354,0 L80.292027,0 C91.2152691,0 100.07,8.85473088 100.07,19.777973 Z M91.0300839,11.4421998 C91.0300839,9.6901381 89.6095989,8.26989704 87.8575372,8.26989704 L77.1658376,8.26989704 C75.413288,8.26989704 73.9932909,9.6901381 73.9932909,11.4421998 L73.9932909,22.3691016 C73.9932909,24.1211633 75.413288,25.5414044 77.1658376,25.5414044 L87.8575372,25.5414044 C89.6095989,25.5414044 91.0300839,24.1211633 91.0300839,22.3691016 L91.0300839,11.4421998 L91.0300839,11.4421998 Z M30.292027,50.7178061 C30.292027,44.8162787 32.9021866,39.5166642 37.0243259,35.9007954 C38.4701854,34.6328014 40.1017181,33.5734153 41.8735427,32.7675304 C44.3546338,31.6390963 47.1063051,31.0049773 50.0048558,31.0049773 C52.9036505,31.0049773 55.6548338,31.6390963 58.1359249,32.7675304 C59.9079935,33.5734153 61.5395262,34.6328014 62.9853857,35.9007954 C67.107525,39.5166642 69.7174406,44.8165227 69.7174406,50.7178061 C69.7174406,61.5873713 60.874665,70.4303909 50.0048558,70.4303909 C39.1352906,70.4303909 30.292027,61.5873713 30.292027,50.7178061 Z M35.5006349,50.7178061 C35.5006349,58.7642122 42.0235939,65.2866833 50.07,65.2866833 C58.1164061,65.2866833 64.6391212,58.7642122 64.6391212,50.7178061 C64.6391212,42.671156 58.1166501,36.1486849 50.07,36.1486849 C42.0235939,36.1486849 35.5006349,42.671156 35.5006349,50.7178061 Z',
		className: "Icons",
		pathToImage: './images/icons_png/insta.png'
	
	}, {
		name: "pinterest",
		url: "https://www.pinterest.com/archmixes",
		path: 'M32.6,62.9c-0.8,3-1.6,6.1-2.4,9.2c-0.8,3-1.5,6.1-2.7,8.9c-1.9,4.6-4.4,9-7.6,12.6c-2.1,2.4-1.7,1.4-2.3,1.3c-0.5-0.1-0.5-0.6-0.6-1.2c-0.5-3.7-0.1-7.9,0.1-12c0.3-4.7,1.3-8.6,2.3-12.5c1.8-7.4,3.6-14.7,5.5-22.1c0.1-0.5,0.5-1.3,0.3-1.6c-0.8-2.1-1.3-4-1.5-6.1c-0.2-2.5,0-4.8,0.6-7c1-3.8,3.4-7.2,7-8.4c2.3-0.8,4.8-0.4,6.3,0.5c1.6,0.9,2.6,2.4,3.1,4.5c0.5,2.2,0.1,4.9-0.4,6.8c-1,4.4-2.3,7.7-3.5,11.9c-0.6,2.1-1.3,4.2-0.7,6.5c0.5,2.1,1.6,3.5,3.1,4.6c1.5,1.1,3.4,1.8,5.9,1.7c4.5-0.1,7.6-2.9,9.7-5.6c3.4-4.2,5.4-10,6.3-16.8c0.3-2.2,0.5-4.7,0.3-7.2c-0.3-4.6-1.7-8.4-4-11.3c-2.2-2.8-5.3-5-9.1-6.2c-3.8-1.3-9-1.7-13.7-1c-8.5,1.4-14.5,6-18.1,12.6c-1.9,3.4-3.1,7.3-3.2,12.3c0,3.8,0.9,6.7,2.4,9c0.5,0.7,1.2,1.3,1.7,2.2c0.7,1.2-0.1,2.9-0.5,4.2c-0.4,1.5-0.5,3.6-2.3,3.7c-0.8,0-2.4-1-3-1.4c-3.7-2.8-5.1-4.7-7-9.3c-1.4-3.5-2-10.1-1.3-13.7c0.7-3.5,2.3-8.3,3.8-10.9c3-5.4,7.4-9.7,12.8-12.7c4.1-2.3,8.7-4,14.3-4.7C36.1,3.2,38,3.1,40.1,3c6.1-0.2,11.6,1.2,15.8,3.1c4.4,2,7.9,4.6,10.8,7.8c3,3.3,5.2,7.2,6.6,12c0.7,2.5,1,5.3,1,8.4c0,3.1-0.3,5.7-0.8,8.4c-1.8,10.2-6.8,18.4-14.2,23.1c-1.8,1.1-4,2.2-6.4,2.9c-2.4,0.7-5.2,1.2-8.2,0.9c-2.9-0.2-5.2-1-7.2-2.1C35.4,66.3,33.7,64.9,32.6,62.9z',
		className: "Icons",
		pathToImage: './images/icons_png/pinterest.png'
	
	}, {
		name: "reddit",
		url: "https://www.reddit.com/user/archmixes/",
		path: 'M85.6212529,54.5880278 C85.9303016,55.3781903 86.0706265,56.1942459 86.0706265,57.0050116 C86.0706265,58.637123 85.5068213,60.2224594 84.5607425,61.5165661 C83.6252436,62.7953596 82.2996752,63.787935 80.740232,64.2247796 L80.7430162,64.2247796 C80.7299304,64.2300696 80.7168445,64.2300696 80.7104408,64.2350812 C80.7040371,64.2350812 80.6934571,64.2403712 80.6884455,64.2403712 C79.9581439,64.4898376 79.2094664,64.6067749 78.4666357,64.6067749 C76.7253828,64.6067749 75.0153132,63.9792111 73.6482599,62.9095128 C72.2917865,61.8442691 71.2649652,60.3135035 70.9428306,58.4979118 L70.9400464,58.4979118 C70.9400464,58.4926218 70.9400464,58.4862181 70.9375406,58.4787007 C70.9375406,58.4734107 70.9375406,58.4681206 70.9322506,58.4606032 L70.9375406,58.4606032 C70.8361949,57.9925754 70.7841299,57.5251044 70.7841299,57.062645 C70.7841299,55.4903944 71.319536,53.9805104 72.2032483,52.7329002 C73.0841763,51.4930858 74.3264965,50.5083063 75.7804176,50.0012993 C75.7857077,50.0012993 75.7909977,49.9985151 75.7909977,49.9985151 C75.7985151,49.9985151 75.7985151,49.9909977 75.8051972,49.9909977 C76.6276566,49.6869606 77.4957773,49.5346636 78.35471,49.5346636 C79.9191647,49.5346636 81.460232,50.0090951 82.7596288,50.8769374 C84.0434339,51.73058 85.0855684,52.9820882 85.6078886,54.5362413 C85.6131787,54.5465429 85.6131787,54.5557309 85.6181903,54.5649188 C85.6181903,54.5752204 85.6234803,54.5807889 85.6284919,54.5883063 L85.6212529,54.5883063 L85.6212529,54.5880278 Z M80.8340603,73.8790719 C80.2209745,73.4814849 79.5112761,73.2412065 78.7603712,73.2412065 C78.1548028,73.2412065 77.5258469,73.4141067 76.9659397,73.785522 L76.9659397,73.785522 C71.6748028,76.9433875 65.4517865,78.6740603 59.2730394,78.6740603 C54.6373086,78.6740603 50.0296984,77.6956845 45.8553132,75.6451044 L45.8338747,75.6348028 L45.812993,75.627007 C45.1834803,75.3697448 44.4662645,74.822645 43.6838979,74.3017169 C43.2863109,74.0441763 42.8711833,73.7883063 42.4103944,73.5998144 C41.9557309,73.4063109 41.4506729,73.2709977 40.9108121,73.2709977 C40.4639443,73.2709977 39.9942459,73.3709513 39.5306729,73.5814385 C39.5067285,73.5906265 39.4838979,73.599536 39.4605104,73.6087239 L39.4630162,73.6087239 C38.7346636,73.8868677 38.1655684,74.3963805 37.7997216,74.9991647 C37.4177262,75.6200464 37.2300696,76.3428306 37.2300696,77.0625522 C37.2300696,77.7123898 37.3834803,78.361949 37.7008817,78.9519258 C38.0029698,79.5107193 38.4676566,79.9993503 39.0757309,80.3267749 C45.0420418,84.3510905 52.067471,86.1741995 59.1199072,86.1677958 C65.4785151,86.1677958 71.8755452,84.6957773 77.5709513,82.0162413 L77.6007425,81.9981439 L77.62942,81.9825522 C78.3803248,81.5379118 79.3784687,81.1392111 80.3192575,80.5584223 C80.7845012,80.262181 81.2391647,79.9191647 81.6289559,79.4734107 C82.0187471,79.0304408 82.3319722,78.4847332 82.5087703,77.8376798 L82.5087703,77.8348956 C82.5828306,77.5492343 82.6179118,77.2710905 82.6179118,76.9929466 C82.6179118,76.4642227 82.4878886,75.9625058 82.2723898,75.5117401 C81.9566589,74.8329466 81.4396288,74.2769374 80.8340603,73.8790719 Z M38.9443155,64.2011137 C38.9546172,64.2011137 38.9682599,64.2050116 38.9799536,64.2114153 C39.7414385,64.4895592 40.5263109,64.6270998 41.3033875,64.6270998 C43.2420418,64.6270998 45.1261253,63.8330394 46.5524826,62.5389327 C47.9766125,61.2409281 48.9519258,59.4047332 48.9519258,57.3115545 C48.9519258,57.2569838 48.9519258,57.202413 48.94942,57.1375406 C48.95471,57.0439907 48.9572158,56.9412529 48.9572158,56.8360093 C48.9572158,54.759536 47.9949884,52.9158237 46.5845012,51.6122506 C45.1687239,50.3075638 43.2890951,49.509884 41.3432019,49.509884 C40.8233875,49.509884 40.2938283,49.5708585 39.7762413,49.6916937 C39.7684455,49.6916937 39.7625986,49.6941995 39.7548028,49.6941995 L39.747007,49.6941995 C37.1710441,50.2335035 34.9099768,52.1451508 34.0755452,54.7748492 L34.0755452,54.7748492 L34.0755452,54.7776334 C34.0755452,54.7829234 34.0730394,54.787935 34.0730394,54.787935 C33.8333179,55.507935 33.7216705,56.2510441 33.7216705,56.9863573 C33.7216705,58.597587 34.2542923,60.1676102 35.172529,61.4589327 C36.0826914,62.7285383 37.3703944,63.7266821 38.9167517,64.192761 C38.9278886,64.1933179 38.9331787,64.1961021 38.9443155,64.2011137 Z M119.730766,45.4090023 L119.730766,45.4195824 C119.749142,45.6812993 119.754153,45.9424594 119.754153,46.201949 C119.754153,49.1106265 118.82116,51.9076566 117.26478,54.2806497 C115.811972,56.5013457 113.808445,58.3592575 111.500603,59.6199536 C111.648724,60.7776334 111.734478,61.9445012 111.734478,63.107471 C111.731694,69.37058 109.572251,75.5270534 105.811879,80.4612529 L105.811879,80.4637587 L105.804084,80.4637587 C98.8521578,89.7118329 88.1763341,95.1655684 77.3963805,97.9163805 L77.3935963,97.9163805 L77.3860789,97.9227842 C71.6374942,99.3185151 65.7096056,100.031555 59.7833875,100.031555 C50.9493271,100.031555 42.1222274,98.4384223 33.8851044,95.1354988 L33.8825986,95.127703 L33.8748028,95.127703 C25.3350348,91.6076102 17.1981439,86.0124362 12.2082599,77.8142923 C9.5237123,73.4402784 8.0500232,68.3086775 8.0500232,63.1528538 C8.0500232,61.9862645 8.12881671,60.8177262 8.28473318,59.6625522 C6.03730858,58.397123 4.09085847,56.6026914 2.64529002,54.4596752 C1.10227378,52.1582367 0.123897912,49.4619954 0.000278422274,46.6117865 L0.000278422274,46.6006497 L0.000278422274,46.590348 L0.000278422274,46.5675174 C0.00278422274,42.5757773 1.73679814,38.7945244 4.43136891,36.0064037 C7.12566125,33.2191183 10.8061253,31.3974014 14.7538747,31.3974014 L14.917587,31.3974014 C15.3316009,31.3692807 15.7492343,31.3531323 16.1671462,31.3531323 C18.1500696,31.3531323 20.1374478,31.6741531 22.0248724,32.3977726 L22.035174,32.4055684 L22.0457541,32.4089095 C23.6569838,33.0874246 25.2579118,33.9059861 26.684826,35.0397216 C27.1472854,34.7972158 27.6515081,34.5243619 28.2172622,34.3088631 C36.8661717,29.1872854 46.9191647,27.2116009 56.7160093,26.6416705 C56.8012065,21.7884919 57.397587,16.7075638 59.7644548,12.2611601 C61.7356845,8.56677494 65.1572158,5.69067285 69.2308121,4.69392111 L69.2477958,4.68556845 L69.2697912,4.68306265 C70.8214385,4.38292343 72.3858933,4.24454756 73.9400464,4.24454756 C78.0799072,4.24454756 82.1704872,5.22487239 85.9985151,6.75508121 C87.692993,4.19777262 90.1124826,2.20176334 92.9507193,1.08222738 L92.9780046,1.06663573 L93.00529,1.05633411 C94.6710905,0.537354988 96.4307193,0.23387471 98.1967517,0.23387471 C100.059954,0.23387471 101.937912,0.574385151 103.697262,1.36037123 L103.697262,1.35396752 C103.699768,1.36037123 103.702552,1.36037123 103.702552,1.36037123 C103.715638,1.36482599 103.72594,1.37262181 103.734849,1.37262181 C106.257077,2.34403712 108.392019,4.13930394 109.9058,6.37030162 C111.420974,8.61104408 112.312483,11.2950348 112.312483,14.054478 C112.312483,14.5631555 112.283805,15.0726682 112.224223,15.5827378 L112.218933,15.5930394 C112.218933,15.6008353 112.218933,15.6119722 112.216148,15.619768 C111.920186,19.1860789 110.113782,22.3149884 107.556473,24.5468213 C104.983852,26.7875638 101.651972,28.1409745 98.2321114,28.1409745 C97.6836195,28.1409745 97.130116,28.110348 96.5791183,28.0368445 C93.1873782,27.7776334 90.0247796,26.1363341 87.7013457,23.6948492 C85.370116,21.2572622 83.8680278,18.0002784 83.8680278,14.4846404 C83.8680278,14.3145244 83.8836195,14.140232 83.8886311,13.9715081 C80.7048724,12.5537819 77.3239907,11.3777262 73.9639907,11.3805104 C73.4778654,11.3805104 72.9920186,11.407239 72.5058933,11.4565197 L72.5006032,11.4565197 C69.985058,11.6990255 67.6460325,13.2846404 66.5128538,15.5651972 L66.5128538,15.567703 L66.5128538,15.5754988 C64.7924826,18.9260325 64.4494664,22.8425986 64.3974014,26.7302088 C74.0416705,27.3591647 83.7430162,29.6734107 92.2516009,34.5644548 L92.2646868,34.5644548 L92.3866357,34.6365661 C92.5478422,34.732065 92.8465893,34.8957773 93.1169374,35.04 C93.7019026,34.5655684 94.3202784,34.0777726 95.0258005,33.657355 C97.6051044,31.9394896 100.661346,31.08529 103.718979,31.08529 C105.075452,31.08529 106.433318,31.2581903 107.750812,31.5959165 L107.756102,31.5959165 L107.810673,31.612065 C107.830162,31.6148492 107.844362,31.6212529 107.860232,31.6212529 L107.860232,31.6237587 C110.973828,32.4158701 113.790626,34.2038979 115.911369,36.6150348 C118.030719,39.0300696 119.455963,42.0854756 119.734107,45.4023202 L119.734107,45.4092807 L119.730766,45.4092807 L119.730766,45.4090023 Z M91.3230626,13.8467749 C91.3230626,13.977355 91.3258469,14.1112761 91.3389327,14.247703 L91.3389327,14.2554988 L91.3389327,14.2710905 C91.4012993,15.9466357 92.192297,17.5060789 93.3945244,18.6579118 C94.602877,19.81058 96.2065893,20.5238979 97.8331323,20.5303016 L97.855406,20.5303016 L97.8774014,20.5303016 C97.9943387,20.5394896 98.1140603,20.5394896 98.2282135,20.5394896 C99.8706265,20.5419954 101.500232,19.8345244 102.724176,18.6865893 C103.950626,17.5328074 104.759165,15.9636195 104.824037,14.2738747 L104.826543,14.2660789 L104.826543,14.2557773 C104.837123,14.1265893 104.842413,14.0043619 104.842413,13.8723898 C104.842413,12.1330858 104.028863,10.4750812 102.75536,9.24723898 C101.487146,8.02051044 99.7795824,7.26041763 98.0959629,7.26487239 C97.552761,7.26487239 97.0145708,7.33893271 96.487239,7.50264501 L96.4691415,7.50403712 L96.4535499,7.51044084 C95.0658933,7.87099768 93.7651044,8.72658933 92.8307193,9.86283063 C91.8921578,10.9937819 91.3230626,12.3920186 91.3230626,13.8467749 Z M20.1332715,39.696891 C18.8441763,39.0966125 17.5110905,38.6678422 16.1935963,38.6734107 C15.972529,38.6734107 15.7489559,38.6864965 15.5281671,38.7104408 L15.4975406,38.7104408 L15.4669142,38.7143387 C13.5750348,38.7664037 11.6656148,39.5913689 10.232297,40.9135963 C8.79786543,42.2310905 7.84928074,44.0102088 7.77633411,45.9716937 L7.77633411,45.9897912 L7.77299304,46.0059397 C7.76018561,46.1646404 7.75489559,46.3225058 7.75489559,46.4745244 C7.75489559,47.6842691 8.12603248,48.8536427 8.75526682,49.918051 C9.22106729,50.7107193 9.83192575,51.4329466 10.5226914,52.062181 C12.7336427,47.2209745 16.1880278,43.112297 20.1332715,39.696891 Z M104.148306,63.3786543 C104.148306,59.063109 102.591369,54.7283527 100.070534,51.2383295 C95.0441763,44.2446404 87.2477958,39.6832483 79.1367981,37.1401392 L79.0797216,37.1200928 C77.5227842,36.6425986 75.9508121,36.2196752 74.3651972,35.8577262 C69.625058,34.7785615 64.7651972,34.2412065 59.910348,34.2412065 C53.3913689,34.2412065 46.8726682,35.2059397 40.6309977,37.1309513 C32.521949,39.7044084 24.6993968,44.2335035 19.6844548,51.2497448 L19.6844548,51.2550348 C17.1427378,54.759536 15.6542923,59.1087703 15.6542923,63.4396288 C15.6542923,65.0341531 15.8536427,66.6283991 16.275174,68.179768 L16.280464,68.1825522 C17.1931323,71.665058 18.9780974,74.7730858 21.2890023,77.4799072 C23.5985151,80.1931323 26.4320186,82.5076566 29.4122506,84.3956381 C30.0723898,84.8049188 30.7350348,85.19471 31.4132715,85.5753132 C40.0705336,90.4076102 50.0391647,92.5258469 59.9362413,92.5258469 C61.610116,92.5258469 63.2940139,92.4662645 64.9570302,92.3465429 C74.9237123,91.5226914 84.9316009,88.5808817 93.0219954,82.5697448 L93.0247796,82.5633411 C95.6001856,80.659768 97.9857077,78.3558237 99.8725754,75.7350348 C101.767239,73.1128538 103.154896,70.1813457 103.771044,66.997587 L103.771044,66.9883991 L103.77355,66.9856148 C104.026079,65.7967517 104.148306,64.5897912 104.148306,63.3786543 Z M112.014849,46.2041763 C112.012343,45.1567517 111.773179,44.1140603 111.248353,43.1415313 L111.235267,43.1292807 L111.229977,43.1136891 C110.528074,41.6686775 109.426079,40.5772622 108.098283,39.8333179 C106.770209,39.0843619 105.216056,38.7040371 103.656891,38.7040371 C102.247239,38.7040371 100.844826,39.0192111 99.6002784,39.644826 C103.558329,43.0816705 107.030534,47.212065 109.274339,52.0724826 C109.996845,51.4435267 110.612993,50.6753596 111.07406,49.8217169 C111.674617,48.7016241 112.014849,47.4445476 112.014849,46.2041763 Z',
		className: "Icons",
		pathToImage: './images/icons_png/reddit.png'
	
	}, {
		name: "tumblr",
		url: "http://archmixes.tumblr.com/",
		path: 'M20.7,3l11.6,0.1L32.1,26l21,0.1l-0.1,14L32.5,40l-0.1,23.2c0,0-1,8.9,8.9,8c3.5-0.3,9.3-1.6,12.7-6l-0.1,14.2c0,0-4.6,4.7-13.5,6c-3.4,0.5-10,0.6-13.5,0.2c-6.5-0.9-15.2-4.1-15.1-21.3l0.2-24.2L3,39.8l0.1-14.4C3.1,25.4,20.5,24.9,20.7,3z',
		className: "Icons",
		pathToImage: './images/icons_png/tumblr.png'
	}, {
		name: "youtube",
		url: "https://www.youtube.com/channel/UC5hDO86UUlnEsX2c6c3b1ZA",
		path: 'M19.9,956.4c-8.8,0-15.9,7-15.9,15.8L4,999.9c0,8.8,7,15.9,15.8,15.9l51.5,0.1c8.8,0,15.9-7,15.9-15.8l0.1-27.7c0-8.8-7-15.9-15.8-15.9L19.9,956.4L19.9,956.4z M35.7,972.2l21.8,13.9L35.7,1000L35.7,972.2z',
		className: "Icons",
		pathToImage: './images/icons_png/youtube.png'
	}, {
		name: "sketchfab",
		url: "https://sketchfab.com/samtous/models",
		path: 'M19.9,956.4c-8.8,0-15.9,7-15.9,15.8L4,999.9c0,8.8,7,15.9,15.8,15.9l51.5,0.1c8.8,0,15.9-7,15.9-15.8l0.1-27.7c0-8.8-7-15.9-15.8-15.9L19.9,956.4L19.9,956.4z M35.7,972.2l21.8,13.9L35.7,1000L35.7,972.2z',
		className: "Icons",
		pathToImage: './images/icons_png/sketchfab.png'
	}, {
		name: "bld1",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld1.png'
	}, {
		name: "mockup",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld2.png'
	}, {
		name: "mockup",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld3.png'
	}, {
		name: "mockup",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld4.png'
	}, {
		name: "mockup",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld5.png'
	}, {
		name: "mockup",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld6.png'
	}, {
		name: "mockup",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld7.png'
	}, {
		name: "mockup",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld8.png'
	}, {
		name: "mockup",
		path: 'M30.408,2.658 L30.408,2.515 L30.408,2.515 L30.408,2.397 L30.943,2.383 C30.943,2.383 30.959,2.356 30.945,2.232 C31.207,2.122 31.757,0.76 31.605,0.815 C31.454,0.87 30.89,1.311 30.735,1.42 C30.58,1.53 30.519,1.792 30.395,1.736 C30.27,1.682 30.395,1.544 30.433,1.406 C30.472,1.269 30.23,1.089 30.093,1.173 C29.955,1.255 30.01,1.668 30.01,1.668 C30.01,1.668 30.01,1.792 29.749,1.737 C29.667,1.572 28.938,0.857 28.483,0.87 C28.483,1.627 29.389,2.149 29.389,2.149 L29.389,2.397 L29.899,2.397 C29.899,2.397 29.913,2.549 29.913,2.7 C29.005,2.7 28.95,4.626 30.175,4.626 L30.175,5.672 L30.216,5.768 C30.216,5.768 30.409,5.837 30.409,5.7 C30.409,5.562 30.353,5.508 30.353,5.508 L30.381,4.628 C31.549,4.625 31.261,2.658 30.408,2.658 Z M30.067,3.827 L30.067,4.162 L30.067,4.24 C29.687,4.226 29.665,3.827 29.665,3.827 L29.68,3.827 C29.669,3.782 29.665,3.749 29.665,3.749 L30.067,3.749 L30.067,3.827 Z M30.073,3.081 L30.073,3.405 L30.073,3.483 L29.66,3.483 C29.661,3.45 29.678,3.433 29.685,3.405 L29.66,3.405 C29.674,3.026 30.073,3.003 30.073,3.003 L30.073,3.081 Z M30.418,3.412 L30.418,3.077 L30.418,2.999 C30.797,3.012 30.82,3.412 30.82,3.412 L30.805,3.412 C30.815,3.457 30.82,3.49 30.82,3.49 L30.418,3.49 L30.418,3.412 Z M30.824,3.834 C30.81,4.213 30.411,4.236 30.411,4.236 L30.411,4.158 L30.411,3.834 L30.411,3.756 L30.824,3.756 C30.823,3.789 30.806,3.806 30.8,3.834 L30.824,3.834 L30.824,3.834 Z M57.08,21.617 L57.08,21.19 L56.861,21.19 L56.861,17.722 L56.888,17.722 L57.458,17.127 L39.255,17.127 L39.255,16.814 L39.334,16.814 L39.522,16.22 L35.598,16.22 C35.69,16.185 35.804,16.069 35.91,16.034 C36.076,15.979 36.048,15.731 36.103,15.401 C36.158,15.071 36.295,14.713 36.35,14.934 C36.406,15.154 36.213,15.677 36.295,15.896 C36.378,16.116 36.708,15.787 36.708,15.594 C36.708,15.401 36.653,14.658 36.625,14.493 C36.598,14.328 36.873,13.778 37.203,13.75 C37.534,13.723 37.616,13.86 37.835,14.328 C38.056,14.796 37.698,15.346 37.56,15.4 C37.56,15.4 37.56,15.703 37.725,15.786 C37.891,15.868 38.111,15.483 38.165,15.264 C38.22,15.043 38.385,14.411 38.358,14.108 C38.331,13.806 38.083,13.668 38.134,13.42 C38.185,13.172 38.137,12.594 38.083,12.43 C38.028,12.265 37.808,12.072 37.808,12.072 C37.808,11.88 38.303,11.44 38.247,11.165 C38.302,11.054 38.33,10.477 38.33,10.477 L38.468,10.339 L38.358,10.202 L38.275,9.817 L38.468,9.377 L38.22,9.57 L38.165,9.212 L38,9.431 L37.587,9.431 C37.587,9.431 37.285,9.705 37.174,9.733 C37.064,9.76 36.954,9.843 36.954,9.843 L36.817,10.311 L36.569,10.503 C36.569,10.503 36.762,10.64 36.762,10.806 C36.762,10.957 36.689,11.265 36.551,11.486 L34.65,11.471 C34.612,11.345 34.571,11.274 34.528,11.274 C34.485,11.274 34.445,11.344 34.407,11.47 L33.928,11.466 C33.928,11.356 34.121,11.081 34.203,10.916 C34.286,10.751 34.038,10.558 34.011,10.476 C33.983,10.394 34.093,9.954 34.087,9.844 C34.081,9.734 33.956,9.651 34.066,9.404 C34.175,9.157 33.818,9.212 33.735,9.349 C33.653,9.486 33.515,9.514 33.433,9.266 C33.35,9.018 33.13,9.239 33.13,9.349 C33.13,9.459 33.102,9.596 32.882,9.844 C32.662,10.092 32.799,10.724 32.772,11.082 C32.748,11.398 32.57,11.42 32.341,11.551 C32.383,11.524 32.409,11.492 32.456,11.467 C32.677,10.755 32.594,10.257 32.594,10.257 C32.594,10.257 32.292,9.68 30.751,9.68 C29.21,9.68 28.962,10.202 28.962,10.202 C28.962,10.202 28.902,10.369 28.863,10.578 C28.876,10.29 28.877,9.995 28.742,9.844 C28.522,9.596 28.494,9.459 28.494,9.349 C28.494,9.239 28.274,9.018 28.191,9.266 C28.108,9.514 27.971,9.486 27.889,9.349 C27.806,9.211 27.449,9.157 27.558,9.404 C27.668,9.652 27.544,9.734 27.537,9.844 C27.531,9.954 27.641,10.394 27.613,10.476 C27.585,10.559 27.338,10.751 27.421,10.916 C27.504,11.081 27.696,11.356 27.696,11.466 L27.217,11.47 C27.18,11.345 27.139,11.274 27.096,11.274 C27.053,11.274 27.012,11.345 26.975,11.471 L25.074,11.486 C24.935,11.266 24.863,10.957 24.863,10.806 C24.863,10.64 25.056,10.503 25.056,10.503 L24.808,10.311 L24.67,9.843 C24.67,9.843 24.56,9.76 24.45,9.733 C24.34,9.705 24.037,9.431 24.037,9.431 L23.624,9.431 L23.458,9.211 L23.404,9.569 L23.156,9.376 L23.348,9.816 L23.265,10.201 L23.155,10.338 L23.293,10.476 C23.293,10.476 23.32,11.054 23.376,11.164 C23.32,11.439 23.816,11.879 23.816,12.071 C23.816,12.071 23.596,12.264 23.541,12.429 C23.486,12.594 23.439,13.172 23.489,13.419 C23.541,13.667 23.293,13.805 23.265,14.107 C23.238,14.41 23.403,15.042 23.457,15.263 C23.513,15.483 23.732,15.867 23.898,15.785 C24.063,15.702 24.063,15.399 24.063,15.399 C23.925,15.345 23.567,14.795 23.787,14.327 C24.008,13.859 24.09,13.722 24.42,13.749 C24.75,13.777 25.025,14.327 24.998,14.492 C24.971,14.657 24.915,15.399 24.915,15.593 C24.915,15.786 25.246,16.115 25.328,15.895 C25.411,15.675 25.218,15.153 25.273,14.933 C25.328,14.712 25.466,15.07 25.521,15.4 C25.576,15.731 25.548,15.978 25.713,16.033 C25.819,16.068 25.934,16.184 26.025,16.219 L21.98,16.219 L22.168,16.813 L22.247,16.813 L22.247,17.126 L4.21,17.126 L4.78,17.721 L4.788,17.721 L4.788,21.189 L4.423,21.189 L4.423,21.616 L0.693,21.616 L1.696,22.21 L1.72,22.21 L1.72,22.672 L2.855,22.672 L2.855,25.057 L2.092,25.057 L2.092,25.486 L2.47,25.486 L2.47,25.858 L2.092,25.858 L2.092,26.297 L2.508,26.297 L2.635,26.847 L2.854,26.847 L2.854,50.6 L2.636,50.6 L2.509,51.15 L2.14,51.15 L2.14,51.59 L2.855,51.59 L6.831,51.59 L7.532,51.59 L7.532,51.15 L7.178,51.15 L7.051,50.6 L6.831,50.6 L6.831,26.849 L7.051,26.849 L7.178,26.299 L7.485,26.299 L7.485,25.86 L12.17,25.86 L12.17,26.299 L12.58,26.299 L12.706,26.849 L12.926,26.849 L12.926,50.602 L12.706,50.602 L12.58,51.152 L12.218,51.152 L12.218,51.592 L12.926,51.592 L16.902,51.592 L17.61,51.592 L17.61,51.152 L17.249,51.152 L17.122,50.602 L16.903,50.602 L16.903,26.849 L17.122,26.849 L17.249,26.299 L17.563,26.299 L17.563,25.86 L22.248,25.86 L22.248,26.299 L22.65,26.299 L22.777,26.849 L22.996,26.849 L22.996,50.602 L22.777,50.602 L22.65,51.152 L22.296,51.152 L22.296,51.592 L22.997,51.592 L26.973,51.592 L27.688,51.592 L27.688,51.152 L27.319,51.152 L27.192,50.602 L26.972,50.602 L26.972,26.849 L27.192,26.849 L27.32,26.299 L27.64,26.299 L27.64,25.86 L33.864,25.86 L33.864,26.299 L34.281,26.299 L34.408,26.849 L34.628,26.849 L34.628,50.602 L34.408,50.602 L34.281,51.152 L33.913,51.152 L33.913,51.592 L34.628,51.592 L38.604,51.592 L39.305,51.592 L39.305,51.152 L38.951,51.152 L38.824,50.602 L38.604,50.602 L38.604,26.849 L38.824,26.849 L38.95,26.299 L39.257,26.299 L39.257,25.86 L43.943,25.86 L43.943,26.299 L44.352,26.299 L44.479,26.849 L44.699,26.849 L44.699,50.602 L44.479,50.602 L44.353,51.152 L43.992,51.152 L43.992,51.592 L44.7,51.592 L48.677,51.592 L49.385,51.592 L49.385,51.152 L49.02,51.152 L48.894,50.602 L48.674,50.602 L48.674,26.849 L48.894,26.849 L49.02,26.299 L49.333,26.299 L49.333,25.86 L54.018,25.86 L54.018,26.299 L54.421,26.299 L54.547,26.849 L54.767,26.849 L54.767,50.602 L54.547,50.602 L54.42,51.152 L54.066,51.152 L54.066,51.592 L54.767,51.592 L58.743,51.592 L59.459,51.592 L59.459,51.152 L59.09,51.152 L58.963,50.602 L58.743,50.602 L58.743,26.849 L58.963,26.849 L59.09,26.299 L59.411,26.299 L59.411,25.86 L59.128,25.86 L59.128,25.488 L59.411,25.488 L59.411,25.059 L58.743,25.059 L58.743,22.674 L59.831,22.674 L59.831,22.197 L60.81,21.617 L57.08,21.617 Z',
		className: "Images",
		pathToImage: './images/bld9.png'
	}, {
		name: "mockup",
		className: "Images",
		pathToImage: './images/bld10.png'
	}, {
		name: "mockup",
		className: "Images",
		pathToImage: './images/bld11.png'
	}, {
		name: "mockup",
		className: "Images",
		pathToImage: './images/bld12.png'
	}, {
		name: "mockup",
		className: "Images",
		pathToImage: './images/bld13.png'
	}, {
		name: "mockup",
		className: "Images",
		pathToImage: './images/bld14.png'
	}, {
		name: "mockup",
		className: "Images",
		pathToImage: './images/bld15.png'
	}, {
		name: "mockup",
		className: "Images",
		pathToImage: './images/bld16.png'
	}, {
		name: "mockup",
		className: "Images",
		pathToImage: './images/bld17.png'
	}];

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(46);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Title = function (_React$Component) {
		_inherits(Title, _React$Component);
	
		function Title() {
			_classCallCheck(this, Title);
	
			return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
		}
	
		_createClass(Title, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'Title' },
					_react2.default.createElement(
						'div',
						{ className: 'Links' },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '/' },
							'Archmixes'
						)
					)
				);
			}
		}]);
	
		return Title;
	}(_react2.default.Component);
	
	exports.default = Title;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(162);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(46);
	
	var _Routes = __webpack_require__(128);
	
	var _Routes2 = _interopRequireDefault(_Routes);
	
	__webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_Routes2.default, { history: _reactRouter.browserHistory }), document.getElementById('root'));

/***/ },
/* 132 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isolate = isolate;
	function isolate(data, aForce, filter) {
	    var initialize = aForce.initialize;
	    aForce.initialize = function () {
	        initialize.call(aForce, data.filter(filter));
	    };
	    return aForce;
	}

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org Version 4.4.0. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var version = "4.4.0";
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(array, f) {
	  var n = array.length,
	      m = 0,
	      a,
	      d,
	      s = 0,
	      i = -1,
	      j = 0;
	
	  if (f == null) {
	    while (++i < n) {
	      if (!isNaN(a = number(array[i]))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(a = number(f(array[i], i, array)))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  if (j > 1) return s / (j - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b,
	      c;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = array[i]) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  return [a, c];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant$1 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var step = tickStep(start, stop, count);
	  return range(
	    Math.ceil(start / step) * step,
	    Math.floor(stop / step) * step + step / 2, // inclusive
	    step
	  );
	};
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) tz = ticks(x0, x1, tz);
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] >= x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant$1([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$1(slice.call(_)) : constant$1(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var threshold = function(array, p, f) {
	  if (f == null) f = number;
	  if (!(n = array.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	  if (p >= 1) return +f(array[n - 1], n - 1, array);
	  var n,
	      h = (n - 1) * p,
	      i = Math.floor(h),
	      a = +f(array[i], i, array),
	      b = +f(array[i + 1], i + 1, array);
	  return a + (b - a) * (h - i);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	  }
	
	  return a;
	};
	
	var mean = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1,
	      j = n;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) s += a; else --j;
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) s += a; else --j;
	  }
	
	  if (j) return s / j;
	};
	
	var median = function(array, f) {
	  var numbers = [],
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) numbers.push(a);
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
	  }
	
	  return threshold(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	  }
	
	  return a;
	};
	
	var pairs = function(array) {
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = [p, p = array[++i]];
	  return pairs;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(array, compare) {
	  if (!(n = array.length)) return;
	  var i = 0,
	      n,
	      j = 0,
	      xi,
	      xj = array[j];
	
	  if (!compare) compare = ascending;
	
	  while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	  }
	
	  else {
	    while (++i < n) if (a = +f(array[i], i, array)) s += a;
	  }
	
	  return s;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map$1.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map$1(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) return rollup != null
	        ? rollup(array) : (sortValues != null
	        ? array.sort(sortValues)
	        : array);
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map$1(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map, depth) {
	    if (++depth > keys.length) return map;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map.entries();
	    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map$1();
	}
	
	function setMap(map, key, value) {
	  map.set(key, value);
	}
	
	function Set() {}
	
	var proto = map$1.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	var uniform = function(min, max) {
	  min = min == null ? 0 : +min;
	  max = max == null ? 1 : +max;
	  if (arguments.length === 1) max = min, min = 0;
	  else max -= min;
	  return function() {
	    return Math.random() * max + min;
	  };
	};
	
	var normal = function(mu, sigma) {
	  var x, r;
	  mu = mu == null ? 0 : +mu;
	  sigma = sigma == null ? 1 : +sigma;
	  return function() {
	    var y;
	
	    // If available, use the second previously-generated uniform random.
	    if (x != null) y = x, x = null;
	
	    // Otherwise, generate a new x and y.
	    else do {
	      x = Math.random() * 2 - 1;
	      y = Math.random() * 2 - 1;
	      r = x * x + y * y;
	    } while (!r || r > 1);
	
	    return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
	  };
	};
	
	var logNormal = function() {
	  var randomNormal = normal.apply(this, arguments);
	  return function() {
	    return Math.exp(randomNormal());
	  };
	};
	
	var irwinHall = function(n) {
	  return function() {
	    for (var sum = 0, i = 0; i < n; ++i) sum += Math.random();
	    return sum;
	  };
	};
	
	var bates = function(n) {
	  var randomIrwinHall = irwinHall(n);
	  return function() {
	    return randomIrwinHall() / n;
	  };
	};
	
	var exponential = function(lambda) {
	  return function() {
	    return -Math.log(1 - Math.random()) / lambda;
	  };
	};
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI;
	var halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11;
	var b2 = 6 / 11;
	var b3 = 8 / 11;
	var b4 = 3 / 4;
	var b5 = 9 / 11;
	var b6 = 10 / 11;
	var b7 = 15 / 16;
	var b8 = 21 / 22;
	var b9 = 63 / 64;
	var b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI;
	var amplitude = 1;
	var period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	var area = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      a,
	      b = polygon[n - 1],
	      area = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    area += a[1] * b[0] - a[0] * b[1];
	  }
	
	  return area / 2;
	};
	
	var centroid = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      x = 0,
	      y = 0,
	      a,
	      b = polygon[n - 1],
	      c,
	      k = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    k += c = a[0] * b[1] - b[0] * a[1];
	    x += (a[0] + b[0]) * c;
	    y += (a[1] + b[1]) * c;
	  }
	
	  return k *= 3, [x / k, y / k];
	};
	
	// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
	// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
	// right, +y is up). Returns a positive value if ABC is counter-clockwise,
	// negative if clockwise, and zero if the points are collinear.
	var cross = function(a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	};
	
	function lexicographicOrder(a, b) {
	  return a[0] - b[0] || a[1] - b[1];
	}
	
	// Computes the upper convex hull per the monotone chain algorithm.
	// Assumes points.length >= 3, is sorted by x, unique in y.
	// Returns an array of indices into points in left-to-right order.
	function computeUpperHullIndexes(points) {
	  var n = points.length,
	      indexes = [0, 1],
	      size = 2;
	
	  for (var i = 2; i < n; ++i) {
	    while (size > 1 && cross(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
	    indexes[size++] = i;
	  }
	
	  return indexes.slice(0, size); // remove popped points
	}
	
	var hull = function(points) {
	  if ((n = points.length) < 3) return null;
	
	  var i,
	      n,
	      sortedPoints = new Array(n),
	      flippedPoints = new Array(n);
	
	  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
	  sortedPoints.sort(lexicographicOrder);
	  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];
	
	  var upperIndexes = computeUpperHullIndexes(sortedPoints),
	      lowerIndexes = computeUpperHullIndexes(flippedPoints);
	
	  // Construct the hull polygon, removing possible duplicate endpoints.
	  var skipLeft = lowerIndexes[0] === upperIndexes[0],
	      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
	      hull = [];
	
	  // Add upper hull in right-to-l order.
	  // Then add lower hull in left-to-right order.
	  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
	  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
	
	  return hull;
	};
	
	var contains = function(polygon, point) {
	  var n = polygon.length,
	      p = polygon[n - 1],
	      x = point[0], y = point[1],
	      x0 = p[0], y0 = p[1],
	      x1, y1,
	      inside = false;
	
	  for (var i = 0; i < n; ++i) {
	    p = polygon[i], x1 = p[0], y1 = p[1];
	    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
	    x0 = x1, y0 = y1;
	  }
	
	  return inside;
	};
	
	var length$1 = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      b = polygon[n - 1],
	      xa,
	      ya,
	      xb = b[0],
	      yb = b[1],
	      perimeter = 0;
	
	  while (++i < n) {
	    xa = xb;
	    ya = yb;
	    b = polygon[i];
	    xb = b[0];
	    yb = b[1];
	    xa -= xb;
	    ya -= yb;
	    perimeter += Math.sqrt(xa * xa + ya * ya);
	  }
	
	  return perimeter;
	};
	
	var pi$1 = Math.PI;
	var tau$1 = 2 * pi$1;
	var epsilon = 1e-6;
	var tauEpsilon = tau$1 - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      if (da < 0) da = da % tau$1 + tau$1;
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var tree_add = function(d) {
	  var x = +this._x.call(null, d),
	      y = +this._y.call(null, d);
	  return add(this.cover(x, y), x, y, d);
	};
	
	function add(tree, x, y, d) {
	  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	  var parent,
	      node = tree._root,
	      leaf = {data: d},
	      x0 = tree._x0,
	      y0 = tree._y0,
	      x1 = tree._x1,
	      y1 = tree._y1,
	      xm,
	      ym,
	      xp,
	      yp,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return tree._root = leaf, tree;
	
	  // Find the existing leaf for the new point, or add it.
	  while (node.length) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	  }
	
	  // Is the new point is exactly coincident with the existing point?
	  xp = +tree._x.call(null, node.data);
	  yp = +tree._y.call(null, node.data);
	  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	  // Otherwise, split the leaf node until the old and new point are separated.
	  do {
	    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
	  return parent[j] = node, parent[i] = leaf, tree;
	}
	
	function addAll(data) {
	  var d, i, n = data.length,
	      x,
	      y,
	      xz = new Array(n),
	      yz = new Array(n),
	      x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  // Compute the points and their extent.
	  for (i = 0; i < n; ++i) {
	    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	    xz[i] = x;
	    yz[i] = y;
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  // If there were no (valid) points, inherit the existing extent.
	  if (x1 < x0) x0 = this._x0, x1 = this._x1;
	  if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	  // Expand the tree to cover the new points.
	  this.cover(x0, y0).cover(x1, y1);
	
	  // Add the new points.
	  for (i = 0; i < n; ++i) {
	    add(this, xz[i], yz[i], data[i]);
	  }
	
	  return this;
	}
	
	var tree_cover = function(x, y) {
	  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	  var x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1;
	
	  // If the quadtree has no extent, initialize them.
	  // Integer extent are necessary so that if we later double the extent,
	  // the existing quadrant boundaries don’t change due to floating point error!
	  if (isNaN(x0)) {
	    x1 = (x0 = Math.floor(x)) + 1;
	    y1 = (y0 = Math.floor(y)) + 1;
	  }
	
	  // Otherwise, double repeatedly to cover.
	  else if (x0 > x || x > x1 || y0 > y || y > y1) {
	    var z = x1 - x0,
	        node = this._root,
	        parent,
	        i;
	
	    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
	      case 0: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
	        break;
	      }
	      case 1: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
	        break;
	      }
	      case 2: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
	        break;
	      }
	      case 3: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
	        break;
	      }
	    }
	
	    if (this._root && this._root.length) this._root = node;
	  }
	
	  // If the quadtree covers the point already, just return.
	  else return this;
	
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  return this;
	};
	
	var tree_data = function() {
	  var data = [];
	  this.visit(function(node) {
	    if (!node.length) do data.push(node.data); while (node = node.next)
	  });
	  return data;
	};
	
	var tree_extent = function(_) {
	  return arguments.length
	      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
	      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	};
	
	var Quad = function(node, x0, y0, x1, y1) {
	  this.node = node;
	  this.x0 = x0;
	  this.y0 = y0;
	  this.x1 = x1;
	  this.y1 = y1;
	};
	
	var tree_find = function(x, y, radius) {
	  var data,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1,
	      y1,
	      x2,
	      y2,
	      x3 = this._x1,
	      y3 = this._y1,
	      quads = [],
	      node = this._root,
	      q,
	      i;
	
	  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
	  if (radius == null) radius = Infinity;
	  else {
	    x0 = x - radius, y0 = y - radius;
	    x3 = x + radius, y3 = y + radius;
	    radius *= radius;
	  }
	
	  while (q = quads.pop()) {
	
	    // Stop searching if this quadrant can’t contain a closer node.
	    if (!(node = q.node)
	        || (x1 = q.x0) > x3
	        || (y1 = q.y0) > y3
	        || (x2 = q.x1) < x0
	        || (y2 = q.y1) < y0) continue;
	
	    // Bisect the current quadrant.
	    if (node.length) {
	      var xm = (x1 + x2) / 2,
	          ym = (y1 + y2) / 2;
	
	      quads.push(
	        new Quad(node[3], xm, ym, x2, y2),
	        new Quad(node[2], x1, ym, xm, y2),
	        new Quad(node[1], xm, y1, x2, ym),
	        new Quad(node[0], x1, y1, xm, ym)
	      );
	
	      // Visit the closest quadrant first.
	      if (i = (y >= ym) << 1 | (x >= xm)) {
	        q = quads[quads.length - 1];
	        quads[quads.length - 1] = quads[quads.length - 1 - i];
	        quads[quads.length - 1 - i] = q;
	      }
	    }
	
	    // Visit this point. (Visiting coincident points isn’t necessary!)
	    else {
	      var dx = x - +this._x.call(null, node.data),
	          dy = y - +this._y.call(null, node.data),
	          d2 = dx * dx + dy * dy;
	      if (d2 < radius) {
	        var d = Math.sqrt(radius = d2);
	        x0 = x - d, y0 = y - d;
	        x3 = x + d, y3 = y + d;
	        data = node.data;
	      }
	    }
	  }
	
	  return data;
	};
	
	var tree_remove = function(d) {
	  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	  var parent,
	      node = this._root,
	      retainer,
	      previous,
	      next,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1,
	      x,
	      y,
	      xm,
	      ym,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return this;
	
	  // Find the leaf node for the point.
	  // While descending, also retain the deepest parent with a non-removed sibling.
	  if (node.length) while (true) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	    if (!node.length) break;
	    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
	  }
	
	  // Find the point to remove.
	  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	  if (next = node.next) delete node.next;
	
	  // If there are multiple coincident points, remove just the point.
	  if (previous) return (next ? previous.next = next : delete previous.next), this;
	
	  // If this is the root point, remove it.
	  if (!parent) return this._root = next, this;
	
	  // Remove this leaf.
	  next ? parent[i] = next : delete parent[i];
	
	  // If the parent now contains exactly one leaf, collapse superfluous parents.
	  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
	      && node === (parent[3] || parent[2] || parent[1] || parent[0])
	      && !node.length) {
	    if (retainer) retainer[j] = node;
	    else this._root = node;
	  }
	
	  return this;
	};
	
	function removeAll(data) {
	  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
	  return this;
	}
	
	var tree_root = function() {
	  return this._root;
	};
	
	var tree_size = function() {
	  var size = 0;
	  this.visit(function(node) {
	    if (!node.length) do ++size; while (node = node.next)
	  });
	  return size;
	};
	
	var tree_visit = function(callback) {
	  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	    }
	  }
	  return this;
	};
	
	var tree_visitAfter = function(callback) {
	  var quads = [], next = [], q;
	  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    var node = q.node;
	    if (node.length) {
	      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	    }
	    next.push(q);
	  }
	  while (q = next.pop()) {
	    callback(q.node, q.x0, q.y0, q.x1, q.y1);
	  }
	  return this;
	};
	
	function defaultX(d) {
	  return d[0];
	}
	
	var tree_x = function(_) {
	  return arguments.length ? (this._x = _, this) : this._x;
	};
	
	function defaultY(d) {
	  return d[1];
	}
	
	var tree_y = function(_) {
	  return arguments.length ? (this._y = _, this) : this._y;
	};
	
	function quadtree(nodes, x, y) {
	  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
	  return nodes == null ? tree : tree.addAll(nodes);
	}
	
	function Quadtree(x, y, x0, y0, x1, y1) {
	  this._x = x;
	  this._y = y;
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  this._root = undefined;
	}
	
	function leaf_copy(leaf) {
	  var copy = {data: leaf.data}, next = copy;
	  while (leaf = leaf.next) next = next.next = {data: leaf.data};
	  return copy;
	}
	
	var treeProto = quadtree.prototype = Quadtree.prototype;
	
	treeProto.copy = function() {
	  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	      node = this._root,
	      nodes,
	      child;
	
	  if (!node) return copy;
	
	  if (!node.length) return copy._root = leaf_copy(node), copy;
	
	  nodes = [{source: node, target: copy._root = new Array(4)}];
	  while (node = nodes.pop()) {
	    for (var i = 0; i < 4; ++i) {
	      if (child = node.source[i]) {
	        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
	        else node.target[i] = leaf_copy(child);
	      }
	    }
	  }
	
	  return copy;
	};
	
	treeProto.add = tree_add;
	treeProto.addAll = addAll;
	treeProto.cover = tree_cover;
	treeProto.data = tree_data;
	treeProto.extent = tree_extent;
	treeProto.find = tree_find;
	treeProto.remove = tree_remove;
	treeProto.removeAll = removeAll;
	treeProto.root = tree_root;
	treeProto.size = tree_size;
	treeProto.visit = tree_visit;
	treeProto.visitAfter = tree_visitAfter;
	treeProto.x = tree_x;
	treeProto.y = tree_y;
	
	var slice$1 = [].slice;
	
	var noabort = {};
	
	function Queue(size) {
	  if (!(size >= 1)) throw new Error;
	  this._size = size;
	  this._call =
	  this._error = null;
	  this._tasks = [];
	  this._data = [];
	  this._waiting =
	  this._active =
	  this._ended =
	  this._start = 0; // inside a synchronous task callback?
	}
	
	Queue.prototype = queue.prototype = {
	  constructor: Queue,
	  defer: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    if (this._error != null) return this;
	    var t = slice$1.call(arguments, 1);
	    t.push(callback);
	    ++this._waiting, this._tasks.push(t);
	    poke(this);
	    return this;
	  },
	  abort: function() {
	    if (this._error == null) abort(this, new Error("abort"));
	    return this;
	  },
	  await: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
	    maybeNotify(this);
	    return this;
	  },
	  awaitAll: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    this._call = callback;
	    maybeNotify(this);
	    return this;
	  }
	};
	
	function poke(q) {
	  if (!q._start) {
	    try { start(q); } // let the current task complete
	    catch (e) {
	      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
	      else if (!q._data) throw e; // await callback errored synchronously
	    }
	  }
	}
	
	function start(q) {
	  while (q._start = q._waiting && q._active < q._size) {
	    var i = q._ended + q._active,
	        t = q._tasks[i],
	        j = t.length - 1,
	        c = t[j];
	    t[j] = end(q, i);
	    --q._waiting, ++q._active;
	    t = c.apply(null, t);
	    if (!q._tasks[i]) continue; // task finished synchronously
	    q._tasks[i] = t || noabort;
	  }
	}
	
	function end(q, i) {
	  return function(e, r) {
	    if (!q._tasks[i]) return; // ignore multiple callbacks
	    --q._active, ++q._ended;
	    q._tasks[i] = null;
	    if (q._error != null) return; // ignore secondary errors
	    if (e != null) {
	      abort(q, e);
	    } else {
	      q._data[i] = r;
	      if (q._waiting) poke(q);
	      else maybeNotify(q);
	    }
	  };
	}
	
	function abort(q, e) {
	  var i = q._tasks.length, t;
	  q._error = e; // ignore active callbacks
	  q._data = undefined; // allow gc
	  q._waiting = NaN; // prevent starting
	
	  while (--i >= 0) {
	    if (t = q._tasks[i]) {
	      q._tasks[i] = null;
	      if (t.abort) {
	        try { t.abort(); }
	        catch (e) { /* ignore */ }
	      }
	    }
	  }
	
	  q._active = NaN; // allow notification
	  maybeNotify(q);
	}
	
	function maybeNotify(q) {
	  if (!q._active && q._call) {
	    var d = q._data;
	    q._data = undefined; // allow gc
	    q._call(q._error, d);
	  }
	}
	
	function queue(concurrency) {
	  return new Queue(arguments.length ? +concurrency : Infinity);
	}
	
	var constant$2 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var epsilon$1 = 1e-12;
	var pi$2 = Math.PI;
	var halfPi$1 = pi$2 / 2;
	var tau$2 = 2 * pi$2;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi$1 : x <= -1 ? -halfPi$1 : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$2(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi$1,
	        a1 = endAngle.apply(this, arguments) - halfPi$1,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon$1)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau$2 - epsilon$1) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon$1) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon$1) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon$1) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon$1) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon$1) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon$1) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi$2) {
	          var oc = da0 > epsilon$1 ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon$1)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon$1) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon$1) || !(da0 > epsilon$1)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon$1) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$2 / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$2(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$2(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$2(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$2(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area$1 = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$2(0),
	      y1 = y,
	      defined = constant$2(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$2(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$2(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$2(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$2(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$2(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending$1 = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity$1 = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity$1,
	      sortValues = descending$1,
	      sort = null,
	      startAngle = constant$2(0),
	      endAngle = constant$2(tau$2),
	      padAngle = constant$2(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau$2, Math.max(-tau$2, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$2(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area$1().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi$2);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau$2);
	  }
	};
	
	var cross$1 = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi$2 / 10) / Math.sin(7 * pi$2 / 10);
	var kx = Math.sin(tau$2 / 10) * kr;
	var ky = -Math.cos(tau$2 / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau$2 * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross$1,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$2(circle),
	      size = constant$2(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$2(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$2(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon$1) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon$1) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice$2 = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$2([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$2(slice$2.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$2(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$2(slice$2.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending$1 = function(series) {
	  var sums = series.map(sum$1);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum$1(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$2 = function(series) {
	  return ascending$1(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum$1),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	function basis$1(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$2 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis$1((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed$1 = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis$1((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant$3 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear$1(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential$1(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential$1(a, b, y) : constant$3(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear$1(a, d) : constant$3(isNaN(a) ? b : a);
	}
	
	var interpolateRgb = (function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = color$$1(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$2);
	var rgbBasisClosed = rgbSpline(basisClosed$1);
	
	var array$1 = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var interpolateNumber = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = interpolate(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var interpolateString = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: interpolateNumber(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var interpolate = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant$3(b)
	      : (t === "number" ? interpolateNumber
	      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
	      : b instanceof color ? interpolateRgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array$1
	      : isNaN(b) ? object
	      : interpolateNumber)(a, b);
	};
	
	var interpolateRound = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity$2 = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity$2;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity$2;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var interpolateZoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = hsl(start)).h, (end = hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = hcl(start)).h, (end = hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = cubehelix(start)).h, (end = cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	var noop$1 = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set$2(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set$2(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set$2(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop$1, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	var dsv = function(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n]"),
	      delimiterCode = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns;
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var EOL = {}, // sentinel value for end-of-line
	        EOF = {}, // sentinel value for end-of-file
	        rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // the current line number
	        t, // the current token
	        eol; // is the current token followed by EOL?
	
	    function token() {
	      if (I >= N) return EOF; // special case: end of file
	      if (eol) return eol = false, EOL; // special case: end of line
	
	      // special case: quotes
	      var j = I, c;
	      if (text.charCodeAt(j) === 34) {
	        var i = j;
	        while (i++ < N) {
	          if (text.charCodeAt(i) === 34) {
	            if (text.charCodeAt(i + 1) !== 34) break;
	            ++i;
	          }
	        }
	        I = i + 2;
	        c = text.charCodeAt(i + 1);
	        if (c === 13) {
	          eol = true;
	          if (text.charCodeAt(i + 2) === 10) ++I;
	        } else if (c === 10) {
	          eol = true;
	        }
	        return text.slice(j + 1, i).replace(/""/g, "\"");
	      }
	
	      // common case: find next delimiter or newline
	      while (I < N) {
	        var k = 1;
	        c = text.charCodeAt(I++);
	        if (c === 10) eol = true; // \n
	        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
	        else if (c !== delimiterCode) continue;
	        return text.slice(j, I - k);
	      }
	
	      // special case: last token before EOF
	      return text.slice(j);
	    }
	
	    while ((t = token()) !== EOF) {
	      var a = [];
	      while (t !== EOL && t !== EOF) {
	        a.push(t);
	        t = token();
	      }
	      if (f && (a = f(a, n++)) == null) continue;
	      rows.push(a);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	};
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	var request = function(url, callback) {
	  var request,
	      event = dispatch("beforesend", "progress", "load", "error"),
	      mimeType,
	      headers = map$1(),
	      xhr = new XMLHttpRequest,
	      user = null,
	      password = null,
	      response,
	      responseType,
	      timeout = 0;
	
	  // If IE does not support CORS, use XDomainRequest.
	  if (typeof XDomainRequest !== "undefined"
	      && !("withCredentials" in xhr)
	      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
	
	  "onload" in xhr
	      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
	      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };
	
	  function respond(o) {
	    var status = xhr.status, result;
	    if (!status && hasResponse(xhr)
	        || status >= 200 && status < 300
	        || status === 304) {
	      if (response) {
	        try {
	          result = response.call(request, xhr);
	        } catch (e) {
	          event.call("error", request, e);
	          return;
	        }
	      } else {
	        result = xhr;
	      }
	      event.call("load", request, result);
	    } else {
	      event.call("error", request, o);
	    }
	  }
	
	  xhr.onprogress = function(e) {
	    event.call("progress", request, e);
	  };
	
	  request = {
	    header: function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers.get(name);
	      if (value == null) headers.remove(name);
	      else headers.set(name, value + "");
	      return request;
	    },
	
	    // If mimeType is non-null and no Accept header is set, a default is used.
	    mimeType: function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return request;
	    },
	
	    // Specifies what type the response value should take;
	    // for instance, arraybuffer, blob, document, or text.
	    responseType: function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return request;
	    },
	
	    timeout: function(value) {
	      if (!arguments.length) return timeout;
	      timeout = +value;
	      return request;
	    },
	
	    user: function(value) {
	      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
	    },
	
	    password: function(value) {
	      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
	    },
	
	    // Specify how to convert the response content to a specific type;
	    // changes the callback value on "load" events.
	    response: function(value) {
	      response = value;
	      return request;
	    },
	
	    // Alias for send("GET", …).
	    get: function(data, callback) {
	      return request.send("GET", data, callback);
	    },
	
	    // Alias for send("POST", …).
	    post: function(data, callback) {
	      return request.send("POST", data, callback);
	    },
	
	    // If callback is non-null, it will be used for error and load events.
	    send: function(method, data, callback) {
	      xhr.open(method, url, true, user, password);
	      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
	      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
	      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
	      if (responseType != null) xhr.responseType = responseType;
	      if (timeout > 0) xhr.timeout = timeout;
	      if (callback == null && typeof data === "function") callback = data, data = null;
	      if (callback != null && callback.length === 1) callback = fixCallback(callback);
	      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
	      event.call("beforesend", request, xhr);
	      xhr.send(data == null ? null : data);
	      return request;
	    },
	
	    abort: function() {
	      xhr.abort();
	      return request;
	    },
	
	    on: function() {
	      var value = event.on.apply(event, arguments);
	      return value === event ? request : value;
	    }
	  };
	
	  if (callback != null) {
	    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    return request.get(callback);
	  }
	
	  return request;
	};
	
	function fixCallback(callback) {
	  return function(error, xhr) {
	    callback(error == null ? xhr : null);
	  };
	}
	
	function hasResponse(xhr) {
	  var type = xhr.responseType;
	  return type && type !== "text"
	      ? xhr.response // null on error
	      : xhr.responseText; // "" on error
	}
	
	var type = function(defaultMimeType, response) {
	  return function(url, callback) {
	    var r = request(url).mimeType(defaultMimeType).response(response);
	    if (callback != null) {
	      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      return r.get(callback);
	    }
	    return r;
	  };
	};
	
	var html = type("text/html", function(xhr) {
	  return document.createRange().createContextualFragment(xhr.responseText);
	});
	
	var json = type("application/json", function(xhr) {
	  return JSON.parse(xhr.responseText);
	});
	
	var text = type("text/plain", function(xhr) {
	  return xhr.responseText;
	});
	
	var xml = type("application/xml", function(xhr) {
	  var xml = xhr.responseXML;
	  if (!xml) throw new Error("parse error");
	  return xml;
	});
	
	var dsv$1 = function(defaultMimeType, parse) {
	  return function(url, row, callback) {
	    if (arguments.length < 3) callback = row, row = null;
	    var r = request(url).mimeType(defaultMimeType);
	    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
	    r.row(row);
	    return callback ? r.get(callback) : r;
	  };
	};
	
	function responseOf(parse, row) {
	  return function(request$$1) {
	    return parse(request$$1.responseText, row);
	  };
	}
	
	var csv$1 = dsv$1("text/csv", csvParse);
	
	var tsv$1 = dsv$1("text/tab-separated-values", tsvParse);
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke$1() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow;
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, delay);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) interval = setInterval(poke$1, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	var t0$1 = new Date;
	var t1$1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0$1.setTime(+start), t1$1.setTime(+end);
	      floori(t0$1), floori(t1$1);
	      return Math.floor(count(t0$1, t1$1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent$1 = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	var formatSpecifier = function(specifier) {
	  return new FormatSpecifier(specifier);
	};
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var prefixes = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];
	
	function identity$3(x) {
	  return x;
	}
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
	      currency = locale.currency,
	      decimal = locale.decimal;
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? "%" : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Convert negative to positive, and compute the prefix.
	        // Note that -0 is not less than 0, but 1 / -0 is!
	        var valueNegative = (value < 0 || 1 / value < 0) && (value *= -1, true);
	
	        // Perform the initial formatting.
	        value = formatType(value, precision);
	
	        // If the original value was negative, it may be rounded to zero during
	        // formatting; treat this as (positive) zero.
	        if (valueNegative) {
	          i = -1, n = value.length;
	          valueNegative = false;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), (48 < c && c < 58)
	                || (type === "x" && 96 < c && c < 103)
	                || (type === "X" && 64 < c && c < 71)) {
	              valueNegative = true;
	              break;
	            }
	          }
	        }
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": return valuePrefix + value + valueSuffix + padding;
	        case "=": return valuePrefix + padding + value + valueSuffix;
	        case "^": return padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	      }
	      return padding + valuePrefix + value + valueSuffix;
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale$1;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.format = locale$1.format;
	  exports.formatPrefix = locale$1.formatPrefix;
	  return locale$1;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent$1(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
	};
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale$1(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + day.count(year(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(sunday.count(year(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(monday.count(year(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(utcSunday.count(utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(utcMonday.count(utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$2;
	
	
	
	
	
	defaultLocale$1({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale$1(definition) {
	  locale$2 = formatLocale$1(definition);
	  exports.timeFormat = locale$2.format;
	  exports.timeParse = locale$2.parse;
	  exports.utcFormat = locale$2.utcFormat;
	  exports.utcParse = locale$2.utcParse;
	  return locale$2;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	var array$2 = Array.prototype;
	
	var map$3 = array$2.map;
	var slice$3 = array$2.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range) {
	  var index = map$1(),
	      domain = [],
	      unknown = implicit;
	
	  range = range == null ? [] : slice$3.call(range);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = map$1();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice$3.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point$4() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant$4 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number$1 = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant$4(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = bisectRight(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$3.call(_, number$1), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice$3.call(_), interpolate$$1 = interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
	      return exports.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return exports.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = tickStep(start, stop, n);
	
	    if (step) {
	      step = tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear$2() {
	  var scale = continuous(deinterpolateLinear, interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear$2());
	  };
	
	  return linearish(scale);
	}
	
	function identity$4() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$3.call(_, number$1), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity$4().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant$4(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = exports.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant$4(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[bisectRight(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize$1() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice$3.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize$1()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold$1() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice$3.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond$1 = 1000;
	var durationMinute$1 = durationSecond$1 * 60;
	var durationHour$1 = durationMinute$1 * 60;
	var durationDay$1 = durationHour$1 * 24;
	var durationWeek$1 = durationDay$1 * 7;
	var durationMonth = durationDay$1 * 30;
	var durationYear = durationDay$1 * 365;
	
	function date$1(t) {
	  return new Date(t);
	}
	
	function number$2(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format) {
	  var scale = continuous(deinterpolateLinear, interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second$$1,  1,      durationSecond$1],
	    [second$$1,  5,  5 * durationSecond$1],
	    [second$$1, 15, 15 * durationSecond$1],
	    [second$$1, 30, 30 * durationSecond$1],
	    [minute$$1,  1,      durationMinute$1],
	    [minute$$1,  5,  5 * durationMinute$1],
	    [minute$$1, 15, 15 * durationMinute$1],
	    [minute$$1, 30, 30 * durationMinute$1],
	    [  hour$$1,  1,      durationHour$1  ],
	    [  hour$$1,  3,  3 * durationHour$1  ],
	    [  hour$$1,  6,  6 * durationHour$1  ],
	    [  hour$$1, 12, 12 * durationHour$1  ],
	    [   day$$1,  1,      durationDay$1   ],
	    [   day$$1,  2,  2 * durationDay$1   ],
	    [  week,  1,      durationWeek$1  ],
	    [ month$$1,  1,      durationMonth ],
	    [ month$$1,  3,  3 * durationMonth ],
	    [  year$$1,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second$$1(date) < date ? formatMillisecond
	        : minute$$1(date) < date ? formatSecond
	        : hour$$1(date) < date ? formatMinute
	        : day$$1(date) < date ? formatHour
	        : month$$1(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year$$1(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year$$1;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = tickStep(start, stop, interval);
	        interval = millisecond$$1;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$3.call(_, number$2)) : domain().map(date$1);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));
	
	var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
	
	var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
	
	var rainbow = cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	var namespace = function(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	};
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	var creator = function(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	};
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames$1(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	var selection_on = function(typename, value, capture) {
	  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	};
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	var sourceEvent = function() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	};
	
	var point$5 = function(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	};
	
	var mouse = function(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point$5(node, event);
	};
	
	function none$2() {}
	
	var selector = function(selector) {
	  return selector == null ? none$2 : function() {
	    return this.querySelector(selector);
	  };
	};
	
	var selection_select = function(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	function empty() {
	  return [];
	}
	
	var selectorAll = function(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	};
	
	var selection_selectAll = function(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	};
	
	var selection_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	};
	
	var sparse = function(update) {
	  return new Array(update.length);
	};
	
	var selection_enter = function() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	};
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	var constant$5 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	var selection_data = function(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant$5(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	};
	
	var selection_exit = function() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	};
	
	var selection_merge = function(selection) {
	
	  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	};
	
	var selection_order = function() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	};
	
	var selection_sort = function(compare) {
	  if (!compare) compare = ascending$2;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	};
	
	function ascending$2(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	var selection_call = function() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	};
	
	var selection_nodes = function() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	};
	
	var selection_node = function() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	};
	
	var selection_size = function() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	};
	
	var selection_empty = function() {
	  return !this.node();
	};
	
	var selection_each = function(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	};
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	var selection_attr = function(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	};
	
	var window = function(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	};
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	var selection_style = function(name, value, priority) {
	  var node;
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : window(node = this.node())
	          .getComputedStyle(node, null)
	          .getPropertyValue(name);
	};
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	var selection_property = function(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	};
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	var selection_classed = function(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	};
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	var selection_text = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	};
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	var selection_html = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	};
	
	function raise$1() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	var selection_raise = function() {
	  return this.each(raise$1);
	};
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	var selection_lower = function() {
	  return this.each(lower);
	};
	
	var selection_append = function(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	};
	
	function constantNull() {
	  return null;
	}
	
	var selection_insert = function(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	};
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	var selection_remove = function() {
	  return this.each(remove);
	};
	
	var selection_datum = function(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	};
	
	function dispatchEvent(node, type, params) {
	  var window$$1 = window(node),
	      event = window$$1.CustomEvent;
	
	  if (event) {
	    event = new event(type, params);
	  } else {
	    event = window$$1.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	var selection_dispatch = function(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	};
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	var select = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	};
	
	var selectAll = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	};
	
	var touch = function(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point$5(node, touch);
	    }
	  }
	
	  return null;
	};
	
	var touches = function(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point$5(node, touches[i]);
	  }
	
	  return points;
	};
	
	var emptyOn = dispatch("start", "end", "interrupt");
	var emptyTween = [];
	
	var CREATED = 0;
	var SCHEDULED = 1;
	var STARTING = 2;
	var STARTED = 3;
	var RUNNING = 4;
	var ENDING = 5;
	var ENDED = 6;
	
	var schedule = function(node, name, id, index, group, timing) {
	  var schedules = node.__transition;
	  if (!schedules) node.__transition = {};
	  else if (id in schedules) return;
	  create(node, id, {
	    name: name,
	    index: index, // For context during callback.
	    group: group, // For context during callback.
	    on: emptyOn,
	    tween: emptyTween,
	    time: timing.time,
	    delay: timing.delay,
	    duration: timing.duration,
	    ease: timing.ease,
	    timer: null,
	    state: CREATED
	  });
	};
	
	function init(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
	  return schedule;
	}
	
	function set$3(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
	  return schedule;
	}
	
	function get$1(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
	  return schedule;
	}
	
	function create(node, id, self) {
	  var schedules = node.__transition,
	      tween;
	
	  // Initialize the self timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  schedules[id] = self;
	  self.timer = timer(schedule, 0, self.time);
	
	  function schedule(elapsed) {
	    self.state = SCHEDULED;
	    self.timer.restart(start, self.delay, self.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (self.delay <= elapsed) start(elapsed - self.delay);
	  }
	
	  function start(elapsed) {
	    var i, j, n, o;
	
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (self.state !== SCHEDULED) return stop();
	
	    for (i in schedules) {
	      o = schedules[i];
	      if (o.name !== self.name) continue;
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (o.state === STARTED) return timeout$1(start);
	
	      // Interrupt the active transition, if any.
	      // Dispatch the interrupt event.
	      if (o.state === RUNNING) {
	        o.state = ENDED;
	        o.timer.stop();
	        o.on.call("interrupt", node, node.__data__, o.index, o.group);
	        delete schedules[i];
	      }
	
	      // Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	      else if (+i < id) {
	        o.state = ENDED;
	        o.timer.stop();
	        delete schedules[i];
	      }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    timeout$1(function() {
	      if (self.state === STARTED) {
	        self.state = RUNNING;
	        self.timer.restart(tick, self.delay, self.time);
	        tick(elapsed);
	      }
	    });
	
	    // Dispatch the start event.
	    // Note this must be done before the tween are initialized.
	    self.state = STARTING;
	    self.on.call("start", node, node.__data__, self.index, self.group);
	    if (self.state !== STARTING) return; // interrupted
	    self.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    tween = new Array(n = self.tween.length);
	    for (i = 0, j = -1; i < n; ++i) {
	      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
	        tween[++j] = o;
	      }
	    }
	    tween.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
	        i = -1,
	        n = tween.length;
	
	    while (++i < n) {
	      tween[i].call(null, t);
	    }
	
	    // Dispatch the end event.
	    if (self.state === ENDING) {
	      self.on.call("end", node, node.__data__, self.index, self.group);
	      stop();
	    }
	  }
	
	  function stop() {
	    self.state = ENDED;
	    self.timer.stop();
	    delete schedules[id];
	    for (var i in schedules) return; // eslint-disable-line no-unused-vars
	    delete node.__transition;
	  }
	}
	
	var interrupt = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      active,
	      empty = true,
	      i;
	
	  if (!schedules) return;
	
	  name = name == null ? null : name + "";
	
	  for (i in schedules) {
	    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
	    active = schedule.state > STARTING && schedule.state < ENDING;
	    schedule.state = ENDED;
	    schedule.timer.stop();
	    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
	    delete schedules[i];
	  }
	
	  if (empty) delete node.__transition;
	};
	
	var selection_interrupt = function(name) {
	  return this.each(function() {
	    interrupt(this, name);
	  });
	};
	
	function tweenRemove(id, name) {
	  var tween0, tween1;
	  return function() {
	    var schedule = set$3(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = tween0 = tween;
	      for (var i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1 = tween1.slice();
	          tween1.splice(i, 1);
	          break;
	        }
	      }
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	function tweenFunction(id, name, value) {
	  var tween0, tween1;
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    var schedule = set$3(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = (tween0 = tween).slice();
	      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1[i] = t;
	          break;
	        }
	      }
	      if (i === n) tween1.push(t);
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	var transition_tween = function(name, value) {
	  var id = this._id;
	
	  name += "";
	
	  if (arguments.length < 2) {
	    var tween = get$1(this.node(), id).tween;
	    for (var i = 0, n = tween.length, t; i < n; ++i) {
	      if ((t = tween[i]).name === name) {
	        return t.value;
	      }
	    }
	    return null;
	  }
	
	  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
	};
	
	function tweenValue(transition, name, value) {
	  var id = transition._id;
	
	  transition.each(function() {
	    var schedule = set$3(this, id);
	    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
	  });
	
	  return function(node) {
	    return get$1(node, id).value[name];
	  };
	}
	
	var interpolate$1 = function(a, b) {
	  var c;
	  return (typeof b === "number" ? interpolateNumber
	      : b instanceof color ? interpolateRgb
	      : (c = color(b)) ? (b = c, interpolateRgb)
	      : interpolateString)(a, b);
	};
	
	function attrRemove$1(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS$1(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant$1(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrConstantNS$1(fullname, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrFunction$1(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttribute(name);
	    value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function attrFunctionNS$1(fullname, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
	    value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_attr = function(name, value) {
	  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
	  return this.attrTween(name, typeof value === "function"
	      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
	      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
	      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value));
	};
	
	function attrTweenNS(fullname, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttributeNS(fullname.space, fullname.local, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	function attrTween(name, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttribute(name, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_attrTween = function(name, value) {
	  var key = "attr." + name;
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  var fullname = namespace(name);
	  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
	};
	
	function delayFunction(id, value) {
	  return function() {
	    init(this, id).delay = +value.apply(this, arguments);
	  };
	}
	
	function delayConstant(id, value) {
	  return value = +value, function() {
	    init(this, id).delay = value;
	  };
	}
	
	var transition_delay = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? delayFunction
	          : delayConstant)(id, value))
	      : get$1(this.node(), id).delay;
	};
	
	function durationFunction(id, value) {
	  return function() {
	    set$3(this, id).duration = +value.apply(this, arguments);
	  };
	}
	
	function durationConstant(id, value) {
	  return value = +value, function() {
	    set$3(this, id).duration = value;
	  };
	}
	
	var transition_duration = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? durationFunction
	          : durationConstant)(id, value))
	      : get$1(this.node(), id).duration;
	};
	
	function easeConstant(id, value) {
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    set$3(this, id).ease = value;
	  };
	}
	
	var transition_ease = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each(easeConstant(id, value))
	      : get$1(this.node(), id).ease;
	};
	
	var transition_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, this._name, this._id);
	};
	
	var transition_merge = function(transition) {
	  if (transition._id !== this._id) throw new Error;
	
	  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Transition(merges, this._parents, this._name, this._id);
	};
	
	function start$1(name) {
	  return (name + "").trim().split(/^|\s+/).every(function(t) {
	    var i = t.indexOf(".");
	    if (i >= 0) t = t.slice(0, i);
	    return !t || t === "start";
	  });
	}
	
	function onFunction(id, name, listener) {
	  var on0, on1, sit = start$1(name) ? init : set$3;
	  return function() {
	    var schedule = sit(this, id),
	        on = schedule.on;
	
	    // If this node shared a dispatch with the previous node,
	    // just assign the updated shared dispatch and we’re done!
	    // Otherwise, copy-on-write.
	    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
	
	    schedule.on = on1;
	  };
	}
	
	var transition_on = function(name, listener) {
	  var id = this._id;
	
	  return arguments.length < 2
	      ? get$1(this.node(), id).on.on(name)
	      : this.each(onFunction(id, name, listener));
	};
	
	function removeFunction(id) {
	  return function() {
	    var parent = this.parentNode;
	    for (var i in this.__transition) if (+i !== id) return;
	    if (parent) parent.removeChild(this);
	  };
	}
	
	var transition_remove = function() {
	  return this.on("end.remove", removeFunction(this._id));
	};
	
	var transition_select = function(select$$1) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select$$1 !== "function") select$$1 = selector(select$$1);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select$$1.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, name, id);
	};
	
	var transition_selectAll = function(select$$1) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select$$1 !== "function") select$$1 = selectorAll(select$$1);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        for (var children = select$$1.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
	          if (child = children[k]) {
	            schedule(child, name, id, k, children, inherit);
	          }
	        }
	        subgroups.push(children);
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, parents, name, id);
	};
	
	var Selection$1 = selection.prototype.constructor;
	
	var transition_selection = function() {
	  return new Selection$1(this._groups, this._parents);
	};
	
	function styleRemove$1(name, interpolate$$1) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var style = window(this).getComputedStyle(this, null),
	        value0 = style.getPropertyValue(name),
	        value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function styleRemoveEnd(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant$1(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = window(this).getComputedStyle(this, null).getPropertyValue(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function styleFunction$1(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var style = window(this).getComputedStyle(this, null),
	        value0 = style.getPropertyValue(name),
	        value1 = value(this);
	    if (value1 == null) value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_style = function(name, value, priority) {
	  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
	  return value == null ? this
	          .styleTween(name, styleRemove$1(name, i))
	          .on("end.style." + name, styleRemoveEnd(name))
	      : this.styleTween(name, typeof value === "function"
	          ? styleFunction$1(name, i, tweenValue(this, "style." + name, value))
	          : styleConstant$1(name, i, value), priority);
	};
	
	function styleTween(name, value, priority) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.style.setProperty(name, i(t), priority);
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_styleTween = function(name, value, priority) {
	  var key = "style." + (name += "");
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
	};
	
	function textConstant$1(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction$1(value) {
	  return function() {
	    var value1 = value(this);
	    this.textContent = value1 == null ? "" : value1;
	  };
	}
	
	var transition_text = function(value) {
	  return this.tween("text", typeof value === "function"
	      ? textFunction$1(tweenValue(this, "text", value))
	      : textConstant$1(value == null ? "" : value + ""));
	};
	
	var transition_transition = function() {
	  var name = this._name,
	      id0 = this._id,
	      id1 = newId();
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        var inherit = get$1(node, id0);
	        schedule(node, name, id1, i, group, {
	          time: inherit.time + inherit.delay + inherit.duration,
	          delay: 0,
	          duration: inherit.duration,
	          ease: inherit.ease
	        });
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id1);
	};
	
	var id = 0;
	
	function Transition(groups, parents, name, id) {
	  this._groups = groups;
	  this._parents = parents;
	  this._name = name;
	  this._id = id;
	}
	
	function transition(name) {
	  return selection().transition(name);
	}
	
	function newId() {
	  return ++id;
	}
	
	var selection_prototype = selection.prototype;
	
	Transition.prototype = transition.prototype = {
	  constructor: Transition,
	  select: transition_select,
	  selectAll: transition_selectAll,
	  filter: transition_filter,
	  merge: transition_merge,
	  selection: transition_selection,
	  transition: transition_transition,
	  call: selection_prototype.call,
	  nodes: selection_prototype.nodes,
	  node: selection_prototype.node,
	  size: selection_prototype.size,
	  empty: selection_prototype.empty,
	  each: selection_prototype.each,
	  on: transition_on,
	  attr: transition_attr,
	  attrTween: transition_attrTween,
	  style: transition_style,
	  styleTween: transition_styleTween,
	  text: transition_text,
	  remove: transition_remove,
	  tween: transition_tween,
	  delay: transition_delay,
	  duration: transition_duration,
	  ease: transition_ease
	};
	
	var defaultTiming = {
	  time: null, // Set on use.
	  delay: 0,
	  duration: 250,
	  ease: cubicInOut
	};
	
	function inherit(node, id) {
	  var timing;
	  while (!(timing = node.__transition) || !(timing = timing[id])) {
	    if (!(node = node.parentNode)) {
	      return defaultTiming.time = now(), defaultTiming;
	    }
	  }
	  return timing;
	}
	
	var selection_transition = function(name) {
	  var id,
	      timing;
	
	  if (name instanceof Transition) {
	    id = name._id, name = name._name;
	  } else {
	    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
	  }
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        schedule(node, name, id, i, group, timing || inherit(node, id));
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id);
	};
	
	selection.prototype.interrupt = selection_interrupt;
	selection.prototype.transition = selection_transition;
	
	var root$1 = [null];
	
	var active = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      i;
	
	  if (schedules) {
	    name = name == null ? null : name + "";
	    for (i in schedules) {
	      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
	        return new Transition([[node]], root$1, name, +i);
	      }
	    }
	  }
	
	  return null;
	};
	
	var slice$4 = Array.prototype.slice;
	
	var identity$5 = function(x) {
	  return x;
	};
	
	var top = 1;
	var right = 2;
	var bottom = 3;
	var left = 4;
	var epsilon$2 = 1e-6;
	
	function translateX(scale0, scale1, d) {
	  var x = scale0(d);
	  return "translate(" + (isFinite(x) ? x : scale1(d)) + ",0)";
	}
	
	function translateY(scale0, scale1, d) {
	  var y = scale0(d);
	  return "translate(0," + (isFinite(y) ? y : scale1(d)) + ")";
	}
	
	function center(scale) {
	  var offset = scale.bandwidth() / 2;
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$5) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        transform = orient === top || orient === bottom ? translateX : translateY,
	        range = scale.range(),
	        range0 = range[0] + 0.5,
	        range1 = range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : identity$5)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text"),
	        k = orient === top || orient === left ? -1 : 1,
	        x, y = orient === left || orient === right ? (x = "x", "y") : (x = "y", "x");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "#000")
	        .attr(x + "2", k * tickSizeInner)
	        .attr(y + "1", 0.5)
	        .attr(y + "2", 0.5));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "#000")
	        .attr(x, k * spacing)
	        .attr(y, 0.5)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon$2)
	          .attr("transform", function(d) { return transform(position, this.parentNode.__axis || position, d); });
	
	      tickEnter
	          .attr("opacity", epsilon$2)
	          .attr("transform", function(d) { return transform(this.parentNode.__axis || position, position, d); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position, position, d); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice$4.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice$4.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice$4.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	};
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	};
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	};
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	};
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	function Node$2(value) {
	  this._ = value;
	  this.next = null;
	}
	
	var shuffle$1 = function(array) {
	  var i,
	      n = (array = array.slice()).length,
	      head = null,
	      node = head;
	
	  while (n) {
	    var next = new Node$2(array[n - 1]);
	    if (node) node = node.next = next;
	    else node = head = next;
	    array[i] = array[--n];
	  }
	
	  return {
	    head: head,
	    tail: node
	  };
	};
	
	var enclose = function(circles) {
	  return encloseN(shuffle$1(circles), []);
	};
	
	function encloses(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r - b.r;
	  return dr * dr + 1e-6 > dx * dx + dy * dy;
	}
	
	// Returns the smallest circle that contains circles L and intersects circles B.
	function encloseN(L, B) {
	  var circle,
	      l0 = null,
	      l1 = L.head,
	      l2,
	      p1;
	
	  switch (B.length) {
	    case 1: circle = enclose1(B[0]); break;
	    case 2: circle = enclose2(B[0], B[1]); break;
	    case 3: circle = enclose3(B[0], B[1], B[2]); break;
	  }
	
	  while (l1) {
	    p1 = l1._, l2 = l1.next;
	    if (!circle || !encloses(circle, p1)) {
	
	      // Temporarily truncate L before l1.
	      if (l0) L.tail = l0, l0.next = null;
	      else L.head = L.tail = null;
	
	      B.push(p1);
	      circle = encloseN(L, B); // Note: reorders L!
	      B.pop();
	
	      // Move l1 to the front of L and reconnect the truncated list L.
	      if (L.head) l1.next = L.head, L.head = l1;
	      else l1.next = null, L.head = L.tail = l1;
	      l0 = L.tail, l0.next = l2;
	
	    } else {
	      l0 = l1;
	    }
	    l1 = l2;
	  }
	
	  L.tail = l0;
	  return circle;
	}
	
	function enclose1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function enclose2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function enclose3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = 2 * (x1 - x2),
	      b2 = 2 * (y1 - y2),
	      c2 = 2 * (r2 - r1),
	      d2 = x1 * x1 + y1 * y1 - r1 * r1 - x2 * x2 - y2 * y2 + r2 * r2,
	      a3 = 2 * (x1 - x3),
	      b3 = 2 * (y1 - y3),
	      c3 = 2 * (r3 - r1),
	      d3 = x1 * x1 + y1 * y1 - r1 * r1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / ab - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / ab - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (xa * xb + ya * yb + r1),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
	  return {
	    x: xa + xb * r + x1,
	    y: ya + yb * r + y1,
	    r: r
	  };
	}
	
	function place(a, b, c) {
	  var ax = a.x,
	      ay = a.y,
	      da = b.r + c.r,
	      db = a.r + c.r,
	      dx = b.x - ax,
	      dy = b.y - ay,
	      dc = dx * dx + dy * dy;
	  if (dc) {
	    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
	        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	    c.x = ax + x * dx + y * dy;
	    c.y = ay + x * dy - y * dx;
	  } else {
	    c.x = ax + db;
	    c.y = ay;
	  }
	}
	
	function intersects(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r + b.r;
	  return dr * dr > dx * dx + dy * dy;
	}
	
	function distance2(circle, x, y) {
	  var dx = circle.x - x,
	      dy = circle.y - y;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the weighted centroid.
	  var aa = a.r * a.r,
	      ba = b.r * b.r,
	      ca = c.r * c.r,
	      oa = aa + ba + ca,
	      ox = aa * a.x + ba * b.x + ca * c.x,
	      oy = aa * a.y + ba * b.y + ca * c.y,
	      cx, cy, i, j, k, sj, sk;
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // If there are only three elements in the front-chain…
	    if ((k = a.previous) === (j = b.next)) {
	      // If the new circle intersects the third circle,
	      // rotate the front chain to try the next position.
	      if (intersects(j._, c._)) {
	        a = b, b = j, --i;
	        continue pack;
	      }
	    }
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    else {
	      sj = j._.r, sk = k._.r;
	      do {
	        if (sj <= sk) {
	          if (intersects(j._, c._)) {
	            b = j, a.next = b, b.previous = a, --i;
	            continue pack;
	          }
	          j = j.next, sj += j._.r;
	        } else {
	          if (intersects(k._, c._)) {
	            a = k, a.next = b, b.previous = a, --i;
	            continue pack;
	          }
	          k = k.previous, sk += k._.r;
	        }
	      } while (j !== k.next);
	    }
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Update the weighted centroid.
	    oa += ca = c._.r * c._.r;
	    ox += ca * c._.x;
	    oy += ca * c._.y;
	
	    // Compute the new closest circle a to centroid.
	    aa = distance2(a._, cx = ox / oa, cy = oy / oa);
	    while ((c = c.next) !== b) {
	      if ((ca = distance2(c._, cx, cy)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant$6 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	var index = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant$6(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var keyPrefix$1 = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix$1 + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix$1 + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	};
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = (function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	})(phi);
	
	var index$1 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$6(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$6(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$6(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$6(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$6(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((y1 - y0) > (x1 - x0)) {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    } else {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    }
	  }
	};
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	};
	
	var resquarify = (function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	})(phi);
	
	var center$1 = function(x, y) {
	  var nodes;
	
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force() {
	    var i,
	        n = nodes.length,
	        node,
	        sx = 0,
	        sy = 0;
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], sx += node.x, sy += node.y;
	    }
	
	    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	      node = nodes[i], node.x -= sx, node.y -= sy;
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	};
	
	var constant$7 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var jiggle = function() {
	  return (Math.random() - 0.5) * 1e-6;
	};
	
	function x$1(d) {
	  return d.x + d.vx;
	}
	
	function y$1(d) {
	  return d.y + d.vy;
	}
	
	var collide = function(radius) {
	  var nodes,
	      radii,
	      strength = 1,
	      iterations = 1;
	
	  if (typeof radius !== "function") radius = constant$7(radius == null ? 1 : +radius);
	
	  function force() {
	    var i, n = nodes.length,
	        tree,
	        node,
	        xi,
	        yi,
	        ri,
	        ri2;
	
	    for (var k = 0; k < iterations; ++k) {
	      tree = quadtree(nodes, x$1, y$1).visitAfter(prepare);
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        ri = radii[node.index], ri2 = ri * ri;
	        xi = node.x + node.vx;
	        yi = node.y + node.vy;
	        tree.visit(apply);
	      }
	    }
	
	    function apply(quad, x0, y0, x1, y1) {
	      var data = quad.data, rj = quad.r, r = ri + rj;
	      if (data) {
	        if (data.index > node.index) {
	          var x = xi - data.x - data.vx,
	              y = yi - data.y - data.vy,
	              l = x * x + y * y;
	          if (l < r * r) {
	            if (x === 0) x = jiggle(), l += x * x;
	            if (y === 0) y = jiggle(), l += y * y;
	            l = (r - (l = Math.sqrt(l))) / l * strength;
	            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	            node.vy += (y *= l) * r;
	            data.vx -= x * (r = 1 - r);
	            data.vy -= y * r;
	          }
	        }
	        return;
	      }
	      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	    }
	  }
	
	  function prepare(quad) {
	    if (quad.data) return quad.r = radii[quad.data.index];
	    for (var i = quad.r = 0; i < 4; ++i) {
	      if (quad[i] && quad[i].r > quad.r) {
	        quad.r = quad[i].r;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    radii = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = +_, force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : radius;
	  };
	
	  return force;
	};
	
	function index$2(d) {
	  return d.index;
	}
	
	function find(nodeById, nodeId) {
	  var node = nodeById.get(nodeId);
	  if (!node) throw new Error("missing: " + nodeId);
	  return node;
	}
	
	var link = function(links) {
	  var id = index$2,
	      strength = defaultStrength,
	      strengths,
	      distance = constant$7(30),
	      distances,
	      nodes,
	      count,
	      bias,
	      iterations = 1;
	
	  if (links == null) links = [];
	
	  function defaultStrength(link) {
	    return 1 / Math.min(count[link.source.index], count[link.target.index]);
	  }
	
	  function force(alpha) {
	    for (var k = 0, n = links.length; k < iterations; ++k) {
	      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	        link = links[i], source = link.source, target = link.target;
	        x = target.x + target.vx - source.x - source.vx || jiggle();
	        y = target.y + target.vy - source.y - source.vy || jiggle();
	        l = Math.sqrt(x * x + y * y);
	        l = (l - distances[i]) / l * alpha * strengths[i];
	        x *= l, y *= l;
	        target.vx -= x * (b = bias[i]);
	        target.vy -= y * b;
	        source.vx += x * (b = 1 - b);
	        source.vy += y * b;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	
	    var i,
	        n = nodes.length,
	        m = links.length,
	        nodeById = map$1(nodes, id),
	        link;
	
	    for (i = 0, count = new Array(n); i < m; ++i) {
	      link = links[i], link.index = i;
	      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
	      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
	      count[link.source.index] = (count[link.source.index] || 0) + 1;
	      count[link.target.index] = (count[link.target.index] || 0) + 1;
	    }
	
	    for (i = 0, bias = new Array(m); i < m; ++i) {
	      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	    }
	
	    strengths = new Array(m), initializeStrength();
	    distances = new Array(m), initializeDistance();
	  }
	
	  function initializeStrength() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      strengths[i] = +strength(links[i], i, links);
	    }
	  }
	
	  function initializeDistance() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      distances[i] = +distance(links[i], i, links);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.links = function(_) {
	    return arguments.length ? (links = _, initialize(), force) : links;
	  };
	
	  force.id = function(_) {
	    return arguments.length ? (id = _, force) : id;
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initializeStrength(), force) : strength;
	  };
	
	  force.distance = function(_) {
	    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$7(+_), initializeDistance(), force) : distance;
	  };
	
	  return force;
	};
	
	function x$2(d) {
	  return d.x;
	}
	
	function y$2(d) {
	  return d.y;
	}
	
	var initialRadius = 10;
	var initialAngle = Math.PI * (3 - Math.sqrt(5));
	
	var simulation = function(nodes) {
	  var simulation,
	      alpha = 1,
	      alphaMin = 0.001,
	      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
	      alphaTarget = 0,
	      velocityDecay = 0.6,
	      forces = map$1(),
	      stepper = timer(step),
	      event = dispatch("tick", "end");
	
	  if (nodes == null) nodes = [];
	
	  function step() {
	    tick();
	    event.call("tick", simulation);
	    if (alpha < alphaMin) {
	      stepper.stop();
	      event.call("end", simulation);
	    }
	  }
	
	  function tick() {
	    var i, n = nodes.length, node;
	
	    alpha += (alphaTarget - alpha) * alphaDecay;
	
	    forces.each(function(force) {
	      force(alpha);
	    });
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i];
	      if (node.fx == null) node.x += node.vx *= velocityDecay;
	      else node.x = node.fx, node.vx = 0;
	      if (node.fy == null) node.y += node.vy *= velocityDecay;
	      else node.y = node.fy, node.vy = 0;
	    }
	  }
	
	  function initializeNodes() {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.index = i;
	      if (isNaN(node.x) || isNaN(node.y)) {
	        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	        node.x = radius * Math.cos(angle);
	        node.y = radius * Math.sin(angle);
	      }
	      if (isNaN(node.vx) || isNaN(node.vy)) {
	        node.vx = node.vy = 0;
	      }
	    }
	  }
	
	  function initializeForce(force) {
	    if (force.initialize) force.initialize(nodes);
	    return force;
	  }
	
	  initializeNodes();
	
	  return simulation = {
	    tick: tick,
	
	    restart: function() {
	      return stepper.restart(step), simulation;
	    },
	
	    stop: function() {
	      return stepper.stop(), simulation;
	    },
	
	    nodes: function(_) {
	      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
	    },
	
	    alpha: function(_) {
	      return arguments.length ? (alpha = +_, simulation) : alpha;
	    },
	
	    alphaMin: function(_) {
	      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
	    },
	
	    alphaDecay: function(_) {
	      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
	    },
	
	    alphaTarget: function(_) {
	      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
	    },
	
	    velocityDecay: function(_) {
	      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
	    },
	
	    force: function(name, _) {
	      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
	    },
	
	    find: function(x, y, radius) {
	      var i = 0,
	          n = nodes.length,
	          dx,
	          dy,
	          d2,
	          node,
	          closest;
	
	      if (radius == null) radius = Infinity;
	      else radius *= radius;
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        dx = x - node.x;
	        dy = y - node.y;
	        d2 = dx * dx + dy * dy;
	        if (d2 < radius) closest = node, radius = d2;
	      }
	
	      return closest;
	    },
	
	    on: function(name, _) {
	      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	    }
	  };
	};
	
	var manyBody = function() {
	  var nodes,
	      node,
	      alpha,
	      strength = constant$7(-30),
	      strengths,
	      distanceMin2 = 1,
	      distanceMax2 = Infinity,
	      theta2 = 0.81;
	
	  function force(_) {
	    var i, n = nodes.length, tree = quadtree(nodes, x$2, y$2).visitAfter(accumulate);
	    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length, node;
	    strengths = new Array(n);
	    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
	  }
	
	  function accumulate(quad) {
	    var strength = 0, q, c, x$$1, y$$1, i;
	
	    // For internal nodes, accumulate forces from child quadrants.
	    if (quad.length) {
	      for (x$$1 = y$$1 = i = 0; i < 4; ++i) {
	        if ((q = quad[i]) && (c = q.value)) {
	          strength += c, x$$1 += c * q.x, y$$1 += c * q.y;
	        }
	      }
	      quad.x = x$$1 / strength;
	      quad.y = y$$1 / strength;
	    }
	
	    // For leaf nodes, accumulate forces from coincident quadrants.
	    else {
	      q = quad;
	      q.x = q.data.x;
	      q.y = q.data.y;
	      do strength += strengths[q.data.index];
	      while (q = q.next);
	    }
	
	    quad.value = strength;
	  }
	
	  function apply(quad, x1, _, x2) {
	    if (!quad.value) return true;
	
	    var x$$1 = quad.x - node.x,
	        y$$1 = quad.y - node.y,
	        w = x2 - x1,
	        l = x$$1 * x$$1 + y$$1 * y$$1;
	
	    // Apply the Barnes-Hut approximation if possible.
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (w * w / theta2 < l) {
	      if (l < distanceMax2) {
	        if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
	        if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	        node.vx += x$$1 * quad.value * alpha / l;
	        node.vy += y$$1 * quad.value * alpha / l;
	      }
	      return true;
	    }
	
	    // Otherwise, process points directly.
	    else if (quad.length || l >= distanceMax2) return;
	
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (quad.data !== node || quad.next) {
	      if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
	      if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
	      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	    }
	
	    do if (quad.data !== node) {
	      w = strengths[quad.data.index] * alpha / l;
	      node.vx += x$$1 * w;
	      node.vy += y$$1 * w;
	    } while (quad = quad.next);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.distanceMin = function(_) {
	    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	  };
	
	  force.distanceMax = function(_) {
	    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	  };
	
	  force.theta = function(_) {
	    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	  };
	
	  return force;
	};
	
	var x$3 = function(x) {
	  var strength = constant$7(0.1),
	      nodes,
	      strengths,
	      xz;
	
	  if (typeof x !== "function") x = constant$7(x == null ? 0 : +x);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    xz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : x;
	  };
	
	  return force;
	};
	
	var y$3 = function(y) {
	  var strength = constant$7(0.1),
	      nodes,
	      strengths,
	      yz;
	
	  if (typeof y !== "function") y = constant$7(y == null ? 0 : +y);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    yz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : y;
	  };
	
	  return force;
	};
	
	function nopropagation() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	var dragDisable = function(view) {
	  var root = view.document.documentElement,
	      selection$$1 = select(view).on("dragstart.drag", noevent, true);
	  if ("onselectstart" in root) {
	    selection$$1.on("selectstart.drag", noevent, true);
	  } else {
	    root.__noselect = root.style.MozUserSelect;
	    root.style.MozUserSelect = "none";
	  }
	};
	
	function yesdrag(view, noclick) {
	  var root = view.document.documentElement,
	      selection$$1 = select(view).on("dragstart.drag", null);
	  if (noclick) {
	    selection$$1.on("click.drag", noevent, true);
	    setTimeout(function() { selection$$1.on("click.drag", null); }, 0);
	  }
	  if ("onselectstart" in root) {
	    selection$$1.on("selectstart.drag", null);
	  } else {
	    root.style.MozUserSelect = root.__noselect;
	    delete root.__noselect;
	  }
	}
	
	var constant$8 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
	  this.target = target;
	  this.type = type;
	  this.subject = subject;
	  this.identifier = id;
	  this.active = active;
	  this.x = x;
	  this.y = y;
	  this.dx = dx;
	  this.dy = dy;
	  this._ = dispatch;
	}
	
	DragEvent.prototype.on = function() {
	  var value = this._.on.apply(this._, arguments);
	  return value === this._ ? this : value;
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !exports.event.button;
	}
	
	function defaultContainer() {
	  return this.parentNode;
	}
	
	function defaultSubject(d) {
	  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
	}
	
	var drag = function() {
	  var filter = defaultFilter,
	      container = defaultContainer,
	      subject = defaultSubject,
	      gestures = {},
	      listeners = dispatch("start", "drag", "end"),
	      active = 0,
	      mousemoving,
	      touchending;
	
	  function drag(selection$$1) {
	    selection$$1
	        .on("mousedown.drag", mousedowned)
	        .on("touchstart.drag", touchstarted)
	        .on("touchmove.drag", touchmoved)
	        .on("touchend.drag touchcancel.drag", touchended)
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
	    if (!gesture) return;
	    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
	    dragDisable(exports.event.view);
	    nopropagation();
	    mousemoving = false;
	    gesture("start");
	  }
	
	  function mousemoved() {
	    noevent();
	    mousemoving = true;
	    gestures.mouse("drag");
	  }
	
	  function mouseupped() {
	    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
	    yesdrag(exports.event.view, mousemoving);
	    noevent();
	    gestures.mouse("end");
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var touches$$1 = exports.event.changedTouches,
	        c = container.apply(this, arguments),
	        n = touches$$1.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = beforestart(touches$$1[i].identifier, c, touch, this, arguments)) {
	        nopropagation();
	        gesture("start");
	      }
	    }
	  }
	
	  function touchmoved() {
	    var touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches$$1[i].identifier]) {
	        noevent();
	        gesture("drag");
	      }
	    }
	  }
	
	  function touchended() {
	    var touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, gesture;
	
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches$$1[i].identifier]) {
	        nopropagation();
	        gesture("end");
	      }
	    }
	  }
	
	  function beforestart(id, container, point, that, args) {
	    var p = point(container, id), s, dx, dy,
	        sublisteners = listeners.copy();
	
	    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
	      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
	      dx = s.x - p[0] || 0;
	      dy = s.y - p[1] || 0;
	      return true;
	    })) return;
	
	    return function gesture(type) {
	      var p0 = p, n;
	      switch (type) {
	        case "start": gestures[id] = gesture, n = active++; break;
	        case "end": delete gestures[id], --active; // nobreak
	        case "drag": p = point(container, id), n = active; break;
	      }
	      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
	    };
	  }
	
	  drag.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$8(!!_), drag) : filter;
	  };
	
	  drag.container = function(_) {
	    return arguments.length ? (container = typeof _ === "function" ? _ : constant$8(_), drag) : container;
	  };
	
	  drag.subject = function(_) {
	    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$8(_), drag) : subject;
	  };
	
	  drag.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? drag : value;
	  };
	
	  return drag;
	};
	
	var constant$9 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x$4(d) {
	  return d[0];
	}
	
	function y$4(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$3
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$3)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon$3 || Math.abs(endY - startY) > epsilon$3) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon$3 && y1 - endY > epsilon$3 ? [x0, Math.abs(startX - x0) < epsilon$3 ? startY : y1]
	              : Math.abs(endY - y1) < epsilon$3 && x1 - endX > epsilon$3 ? [Math.abs(startY - y1) < epsilon$3 ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon$3 && endY - y0 > epsilon$3 ? [x1, Math.abs(startX - x1) < epsilon$3 ? startY : y0]
	              : Math.abs(endY - y0) < epsilon$3 && endX - x0 > epsilon$3 ? [Math.abs(startY - y0) < epsilon$3 ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2$1) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon$3
	      && Math.abs(y - lArc.circle.cy) < epsilon$3) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon$3
	      && Math.abs(y - rArc.circle.cy) < epsilon$3) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon$3) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon$3) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon$3) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon$3) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon$3 = 1e-6;
	var epsilon2$1 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      var site = cell.site,
	          halfedges = cell.halfedges,
	          j = -1,
	          m = halfedges.length,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this,
	        i0, i1 = that._found || 0,
	        cell = that.cells[i1] || that.cells[i1 = 0],
	        dx = x - cell.site[0],
	        dy = y - cell.site[1],
	        d2 = dx * dx + dy * dy;
	
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0],
	            vy = y - v[1],
	            v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x$$1 = x$4,
	      y$$1 = y$4,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon$3) * epsilon$3, Math.round(y$$1(d, i, data) / epsilon$3) * epsilon$3];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$9(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$9(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	var constant$10 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function ZoomEvent(target, type, transform) {
	  this.target = target;
	  this.type = type;
	  this.transform = transform;
	}
	
	function Transform(k, x, y) {
	  this.k = k;
	  this.x = x;
	  this.y = y;
	}
	
	Transform.prototype = {
	  constructor: Transform,
	  scale: function(k) {
	    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
	  },
	  translate: function(x, y) {
	    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
	  },
	  apply: function(point) {
	    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
	  },
	  applyX: function(x) {
	    return x * this.k + this.x;
	  },
	  applyY: function(y) {
	    return y * this.k + this.y;
	  },
	  invert: function(location) {
	    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
	  },
	  invertX: function(x) {
	    return (x - this.x) / this.k;
	  },
	  invertY: function(y) {
	    return (y - this.y) / this.k;
	  },
	  rescaleX: function(x) {
	    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
	  },
	  rescaleY: function(y) {
	    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
	  },
	  toString: function() {
	    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
	  }
	};
	
	var identity$6 = new Transform(1, 0, 0);
	
	transform.prototype = Transform.prototype;
	
	function transform(node) {
	  return node.__zoom || identity$6;
	}
	
	function nopropagation$1() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent$1 = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter$1() {
	  return !exports.event.button;
	}
	
	function defaultExtent() {
	  var e = this, w, h;
	  if (e instanceof SVGElement) {
	    e = e.ownerSVGElement || e;
	    w = e.width.baseVal.value;
	    h = e.height.baseVal.value;
	  } else {
	    w = e.clientWidth;
	    h = e.clientHeight;
	  }
	  return [[0, 0], [w, h]];
	}
	
	function defaultTransform() {
	  return this.__zoom || identity$6;
	}
	
	var zoom = function() {
	  var filter = defaultFilter$1,
	      extent = defaultExtent,
	      k0 = 0,
	      k1 = Infinity,
	      x0 = -k1,
	      x1 = k1,
	      y0 = x0,
	      y1 = x1,
	      duration = 250,
	      interpolate$$1 = interpolateZoom,
	      gestures = [],
	      listeners = dispatch("start", "zoom", "end"),
	      touchstarting,
	      touchending,
	      touchDelay = 500,
	      wheelDelay = 150;
	
	  function zoom(selection$$1) {
	    selection$$1
	        .on("wheel.zoom", wheeled)
	        .on("mousedown.zoom", mousedowned)
	        .on("dblclick.zoom", dblclicked)
	        .on("touchstart.zoom", touchstarted)
	        .on("touchmove.zoom", touchmoved)
	        .on("touchend.zoom touchcancel.zoom", touchended)
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	        .property("__zoom", defaultTransform);
	  }
	
	  zoom.transform = function(collection, transform) {
	    var selection$$1 = collection.selection ? collection.selection() : collection;
	    selection$$1.property("__zoom", defaultTransform);
	    if (collection !== selection$$1) {
	      schedule(collection, transform);
	    } else {
	      selection$$1.interrupt().each(function() {
	        gesture(this, arguments)
	            .start()
	            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
	            .end();
	      });
	    }
	  };
	
	  zoom.scaleBy = function(selection$$1, k) {
	    zoom.scaleTo(selection$$1, function() {
	      var k0 = this.__zoom.k,
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return k0 * k1;
	    });
	  };
	
	  zoom.scaleTo = function(selection$$1, k) {
	    zoom.transform(selection$$1, function() {
	      var e = extent.apply(this, arguments),
	          t0 = this.__zoom,
	          p0 = centroid(e),
	          p1 = t0.invert(p0),
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return constrain(translate(scale(t0, k1), p0, p1), e);
	    });
	  };
	
	  zoom.translateBy = function(selection$$1, x, y) {
	    zoom.transform(selection$$1, function() {
	      return constrain(this.__zoom.translate(
	        typeof x === "function" ? x.apply(this, arguments) : x,
	        typeof y === "function" ? y.apply(this, arguments) : y
	      ), extent.apply(this, arguments));
	    });
	  };
	
	  function scale(transform, k) {
	    k = Math.max(k0, Math.min(k1, k));
	    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
	  }
	
	  function translate(transform, p0, p1) {
	    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
	    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
	  }
	
	  function constrain(transform, extent) {
	    var dx0 = transform.invertX(extent[0][0]) - x0,
	        dx1 = transform.invertX(extent[1][0]) - x1,
	        dy0 = transform.invertY(extent[0][1]) - y0,
	        dy1 = transform.invertY(extent[1][1]) - y1;
	    return transform.translate(
	      dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
	      dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
	    );
	  }
	
	  function centroid(extent) {
	    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
	  }
	
	  function schedule(transition$$1, transform, center) {
	    transition$$1
	        .on("start.zoom", function() { gesture(this, arguments).start(); })
	        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
	        .tween("zoom", function() {
	          var that = this,
	              args = arguments,
	              g = gesture(that, args),
	              e = extent.apply(that, args),
	              p = center || centroid(e),
	              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
	              a = that.__zoom,
	              b = typeof transform === "function" ? transform.apply(that, args) : transform,
	              i = interpolate$$1(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
	          return function(t) {
	            if (t === 1) t = b; // Avoid rounding error on end.
	            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
	            g.zoom(null, t);
	          };
	        });
	  }
	
	  function gesture(that, args) {
	    for (var i = 0, n = gestures.length, g; i < n; ++i) {
	      if ((g = gestures[i]).that === that) {
	        return g;
	      }
	    }
	    return new Gesture(that, args);
	  }
	
	  function Gesture(that, args) {
	    this.that = that;
	    this.args = args;
	    this.index = -1;
	    this.active = 0;
	    this.extent = extent.apply(that, args);
	  }
	
	  Gesture.prototype = {
	    start: function() {
	      if (++this.active === 1) {
	        this.index = gestures.push(this) - 1;
	        this.emit("start");
	      }
	      return this;
	    },
	    zoom: function(key, transform) {
	      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
	      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
	      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
	      this.that.__zoom = transform;
	      this.emit("zoom");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) {
	        gestures.splice(this.index, 1);
	        this.index = -1;
	        this.emit("end");
	      }
	      return this;
	    },
	    emit: function(type) {
	      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function wheeled() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        t = this.__zoom,
	        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, -exports.event.deltaY * (exports.event.deltaMode ? 120 : 1) / 500))),
	        p = mouse(this);
	
	    // If the mouse is in the same location as before, reuse it.
	    // If there were recent wheel events, reset the wheel idle timeout.
	    if (g.wheel) {
	      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
	        g.mouse[1] = t.invert(g.mouse[0] = p);
	      }
	      clearTimeout(g.wheel);
	    }
	
	    // If this wheel event won’t trigger a transform change, ignore it.
	    else if (t.k === k) return;
	
	    // Otherwise, capture the mouse point and location at the start.
	    else {
	      g.mouse = [p, t.invert(p)];
	      interrupt(this);
	      g.start();
	    }
	
	    noevent$1();
	    g.wheel = setTimeout(wheelidled, wheelDelay);
	    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));
	
	    function wheelidled() {
	      g.wheel = null;
	      g.end();
	    }
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
	        p = mouse(this);
	
	    dragDisable(exports.event.view);
	    nopropagation$1();
	    g.mouse = [p, this.__zoom.invert(p)];
	    interrupt(this);
	    g.start();
	
	    function mousemoved() {
	      noevent$1();
	      g.moved = true;
	      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent));
	    }
	
	    function mouseupped() {
	      v.on("mousemove.zoom mouseup.zoom", null);
	      yesdrag(exports.event.view, g.moved);
	      noevent$1();
	      g.end();
	    }
	  }
	
	  function dblclicked() {
	    if (!filter.apply(this, arguments)) return;
	    var t0 = this.__zoom,
	        p0 = mouse(this),
	        p1 = t0.invert(p0),
	        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
	        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));
	
	    noevent$1();
	    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
	    else select(this).call(zoom.transform, t1);
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t, p;
	
	    nopropagation$1();
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
	      p = [p, this.__zoom.invert(p), t.identifier];
	      if (!g.touch0) g.touch0 = p;
	      else if (!g.touch1) g.touch1 = p;
	    }
	
	    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
	    if (touchstarting) {
	      touchstarting = clearTimeout(touchstarting);
	      if (!g.touch1) {
	        g.end();
	        p = select(this).on("dblclick.zoom");
	        if (p) p.apply(this, arguments);
	        return;
	      }
	    }
	
	    if (exports.event.touches.length === n) {
	      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
	      interrupt(this);
	      g.start();
	    }
	  }
	
	  function touchmoved() {
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t, p, l;
	
	    noevent$1();
	    if (touchstarting) touchstarting = clearTimeout(touchstarting);
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
	      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
	      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
	    }
	    t = g.that.__zoom;
	    if (g.touch1) {
	      var p0 = g.touch0[0], l0 = g.touch0[1],
	          p1 = g.touch1[0], l1 = g.touch1[1],
	          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
	          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
	      t = scale(t, Math.sqrt(dp / dl));
	      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
	      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
	    }
	    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
	    else return;
	    g.zoom("touch", constrain(translate(t, p, l), g.extent));
	  }
	
	  function touchended() {
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t;
	
	    nopropagation$1();
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, touchDelay);
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i];
	      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
	      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
	    }
	    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
	    if (!g.touch0) g.end();
	  }
	
	  zoom.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$10(!!_), zoom) : filter;
	  };
	
	  zoom.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$10([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
	  };
	
	  zoom.scaleExtent = function(_) {
	    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
	  };
	
	  zoom.translateExtent = function(_) {
	    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
	  };
	
	  zoom.duration = function(_) {
	    return arguments.length ? (duration = +_, zoom) : duration;
	  };
	
	  zoom.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, zoom) : interpolate$$1;
	  };
	
	  zoom.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? zoom : value;
	  };
	
	  return zoom;
	};
	
	var constant$11 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var BrushEvent = function(target, type, selection) {
	  this.target = target;
	  this.type = type;
	  this.selection = selection;
	};
	
	function nopropagation$2() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent$2 = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	};
	
	var MODE_DRAG = {name: "drag"};
	var MODE_SPACE = {name: "space"};
	var MODE_HANDLE = {name: "handle"};
	var MODE_CENTER = {name: "center"};
	
	var X = {
	  name: "x",
	  handles: ["e", "w"].map(type$1),
	  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
	  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
	};
	
	var Y = {
	  name: "y",
	  handles: ["n", "s"].map(type$1),
	  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
	  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
	};
	
	var XY = {
	  name: "xy",
	  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type$1),
	  input: function(xy) { return xy; },
	  output: function(xy) { return xy; }
	};
	
	var cursors = {
	  overlay: "crosshair",
	  selection: "move",
	  n: "ns-resize",
	  e: "ew-resize",
	  s: "ns-resize",
	  w: "ew-resize",
	  nw: "nwse-resize",
	  ne: "nesw-resize",
	  se: "nwse-resize",
	  sw: "nesw-resize"
	};
	
	var flipX = {
	  e: "w",
	  w: "e",
	  nw: "ne",
	  ne: "nw",
	  se: "sw",
	  sw: "se"
	};
	
	var flipY = {
	  n: "s",
	  s: "n",
	  nw: "sw",
	  ne: "se",
	  se: "ne",
	  sw: "nw"
	};
	
	var signsX = {
	  overlay: +1,
	  selection: +1,
	  n: null,
	  e: +1,
	  s: null,
	  w: -1,
	  nw: -1,
	  ne: +1,
	  se: +1,
	  sw: -1
	};
	
	var signsY = {
	  overlay: +1,
	  selection: +1,
	  n: -1,
	  e: null,
	  s: +1,
	  w: null,
	  nw: -1,
	  ne: -1,
	  se: +1,
	  sw: +1
	};
	
	function type$1(t) {
	  return {type: t};
	}
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter$2() {
	  return !exports.event.button;
	}
	
	function defaultExtent$1() {
	  var svg = this.ownerSVGElement || this;
	  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
	}
	
	// Like d3.local, but with the name “__brush” rather than auto-generated.
	function local$1(node) {
	  while (!node.__brush) if (!(node = node.parentNode)) return;
	  return node.__brush;
	}
	
	function empty$1(extent) {
	  return extent[0][0] === extent[1][0]
	      || extent[0][1] === extent[1][1];
	}
	
	function brushSelection(node) {
	  var state = node.__brush;
	  return state ? state.dim.output(state.selection) : null;
	}
	
	function brushX() {
	  return brush$1(X);
	}
	
	function brushY() {
	  return brush$1(Y);
	}
	
	var brush = function() {
	  return brush$1(XY);
	};
	
	function brush$1(dim) {
	  var extent = defaultExtent$1,
	      filter = defaultFilter$2,
	      listeners = dispatch(brush, "start", "brush", "end"),
	      handleSize = 6,
	      touchending;
	
	  function brush(group) {
	    var overlay = group
	        .property("__brush", initialize)
	      .selectAll(".overlay")
	      .data([type$1("overlay")]);
	
	    overlay.enter().append("rect")
	        .attr("class", "overlay")
	        .attr("pointer-events", "all")
	        .attr("cursor", cursors.overlay)
	      .merge(overlay)
	        .each(function() {
	          var extent = local$1(this).extent;
	          select(this)
	              .attr("x", extent[0][0])
	              .attr("y", extent[0][1])
	              .attr("width", extent[1][0] - extent[0][0])
	              .attr("height", extent[1][1] - extent[0][1]);
	        });
	
	    group.selectAll(".selection")
	      .data([type$1("selection")])
	      .enter().append("rect")
	        .attr("class", "selection")
	        .attr("cursor", cursors.selection)
	        .attr("fill", "#777")
	        .attr("fill-opacity", 0.3)
	        .attr("stroke", "#fff")
	        .attr("shape-rendering", "crispEdges");
	
	    var handle = group.selectAll(".handle")
	      .data(dim.handles, function(d) { return d.type; });
	
	    handle.exit().remove();
	
	    handle.enter().append("rect")
	        .attr("class", function(d) { return "handle handle--" + d.type; })
	        .attr("cursor", function(d) { return cursors[d.type]; });
	
	    group
	        .each(redraw)
	        .attr("fill", "none")
	        .attr("pointer-events", "all")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	        .on("mousedown.brush touchstart.brush", started);
	  }
	
	  brush.move = function(group, selection$$1) {
	    if (group.selection) {
	      group
	          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
	          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
	          .tween("brush", function() {
	            var that = this,
	                state = that.__brush,
	                emit = emitter(that, arguments),
	                selection0 = state.selection,
	                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(this, arguments) : selection$$1, state.extent),
	                i = interpolate(selection0, selection1);
	
	            function tween(t) {
	              state.selection = t === 1 && empty$1(selection1) ? null : i(t);
	              redraw.call(that);
	              emit.brush();
	            }
	
	            return selection0 && selection1 ? tween : tween(1);
	          });
	    } else {
	      group
	          .each(function() {
	            var that = this,
	                args = arguments,
	                state = that.__brush,
	                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(that, args) : selection$$1, state.extent),
	                emit = emitter(that, args).beforestart();
	
	            interrupt(that);
	            state.selection = selection1 == null || empty$1(selection1) ? null : selection1;
	            redraw.call(that);
	            emit.start().brush().end();
	          });
	    }
	  };
	
	  function redraw() {
	    var group = select(this),
	        selection$$1 = local$1(this).selection;
	
	    if (selection$$1) {
	      group.selectAll(".selection")
	          .style("display", null)
	          .attr("x", selection$$1[0][0])
	          .attr("y", selection$$1[0][1])
	          .attr("width", selection$$1[1][0] - selection$$1[0][0])
	          .attr("height", selection$$1[1][1] - selection$$1[0][1]);
	
	      group.selectAll(".handle")
	          .style("display", null)
	          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection$$1[1][0] - handleSize / 2 : selection$$1[0][0] - handleSize / 2; })
	          .attr("y", function(d) { return d.type[0] === "s" ? selection$$1[1][1] - handleSize / 2 : selection$$1[0][1] - handleSize / 2; })
	          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection$$1[1][0] - selection$$1[0][0] + handleSize : handleSize; })
	          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection$$1[1][1] - selection$$1[0][1] + handleSize : handleSize; });
	    }
	
	    else {
	      group.selectAll(".selection,.handle")
	          .style("display", "none")
	          .attr("x", null)
	          .attr("y", null)
	          .attr("width", null)
	          .attr("height", null);
	    }
	  }
	
	  function emitter(that, args) {
	    return that.__brush.emitter || new Emitter(that, args);
	  }
	
	  function Emitter(that, args) {
	    this.that = that;
	    this.args = args;
	    this.state = that.__brush;
	    this.active = 0;
	  }
	
	  Emitter.prototype = {
	    beforestart: function() {
	      if (++this.active === 1) this.state.emitter = this, this.starting = true;
	      return this;
	    },
	    start: function() {
	      if (this.starting) this.starting = false, this.emit("start");
	      return this;
	    },
	    brush: function() {
	      this.emit("brush");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) delete this.state.emitter, this.emit("end");
	      return this;
	    },
	    emit: function(type) {
	      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function started() {
	    if (exports.event.touches) { if (exports.event.changedTouches.length < exports.event.touches.length) return noevent$2(); }
	    else if (touchending) return;
	    if (!filter.apply(this, arguments)) return;
	
	    var that = this,
	        type = exports.event.target.__data__.type,
	        mode = (exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
	        signX = dim === Y ? null : signsX[type],
	        signY = dim === X ? null : signsY[type],
	        state = local$1(that),
	        extent = state.extent,
	        selection$$1 = state.selection,
	        W = extent[0][0], w0, w1,
	        N = extent[0][1], n0, n1,
	        E = extent[1][0], e0, e1,
	        S = extent[1][1], s0, s1,
	        dx,
	        dy,
	        moving,
	        shifting = signX && signY && exports.event.shiftKey,
	        lockX,
	        lockY,
	        point0 = mouse(that),
	        point = point0,
	        emit = emitter(that, arguments).beforestart();
	
	    if (type === "overlay") {
	      state.selection = selection$$1 = [
	        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
	        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
	      ];
	    } else {
	      w0 = selection$$1[0][0];
	      n0 = selection$$1[0][1];
	      e0 = selection$$1[1][0];
	      s0 = selection$$1[1][1];
	    }
	
	    w1 = w0;
	    n1 = n0;
	    e1 = e0;
	    s1 = s0;
	
	    var group = select(that)
	        .attr("pointer-events", "none");
	
	    var overlay = group.selectAll(".overlay")
	        .attr("cursor", cursors[type]);
	
	    if (exports.event.touches) {
	      group
	          .on("touchmove.brush", moved, true)
	          .on("touchend.brush touchcancel.brush", ended, true);
	    } else {
	      var view = select(exports.event.view)
	          .on("keydown.brush", keydowned, true)
	          .on("keyup.brush", keyupped, true)
	          .on("mousemove.brush", moved, true)
	          .on("mouseup.brush", ended, true);
	
	      dragDisable(exports.event.view);
	    }
	
	    nopropagation$2();
	    interrupt(that);
	    redraw.call(that);
	    emit.start();
	
	    function moved() {
	      var point1 = mouse(that);
	      if (shifting && !lockX && !lockY) {
	        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
	        else lockX = true;
	      }
	      point = point1;
	      moving = true;
	      noevent$2();
	      move();
	    }
	
	    function move() {
	      var t;
	
	      dx = point[0] - point0[0];
	      dy = point[1] - point0[1];
	
	      switch (mode) {
	        case MODE_SPACE:
	        case MODE_DRAG: {
	          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
	          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
	          break;
	        }
	        case MODE_HANDLE: {
	          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
	          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
	          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
	          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
	          break;
	        }
	        case MODE_CENTER: {
	          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
	          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
	          break;
	        }
	      }
	
	      if (e1 < w1) {
	        signX *= -1;
	        t = w0, w0 = e0, e0 = t;
	        t = w1, w1 = e1, e1 = t;
	        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
	      }
	
	      if (s1 < n1) {
	        signY *= -1;
	        t = n0, n0 = s0, s0 = t;
	        t = n1, n1 = s1, s1 = t;
	        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
	      }
	
	      if (state.selection) selection$$1 = state.selection; // May be set by brush.move!
	      if (lockX) w1 = selection$$1[0][0], e1 = selection$$1[1][0];
	      if (lockY) n1 = selection$$1[0][1], s1 = selection$$1[1][1];
	
	      if (selection$$1[0][0] !== w1
	          || selection$$1[0][1] !== n1
	          || selection$$1[1][0] !== e1
	          || selection$$1[1][1] !== s1) {
	        state.selection = [[w1, n1], [e1, s1]];
	        redraw.call(that);
	        emit.brush();
	      }
	    }
	
	    function ended() {
	      nopropagation$2();
	      if (exports.event.touches) {
	        if (exports.event.touches.length) return;
	        if (touchending) clearTimeout(touchending);
	        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
	      } else {
	        yesdrag(exports.event.view, moving);
	        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
	      }
	      group.attr("pointer-events", "all");
	      overlay.attr("cursor", cursors.overlay);
	      if (state.selection) selection$$1 = state.selection; // May be set by brush.move (on start)!
	      if (empty$1(selection$$1)) state.selection = null, redraw.call(that);
	      emit.end();
	    }
	
	    function keydowned() {
	      switch (exports.event.keyCode) {
	        case 16: { // SHIFT
	          shifting = signX && signY;
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_HANDLE) {
	            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	            mode = MODE_CENTER;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE; takes priority over ALT
	          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
	            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
	            mode = MODE_SPACE;
	            overlay.attr("cursor", cursors.selection);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent$2();
	    }
	
	    function keyupped() {
	      switch (exports.event.keyCode) {
	        case 16: { // SHIFT
	          if (shifting) {
	            lockX = lockY = shifting = false;
	            move();
	          }
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	            mode = MODE_HANDLE;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE
	          if (mode === MODE_SPACE) {
	            if (exports.event.altKey) {
	              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	              mode = MODE_CENTER;
	            } else {
	              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	              mode = MODE_HANDLE;
	            }
	            overlay.attr("cursor", cursors[type]);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent$2();
	    }
	  }
	
	  function initialize() {
	    var state = this.__brush || {selection: null};
	    state.extent = extent.apply(this, arguments);
	    state.dim = dim;
	    return state;
	  }
	
	  brush.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$11([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
	  };
	
	  brush.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$11(!!_), brush) : filter;
	  };
	
	  brush.handleSize = function(_) {
	    return arguments.length ? (handleSize = +_, brush) : handleSize;
	  };
	
	  brush.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? brush : value;
	  };
	
	  return brush;
	}
	
	var cos = Math.cos;
	var sin = Math.sin;
	var pi$3 = Math.PI;
	var halfPi$2 = pi$3 / 2;
	var tau$3 = pi$3 * 2;
	var max$1 = Math.max;
	
	function compareValue(compare) {
	  return function(a, b) {
	    return compare(
	      a.source.value + a.target.value,
	      b.source.value + b.target.value
	    );
	  };
	}
	
	var chord = function() {
	  var padAngle = 0,
	      sortGroups = null,
	      sortSubgroups = null,
	      sortChords = null;
	
	  function chord(matrix) {
	    var n = matrix.length,
	        groupSums = [],
	        groupIndex = range(n),
	        subgroupIndex = [],
	        chords = [],
	        groups = chords.groups = new Array(n),
	        subgroups = new Array(n * n),
	        k,
	        x,
	        x0,
	        dx,
	        i,
	        j;
	
	    // Compute the sum.
	    k = 0, i = -1; while (++i < n) {
	      x = 0, j = -1; while (++j < n) {
	        x += matrix[i][j];
	      }
	      groupSums.push(x);
	      subgroupIndex.push(range(n));
	      k += x;
	    }
	
	    // Sort groups…
	    if (sortGroups) groupIndex.sort(function(a, b) {
	      return sortGroups(groupSums[a], groupSums[b]);
	    });
	
	    // Sort subgroups…
	    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
	      d.sort(function(a, b) {
	        return sortSubgroups(matrix[i][a], matrix[i][b]);
	      });
	    });
	
	    // Convert the sum to scaling factor for [0, 2pi].
	    // TODO Allow start and end angle to be specified?
	    // TODO Allow padding to be specified as percentage?
	    k = max$1(0, tau$3 - padAngle * n) / k;
	    dx = k ? padAngle : tau$3 / n;
	
	    // Compute the start and end angle for each group and subgroup.
	    // Note: Opera has a bug reordering object literal properties!
	    x = 0, i = -1; while (++i < n) {
	      x0 = x, j = -1; while (++j < n) {
	        var di = groupIndex[i],
	            dj = subgroupIndex[di][j],
	            v = matrix[di][dj],
	            a0 = x,
	            a1 = x += v * k;
	        subgroups[dj * n + di] = {
	          index: di,
	          subindex: dj,
	          startAngle: a0,
	          endAngle: a1,
	          value: v
	        };
	      }
	      groups[di] = {
	        index: di,
	        startAngle: x0,
	        endAngle: x,
	        value: groupSums[di]
	      };
	      x += dx;
	    }
	
	    // Generate chords for each (non-empty) subgroup-subgroup link.
	    i = -1; while (++i < n) {
	      j = i - 1; while (++j < n) {
	        var source = subgroups[j * n + i],
	            target = subgroups[i * n + j];
	        if (source.value || target.value) {
	          chords.push(source.value < target.value
	              ? {source: target, target: source}
	              : {source: source, target: target});
	        }
	      }
	    }
	
	    return sortChords ? chords.sort(sortChords) : chords;
	  }
	
	  chord.padAngle = function(_) {
	    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
	  };
	
	  chord.sortGroups = function(_) {
	    return arguments.length ? (sortGroups = _, chord) : sortGroups;
	  };
	
	  chord.sortSubgroups = function(_) {
	    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
	  };
	
	  chord.sortChords = function(_) {
	    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
	  };
	
	  return chord;
	};
	
	var slice$5 = Array.prototype.slice;
	
	var constant$12 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultSource(d) {
	  return d.source;
	}
	
	function defaultTarget(d) {
	  return d.target;
	}
	
	function defaultRadius$1(d) {
	  return d.radius;
	}
	
	function defaultStartAngle(d) {
	  return d.startAngle;
	}
	
	function defaultEndAngle(d) {
	  return d.endAngle;
	}
	
	var ribbon = function() {
	  var source = defaultSource,
	      target = defaultTarget,
	      radius = defaultRadius$1,
	      startAngle = defaultStartAngle,
	      endAngle = defaultEndAngle,
	      context = null;
	
	  function ribbon() {
	    var buffer,
	        argv = slice$5.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv),
	        sr = +radius.apply(this, (argv[0] = s, argv)),
	        sa0 = startAngle.apply(this, argv) - halfPi$2,
	        sa1 = endAngle.apply(this, argv) - halfPi$2,
	        sx0 = sr * cos(sa0),
	        sy0 = sr * sin(sa0),
	        tr = +radius.apply(this, (argv[0] = t, argv)),
	        ta0 = startAngle.apply(this, argv) - halfPi$2,
	        ta1 = endAngle.apply(this, argv) - halfPi$2;
	
	    if (!context) context = buffer = path();
	
	    context.moveTo(sx0, sy0);
	    context.arc(0, 0, sr, sa0, sa1);
	    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
	      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
	      context.arc(0, 0, tr, ta0, ta1);
	    }
	    context.quadraticCurveTo(0, 0, sx0, sy0);
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  ribbon.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$12(+_), ribbon) : radius;
	  };
	
	  ribbon.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$12(+_), ribbon) : startAngle;
	  };
	
	  ribbon.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$12(+_), ribbon) : endAngle;
	  };
	
	  ribbon.source = function(_) {
	    return arguments.length ? (source = _, ribbon) : source;
	  };
	
	  ribbon.target = function(_) {
	    return arguments.length ? (target = _, ribbon) : target;
	  };
	
	  ribbon.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
	  };
	
	  return ribbon;
	};
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	};
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add$1(temp, y, this.t);
	    add$1(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add$1(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon$4 = 1e-6;
	var epsilon2$2 = 1e-12;
	var pi$4 = Math.PI;
	var halfPi$3 = pi$4 / 2;
	var quarterPi = pi$4 / 4;
	var tau$4 = pi$4 * 2;
	
	var degrees$1 = 180 / pi$4;
	var radians = pi$4 / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos$1 = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log$1 = Math.log;
	var pow$1 = Math.pow;
	var sin$1 = Math.sin;
	var sign$1 = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt$1 = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
	}
	
	function asin$1(x) {
	  return x > 1 ? halfPi$3 : x < -1 ? -halfPi$3 : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin$1(x / 2)) * x;
	}
	
	function noop$2() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(feature, stream) {
	    streamGeometry(feature.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop$2,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau$4 + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop$2;
	  },
	  sphere: function() {
	    areaSum.add(tau$4);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos$1(phi),
	      sinPhi = sin$1(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
	      v = k * sdLambda * sin$1(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area$2 = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	};
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin$1(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
	  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt$1(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon$4) phi1 = 90;
	    else if (deltaSum < -epsilon$4) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees$1 * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees$1;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees$1;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    boundsPoint(lambda, phi);
	  }
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon$4) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range, x) {
	  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	};
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop$2,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi);
	  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi);
	  x0 = cosPhi * cos$1(lambda);
	  y0 = cosPhi * sin$1(lambda);
	  z0 = sin$1(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi),
	      x = cosPhi * cos$1(lambda),
	      y = cosPhi * sin$1(lambda),
	      z = sin$1(phi),
	      w = atan2(sqrt$1((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos$1(phi);
	  x0 = cosPhi * cos$1(lambda);
	  y0 = cosPhi * sin$1(lambda);
	  z0 = sin$1(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi),
	      x = cosPhi * cos$1(lambda),
	      y = cosPhi * sin$1(lambda),
	      z = sin$1(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt$1(cx * cx + cy * cy + cz * cz),
	      u = x0 * x + y0 * y + z0 * z,
	      v = m && -acos(u) / m, // area weight
	      w = atan2(m, u); // line weight
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid$1 = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2$2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon$4) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2$2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees$1, asin$1(z / sqrt$1(m)) * degrees$1];
	};
	
	var constant$13 = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi$4 ? lambda - tau$4 : lambda < -pi$4 ? lambda + tau$4 : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau$4) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi$4 ? lambda - tau$4 : lambda < -pi$4 ? lambda + tau$4 : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos$1(deltaPhi),
	      sinDeltaPhi = sin$1(deltaPhi),
	      cosDeltaGamma = cos$1(deltaGamma),
	      sinDeltaGamma = sin$1(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos$1(phi),
	        x = cos$1(lambda) * cosPhi,
	        y = sin$1(lambda) * cosPhi,
	        z = sin$1(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin$1(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos$1(phi),
	        x = cos$1(lambda) * cosPhi,
	        y = sin$1(lambda) * cosPhi,
	        z = sin$1(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin$1(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
	  };
	
	  return forward;
	};
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos$1(radius),
	      sinRadius = sin$1(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau$4;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$4;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau$4 - epsilon$4) % tau$4;
	}
	
	var circle$1 = function() {
	  var center = constant$13([0, 0]),
	      radius = constant$13(90),
	      precision = constant$13(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees$1, x[1] *= degrees$1;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant$13([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$13(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$13(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop$2,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon$4 && abs(a[1] - b[1]) < epsilon$4;
	};
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link$1(subject);
	  link$1(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	function link$1(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipExtent(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon$4 ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon$4 ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon$4 ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent$1 = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop$2,
	  point: noop$2,
	  lineStart: lengthLineStart,
	  lineEnd: noop$2,
	  polygonStart: noop$2,
	  polygonEnd: noop$2
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop$2;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin$1(phi),
	      cosPhi = cos$1(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos$1(delta),
	      sinDelta = sin$1(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt$1(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length$2 = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	};
	
	var coordinates = [null, null];
	var object$1 = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length$2(object$1);
	};
	
	function graticuleX(y0, y1, dy) {
	  var y = range(y0, y1 - epsilon$4, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = range(x0, x1 - epsilon$4, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	function graticule() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$4; }).map(x))
	        .concat(range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$4; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon$4], [180, 90 - epsilon$4]])
	      .extentMinor([[-180, -80 - epsilon$4], [180, 80 + epsilon$4]]);
	}
	
	function graticule10() {
	  return graticule()();
	}
	
	var interpolate$2 = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos$1(y0),
	      sy0 = sin$1(y0),
	      cy1 = cos$1(y1),
	      sy1 = sin$1(y1),
	      kx0 = cy0 * cos$1(x0),
	      ky0 = cy0 * sin$1(x0),
	      kx1 = cy1 * cos$1(x1),
	      ky1 = cy1 * sin$1(x1),
	      d = 2 * asin$1(sqrt$1(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin$1(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin$1(t *= d) / k,
	        A = sin$1(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees$1,
	      atan2(z, sqrt$1(x * x + y * y)) * degrees$1
	    ];
	  } : function() {
	    return [x0 * degrees$1, y0 * degrees$1];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var identity$7 = function(x) {
	  return x;
	};
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop$2,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$2;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: noop$2,
	  polygonEnd: noop$2,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt$1(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt$1(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau$4);
	        break;
	      }
	    }
	  },
	  result: noop$2
	};
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _circle: circle$2(4.5),
	  pointRadius: function(_) {
	    return this._circle = circle$2(_), this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    }
	  }
	};
	
	function circle$2(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index$3 = function(projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$7) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	};
	
	var sum$2 = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin$1(lambda), -cos$1(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum$2.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin$1(phi0),
	        cosPhi0 = cos$1(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin$1(phi1),
	          cosPhi1 = cos$1(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi$4,
	          k = sinPhi0 * sinPhi1;
	
	      sum$2.add(atan2(k * sign$$1 * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau$4 : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon$4 || angle < epsilon$4 && sum$2 < -epsilon$4) ^ (winding & 1);
	};
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(rotate, sink) {
	    var line = clipLine(sink),
	        rotatedStart = rotate.invert(start[0], start[1]),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = merge(segments);
	        var startInside = polygonContains(polygon, rotatedStart);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      var point = rotate(lambda, phi);
	      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      var point = rotate(lambda, phi);
	      line.point(point[0], point[1]);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      var point = rotate(lambda, phi);
	      ringSink.point(point[0], point[1]);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi$3 - epsilon$4 : halfPi$3 - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi$3 - epsilon$4 : halfPi$3 - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi$4, -halfPi$3]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi$4 : -pi$4,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi$4) < epsilon$4) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$3 : -halfPi$3);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi$4) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon$4) lambda0 -= sign0 * epsilon$4; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon$4) lambda1 -= sign1 * epsilon$4;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon$4
	      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
	          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi$3;
	    stream.point(-pi$4, phi);
	    stream.point(0, phi);
	    stream.point(pi$4, phi);
	    stream.point(pi$4, 0);
	    stream.point(pi$4, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi$4, -phi);
	    stream.point(-pi$4, 0);
	    stream.point(-pi$4, phi);
	  } else if (abs(from[0] - to[0]) > epsilon$4) {
	    var lambda = from[0] < to[0] ? pi$4 : -pi$4;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius, delta) {
	  var cr = cos$1(radius),
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon$4; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos$1(lambda) * cos$1(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi$4 : -pi$4), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon$4;
	            point1[1] += epsilon$4;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt$1(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi$4) < epsilon$4,
	        meridian = polar || delta < epsilon$4;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$4 ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi$4 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi$4 - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$4, radius - pi$4]);
	};
	
	var transform$1 = function(methods) {
	  return {
	    stream: transformer(methods)
	  };
	};
	
	function transformer(methods) {
	  return function(stream) {
	    var s = new TransformStream;
	    for (var key in methods) s[key] = methods[key];
	    s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fitExtent(projection, extent, object) {
	  var w = extent[1][0] - extent[0][0],
	      h = extent[1][1] - extent[0][1],
	      clip = projection.clipExtent && projection.clipExtent();
	
	  projection
	      .scale(150)
	      .translate([0, 0]);
	
	  if (clip != null) projection.clipExtent(null);
	
	  geoStream(object, projection.stream(boundsStream$1));
	
	  var b = boundsStream$1.result(),
	      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	  if (clip != null) projection.clipExtent(clip);
	
	  return projection
	      .scale(k * 150)
	      .translate([x, y]);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	};
	
	function resampleNone(project) {
	  return transformer({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt$1(a * a + b * b + c * c),
	          phi2 = asin$1(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon$4 || abs(lambda0 - lambda1) < epsilon$4 ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transformer({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity$7, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees$1, point[1] * degrees$1];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$7) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$1(delta2);
	  };
	
	  projection.fitExtent = function(extent, object) {
	    return fitExtent(projection, extent, object);
	  };
	
	  projection.fitSize = function(size, object) {
	    return fitSize(projection, size, object);
	  };
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi$4 / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos$1(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin$1(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon$4) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt$1(c) / n;
	
	  function project(x, y) {
	    var r = sqrt$1(c - 2 * n * sin$1(y)) / n;
	    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign$1(r0y), asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	};
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	};
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null,
	        (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon$4, y + 0.120 * k + epsilon$4], [x - 0.214 * k - epsilon$4, y + 0.234 * k - epsilon$4]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon$4, y + 0.166 * k + epsilon$4], [x - 0.115 * k - epsilon$4, y + 0.234 * k - epsilon$4]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function(extent, object) {
	    return fitExtent(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function(size, object) {
	    return fitSize(albersUsa, size, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos$1(x),
	        cy = cos$1(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin$1(x),
	      k * sin$1(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt$1(x * x + y * y),
	        c = angle(z),
	        sc = sin$1(c),
	        cc = cos$1(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin$1(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt$1(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin$1(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin$1(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	};
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log$1(tan((halfPi$3 + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi$3];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau$4);
	};
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      clipAuto;
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), clipAuto && m.clipExtent(null), m) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), clipAuto && m.clipExtent(null), m) : translate();
	  };
	
	  m.clipExtent = function(_) {
	    if (!arguments.length) return clipAuto ? null : clipExtent();
	    if (clipAuto = _ == null) {
	      var k = pi$4 * scale(),
	          t = translate();
	      _ = [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]];
	    }
	    clipExtent(_);
	    return m;
	  };
	
	  return m.clipExtent(null);
	}
	
	function tany(y) {
	  return tan((halfPi$3 + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos$1(y0),
	      n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)),
	      f = cy0 * pow$1(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi$3 + epsilon$4) y = -halfPi$3 + epsilon$4; }
	    else { if (y > halfPi$3 - epsilon$4) y = halfPi$3 - epsilon$4; }
	    var r = f / pow$1(tany(y), n);
	    return [r * sin$1(n * x), f - r * cos$1(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign$1(n) * sqrt$1(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign$1(fy), 2 * atan(pow$1(f / r, 1 / n)) - halfPi$3];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	};
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	};
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos$1(y0),
	      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon$4) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin$1(nx), g - gy * cos$1(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign$1(gy), g - sign$1(n) * sqrt$1(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	};
	
	function gnomonicRaw(x, y) {
	  var cy = cos$1(y), k = cos$1(x) * cy;
	  return [cy * sin$1(x) / k, sin$1(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	};
	
	function scaleTranslate(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity$7 : transformer({
	    point: function(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}
	
	var identity$8 = function() {
	  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity$7, // scale, translate and reflect
	      x0 = null, y0, x1, y1, clip = identity$7, // clip extent
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
	    },
	    clipExtent: function(_) {
	      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$7) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function(_) {
	      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function(extent, object) {
	      return fitExtent(projection, extent, object);
	    },
	    fitSize: function(size, object) {
	      return fitSize(projection, size, object);
	    }
	  };
	};
	
	function orthographicRaw(x, y) {
	  return [cos$1(y) * sin$1(x), sin$1(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin$1);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon$4);
	};
	
	function stereographicRaw(x, y) {
	  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
	  return [cy * sin$1(x) / k, sin$1(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	};
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log$1(tan((halfPi$3 + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi$3];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	};
	
	exports.version = version;
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = threshold;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	exports.entries = entries;
	exports.keys = keys;
	exports.values = values;
	exports.map = map$1;
	exports.set = set;
	exports.nest = nest;
	exports.randomUniform = uniform;
	exports.randomNormal = normal;
	exports.randomLogNormal = logNormal;
	exports.randomBates = bates;
	exports.randomIrwinHall = irwinHall;
	exports.randomExponential = exponential;
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	exports.polygonArea = area;
	exports.polygonCentroid = centroid;
	exports.polygonHull = hull;
	exports.polygonContains = contains;
	exports.polygonLength = length$1;
	exports.path = path;
	exports.quadtree = quadtree;
	exports.queue = queue;
	exports.arc = arc;
	exports.area = area$1;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross$1;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending$1;
	exports.stackOrderDescending = descending$2;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	exports.interpolate = interpolate;
	exports.interpolateArray = array$1;
	exports.interpolateDate = date;
	exports.interpolateNumber = interpolateNumber;
	exports.interpolateObject = object;
	exports.interpolateRound = interpolateRound;
	exports.interpolateString = interpolateString;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = interpolateZoom;
	exports.interpolateRgb = interpolateRgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateBasis = basis$2;
	exports.interpolateBasisClosed = basisClosed$1;
	exports.quantize = quantize;
	exports.dispatch = dispatch;
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	exports.request = request;
	exports.html = html;
	exports.json = json;
	exports.text = text;
	exports.xml = xml;
	exports.csv = csv$1;
	exports.tsv = tsv$1;
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	exports.formatLocale = formatLocale;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatLocale = formatLocale$1;
	exports.timeFormatDefaultLocale = defaultLocale$1;
	exports.scaleBand = band;
	exports.scalePoint = point$4;
	exports.scaleIdentity = identity$4;
	exports.scaleLinear = linear$2;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$$1;
	exports.scaleQuantize = quantize$1;
	exports.scaleThreshold = threshold$1;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.scaleSequential = sequential;
	exports.interpolateCubehelixDefault = cubehelix$3;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.creator = creator;
	exports.customEvent = customEvent;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = window;
	exports.active = active;
	exports.interrupt = interrupt;
	exports.transition = transition;
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	exports.forceCenter = center$1;
	exports.forceCollide = collide;
	exports.forceLink = link;
	exports.forceManyBody = manyBody;
	exports.forceSimulation = simulation;
	exports.forceX = x$3;
	exports.forceY = y$3;
	exports.drag = drag;
	exports.dragDisable = dragDisable;
	exports.dragEnable = yesdrag;
	exports.voronoi = voronoi;
	exports.zoom = zoom;
	exports.zoomIdentity = identity$6;
	exports.zoomTransform = transform;
	exports.brush = brush;
	exports.brushX = brushX;
	exports.brushY = brushY;
	exports.brushSelection = brushSelection;
	exports.chord = chord;
	exports.ribbon = ribbon;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoArea = area$2;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid$1;
	exports.geoCircle = circle$1;
	exports.geoClipExtent = extent$1;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoDistance = distance;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoGraticule = graticule;
	exports.geoGraticule10 = graticule10;
	exports.geoIdentity = identity$8;
	exports.geoInterpolate = interpolate$2;
	exports.geoLength = length$2;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoPath = index$3;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoRotation = rotation;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoStream = geoStream;
	exports.geoTransform = transform$1;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["EmojiMart"] = factory(require("react"));
		else
			root["EmojiMart"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.frequently = exports.store = exports.emojiIndex = exports.Category = exports.Emoji = exports.Picker = undefined;
	
		var _components = __webpack_require__(1);
	
		Object.defineProperty(exports, 'Picker', {
		  enumerable: true,
		  get: function get() {
		    return _components.Picker;
		  }
		});
		Object.defineProperty(exports, 'Emoji', {
		  enumerable: true,
		  get: function get() {
		    return _components.Emoji;
		  }
		});
		Object.defineProperty(exports, 'Category', {
		  enumerable: true,
		  get: function get() {
		    return _components.Category;
		  }
		});
	
		var _emojiIndex = __webpack_require__(25);
	
		var _emojiIndex2 = _interopRequireDefault(_emojiIndex);
	
		var _store = __webpack_require__(17);
	
		var _store2 = _interopRequireDefault(_store);
	
		var _frequently = __webpack_require__(16);
	
		var _frequently2 = _interopRequireDefault(_frequently);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.emojiIndex = _emojiIndex2.default;
		exports.store = _store2.default;
		exports.frequently = _frequently2.default;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _anchors = __webpack_require__(2);
	
		Object.defineProperty(exports, 'Anchors', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_anchors).default;
		  }
		});
	
		var _category = __webpack_require__(15);
	
		Object.defineProperty(exports, 'Category', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_category).default;
		  }
		});
	
		var _emoji = __webpack_require__(18);
	
		Object.defineProperty(exports, 'Emoji', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_emoji).default;
		  }
		});
	
		var _picker = __webpack_require__(21);
	
		Object.defineProperty(exports, 'Picker', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_picker).default;
		  }
		});
	
		var _preview = __webpack_require__(23);
	
		Object.defineProperty(exports, 'Preview', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_preview).default;
		  }
		});
	
		var _search = __webpack_require__(24);
	
		Object.defineProperty(exports, 'Search', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_search).default;
		  }
		});
	
		var _skins = __webpack_require__(26);
	
		Object.defineProperty(exports, 'Skins', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_skins).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _svgInlineReact = __webpack_require__(4);
	
		var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
		var _svgs = __webpack_require__(5);
	
		var SVGs = _interopRequireWildcard(_svgs);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Anchors = function (_React$Component) {
		  _inherits(Anchors, _React$Component);
	
		  function Anchors(props) {
		    _classCallCheck(this, Anchors);
	
		    var _this = _possibleConstructorReturn(this, (Anchors.__proto__ || Object.getPrototypeOf(Anchors)).call(this, props));
	
		    var defaultCategory = props.categories[0];
		    if (defaultCategory.anchor) {
		      defaultCategory = defaultCategory.anchor;
		    }
	
		    _this.state = {
		      selected: defaultCategory.name
		    };
		    return _this;
		  }
	
		  _createClass(Anchors, [{
		    key: 'render',
		    value: function render() {
		      var _props = this.props;
		      var categories = _props.categories;
		      var onAnchorClick = _props.onAnchorClick;
		      var color = _props.color;
		      var i18n = _props.i18n;
		      var selected = this.state.selected;
	
	
		      return _react2.default.createElement(
		        'div',
		        { className: 'emoji-mart-anchors' },
		        categories.map(function (category, i) {
		          var name = category.name;
		          var anchor = category.anchor;
		          var isSelected = name == selected;
	
		          if (anchor) {
		            return null;
		          }
	
		          return _react2.default.createElement(
		            'span',
		            {
		              key: name,
		              title: i18n.categories[name.toLowerCase()],
		              onClick: function onClick() {
		                return onAnchorClick(category, i);
		              },
		              className: 'emoji-mart-anchor ' + (isSelected ? 'emoji-mart-anchor-selected' : ''),
		              style: { color: isSelected ? color : null }
		            },
		            _react2.default.createElement(_svgInlineReact2.default, { src: SVGs[name] }),
		            _react2.default.createElement('span', { className: 'emoji-mart-anchor-bar', style: { backgroundColor: color } })
		          );
		        })
		      );
		    }
		  }]);
	
		  return Anchors;
		}(_react2.default.Component);
	
		exports.default = Anchors;
	
	
		Anchors.propTypes = {
		  categories: _react2.default.PropTypes.array,
		  onAnchorClick: _react2.default.PropTypes.func
		};
	
		Anchors.defaultProps = {
		  categories: [],
		  onAnchorClick: function onAnchorClick() {}
		};
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
		var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var DOMParser = typeof window !== 'undefined' && window.DOMParser;
		var process = process || {};
		process.env = process.env || {};
		var parserAvailable = typeof DOMParser !== 'undefined' && DOMParser.prototype != null && DOMParser.prototype.parseFromString != null;
	
		if ("production" !== process.env.NODE_ENV && !parserAvailable) {
		    console.info('<InlineSVG />: `raw` prop works only when `window.DOMParser` exists.');
		}
	
		function isParsable(src) {
		    // kinda naive but meh, ain't gonna use full-blown parser for this
		    return parserAvailable && typeof src === 'string' && src.trim().substr(0, 4) === '<svg';
		}
	
		// parse SVG string using `DOMParser`
		function parseFromSVGString(src) {
		    var parser = new DOMParser();
		    return parser.parseFromString(src, "image/svg+xml");
		}
	
		// Transform DOM prop/attr names applicable to `<svg>` element but react-limited
		function switchSVGAttrToReactProp(propName) {
		    switch (propName) {
		        case 'class':
		            return 'className';
		        default:
		            return propName;
		    }
		}
	
		var InlineSVG = (function (_React$Component) {
		    _inherits(InlineSVG, _React$Component);
	
		    _createClass(InlineSVG, null, [{
		        key: 'defaultProps',
		        value: {
		            element: 'i',
		            raw: false,
		            src: ''
		        },
		        enumerable: true
		    }, {
		        key: 'propTypes',
		        value: {
		            src: _react2['default'].PropTypes.string.isRequired,
		            element: _react2['default'].PropTypes.string,
		            raw: _react2['default'].PropTypes.bool
		        },
		        enumerable: true
		    }]);
	
		    function InlineSVG(props) {
		        _classCallCheck(this, InlineSVG);
	
		        _get(Object.getPrototypeOf(InlineSVG.prototype), 'constructor', this).call(this, props);
		        this._extractSVGProps = this._extractSVGProps.bind(this);
		    }
	
		    // Serialize `Attr` objects in `NamedNodeMap`
	
		    _createClass(InlineSVG, [{
		        key: '_serializeAttrs',
		        value: function _serializeAttrs(map) {
		            var ret = {};
		            var prop = undefined;
		            for (var i = 0; i < map.length; i++) {
		                prop = switchSVGAttrToReactProp(map[i].name);
		                ret[prop] = map[i].value;
		            }
		            return ret;
		        }
	
		        // get <svg /> element props
		    }, {
		        key: '_extractSVGProps',
		        value: function _extractSVGProps(src) {
		            var map = parseFromSVGString(src).documentElement.attributes;
		            return map.length > 0 ? this._serializeAttrs(map) : null;
		        }
	
		        // get content inside <svg> element.
		    }, {
		        key: '_stripSVG',
		        value: function _stripSVG(src) {
		            return parseFromSVGString(src).documentElement.innerHTML;
		        }
		    }, {
		        key: 'componentWillReceiveProps',
		        value: function componentWillReceiveProps(_ref) {
		            var children = _ref.children;
	
		            if ("production" !== process.env.NODE_ENV && children != null) {
		                console.info('<InlineSVG />: `children` prop will be ignored.');
		            }
		        }
		    }, {
		        key: 'render',
		        value: function render() {
		            var Element = undefined,
		                __html = undefined,
		                svgProps = undefined;
		            var _props = this.props;
		            var element = _props.element;
		            var raw = _props.raw;
		            var src = _props.src;
	
		            var otherProps = _objectWithoutProperties(_props, ['element', 'raw', 'src']);
	
		            if (raw === true && isParsable(src)) {
		                Element = 'svg';
		                svgProps = this._extractSVGProps(src);
		                __html = this._stripSVG(src);
		            }
		            __html = __html || src;
		            Element = Element || element;
		            svgProps = svgProps || {};
	
		            return _react2['default'].createElement(Element, _extends({}, svgProps, otherProps, { src: null, children: null,
		                dangerouslySetInnerHTML: { __html: __html } }));
		        }
		    }]);
	
		    return InlineSVG;
		})(_react2['default'].Component);
	
		exports['default'] = InlineSVG;
		module.exports = exports['default'];
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _activity = __webpack_require__(6);
	
		Object.defineProperty(exports, 'Activity', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_activity).default;
		  }
		});
	
		var _flags = __webpack_require__(7);
	
		Object.defineProperty(exports, 'Flags', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_flags).default;
		  }
		});
	
		var _foods = __webpack_require__(8);
	
		Object.defineProperty(exports, 'Foods', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_foods).default;
		  }
		});
	
		var _nature = __webpack_require__(9);
	
		Object.defineProperty(exports, 'Nature', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_nature).default;
		  }
		});
	
		var _objects = __webpack_require__(10);
	
		Object.defineProperty(exports, 'Objects', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_objects).default;
		  }
		});
	
		var _people = __webpack_require__(11);
	
		Object.defineProperty(exports, 'People', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_people).default;
		  }
		});
	
		var _places = __webpack_require__(12);
	
		Object.defineProperty(exports, 'Places', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_places).default;
		  }
		});
	
		var _recent = __webpack_require__(13);
	
		Object.defineProperty(exports, 'Recent', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_recent).default;
		  }
		});
	
		var _symbols = __webpack_require__(14);
	
		Object.defineProperty(exports, 'Symbols', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_symbols).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113\"></path></svg>"
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z\"></path></svg>"
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9\"></path></svg>"
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8\"></path><path d=\"M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235\"></path></svg>"
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z\"></path><path d=\"M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789\"></path></svg>"
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10\"></path><path d=\"M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0\"></path></svg>"
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5\"></path><path d=\"M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z\"></path></svg>"
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z\"></path><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10\"></path></svg>"
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" height=\"24\" width=\"24\"><path d=\"M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76\"></path></svg>"
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _frequently = __webpack_require__(16);
	
		var _frequently2 = _interopRequireDefault(_frequently);
	
		var _ = __webpack_require__(1);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Category = function (_React$Component) {
		  _inherits(Category, _React$Component);
	
		  function Category() {
		    _classCallCheck(this, Category);
	
		    return _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).apply(this, arguments));
		  }
	
		  _createClass(Category, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.container = this.refs.container;
		      this.label = this.refs.label;
		      this.parent = this.container.parentNode;
	
		      this.margin = 0;
		      this.minMargin = 0;
	
		      this.memoizeSize();
		    }
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function shouldComponentUpdate(nextProps, nextState) {
		      var _props = this.props;
		      var name = _props.name;
		      var perLine = _props.perLine;
		      var native = _props.native;
		      var hasStickyPosition = _props.hasStickyPosition;
		      var emojis = _props.emojis;
		      var emojiProps = _props.emojiProps;
		      var skin = emojiProps.skin;
		      var size = emojiProps.size;
		      var set = emojiProps.set;
		      var nextPerLine = nextProps.perLine;
		      var nextNative = nextProps.native;
		      var nextHasStickyPosition = nextProps.hasStickyPosition;
		      var nextEmojis = nextProps.emojis;
		      var nextEmojiProps = nextProps.emojiProps;
		      var nextSkin = nextEmojiProps.skin;
		      var nextSize = nextEmojiProps.size;
		      var nextSet = nextEmojiProps.set;
		      var shouldUpdate = false;
	
		      if (name == 'Recent' && perLine != nextPerLine) {
		        shouldUpdate = true;
		      }
	
		      if (name == 'Search') {
		        shouldUpdate = !(emojis == nextEmojis);
		      }
	
		      if (skin != nextSkin || size != nextSize || native != nextNative || set != nextSet || hasStickyPosition != nextHasStickyPosition) {
		        shouldUpdate = true;
		      }
	
		      return shouldUpdate;
		    }
		  }, {
		    key: 'memoizeSize',
		    value: function memoizeSize() {
		      var _container$getBoundin = this.container.getBoundingClientRect();
	
		      var top = _container$getBoundin.top;
		      var height = _container$getBoundin.height;
	
		      var _parent$getBoundingCl = this.parent.getBoundingClientRect();
	
		      var parentTop = _parent$getBoundingCl.top;
	
		      var _label$getBoundingCli = this.label.getBoundingClientRect();
	
		      var labelHeight = _label$getBoundingCli.height;
	
	
		      this.top = top - parentTop + this.parent.scrollTop;
	
		      if (height == 0) {
		        this.maxMargin = 0;
		      } else {
		        this.maxMargin = height - labelHeight;
		      }
		    }
		  }, {
		    key: 'handleScroll',
		    value: function handleScroll(scrollTop) {
		      var margin = scrollTop - this.top;
		      margin = margin < this.minMargin ? this.minMargin : margin;
		      margin = margin > this.maxMargin ? this.maxMargin : margin;
	
		      if (margin == this.margin) return;
		      var name = this.props.name;
	
	
		      if (!this.props.hasStickyPosition) {
		        this.label.style.top = margin + 'px';
		      }
	
		      this.margin = margin;
		      return true;
		    }
		  }, {
		    key: 'getEmojis',
		    value: function getEmojis() {
		      var _props2 = this.props;
		      var name = _props2.name;
		      var emojis = _props2.emojis;
		      var perLine = _props2.perLine;
	
	
		      if (name == 'Recent') {
		        var frequentlyUsed = _frequently2.default.get(perLine * 4);
	
		        if (frequentlyUsed.length) {
		          emojis = frequentlyUsed;
		        }
		      }
	
		      if (emojis) {
		        emojis = emojis.slice(0);
		      }
	
		      return emojis;
		    }
		  }, {
		    key: 'updateDisplay',
		    value: function updateDisplay(display) {
		      var emojis = this.getEmojis();
	
		      if (!emojis) {
		        return;
		      }
	
		      this.container.style.display = display;
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props3 = this.props;
		      var name = _props3.name;
		      var hasStickyPosition = _props3.hasStickyPosition;
		      var emojiProps = _props3.emojiProps;
		      var i18n = _props3.i18n;
		      var emojis = this.getEmojis();
		      var labelStyles = {};
		      var labelSpanStyles = {};
		      var containerStyles = {};
	
		      if (!emojis) {
		        containerStyles = {
		          display: 'none'
		        };
		      }
	
		      if (!hasStickyPosition) {
		        labelStyles = {
		          height: 28
		        };
	
		        labelSpanStyles = {
		          position: 'absolute'
		        };
		      }
	
		      return _react2.default.createElement(
		        'div',
		        { ref: 'container', className: 'emoji-mart-category', style: containerStyles },
		        _react2.default.createElement(
		          'div',
		          { style: labelStyles, 'data-name': name, className: 'emoji-mart-category-label' },
		          _react2.default.createElement(
		            'span',
		            { style: labelSpanStyles, ref: 'label' },
		            i18n.categories[name.toLowerCase()]
		          )
		        ),
		        emojis && emojis.map(function (emoji) {
		          return _react2.default.createElement(_.Emoji, _extends({
		            key: emoji.id || emoji,
		            emoji: emoji
		          }, emojiProps));
		        }),
		        emojis && !emojis.length && _react2.default.createElement(
		          'div',
		          { className: 'emoji-mart-no-results' },
		          _react2.default.createElement(_.Emoji, _extends({}, emojiProps, {
		            size: 22,
		            emoji: 'sleuth_or_spy'
		          })),
		          _react2.default.createElement(
		            'span',
		            { className: 'emoji-mart-no-results-label' },
		            'No emoji found'
		          )
		        )
		      );
		    }
		  }]);
	
		  return Category;
		}(_react2.default.Component);
	
		exports.default = Category;
	
	
		Category.propTypes = {
		  emojis: _react2.default.PropTypes.array,
		  hasStickyPosition: _react2.default.PropTypes.bool,
		  name: _react2.default.PropTypes.string.isRequired,
		  native: _react2.default.PropTypes.bool.isRequired,
		  perLine: _react2.default.PropTypes.number.isRequired,
		  emojiProps: _react2.default.PropTypes.object.isRequired
		};
	
		Category.defaultProps = {
		  emojis: [],
		  hasStickyPosition: true
		};
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _store = __webpack_require__(17);
	
		var _store2 = _interopRequireDefault(_store);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var frequently = _store2.default.get('frequently') || {};
	
		function add(emoji) {
		  var id = emoji.id;
	
	
		  frequently[id] || (frequently[id] = 0);
		  frequently[id] += 1;
	
		  _store2.default.set('last', id);
		  _store2.default.set('frequently', frequently);
		}
	
		function get(quantity) {
		  var sorted = Object.keys(frequently).sort(function (a, b) {
		    return frequently[a] - frequently[b];
		  }).reverse(),
		      sliced = sorted.slice(0, quantity),
		      last = _store2.default.get('last');
	
		  if (last && sliced.indexOf(last) == -1) {
		    sliced.pop();
		    sliced.push(last);
		  }
	
		  return sliced;
		}
	
		exports.default = { add: add, get: get };
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		var NAMESPACE = 'emoji-mart';
	
		var isLocalStorageSupported = typeof window !== 'undefined' && 'localStorage' in window;
	
		function update(state) {
		  for (var key in state) {
		    var value = state[key];
		    set(key, value);
		  }
		}
	
		function set(key, value) {
		  if (!isLocalStorageSupported) return;
		  try {
		    window.localStorage[NAMESPACE + '.' + key] = JSON.stringify(value);
		  } catch (e) {}
		}
	
		function get(key) {
		  if (!isLocalStorageSupported) return;
		  try {
		    var value = window.localStorage[NAMESPACE + '.' + key];
		  } catch (e) {
		    return;
		  }
	
		  if (value) {
		    return JSON.parse(value);
		  }
		}
	
		function setNamespace(namespace) {
		  NAMESPACE = namespace;
		}
	
		exports.default = { update: update, set: set, get: get, setNamespace: setNamespace };
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _data = __webpack_require__(19);
	
		var _data2 = _interopRequireDefault(_data);
	
		var _utils = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SHEET_COLUMNS = 41;
	
		var Emoji = function (_React$Component) {
		  _inherits(Emoji, _React$Component);
	
		  function Emoji(props) {
		    _classCallCheck(this, Emoji);
	
		    var _this = _possibleConstructorReturn(this, (Emoji.__proto__ || Object.getPrototypeOf(Emoji)).call(this, props));
	
		    _this.hasSkinVariations = !!_this.getData().skin_variations;
		    return _this;
		  }
	
		  _createClass(Emoji, [{
		    key: 'shouldComponentUpdate',
		    value: function shouldComponentUpdate(nextProps) {
		      return this.hasSkinVariations && nextProps.skin != this.props.skin || nextProps.size != this.props.size || nextProps.native != this.props.native || nextProps.set != this.props.set || nextProps.emoji != this.props.emoji;
		    }
		  }, {
		    key: 'getPosition',
		    value: function getPosition() {
		      var _getData2 = this.getData();
	
		      var sheet_x = _getData2.sheet_x;
		      var sheet_y = _getData2.sheet_y;
		      var multiply = 100 / (SHEET_COLUMNS - 1);
	
		      return multiply * sheet_x + '% ' + multiply * sheet_y + '%';
		    }
		  }, {
		    key: 'getData',
		    value: function getData() {
		      var _props = this.props;
		      var emoji = _props.emoji;
		      var skin = _props.skin;
		      var set = _props.set;
	
		      return (0, _utils.getData)(emoji, skin, set);
		    }
		  }, {
		    key: 'getSanitizedData',
		    value: function getSanitizedData() {
		      var _props2 = this.props;
		      var emoji = _props2.emoji;
		      var skin = _props2.skin;
		      var set = _props2.set;
	
		      return (0, _utils.getSanitizedData)(emoji, skin, set);
		    }
		  }, {
		    key: 'handleClick',
		    value: function handleClick(e) {
		      var onClick = this.props.onClick;
		      var emoji = this.getSanitizedData();
	
		      onClick(emoji, e);
		    }
		  }, {
		    key: 'handleOver',
		    value: function handleOver(e) {
		      var onOver = this.props.onOver;
		      var emoji = this.getSanitizedData();
	
		      onOver(emoji, e);
		    }
		  }, {
		    key: 'handleLeave',
		    value: function handleLeave(e) {
		      var onLeave = this.props.onLeave;
		      var emoji = this.getSanitizedData();
	
		      onLeave(emoji, e);
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props3 = this.props;
		      var set = _props3.set;
		      var size = _props3.size;
		      var sheetSize = _props3.sheetSize;
		      var native = _props3.native;
		      var forceSize = _props3.forceSize;
		      var onOver = _props3.onOver;
		      var onLeave = _props3.onLeave;
		      var backgroundImageFn = _props3.backgroundImageFn;
	
		      var _getData3 = this.getData();
	
		      var unified = _getData3.unified;
		      var style = {};
		      var children = this.props.children;
	
		      if (!unified) {
		        return null;
		      }
	
		      if (native && unified) {
		        style = { fontSize: size };
		        children = (0, _utils.unifiedToNative)(unified);
	
		        if (forceSize) {
		          style.display = 'inline-block';
		          style.width = size;
		          style.height = size;
		        }
		      } else {
		        style = {
		          width: size,
		          height: size,
		          display: 'inline-block',
		          backgroundImage: 'url(' + backgroundImageFn(set, sheetSize) + ')',
		          backgroundSize: 100 * SHEET_COLUMNS + '%',
		          backgroundPosition: this.getPosition()
		        };
		      }
	
		      return _react2.default.createElement(
		        'span',
		        {
		          onClick: this.handleClick.bind(this),
		          onMouseEnter: this.handleOver.bind(this),
		          onMouseLeave: this.handleLeave.bind(this),
		          className: 'emoji-mart-emoji' },
		        _react2.default.createElement(
		          'span',
		          { style: style },
		          children
		        )
		      );
		    }
		  }]);
	
		  return Emoji;
		}(_react2.default.Component);
	
		exports.default = Emoji;
	
	
		Emoji.propTypes = {
		  onOver: _react2.default.PropTypes.func,
		  onLeave: _react2.default.PropTypes.func,
		  onClick: _react2.default.PropTypes.func,
		  backgroundImageFn: _react2.default.PropTypes.func,
		  native: _react2.default.PropTypes.bool,
		  forceSize: _react2.default.PropTypes.bool,
		  skin: _react2.default.PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
		  sheetSize: _react2.default.PropTypes.oneOf([16, 20, 32, 64]),
		  set: _react2.default.PropTypes.oneOf(['apple', 'google', 'twitter', 'emojione']),
		  size: _react2.default.PropTypes.number.isRequired,
		  emoji: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]).isRequired
		};
	
		Emoji.defaultProps = {
		  skin: 1,
		  set: 'apple',
		  sheetSize: 64,
		  native: false,
		  forceSize: false,
		  backgroundImageFn: function backgroundImageFn(set, sheetSize) {
		    return 'https://unpkg.com/emoji-datasource@' + ('2.4.4') + '/sheet_' + set + '_' + sheetSize + '.png';
		  },
		  onOver: function onOver() {},
		  onLeave: function onLeave() {},
		  onClick: function onClick() {}
		};
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = { categories: [{ name: "People", emojis: ["grinning", "grimacing", "grin", "joy", "smiley", "smile", "sweat_smile", "laughing", "innocent", "wink", "blush", "slightly_smiling_face", "upside_down_face", "relaxed", "yum", "relieved", "heart_eyes", "kissing_heart", "kissing", "kissing_smiling_eyes", "kissing_closed_eyes", "stuck_out_tongue_winking_eye", "stuck_out_tongue_closed_eyes", "stuck_out_tongue", "money_mouth_face", "nerd_face", "sunglasses", "hugging_face", "smirk", "no_mouth", "neutral_face", "expressionless", "unamused", "face_with_rolling_eyes", "thinking_face", "flushed", "disappointed", "worried", "angry", "rage", "pensive", "confused", "slightly_frowning_face", "white_frowning_face", "persevere", "confounded", "tired_face", "weary", "triumph", "open_mouth", "scream", "fearful", "cold_sweat", "hushed", "frowning", "anguished", "cry", "disappointed_relieved", "sleepy", "sweat", "sob", "dizzy_face", "astonished", "zipper_mouth_face", "mask", "face_with_thermometer", "face_with_head_bandage", "sleeping", "zzz", "hankey", "smiling_imp", "imp", "japanese_ogre", "japanese_goblin", "skull", "ghost", "alien", "robot_face", "smiley_cat", "smile_cat", "joy_cat", "heart_eyes_cat", "smirk_cat", "kissing_cat", "scream_cat", "crying_cat_face", "pouting_cat", "raised_hands", "clap", "wave", "+1", "-1", "facepunch", "fist", "v", "ok_hand", "hand", "open_hands", "muscle", "pray", "point_up", "point_up_2", "point_down", "point_left", "point_right", "middle_finger", "raised_hand_with_fingers_splayed", "the_horns", "spock-hand", "writing_hand", "nail_care", "lips", "tongue", "ear", "nose", "eye", "eyes", "bust_in_silhouette", "busts_in_silhouette", "speaking_head_in_silhouette", "baby", "boy", "girl", "man", "woman", "person_with_blond_hair", "older_man", "older_woman", "man_with_gua_pi_mao", "man_with_turban", "cop", "construction_worker", "guardsman", "sleuth_or_spy", "santa", "angel", "princess", "bride_with_veil", "walking", "runner", "dancer", "dancers", "couple", "two_men_holding_hands", "two_women_holding_hands", "bow", "information_desk_person", "no_good", "ok_woman", "raising_hand", "person_with_pouting_face", "person_frowning", "haircut", "massage", "couple_with_heart", "woman-heart-woman", "man-heart-man", "couplekiss", "woman-kiss-woman", "man-kiss-man", "family", "man-woman-girl", "man-woman-girl-boy", "man-woman-boy-boy", "man-woman-girl-girl", "woman-woman-boy", "woman-woman-girl", "woman-woman-girl-boy", "woman-woman-boy-boy", "woman-woman-girl-girl", "man-man-boy", "man-man-girl", "man-man-girl-boy", "man-man-boy-boy", "man-man-girl-girl", "womans_clothes", "shirt", "jeans", "necktie", "dress", "bikini", "kimono", "lipstick", "kiss", "footprints", "high_heel", "sandal", "boot", "mans_shoe", "athletic_shoe", "womans_hat", "tophat", "helmet_with_white_cross", "mortar_board", "crown", "school_satchel", "pouch", "purse", "handbag", "briefcase", "eyeglasses", "dark_sunglasses", "ring", "closed_umbrella"] }, { name: "Nature", emojis: ["dog", "cat", "mouse", "hamster", "rabbit", "bear", "panda_face", "koala", "tiger", "lion_face", "cow", "pig", "pig_nose", "frog", "octopus", "monkey_face", "see_no_evil", "hear_no_evil", "speak_no_evil", "monkey", "chicken", "penguin", "bird", "baby_chick", "hatching_chick", "hatched_chick", "wolf", "boar", "horse", "unicorn_face", "bee", "bug", "snail", "beetle", "ant", "spider", "scorpion", "crab", "snake", "turtle", "tropical_fish", "fish", "blowfish", "dolphin", "whale", "whale2", "crocodile", "leopard", "tiger2", "water_buffalo", "ox", "cow2", "dromedary_camel", "camel", "elephant", "goat", "ram", "sheep", "racehorse", "pig2", "rat", "mouse2", "rooster", "turkey", "dove_of_peace", "dog2", "poodle", "cat2", "rabbit2", "chipmunk", "feet", "dragon", "dragon_face", "cactus", "christmas_tree", "evergreen_tree", "deciduous_tree", "palm_tree", "seedling", "herb", "shamrock", "four_leaf_clover", "bamboo", "tanabata_tree", "leaves", "fallen_leaf", "maple_leaf", "ear_of_rice", "hibiscus", "sunflower", "rose", "tulip", "blossom", "cherry_blossom", "bouquet", "mushroom", "chestnut", "jack_o_lantern", "shell", "spider_web", "earth_americas", "earth_africa", "earth_asia", "full_moon", "waning_gibbous_moon", "last_quarter_moon", "waning_crescent_moon", "new_moon", "waxing_crescent_moon", "first_quarter_moon", "moon", "new_moon_with_face", "full_moon_with_face", "first_quarter_moon_with_face", "last_quarter_moon_with_face", "sun_with_face", "crescent_moon", "star", "star2", "dizzy", "sparkles", "comet", "sunny", "mostly_sunny", "partly_sunny", "barely_sunny", "partly_sunny_rain", "cloud", "rain_cloud", "thunder_cloud_and_rain", "lightning", "zap", "fire", "boom", "snowflake", "snow_cloud", "snowman", "snowman_without_snow", "wind_blowing_face", "dash", "tornado", "fog", "umbrella", "umbrella_with_rain_drops", "droplet", "sweat_drops", "ocean"] }, { name: "Foods", emojis: ["green_apple", "apple", "pear", "tangerine", "lemon", "banana", "watermelon", "grapes", "strawberry", "melon", "cherries", "peach", "pineapple", "tomato", "eggplant", "hot_pepper", "corn", "sweet_potato", "honey_pot", "bread", "cheese_wedge", "poultry_leg", "meat_on_bone", "fried_shrimp", "egg", "hamburger", "fries", "hotdog", "pizza", "spaghetti", "taco", "burrito", "ramen", "stew", "fish_cake", "sushi", "bento", "curry", "rice_ball", "rice", "rice_cracker", "oden", "dango", "shaved_ice", "ice_cream", "icecream", "cake", "birthday", "custard", "candy", "lollipop", "chocolate_bar", "popcorn", "doughnut", "cookie", "beer", "beers", "wine_glass", "cocktail", "tropical_drink", "champagne", "sake", "tea", "coffee", "baby_bottle", "fork_and_knife", "knife_fork_plate"] }, { name: "Activity", emojis: ["soccer", "basketball", "football", "baseball", "tennis", "volleyball", "rugby_football", "8ball", "golf", "golfer", "table_tennis_paddle_and_ball", "badminton_racquet_and_shuttlecock", "ice_hockey_stick_and_puck", "field_hockey_stick_and_ball", "cricket_bat_and_ball", "ski", "skier", "snowboarder", "ice_skate", "bow_and_arrow", "fishing_pole_and_fish", "rowboat", "swimmer", "surfer", "bath", "person_with_ball", "weight_lifter", "bicyclist", "mountain_bicyclist", "horse_racing", "man_in_business_suit_levitating", "trophy", "running_shirt_with_sash", "sports_medal", "medal", "reminder_ribbon", "rosette", "ticket", "admission_tickets", "performing_arts", "art", "circus_tent", "microphone", "headphones", "musical_score", "musical_keyboard", "saxophone", "trumpet", "guitar", "violin", "clapper", "video_game", "space_invader", "dart", "game_die", "slot_machine", "bowling"] }, { name: "Places", emojis: ["car", "taxi", "blue_car", "bus", "trolleybus", "racing_car", "police_car", "ambulance", "fire_engine", "minibus", "truck", "articulated_lorry", "tractor", "racing_motorcycle", "bike", "rotating_light", "oncoming_police_car", "oncoming_bus", "oncoming_automobile", "oncoming_taxi", "aerial_tramway", "mountain_cableway", "suspension_railway", "railway_car", "train", "monorail", "bullettrain_side", "bullettrain_front", "light_rail", "mountain_railway", "steam_locomotive", "train2", "metro", "tram", "station", "helicopter", "small_airplane", "airplane", "airplane_departure", "airplane_arriving", "boat", "motor_boat", "speedboat", "ferry", "passenger_ship", "rocket", "satellite", "seat", "anchor", "construction", "fuelpump", "busstop", "vertical_traffic_light", "traffic_light", "checkered_flag", "ship", "ferris_wheel", "roller_coaster", "carousel_horse", "building_construction", "foggy", "tokyo_tower", "factory", "fountain", "rice_scene", "mountain", "snow_capped_mountain", "mount_fuji", "volcano", "japan", "camping", "tent", "national_park", "motorway", "railway_track", "sunrise", "sunrise_over_mountains", "desert", "beach_with_umbrella", "desert_island", "city_sunrise", "city_sunset", "cityscape", "night_with_stars", "bridge_at_night", "milky_way", "stars", "sparkler", "fireworks", "rainbow", "house_buildings", "european_castle", "japanese_castle", "stadium", "statue_of_liberty", "house", "house_with_garden", "derelict_house_building", "office", "department_store", "post_office", "european_post_office", "hospital", "bank", "hotel", "convenience_store", "school", "love_hotel", "wedding", "classical_building", "church", "mosque", "synagogue", "kaaba", "shinto_shrine"] }, { name: "Objects", emojis: ["watch", "iphone", "calling", "computer", "keyboard", "desktop_computer", "printer", "three_button_mouse", "trackball", "joystick", "compression", "minidisc", "floppy_disk", "cd", "dvd", "vhs", "camera", "camera_with_flash", "video_camera", "movie_camera", "film_projector", "film_frames", "telephone_receiver", "phone", "pager", "fax", "tv", "radio", "studio_microphone", "level_slider", "control_knobs", "stopwatch", "timer_clock", "alarm_clock", "mantelpiece_clock", "hourglass_flowing_sand", "hourglass", "satellite_antenna", "battery", "electric_plug", "bulb", "flashlight", "candle", "wastebasket", "oil_drum", "money_with_wings", "dollar", "yen", "euro", "pound", "moneybag", "credit_card", "gem", "scales", "wrench", "hammer", "hammer_and_pick", "hammer_and_wrench", "pick", "nut_and_bolt", "gear", "chains", "gun", "bomb", "hocho", "dagger_knife", "crossed_swords", "shield", "smoking", "skull_and_crossbones", "coffin", "funeral_urn", "amphora", "crystal_ball", "prayer_beads", "barber", "alembic", "telescope", "microscope", "hole", "pill", "syringe", "thermometer", "label", "bookmark", "toilet", "shower", "bathtub", "key", "old_key", "couch_and_lamp", "sleeping_accommodation", "bed", "door", "bellhop_bell", "frame_with_picture", "world_map", "umbrella_on_ground", "moyai", "shopping_bags", "balloon", "flags", "ribbon", "gift", "confetti_ball", "tada", "dolls", "wind_chime", "crossed_flags", "izakaya_lantern", "email", "envelope_with_arrow", "incoming_envelope", "e-mail", "love_letter", "postbox", "mailbox_closed", "mailbox", "mailbox_with_mail", "mailbox_with_no_mail", "package", "postal_horn", "inbox_tray", "outbox_tray", "scroll", "page_with_curl", "bookmark_tabs", "bar_chart", "chart_with_upwards_trend", "chart_with_downwards_trend", "page_facing_up", "date", "calendar", "spiral_calendar_pad", "card_index", "card_file_box", "ballot_box_with_ballot", "file_cabinet", "clipboard", "spiral_note_pad", "file_folder", "open_file_folder", "card_index_dividers", "rolled_up_newspaper", "newspaper", "notebook", "closed_book", "green_book", "blue_book", "orange_book", "notebook_with_decorative_cover", "ledger", "books", "book", "link", "paperclip", "linked_paperclips", "scissors", "triangular_ruler", "straight_ruler", "pushpin", "round_pushpin", "triangular_flag_on_post", "waving_white_flag", "waving_black_flag", "closed_lock_with_key", "lock", "unlock", "lock_with_ink_pen", "lower_left_ballpoint_pen", "lower_left_fountain_pen", "black_nib", "memo", "pencil2", "lower_left_crayon", "lower_left_paintbrush", "mag", "mag_right"] }, { name: "Symbols", emojis: ["heart", "yellow_heart", "green_heart", "blue_heart", "purple_heart", "broken_heart", "heavy_heart_exclamation_mark_ornament", "two_hearts", "revolving_hearts", "heartbeat", "heartpulse", "sparkling_heart", "cupid", "gift_heart", "heart_decoration", "peace_symbol", "latin_cross", "star_and_crescent", "om_symbol", "wheel_of_dharma", "star_of_david", "six_pointed_star", "menorah_with_nine_branches", "yin_yang", "orthodox_cross", "place_of_worship", "ophiuchus", "aries", "taurus", "gemini", "cancer", "leo", "virgo", "libra", "scorpius", "sagittarius", "capricorn", "aquarius", "pisces", "id", "atom_symbol", "u7a7a", "u5272", "radioactive_sign", "biohazard_sign", "mobile_phone_off", "vibration_mode", "u6709", "u7121", "u7533", "u55b6", "u6708", "eight_pointed_black_star", "vs", "accept", "white_flower", "ideograph_advantage", "secret", "congratulations", "u5408", "u6e80", "u7981", "a", "b", "ab", "cl", "o2", "sos", "no_entry", "name_badge", "no_entry_sign", "x", "o", "anger", "hotsprings", "no_pedestrians", "do_not_litter", "no_bicycles", "non-potable_water", "underage", "no_mobile_phones", "exclamation", "grey_exclamation", "question", "grey_question", "bangbang", "interrobang", "100", "low_brightness", "high_brightness", "trident", "fleur_de_lis", "part_alternation_mark", "warning", "children_crossing", "beginner", "recycle", "u6307", "chart", "sparkle", "eight_spoked_asterisk", "negative_squared_cross_mark", "white_check_mark", "diamond_shape_with_a_dot_inside", "cyclone", "loop", "globe_with_meridians", "m", "atm", "sa", "passport_control", "customs", "baggage_claim", "left_luggage", "wheelchair", "no_smoking", "wc", "parking", "potable_water", "mens", "womens", "baby_symbol", "restroom", "put_litter_in_its_place", "cinema", "signal_strength", "koko", "ng", "ok", "up", "cool", "new", "free", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "keycap_ten", "keycap_star", "1234", "arrow_forward", "double_vertical_bar", "black_right_pointing_triangle_with_double_vertical_bar", "black_square_for_stop", "eject", "black_circle_for_record", "black_right_pointing_double_triangle_with_vertical_bar", "black_left_pointing_double_triangle_with_vertical_bar", "fast_forward", "rewind", "twisted_rightwards_arrows", "repeat", "repeat_one", "arrow_backward", "arrow_up_small", "arrow_down_small", "arrow_double_up", "arrow_double_down", "arrow_right", "arrow_left", "arrow_up", "arrow_down", "arrow_upper_right", "arrow_lower_right", "arrow_lower_left", "arrow_upper_left", "arrow_up_down", "left_right_arrow", "arrows_counterclockwise", "arrow_right_hook", "leftwards_arrow_with_hook", "arrow_heading_up", "arrow_heading_down", "hash", "information_source", "abc", "abcd", "capital_abcd", "symbols", "musical_note", "notes", "wavy_dash", "curly_loop", "heavy_check_mark", "arrows_clockwise", "heavy_plus_sign", "heavy_minus_sign", "heavy_division_sign", "heavy_multiplication_x", "heavy_dollar_sign", "currency_exchange", "copyright", "registered", "tm", "end", "back", "on", "top", "soon", "ballot_box_with_check", "radio_button", "white_circle", "black_circle", "red_circle", "large_blue_circle", "small_orange_diamond", "small_blue_diamond", "large_orange_diamond", "large_blue_diamond", "small_red_triangle", "black_small_square", "white_small_square", "black_large_square", "white_large_square", "small_red_triangle_down", "black_medium_square", "white_medium_square", "black_medium_small_square", "white_medium_small_square", "black_square_button", "white_square_button", "speaker", "sound", "loud_sound", "mute", "mega", "loudspeaker", "bell", "no_bell", "black_joker", "mahjong", "spades", "clubs", "hearts", "diamonds", "flower_playing_cards", "thought_balloon", "right_anger_bubble", "speech_balloon", "left_speech_bubble", "clock1", "clock2", "clock3", "clock4", "clock5", "clock6", "clock7", "clock8", "clock9", "clock10", "clock11", "clock12", "clock130", "clock230", "clock330", "clock430", "clock530", "clock630", "clock730", "clock830", "clock930", "clock1030", "clock1130", "clock1230"] }, { name: "Flags", emojis: ["flag-ac", "flag-ad", "flag-ae", "flag-af", "flag-ag", "flag-ai", "flag-al", "flag-am", "flag-ao", "flag-aq", "flag-ar", "flag-as", "flag-at", "flag-au", "flag-aw", "flag-ax", "flag-az", "flag-ba", "flag-bb", "flag-bd", "flag-be", "flag-bf", "flag-bg", "flag-bh", "flag-bi", "flag-bj", "flag-bl", "flag-bm", "flag-bn", "flag-bo", "flag-bq", "flag-br", "flag-bs", "flag-bt", "flag-bv", "flag-bw", "flag-by", "flag-bz", "flag-ca", "flag-cc", "flag-cd", "flag-cf", "flag-cg", "flag-ch", "flag-ci", "flag-ck", "flag-cl", "flag-cm", "flag-cn", "flag-co", "flag-cp", "flag-cr", "flag-cu", "flag-cv", "flag-cw", "flag-cx", "flag-cy", "flag-cz", "flag-de", "flag-dg", "flag-dj", "flag-dk", "flag-dm", "flag-do", "flag-dz", "flag-ea", "flag-ec", "flag-ee", "flag-eg", "flag-eh", "flag-er", "flag-es", "flag-et", "flag-eu", "flag-fi", "flag-fj", "flag-fk", "flag-fm", "flag-fo", "flag-fr", "flag-ga", "flag-gb", "flag-gd", "flag-ge", "flag-gf", "flag-gg", "flag-gh", "flag-gi", "flag-gl", "flag-gm", "flag-gn", "flag-gp", "flag-gq", "flag-gr", "flag-gs", "flag-gt", "flag-gu", "flag-gw", "flag-gy", "flag-hk", "flag-hm", "flag-hn", "flag-hr", "flag-ht", "flag-hu", "flag-ic", "flag-id", "flag-ie", "flag-il", "flag-im", "flag-in", "flag-io", "flag-iq", "flag-ir", "flag-is", "flag-it", "flag-je", "flag-jm", "flag-jo", "flag-jp", "flag-ke", "flag-kg", "flag-kh", "flag-ki", "flag-km", "flag-kn", "flag-kp", "flag-kr", "flag-kw", "flag-ky", "flag-kz", "flag-la", "flag-lb", "flag-lc", "flag-li", "flag-lk", "flag-lr", "flag-ls", "flag-lt", "flag-lu", "flag-lv", "flag-ly", "flag-ma", "flag-mc", "flag-md", "flag-me", "flag-mf", "flag-mg", "flag-mh", "flag-mk", "flag-ml", "flag-mm", "flag-mn", "flag-mo", "flag-mp", "flag-mq", "flag-mr", "flag-ms", "flag-mt", "flag-mu", "flag-mv", "flag-mw", "flag-mx", "flag-my", "flag-mz", "flag-na", "flag-nc", "flag-ne", "flag-nf", "flag-ng", "flag-ni", "flag-nl", "flag-no", "flag-np", "flag-nr", "flag-nu", "flag-nz", "flag-om", "flag-pa", "flag-pe", "flag-pf", "flag-pg", "flag-ph", "flag-pk", "flag-pl", "flag-pm", "flag-pn", "flag-pr", "flag-ps", "flag-pt", "flag-pw", "flag-py", "flag-qa", "flag-re", "flag-ro", "flag-rs", "flag-ru", "flag-rw", "flag-sa", "flag-sb", "flag-sc", "flag-sd", "flag-se", "flag-sg", "flag-sh", "flag-si", "flag-sj", "flag-sk", "flag-sl", "flag-sm", "flag-sn", "flag-so", "flag-sr", "flag-ss", "flag-st", "flag-sv", "flag-sx", "flag-sy", "flag-sz", "flag-ta", "flag-tc", "flag-td", "flag-tf", "flag-tg", "flag-th", "flag-tj", "flag-tk", "flag-tl", "flag-tm", "flag-tn", "flag-to", "flag-tr", "flag-tt", "flag-tv", "flag-tw", "flag-tz", "flag-ua", "flag-ug", "flag-um", "flag-us", "flag-uy", "flag-uz", "flag-va", "flag-vc", "flag-ve", "flag-vg", "flag-vi", "flag-vn", "flag-vu", "flag-wf", "flag-ws", "flag-xk", "flag-ye", "flag-yt", "flag-za", "flag-zm", "flag-zw"] }], emojis: { "100": { name: "Hundred Points Symbol", unified: "1F4AF", sheet_x: 20, sheet_y: 27, short_names: ["100"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "100,hundred,points,symbol,score,perfect,numbers,century,exam,quiz,test,pass" }, "1234": { name: "Input Symbol for Numbers", unified: "1F522", sheet_x: 23, sheet_y: 18, short_names: ["1234"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "1234,input,symbol,for,numbers,blue-square" }, grinning: { name: "Grinning Face", unified: "1F600", sheet_x: 26, sheet_y: 15, short_names: ["grinning"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":D"], search: "grinning,face,smile,happy,joy,:d" }, heart: { name: "Heavy Black Heart", unified: "2764", variations: ["2764-FE0F"], sheet_x: 4, sheet_y: 10, short_names: ["heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["<3"], search: "heart,heavy,black,love,like,valentines,<3" }, dog: { name: "Dog Face", unified: "1F436", sheet_x: 13, sheet_y: 18, short_names: ["dog"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dog,face,animal,friend,nature,woof,puppy,pet,faithful" }, soccer: { name: "Soccer Ball", unified: "26BD", variations: ["26BD-FE0F"], sheet_x: 2, sheet_y: 18, short_names: ["soccer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "soccer,ball,sports,football" }, watch: { name: "Watch", unified: "231A", variations: ["231A-FE0F"], sheet_x: 0, sheet_y: 14, short_names: ["watch"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "watch,time,accessories" }, green_apple: { name: "Green Apple", unified: "1F34F", sheet_x: 7, sheet_y: 16, short_names: ["green_apple"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "green,apple,fruit,nature" }, "flag-af": { name: "Regional Indicator Symbol Letters AF", unified: "1F1E6-1F1EB", sheet_x: 32, sheet_y: 36, short_names: ["flag-af"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,af,regional,indicator,symbol,letters" }, car: { name: "Automobile", unified: "1F697", sheet_x: 29, sheet_y: 35, short_names: ["car", "red_car"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "car,red,automobile,transportation,vehicle" }, "flag-ax": { name: "Regional Indicator Symbol Letters AX", unified: "1F1E6-1F1FD", sheet_x: 33, sheet_y: 7, short_names: ["flag-ax"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ax,regional,indicator,symbol,letters" }, grimacing: { name: "Grimacing Face", unified: "1F62C", sheet_x: 27, sheet_y: 18, short_names: ["grimacing"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "grimacing,face,grimace,teeth" }, taxi: { name: "Taxi", unified: "1F695", sheet_x: 29, sheet_y: 33, short_names: ["taxi"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "taxi,uber,vehicle,cars,transportation" }, iphone: { name: "Mobile Phone", unified: "1F4F1", sheet_x: 22, sheet_y: 11, short_names: ["iphone"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "iphone,mobile,phone,technology,apple,gadgets,dial" }, basketball: { name: "Basketball and Hoop", unified: "1F3C0", sheet_x: 10, sheet_y: 6, short_names: ["basketball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "basketball,and,hoop,sports,balls,nba" }, cat: { name: "Cat Face", unified: "1F431", sheet_x: 13, sheet_y: 13, short_names: ["cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cat,face,animal,meow,nature,pet" }, apple: { name: "Red Apple", unified: "1F34E", sheet_x: 7, sheet_y: 15, short_names: ["apple"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "apple,red,fruit,mac,school" }, yellow_heart: { name: "Yellow Heart", unified: "1F49B", sheet_x: 20, sheet_y: 2, short_names: ["yellow_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["<3"], search: "yellow,heart,love,like,affection,valentines,<3" }, mouse: { name: "Mouse Face", unified: "1F42D", sheet_x: 13, sheet_y: 9, short_names: ["mouse"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mouse,face,animal,nature,cheese,rodent" }, pear: { name: "Pear", unified: "1F350", sheet_x: 7, sheet_y: 17, short_names: ["pear"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pear,fruit,nature,food" }, green_heart: { name: "Green Heart", unified: "1F49A", sheet_x: 20, sheet_y: 1, short_names: ["green_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["<3"], search: "green,heart,love,like,affection,valentines,<3" }, football: { name: "American Football", unified: "1F3C8", sheet_x: 10, sheet_y: 24, short_names: ["football"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "football,american,sports,balls,nfl" }, grin: { name: "Grinning Face with Smiling Eyes", unified: "1F601", sheet_x: 26, sheet_y: 16, short_names: ["grin"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "grin,grinning,face,with,smiling,eyes,happy,smile,joy" }, "flag-al": { name: "Regional Indicator Symbol Letters AL", unified: "1F1E6-1F1F1", sheet_x: 32, sheet_y: 39, short_names: ["flag-al"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,al,regional,indicator,symbol,letters" }, calling: { name: "Mobile Phone with Rightwards Arrow at Left", unified: "1F4F2", sheet_x: 22, sheet_y: 12, short_names: ["calling"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "calling,mobile,phone,with,rightwards,arrow,at,left,iphone,incoming" }, blue_car: { name: "Recreational Vehicle", unified: "1F699", sheet_x: 29, sheet_y: 37, short_names: ["blue_car"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "blue,car,recreational,vehicle,transportation" }, hamster: { name: "Hamster Face", unified: "1F439", sheet_x: 13, sheet_y: 21, short_names: ["hamster"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hamster,face,animal,nature" }, blue_heart: { name: "Blue Heart", unified: "1F499", sheet_x: 20, sheet_y: 0, short_names: ["blue_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["<3"], search: "blue,heart,love,like,affection,valentines,<3" }, bus: { name: "Bus", unified: "1F68C", sheet_x: 29, sheet_y: 24, short_names: ["bus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bus,car,vehicle,transportation" }, joy: { name: "Face with Tears of Joy", unified: "1F602", sheet_x: 26, sheet_y: 17, short_names: ["joy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "joy,face,with,tears,of,cry,weep,happy,haha" }, computer: { name: "Personal Computer", unified: "1F4BB", sheet_x: 20, sheet_y: 39, short_names: ["computer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "computer,personal,technology,laptop,screen,display,monitor" }, tangerine: { name: "Tangerine", unified: "1F34A", sheet_x: 7, sheet_y: 11, short_names: ["tangerine"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tangerine,food,fruit,nature" }, baseball: { name: "Baseball", unified: "26BE", variations: ["26BE-FE0F"], sheet_x: 2, sheet_y: 19, short_names: ["baseball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "baseball,sports,balls" }, "flag-dz": { name: "Regional Indicator Symbol Letters DZ", unified: "1F1E9-1F1FF", sheet_x: 34, sheet_y: 15, short_names: ["flag-dz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,dz,regional,indicator,symbol,letters" }, tennis: { name: "Tennis Racquet and Ball", unified: "1F3BE", sheet_x: 10, sheet_y: 4, short_names: ["tennis"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tennis,racquet,and,ball,sports,balls,green" }, trolleybus: { name: "Trolleybus", unified: "1F68E", sheet_x: 29, sheet_y: 26, short_names: ["trolleybus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "trolleybus,bart,transportation,vehicle" }, keyboard: { name: "Keyboard", unified: "2328", variations: ["2328-FE0F"], sheet_x: 0, sheet_y: 16, short_names: ["keyboard"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "keyboard,technology,computer,type,input,text" }, rabbit: { name: "Rabbit Face", unified: "1F430", sheet_x: 13, sheet_y: 12, short_names: ["rabbit"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rabbit,face,animal,nature,pet,spring,magic" }, "flag-as": { name: "Regional Indicator Symbol Letters AS", unified: "1F1E6-1F1F8", sheet_x: 33, sheet_y: 3, short_names: ["flag-as"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,as,regional,indicator,symbol,letters" }, lemon: { name: "Lemon", unified: "1F34B", sheet_x: 7, sheet_y: 12, short_names: ["lemon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lemon,fruit,nature" }, purple_heart: { name: "Purple Heart", unified: "1F49C", sheet_x: 20, sheet_y: 3, short_names: ["purple_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["<3"], search: "purple,heart,love,like,affection,valentines,<3" }, smiley: { name: "Smiling Face with Open Mouth", unified: "1F603", sheet_x: 26, sheet_y: 18, short_names: ["smiley"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["=)", "=-)"], search: "smiley,smiling,face,with,open,mouth,happy,joy,haha,:d,=),=-)" }, desktop_computer: { name: "Desktop Computer", unified: "1F5A5", sheet_x: 25, sheet_y: 31, short_names: ["desktop_computer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "desktop,computer,technology,computing,screen" }, racing_car: { name: "Racing Car", unified: "1F3CE", sheet_x: 10, sheet_y: 40, short_names: ["racing_car"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "racing,car,sports,race,fast,formula,f1" }, volleyball: { name: "Volleyball", unified: "1F3D0", sheet_x: 11, sheet_y: 1, short_names: ["volleyball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "volleyball,sports,balls" }, banana: { name: "Banana", unified: "1F34C", sheet_x: 7, sheet_y: 13, short_names: ["banana"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "banana,fruit,food,monkey" }, bear: { name: "Bear Face", unified: "1F43B", sheet_x: 13, sheet_y: 23, short_names: ["bear"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bear,face,animal,nature,wild" }, smile: { name: "Smiling Face with Open Mouth and Smiling Eyes", unified: "1F604", sheet_x: 26, sheet_y: 19, short_names: ["smile"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["C:", "c:", ":D", ":-D"], search: "smile,smiling,face,with,open,mouth,and,eyes,happy,joy,funny,haha,laugh,like,:d,c:,:-d" }, "flag-ad": { name: "Regional Indicator Symbol Letters AD", unified: "1F1E6-1F1E9", sheet_x: 32, sheet_y: 34, short_names: ["flag-ad"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ad,regional,indicator,symbol,letters" }, broken_heart: { name: "Broken Heart", unified: "1F494", sheet_x: 19, sheet_y: 36, short_names: ["broken_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["</3"], search: "broken,heart,sad,sorry,break,</3" }, sweat_smile: { name: "Smiling Face with Open Mouth and Cold Sweat", unified: "1F605", sheet_x: 26, sheet_y: 20, short_names: ["sweat_smile"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sweat,smile,smiling,face,with,open,mouth,and,cold,hot,happy,laugh" }, printer: { name: "Printer", unified: "1F5A8", sheet_x: 25, sheet_y: 32, short_names: ["printer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "printer,paper,ink" }, rugby_football: { name: "Rugby Football", unified: "1F3C9", sheet_x: 10, sheet_y: 25, short_names: ["rugby_football"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rugby,football,sports,team" }, heavy_heart_exclamation_mark_ornament: { name: "Heavy Heart Exclamation Mark Ornament", unified: "2763", variations: ["2763-FE0F"], sheet_x: 4, sheet_y: 9, short_names: ["heavy_heart_exclamation_mark_ornament"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heavy,heart,exclamation,mark,ornament,decoration,love" }, "flag-ao": { name: "Regional Indicator Symbol Letters AO", unified: "1F1E6-1F1F4", sheet_x: 33, sheet_y: 0, short_names: ["flag-ao"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ao,regional,indicator,symbol,letters" }, watermelon: { name: "Watermelon", unified: "1F349", sheet_x: 7, sheet_y: 10, short_names: ["watermelon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "watermelon,fruit,food,picnic,summer" }, panda_face: { name: "Panda Face", unified: "1F43C", sheet_x: 13, sheet_y: 24, short_names: ["panda_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "panda,face,animal,nature" }, police_car: { name: "Police Car", unified: "1F693", sheet_x: 29, sheet_y: 31, short_names: ["police_car"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "police,car,vehicle,cars,transportation,law,legal,enforcement" }, ambulance: { name: "Ambulance", unified: "1F691", sheet_x: 29, sheet_y: 29, short_names: ["ambulance"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ambulance,health,911,hospital" }, grapes: { name: "Grapes", unified: "1F347", sheet_x: 7, sheet_y: 8, short_names: ["grapes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "grapes,fruit,food,wine" }, two_hearts: { name: "Two Hearts", unified: "1F495", sheet_x: 19, sheet_y: 37, short_names: ["two_hearts"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "two,hearts,love,like,affection,valentines" }, "flag-ai": { name: "Regional Indicator Symbol Letters AI", unified: "1F1E6-1F1EE", sheet_x: 32, sheet_y: 38, short_names: ["flag-ai"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ai,regional,indicator,symbol,letters" }, three_button_mouse: { name: "Three Button Mouse", unified: "1F5B1", sheet_x: 25, sheet_y: 33, short_names: ["three_button_mouse"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "three,button,mouse,click" }, "8ball": { name: "Billiards", unified: "1F3B1", sheet_x: 9, sheet_y: 32, short_names: ["8ball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "8ball,billiards,pool,hobby,game,luck,magic" }, laughing: { name: "Smiling Face with Open Mouth and Tightly-Closed Eyes", unified: "1F606", sheet_x: 26, sheet_y: 21, short_names: ["laughing", "satisfied"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":>", ":->"], search: "laughing,satisfied,smiling,face,with,open,mouth,and,tightly,closed,eyes,happy,joy,lol,haha,glad,xd,:>,:->" }, koala: { name: "Koala", unified: "1F428", sheet_x: 13, sheet_y: 4, short_names: ["koala"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "koala,animal,nature" }, "flag-aq": { name: "Regional Indicator Symbol Letters AQ", unified: "1F1E6-1F1F6", sheet_x: 33, sheet_y: 1, short_names: ["flag-aq"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,aq,regional,indicator,symbol,letters" }, fire_engine: { name: "Fire Engine", unified: "1F692", sheet_x: 29, sheet_y: 30, short_names: ["fire_engine"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fire,engine,transportation,cars,vehicle" }, revolving_hearts: { name: "Revolving Hearts", unified: "1F49E", sheet_x: 20, sheet_y: 5, short_names: ["revolving_hearts"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "revolving,hearts,love,like,affection,valentines" }, golf: { name: "Flag in Hole", unified: "26F3", variations: ["26F3-FE0F"], sheet_x: 2, sheet_y: 33, short_names: ["golf"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "golf,flag,in,hole,sports,business,summer" }, innocent: { name: "Smiling Face with Halo", unified: "1F607", sheet_x: 26, sheet_y: 22, short_names: ["innocent"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "innocent,smiling,face,with,halo,angel,heaven" }, strawberry: { name: "Strawberry", unified: "1F353", sheet_x: 7, sheet_y: 20, short_names: ["strawberry"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "strawberry,fruit,food,nature" }, trackball: { name: "Trackball", unified: "1F5B2", sheet_x: 25, sheet_y: 34, short_names: ["trackball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "trackball,technology,trackpad" }, tiger: { name: "Tiger Face", unified: "1F42F", sheet_x: 13, sheet_y: 11, short_names: ["tiger"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tiger,face,animal,cat,danger,wild,nature,roar" }, lion_face: { name: "Lion Face", unified: "1F981", sheet_x: 32, sheet_y: 16, short_names: ["lion_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lion,face,animal,nature" }, "flag-ag": { name: "Regional Indicator Symbol Letters AG", unified: "1F1E6-1F1EC", sheet_x: 32, sheet_y: 37, short_names: ["flag-ag"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ag,regional,indicator,symbol,letters" }, minibus: { name: "Minibus", unified: "1F690", sheet_x: 29, sheet_y: 28, short_names: ["minibus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "minibus,vehicle,car,transportation" }, melon: { name: "Melon", unified: "1F348", sheet_x: 7, sheet_y: 9, short_names: ["melon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "melon,fruit,nature,food" }, wink: { name: "Winking Face", unified: "1F609", sheet_x: 26, sheet_y: 24, short_names: ["wink"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [";)", ";-)"], search: "wink,winking,face,happy,mischievous,secret,;),;-)" }, golfer: { name: "Golfer", unified: "1F3CC", sheet_x: 10, sheet_y: 38, short_names: ["golfer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "golfer,sports,business" }, heartbeat: { name: "Beating Heart", unified: "1F493", sheet_x: 19, sheet_y: 35, short_names: ["heartbeat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heartbeat,beating,heart,love,like,affection,valentines,pink" }, joystick: { name: "Joystick", unified: "1F579", sheet_x: 25, sheet_y: 7, short_names: ["joystick"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "joystick,game,play" }, heartpulse: { name: "Growing Heart", unified: "1F497", sheet_x: 19, sheet_y: 39, short_names: ["heartpulse"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heartpulse,growing,heart,like,love,affection,valentines,pink" }, "flag-ar": { name: "Regional Indicator Symbol Letters AR", unified: "1F1E6-1F1F7", sheet_x: 33, sheet_y: 2, short_names: ["flag-ar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ar,regional,indicator,symbol,letters" }, table_tennis_paddle_and_ball: { name: "Table Tennis Paddle and Ball", unified: "1F3D3", sheet_x: 11, sheet_y: 4, short_names: ["table_tennis_paddle_and_ball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "table,tennis,paddle,and,ball" }, cow: { name: "Cow Face", unified: "1F42E", sheet_x: 13, sheet_y: 10, short_names: ["cow"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cow,face,beef,ox,animal,nature,moo,milk" }, cherries: { name: "Cherries", unified: "1F352", sheet_x: 7, sheet_y: 19, short_names: ["cherries"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cherries,food,fruit" }, compression: { name: "Compression", unified: "1F5DC", sheet_x: 26, sheet_y: 1, short_names: ["compression"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "compression,tool" }, truck: { name: "Delivery Truck", unified: "1F69A", sheet_x: 29, sheet_y: 38, short_names: ["truck"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "truck,delivery,cars,transportation" }, blush: { name: "Smiling Face with Smiling Eyes", unified: "1F60A", sheet_x: 26, sheet_y: 25, short_names: ["blush"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":)"], search: "blush,smiling,face,with,eyes,smile,happy,flushed,crush,embarrassed,shy,joy,:)" }, slightly_smiling_face: { name: "Slightly Smiling Face", unified: "1F642", sheet_x: 27, sheet_y: 40, short_names: ["slightly_smiling_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":)", "(:", ":-)"], search: "slightly,smiling,face,:),(:,:-)" }, pig: { name: "Pig Face", unified: "1F437", sheet_x: 13, sheet_y: 19, short_names: ["pig"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pig,face,animal,oink,nature" }, sparkling_heart: { name: "Sparkling Heart", unified: "1F496", sheet_x: 19, sheet_y: 38, short_names: ["sparkling_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sparkling,heart,love,like,affection,valentines" }, badminton_racquet_and_shuttlecock: { name: "Badminton Racquet and Shuttlecock", unified: "1F3F8", sheet_x: 11, sheet_y: 38, short_names: ["badminton_racquet_and_shuttlecock"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "badminton,racquet,and,shuttlecock" }, peach: { name: "Peach", unified: "1F351", sheet_x: 7, sheet_y: 18, short_names: ["peach"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "peach,fruit,nature,food" }, minidisc: { name: "Minidisc", unified: "1F4BD", sheet_x: 21, sheet_y: 0, short_names: ["minidisc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "minidisc,technology,record,data,disk,90s" }, articulated_lorry: { name: "Articulated Lorry", unified: "1F69B", sheet_x: 29, sheet_y: 39, short_names: ["articulated_lorry"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "articulated,lorry,vehicle,cars,transportation,express" }, "flag-am": { name: "Regional Indicator Symbol Letters AM", unified: "1F1E6-1F1F2", sheet_x: 32, sheet_y: 40, short_names: ["flag-am"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,am,regional,indicator,symbol,letters" }, ice_hockey_stick_and_puck: { name: "Ice Hockey Stick and Puck", unified: "1F3D2", sheet_x: 11, sheet_y: 3, short_names: ["ice_hockey_stick_and_puck"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ice,hockey,stick,and,puck" }, pineapple: { name: "Pineapple", unified: "1F34D", sheet_x: 7, sheet_y: 14, short_names: ["pineapple"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pineapple,fruit,nature,food" }, "flag-aw": { name: "Regional Indicator Symbol Letters AW", unified: "1F1E6-1F1FC", sheet_x: 33, sheet_y: 6, short_names: ["flag-aw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,aw,regional,indicator,symbol,letters" }, pig_nose: { name: "Pig Nose", unified: "1F43D", sheet_x: 13, sheet_y: 25, short_names: ["pig_nose"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pig,nose,animal,oink" }, floppy_disk: { name: "Floppy Disk", unified: "1F4BE", sheet_x: 21, sheet_y: 1, short_names: ["floppy_disk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "floppy,disk,oldschool,technology,save,90s,80s" }, tractor: { name: "Tractor", unified: "1F69C", sheet_x: 29, sheet_y: 40, short_names: ["tractor"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tractor,vehicle,car,farming,agriculture" }, upside_down_face: { name: "Upside-Down Face", unified: "1F643", sheet_x: 28, sheet_y: 0, short_names: ["upside_down_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "upside,down,face" }, cupid: { name: "Heart with Arrow", unified: "1F498", sheet_x: 19, sheet_y: 40, short_names: ["cupid"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cupid,heart,with,arrow,love,like,affection,valentines" }, cd: { name: "Optical Disc", unified: "1F4BF", sheet_x: 21, sheet_y: 2, short_names: ["cd"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cd,optical,disc,technology,dvd,disk,90s" }, gift_heart: { name: "Heart with Ribbon", unified: "1F49D", sheet_x: 20, sheet_y: 4, short_names: ["gift_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "gift,heart,with,ribbon,love,valentines" }, "flag-au": { name: "Regional Indicator Symbol Letters AU", unified: "1F1E6-1F1FA", sheet_x: 33, sheet_y: 5, short_names: ["flag-au"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,au,regional,indicator,symbol,letters" }, field_hockey_stick_and_ball: { name: "Field Hockey Stick and Ball", unified: "1F3D1", sheet_x: 11, sheet_y: 2, short_names: ["field_hockey_stick_and_ball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "field,hockey,stick,and,ball" }, tomato: { name: "Tomato", unified: "1F345", sheet_x: 7, sheet_y: 6, short_names: ["tomato"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tomato,fruit,vegetable,nature,food" }, racing_motorcycle: { name: "Racing Motorcycle", unified: "1F3CD", sheet_x: 10, sheet_y: 39, short_names: ["racing_motorcycle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "racing,motorcycle,race,sports,fast" }, relaxed: { name: "White Smiling Face", unified: "263A", variations: ["263A-FE0F"], sheet_x: 1, sheet_y: 25, short_names: ["relaxed"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "relaxed,white,smiling,face,blush,massage,happiness" }, frog: { name: "Frog Face", unified: "1F438", sheet_x: 13, sheet_y: 20, short_names: ["frog"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "frog,face,animal,nature,croak" }, cricket_bat_and_ball: { name: "Cricket Bat and Ball", unified: "1F3CF", sheet_x: 11, sheet_y: 0, short_names: ["cricket_bat_and_ball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cricket,bat,and,ball" }, dvd: { name: "Dvd", unified: "1F4C0", sheet_x: 21, sheet_y: 3, short_names: ["dvd"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dvd,cd,disk,disc" }, octopus: { name: "Octopus", unified: "1F419", sheet_x: 12, sheet_y: 30, short_names: ["octopus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "octopus,animal,creature,ocean,sea,nature,beach" }, bike: { name: "Bicycle", unified: "1F6B2", sheet_x: 30, sheet_y: 26, short_names: ["bike"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bike,bicycle,sports,exercise,hipster" }, heart_decoration: { name: "Heart Decoration", unified: "1F49F", sheet_x: 20, sheet_y: 6, short_names: ["heart_decoration"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heart,decoration,purple-square,love,like" }, yum: { name: "Face Savouring Delicious Food", unified: "1F60B", sheet_x: 26, sheet_y: 26, short_names: ["yum"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "yum,face,savouring,delicious,food,happy,joy,tongue,smile,silly,yummy" }, eggplant: { name: "Aubergine", unified: "1F346", sheet_x: 7, sheet_y: 7, short_names: ["eggplant"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "eggplant,aubergine,vegetable,nature,food" }, "flag-at": { name: "Regional Indicator Symbol Letters AT", unified: "1F1E6-1F1F9", sheet_x: 33, sheet_y: 4, short_names: ["flag-at"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,at,regional,indicator,symbol,letters" }, rotating_light: { name: "Police Cars Revolving Light", unified: "1F6A8", sheet_x: 30, sheet_y: 16, short_names: ["rotating_light"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rotating,light,police,cars,revolving,ambulance,911,emergency,alert,error,pinged,law,legal" }, monkey_face: { name: "Monkey Face", unified: "1F435", sheet_x: 13, sheet_y: 17, short_names: ["monkey_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":o)"], search: "monkey,face,animal,nature,circus,:o)" }, ski: { name: "Ski and Ski Boot", unified: "1F3BF", sheet_x: 10, sheet_y: 5, short_names: ["ski"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ski,and,boot,sports,winter,cold,snow" }, hot_pepper: { name: "Hot Pepper", unified: "1F336", sheet_x: 6, sheet_y: 32, short_names: ["hot_pepper"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hot,pepper,food,spicy" }, peace_symbol: { name: "Peace Symbol", unified: "262E", variations: ["262E-FE0F"], sheet_x: 1, sheet_y: 21, short_names: ["peace_symbol"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "peace,symbol,hippie" }, "flag-az": { name: "Regional Indicator Symbol Letters AZ", unified: "1F1E6-1F1FF", sheet_x: 33, sheet_y: 8, short_names: ["flag-az"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,az,regional,indicator,symbol,letters" }, relieved: { name: "Relieved Face", unified: "1F60C", sheet_x: 26, sheet_y: 27, short_names: ["relieved"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "relieved,face,relaxed,phew,massage,happiness" }, vhs: { name: "Videocassette", unified: "1F4FC", sheet_x: 22, sheet_y: 22, short_names: ["vhs"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "vhs,videocassette,record,video,oldschool,90s,80s" }, oncoming_police_car: { name: "Oncoming Police Car", unified: "1F694", sheet_x: 29, sheet_y: 32, short_names: ["oncoming_police_car"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "oncoming,police,car,vehicle,law,legal,enforcement,911" }, corn: { name: "Ear of Maize", unified: "1F33D", sheet_x: 6, sheet_y: 39, short_names: ["corn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "corn,ear,of,maize,food,vegetable,plant" }, latin_cross: { name: "Latin Cross", unified: "271D", variations: ["271D-FE0F"], sheet_x: 3, sheet_y: 37, short_names: ["latin_cross"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "latin,cross,christianity" }, camera: { name: "Camera", unified: "1F4F7", sheet_x: 22, sheet_y: 17, short_names: ["camera"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "camera,gadgets,photography" }, see_no_evil: { name: "See-No-Evil Monkey", unified: "1F648", sheet_x: 28, sheet_y: 20, short_names: ["see_no_evil"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "see,no,evil,monkey,animal,nature,haha" }, heart_eyes: { name: "Smiling Face with Heart-Shaped Eyes", unified: "1F60D", sheet_x: 26, sheet_y: 28, short_names: ["heart_eyes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heart,eyes,smiling,face,with,shaped,love,like,affection,valentines,infatuation,crush" }, "flag-bs": { name: "Regional Indicator Symbol Letters BS", unified: "1F1E7-1F1F8", sheet_x: 33, sheet_y: 24, short_names: ["flag-bs"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bs,regional,indicator,symbol,letters" }, skier: { name: "Skier", unified: "26F7", sheet_x: 2, sheet_y: 36, short_names: ["skier"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "skier,sports,winter,snow" }, oncoming_bus: { name: "Oncoming Bus", unified: "1F68D", sheet_x: 29, sheet_y: 25, short_names: ["oncoming_bus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "oncoming,bus,vehicle,transportation" }, snowboarder: { name: "Snowboarder", unified: "1F3C2", sheet_x: 10, sheet_y: 8, short_names: ["snowboarder"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "snowboarder,sports,winter" }, sweet_potato: { name: "Roasted Sweet Potato", unified: "1F360", sheet_x: 7, sheet_y: 33, short_names: ["sweet_potato"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sweet,potato,roasted,food,nature" }, hear_no_evil: { name: "Hear-No-Evil Monkey", unified: "1F649", sheet_x: 28, sheet_y: 21, short_names: ["hear_no_evil"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hear,no,evil,monkey,animal,nature" }, "flag-bh": { name: "Regional Indicator Symbol Letters BH", unified: "1F1E7-1F1ED", sheet_x: 33, sheet_y: 15, short_names: ["flag-bh"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bh,regional,indicator,symbol,letters" }, star_and_crescent: { name: "Star and Crescent", unified: "262A", variations: ["262A-FE0F"], sheet_x: 1, sheet_y: 20, short_names: ["star_and_crescent"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "star,and,crescent,islam" }, kissing_heart: { name: "Face Throwing a Kiss", unified: "1F618", sheet_x: 26, sheet_y: 39, short_names: ["kissing_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "kissing,heart,face,throwing,a,kiss,love,like,affection,valentines,infatuation" }, camera_with_flash: { name: "Camera with Flash", unified: "1F4F8", sheet_x: 22, sheet_y: 18, short_names: ["camera_with_flash"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "camera,with,flash,photography,gadgets" }, ice_skate: { name: "Ice Skate", unified: "26F8", sheet_x: 2, sheet_y: 37, short_names: ["ice_skate"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ice,skate,sports" }, oncoming_automobile: { name: "Oncoming Automobile", unified: "1F698", sheet_x: 29, sheet_y: 36, short_names: ["oncoming_automobile"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "oncoming,automobile,car,vehicle,transportation" }, speak_no_evil: { name: "Speak-No-Evil Monkey", unified: "1F64A", sheet_x: 28, sheet_y: 22, short_names: ["speak_no_evil"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "speak,no,evil,monkey,animal,nature,omg" }, honey_pot: { name: "Honey Pot", unified: "1F36F", sheet_x: 8, sheet_y: 7, short_names: ["honey_pot"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "honey,pot,bees,sweet,kitchen" }, kissing: { name: "Kissing Face", unified: "1F617", sheet_x: 26, sheet_y: 38, short_names: ["kissing"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "kissing,face,love,like,3,valentines,infatuation" }, video_camera: { name: "Video Camera", unified: "1F4F9", sheet_x: 22, sheet_y: 19, short_names: ["video_camera"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "video,camera,film,record" }, om_symbol: { name: "Om Symbol", unified: "1F549", sheet_x: 24, sheet_y: 5, short_names: ["om_symbol"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "om,symbol,hinduism,buddhism,sikhism,jainism" }, "flag-bd": { name: "Regional Indicator Symbol Letters BD", unified: "1F1E7-1F1E9", sheet_x: 33, sheet_y: 11, short_names: ["flag-bd"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bd,regional,indicator,symbol,letters" }, monkey: { name: "Monkey", unified: "1F412", sheet_x: 12, sheet_y: 23, short_names: ["monkey"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "monkey,animal,nature,banana,circus" }, movie_camera: { name: "Movie Camera", unified: "1F3A5", sheet_x: 9, sheet_y: 20, short_names: ["movie_camera"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "movie,camera,film,record" }, oncoming_taxi: { name: "Oncoming Taxi", unified: "1F696", sheet_x: 29, sheet_y: 34, short_names: ["oncoming_taxi"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "oncoming,taxi,vehicle,cars,uber" }, "flag-bb": { name: "Regional Indicator Symbol Letters BB", unified: "1F1E7-1F1E7", sheet_x: 33, sheet_y: 10, short_names: ["flag-bb"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bb,regional,indicator,symbol,letters" }, kissing_smiling_eyes: { name: "Kissing Face with Smiling Eyes", unified: "1F619", sheet_x: 26, sheet_y: 40, short_names: ["kissing_smiling_eyes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "kissing,smiling,eyes,face,with,affection,valentines,infatuation" }, bread: { name: "Bread", unified: "1F35E", sheet_x: 7, sheet_y: 31, short_names: ["bread"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bread,food,wheat,breakfast,toast" }, bow_and_arrow: { name: "Bow and Arrow", unified: "1F3F9", sheet_x: 11, sheet_y: 39, short_names: ["bow_and_arrow"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bow,and,arrow,sports" }, wheel_of_dharma: { name: "Wheel of Dharma", unified: "2638", variations: ["2638-FE0F"], sheet_x: 1, sheet_y: 23, short_names: ["wheel_of_dharma"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wheel,of,dharma,hinduism,buddhism,sikhism,jainism" }, aerial_tramway: { name: "Aerial Tramway", unified: "1F6A1", sheet_x: 30, sheet_y: 4, short_names: ["aerial_tramway"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "aerial,tramway,transportation,vehicle,ski" }, cheese_wedge: { name: "Cheese Wedge", unified: "1F9C0", sheet_x: 32, sheet_y: 20, short_names: ["cheese_wedge"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cheese,wedge,food,chadder" }, film_projector: { name: "Film Projector", unified: "1F4FD", sheet_x: 22, sheet_y: 23, short_names: ["film_projector"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "film,projector,video,tape,record,movie" }, fishing_pole_and_fish: { name: "Fishing Pole and Fish", unified: "1F3A3", sheet_x: 9, sheet_y: 18, short_names: ["fishing_pole_and_fish"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fishing,pole,and,fish,food,hobby,summer" }, kissing_closed_eyes: { name: "Kissing Face with Closed Eyes", unified: "1F61A", sheet_x: 27, sheet_y: 0, short_names: ["kissing_closed_eyes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "kissing,closed,eyes,face,with,love,like,affection,valentines,infatuation" }, star_of_david: { name: "Star of David", unified: "2721", variations: ["2721-FE0F"], sheet_x: 3, sheet_y: 38, short_names: ["star_of_david"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "star,of,david,judaism" }, chicken: { name: "Chicken", unified: "1F414", sheet_x: 12, sheet_y: 25, short_names: ["chicken"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "chicken,animal,cluck,nature,bird" }, "flag-by": { name: "Regional Indicator Symbol Letters BY", unified: "1F1E7-1F1FE", sheet_x: 33, sheet_y: 28, short_names: ["flag-by"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,by,regional,indicator,symbol,letters" }, six_pointed_star: { name: "Six Pointed Star with Middle Dot", unified: "1F52F", sheet_x: 23, sheet_y: 31, short_names: ["six_pointed_star"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "six,pointed,star,with,middle,dot,purple-square,religion,jewish,hexagram" }, penguin: { name: "Penguin", unified: "1F427", sheet_x: 13, sheet_y: 3, short_names: ["penguin"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "penguin,animal,nature" }, mountain_cableway: { name: "Mountain Cableway", unified: "1F6A0", sheet_x: 30, sheet_y: 3, short_names: ["mountain_cableway"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mountain,cableway,transportation,vehicle,ski" }, stuck_out_tongue_winking_eye: { name: "Face with Stuck-out Tongue and Winking Eye", unified: "1F61C", sheet_x: 27, sheet_y: 2, short_names: ["stuck_out_tongue_winking_eye"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [";p", ";-p", ";b", ";-b", ";P", ";-P"], search: "stuck,out,tongue,winking,eye,face,with,and,prank,childish,playful,mischievous,smile,;p,;-p,;b,;-b" }, "flag-be": { name: "Regional Indicator Symbol Letters BE", unified: "1F1E7-1F1EA", sheet_x: 33, sheet_y: 12, short_names: ["flag-be"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,be,regional,indicator,symbol,letters" }, film_frames: { name: "Film Frames", unified: "1F39E", sheet_x: 9, sheet_y: 13, short_names: ["film_frames"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "film,frames,movie" }, poultry_leg: { name: "Poultry Leg", unified: "1F357", sheet_x: 7, sheet_y: 24, short_names: ["poultry_leg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "poultry,leg,food,meat,drumstick,bird,chicken,turkey" }, rowboat: { name: "Rowboat", unified: "1F6A3", sheet_x: 30, sheet_y: 6, short_names: ["rowboat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F6A3-1F3FB": { unified: "1F6A3-1F3FB", image: "1f6a3-1f3fb.png", sheet_x: 30, sheet_y: 7, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6A3-1F3FC": { unified: "1F6A3-1F3FC", image: "1f6a3-1f3fc.png", sheet_x: 30, sheet_y: 8, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6A3-1F3FD": { unified: "1F6A3-1F3FD", image: "1f6a3-1f3fd.png", sheet_x: 30, sheet_y: 9, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6A3-1F3FE": { unified: "1F6A3-1F3FE", image: "1f6a3-1f3fe.png", sheet_x: 30, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6A3-1F3FF": { unified: "1F6A3-1F3FF", image: "1f6a3-1f3ff.png", sheet_x: 30, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "rowboat,sports,hobby,water,ship" }, menorah_with_nine_branches: { name: "Menorah with Nine Branches", unified: "1F54E", sheet_x: 24, sheet_y: 10, short_names: ["menorah_with_nine_branches"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "menorah,with,nine,branches,hanukkah,candles,jewish" }, stuck_out_tongue_closed_eyes: { name: "Face with Stuck-out Tongue and Tightly-Closed Eyes", unified: "1F61D", sheet_x: 27, sheet_y: 3, short_names: ["stuck_out_tongue_closed_eyes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "stuck,out,tongue,closed,eyes,face,with,and,tightly,prank,playful,mischievous,smile" }, "flag-bz": { name: "Regional Indicator Symbol Letters BZ", unified: "1F1E7-1F1FF", sheet_x: 33, sheet_y: 29, short_names: ["flag-bz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bz,regional,indicator,symbol,letters" }, swimmer: { name: "Swimmer", unified: "1F3CA", sheet_x: 10, sheet_y: 26, short_names: ["swimmer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F3CA-1F3FB": { unified: "1F3CA-1F3FB", image: "1f3ca-1f3fb.png", sheet_x: 10, sheet_y: 27, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3CA-1F3FC": { unified: "1F3CA-1F3FC", image: "1f3ca-1f3fc.png", sheet_x: 10, sheet_y: 28, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3CA-1F3FD": { unified: "1F3CA-1F3FD", image: "1f3ca-1f3fd.png", sheet_x: 10, sheet_y: 29, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3CA-1F3FE": { unified: "1F3CA-1F3FE", image: "1f3ca-1f3fe.png", sheet_x: 10, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3CA-1F3FF": { unified: "1F3CA-1F3FF", image: "1f3ca-1f3ff.png", sheet_x: 10, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "swimmer,sports,exercise,human,athlete,water,summer" }, bird: { name: "Bird", unified: "1F426", sheet_x: 13, sheet_y: 2, short_names: ["bird"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bird,animal,nature,fly,tweet,spring" }, telephone_receiver: { name: "Telephone Receiver", unified: "1F4DE", sheet_x: 21, sheet_y: 33, short_names: ["telephone_receiver"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "telephone,receiver,technology,communication,dial" }, meat_on_bone: { name: "Meat on Bone", unified: "1F356", sheet_x: 7, sheet_y: 23, short_names: ["meat_on_bone"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "meat,on,bone,good,food,drumstick" }, suspension_railway: { name: "Suspension Railway", unified: "1F69F", sheet_x: 30, sheet_y: 2, short_names: ["suspension_railway"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "suspension,railway,vehicle,transportation" }, "flag-bj": { name: "Regional Indicator Symbol Letters BJ", unified: "1F1E7-1F1EF", sheet_x: 33, sheet_y: 17, short_names: ["flag-bj"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bj,regional,indicator,symbol,letters" }, yin_yang: { name: "Yin Yang", unified: "262F", variations: ["262F-FE0F"], sheet_x: 1, sheet_y: 22, short_names: ["yin_yang"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "yin,yang,balance" }, stuck_out_tongue: { name: "Face with Stuck-out Tongue", unified: "1F61B", sheet_x: 27, sheet_y: 1, short_names: ["stuck_out_tongue"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":p", ":-p", ":P", ":-P", ":b", ":-b"], search: "stuck,out,tongue,face,with,prank,childish,playful,mischievous,smile,:p,:-p,:b,:-b" }, phone: { name: "Black Telephone", unified: "260E", variations: ["260E-FE0F"], sheet_x: 1, sheet_y: 5, short_names: ["phone", "telephone"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "phone,telephone,black,technology,communication,dial" }, railway_car: { name: "Railway Car", unified: "1F683", sheet_x: 29, sheet_y: 15, short_names: ["railway_car"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "railway,car,transportation,vehicle" }, fried_shrimp: { name: "Fried Shrimp", unified: "1F364", sheet_x: 7, sheet_y: 37, short_names: ["fried_shrimp"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fried,shrimp,food,animal,appetizer,summer" }, surfer: { name: "Surfer", unified: "1F3C4", sheet_x: 10, sheet_y: 15, short_names: ["surfer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F3C4-1F3FB": { unified: "1F3C4-1F3FB", image: "1f3c4-1f3fb.png", sheet_x: 10, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3C4-1F3FC": { unified: "1F3C4-1F3FC", image: "1f3c4-1f3fc.png", sheet_x: 10, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3C4-1F3FD": { unified: "1F3C4-1F3FD", image: "1f3c4-1f3fd.png", sheet_x: 10, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3C4-1F3FE": { unified: "1F3C4-1F3FE", image: "1f3c4-1f3fe.png", sheet_x: 10, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3C4-1F3FF": { unified: "1F3C4-1F3FF", image: "1f3c4-1f3ff.png", sheet_x: 10, sheet_y: 20, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "surfer,sports,ocean,sea,summer,beach" }, baby_chick: { name: "Baby Chick", unified: "1F424", sheet_x: 13, sheet_y: 0, short_names: ["baby_chick"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "baby,chick,animal,chicken,bird" }, egg: { name: "Cooking", unified: "1F373", sheet_x: 8, sheet_y: 11, short_names: ["egg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "egg,cooking,food,breakfast,kitchen" }, "flag-bm": { name: "Regional Indicator Symbol Letters BM", unified: "1F1E7-1F1F2", sheet_x: 33, sheet_y: 19, short_names: ["flag-bm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bm,regional,indicator,symbol,letters" }, hatching_chick: { name: "Hatching Chick", unified: "1F423", sheet_x: 12, sheet_y: 40, short_names: ["hatching_chick"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hatching,chick,animal,chicken,egg,born,baby,bird" }, train: { name: "Tram Car", unified: "1F68B", sheet_x: 29, sheet_y: 23, short_names: ["train"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "train,tram,car,transportation,vehicle,carriage,public,travel" }, pager: { name: "Pager", unified: "1F4DF", sheet_x: 21, sheet_y: 34, short_names: ["pager"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pager,bbcall,oldschool,90s" }, bath: { name: "Bath", unified: "1F6C0", sheet_x: 31, sheet_y: 14, short_names: ["bath"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F6C0-1F3FB": { unified: "1F6C0-1F3FB", image: "1f6c0-1f3fb.png", sheet_x: 31, sheet_y: 15, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6C0-1F3FC": { unified: "1F6C0-1F3FC", image: "1f6c0-1f3fc.png", sheet_x: 31, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6C0-1F3FD": { unified: "1F6C0-1F3FD", image: "1f6c0-1f3fd.png", sheet_x: 31, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6C0-1F3FE": { unified: "1F6C0-1F3FE", image: "1f6c0-1f3fe.png", sheet_x: 31, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6C0-1F3FF": { unified: "1F6C0-1F3FF", image: "1f6c0-1f3ff.png", sheet_x: 31, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "bath,clean,shower,bathroom" }, money_mouth_face: { name: "Money-Mouth Face", unified: "1F911", sheet_x: 32, sheet_y: 2, short_names: ["money_mouth_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "money,mouth,face" }, orthodox_cross: { name: "Orthodox Cross", unified: "2626", variations: ["2626-FE0F"], sheet_x: 1, sheet_y: 19, short_names: ["orthodox_cross"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "orthodox,cross,suppedaneum,religion" }, hatched_chick: { name: "Front-Facing Baby Chick", unified: "1F425", sheet_x: 13, sheet_y: 1, short_names: ["hatched_chick"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hatched,chick,front,facing,baby,animal,chicken,bird" }, place_of_worship: { name: "Place of Worship", unified: "1F6D0", sheet_x: 31, sheet_y: 30, short_names: ["place_of_worship"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "place,of,worship,religion,church,temple,prayer" }, hamburger: { name: "Hamburger", unified: "1F354", sheet_x: 7, sheet_y: 21, short_names: ["hamburger"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hamburger,meat,fast food,beef,cheeseburger,mcdonalds,burger king" }, "flag-bt": { name: "Regional Indicator Symbol Letters BT", unified: "1F1E7-1F1F9", sheet_x: 33, sheet_y: 25, short_names: ["flag-bt"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bt,regional,indicator,symbol,letters" }, fax: { name: "Fax Machine", unified: "1F4E0", sheet_x: 21, sheet_y: 35, short_names: ["fax"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fax,machine,communication,technology" }, nerd_face: { name: "Nerd Face", unified: "1F913", sheet_x: 32, sheet_y: 4, short_names: ["nerd_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "nerd,face" }, monorail: { name: "Monorail", unified: "1F69D", sheet_x: 30, sheet_y: 0, short_names: ["monorail"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "monorail,transportation,vehicle" }, person_with_ball: { name: "Person with Ball", unified: "26F9", sheet_x: 2, sheet_y: 38, short_names: ["person_with_ball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "26F9-1F3FB": { unified: "26F9-1F3FB", image: "26f9-1f3fb.png", sheet_x: 2, sheet_y: 39, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "26F9-1F3FC": { unified: "26F9-1F3FC", image: "26f9-1f3fc.png", sheet_x: 2, sheet_y: 40, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "26F9-1F3FD": { unified: "26F9-1F3FD", image: "26f9-1f3fd.png", sheet_x: 3, sheet_y: 0, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "26F9-1F3FE": { unified: "26F9-1F3FE", image: "26f9-1f3fe.png", sheet_x: 3, sheet_y: 1, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "26F9-1F3FF": { unified: "26F9-1F3FF", image: "26f9-1f3ff.png", sheet_x: 3, sheet_y: 2, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "person,with,ball,sports,human" }, weight_lifter: { name: "Weight Lifter", unified: "1F3CB", sheet_x: 10, sheet_y: 32, short_names: ["weight_lifter"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F3CB-1F3FB": { unified: "1F3CB-1F3FB", image: "1f3cb-1f3fb.png", sheet_x: 10, sheet_y: 33, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3CB-1F3FC": { unified: "1F3CB-1F3FC", image: "1f3cb-1f3fc.png", sheet_x: 10, sheet_y: 34, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3CB-1F3FD": { unified: "1F3CB-1F3FD", image: "1f3cb-1f3fd.png", sheet_x: 10, sheet_y: 35, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3CB-1F3FE": { unified: "1F3CB-1F3FE", image: "1f3cb-1f3fe.png", sheet_x: 10, sheet_y: 36, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3CB-1F3FF": { unified: "1F3CB-1F3FF", image: "1f3cb-1f3ff.png", sheet_x: 10, sheet_y: 37, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "weight,lifter,sports,training,exercise" }, sunglasses: { name: "Smiling Face with Sunglasses", unified: "1F60E", sheet_x: 26, sheet_y: 29, short_names: ["sunglasses"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["8)"], search: "sunglasses,smiling,face,with,cool,smile,summer,beach,8)" }, wolf: { name: "Wolf Face", unified: "1F43A", sheet_x: 13, sheet_y: 22, short_names: ["wolf"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wolf,face,animal,nature,wild" }, bullettrain_side: { name: "High-Speed Train", unified: "1F684", sheet_x: 29, sheet_y: 16, short_names: ["bullettrain_side"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bullettrain,side,high,speed,train,transportation,vehicle" }, ophiuchus: { name: "Ophiuchus", unified: "26CE", sheet_x: 2, sheet_y: 23, short_names: ["ophiuchus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ophiuchus,sign,purple-square,constellation,astrology" }, "flag-bo": { name: "Regional Indicator Symbol Letters BO", unified: "1F1E7-1F1F4", sheet_x: 33, sheet_y: 21, short_names: ["flag-bo"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bo,regional,indicator,symbol,letters" }, tv: { name: "Television", unified: "1F4FA", sheet_x: 22, sheet_y: 20, short_names: ["tv"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tv,television,technology,program,oldschool,show" }, fries: { name: "French Fries", unified: "1F35F", sheet_x: 7, sheet_y: 32, short_names: ["fries"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fries,french,chips,snack,fast food" }, bicyclist: { name: "Bicyclist", unified: "1F6B4", sheet_x: 30, sheet_y: 28, short_names: ["bicyclist"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F6B4-1F3FB": { unified: "1F6B4-1F3FB", image: "1f6b4-1f3fb.png", sheet_x: 30, sheet_y: 29, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B4-1F3FC": { unified: "1F6B4-1F3FC", image: "1f6b4-1f3fc.png", sheet_x: 30, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B4-1F3FD": { unified: "1F6B4-1F3FD", image: "1f6b4-1f3fd.png", sheet_x: 30, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B4-1F3FE": { unified: "1F6B4-1F3FE", image: "1f6b4-1f3fe.png", sheet_x: 30, sheet_y: 32, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B4-1F3FF": { unified: "1F6B4-1F3FF", image: "1f6b4-1f3ff.png", sheet_x: 30, sheet_y: 33, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "bicyclist,sports,bike,exercise,hipster" }, aries: { name: "Aries", unified: "2648", variations: ["2648-FE0F"], sheet_x: 1, sheet_y: 26, short_names: ["aries"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "aries,sign,purple-square,zodiac,astrology" }, hugging_face: { name: "Hugging Face", unified: "1F917", sheet_x: 32, sheet_y: 8, short_names: ["hugging_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hugging,face" }, "flag-bq": { name: "Regional Indicator Symbol Letters BQ", unified: "1F1E7-1F1F6", sheet_x: 33, sheet_y: 22, short_names: ["flag-bq"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,bq,regional,indicator,symbol,letters" }, bullettrain_front: { name: "High-Speed Train with Bullet Nose", unified: "1F685", sheet_x: 29, sheet_y: 17, short_names: ["bullettrain_front"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bullettrain,front,high,speed,train,with,bullet,nose,transportation,vehicle,fast,public,travel" }, radio: { name: "Radio", unified: "1F4FB", sheet_x: 22, sheet_y: 21, short_names: ["radio"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "radio,communication,music,podcast,program" }, hotdog: { name: "Hot Dog", unified: "1F32D", sheet_x: 6, sheet_y: 23, short_names: ["hotdog"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hotdog,hot,dog" }, boar: { name: "Boar", unified: "1F417", sheet_x: 12, sheet_y: 28, short_names: ["boar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "boar,animal,nature" }, studio_microphone: { name: "Studio Microphone", unified: "1F399", sheet_x: 9, sheet_y: 10, short_names: ["studio_microphone"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "studio,microphone,singer,recording,artist" }, pizza: { name: "Slice of Pizza", unified: "1F355", sheet_x: 7, sheet_y: 22, short_names: ["pizza"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pizza,slice,of,food,party" }, "flag-ba": { name: "Regional Indicator Symbol Letters BA", unified: "1F1E7-1F1E6", sheet_x: 33, sheet_y: 9, short_names: ["flag-ba"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ba,regional,indicator,symbol,letters" }, mountain_bicyclist: { name: "Mountain Bicyclist", unified: "1F6B5", sheet_x: 30, sheet_y: 34, short_names: ["mountain_bicyclist"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F6B5-1F3FB": { unified: "1F6B5-1F3FB", image: "1f6b5-1f3fb.png", sheet_x: 30, sheet_y: 35, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B5-1F3FC": { unified: "1F6B5-1F3FC", image: "1f6b5-1f3fc.png", sheet_x: 30, sheet_y: 36, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B5-1F3FD": { unified: "1F6B5-1F3FD", image: "1f6b5-1f3fd.png", sheet_x: 30, sheet_y: 37, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B5-1F3FE": { unified: "1F6B5-1F3FE", image: "1f6b5-1f3fe.png", sheet_x: 30, sheet_y: 38, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B5-1F3FF": { unified: "1F6B5-1F3FF", image: "1f6b5-1f3ff.png", sheet_x: 30, sheet_y: 39, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "mountain,bicyclist,transportation,sports,human,race,bike" }, smirk: { name: "Smirking Face", unified: "1F60F", sheet_x: 26, sheet_y: 30, short_names: ["smirk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "smirk,smirking,face,smile,mean,prank,smug,sarcasm" }, light_rail: { name: "Light Rail", unified: "1F688", sheet_x: 29, sheet_y: 20, short_names: ["light_rail"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "light,rail,transportation,vehicle" }, horse: { name: "Horse Face", unified: "1F434", sheet_x: 13, sheet_y: 16, short_names: ["horse"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "horse,face,animal,brown,nature" }, taurus: { name: "Taurus", unified: "2649", variations: ["2649-FE0F"], sheet_x: 1, sheet_y: 27, short_names: ["taurus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "taurus,purple-square,sign,zodiac,astrology" }, gemini: { name: "Gemini", unified: "264A", variations: ["264A-FE0F"], sheet_x: 1, sheet_y: 28, short_names: ["gemini"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "gemini,sign,zodiac,purple-square,astrology" }, horse_racing: { name: "Horse Racing", unified: "1F3C7", sheet_x: 10, sheet_y: 23, short_names: ["horse_racing"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "horse,racing,animal,betting,competition,gambling,luck" }, level_slider: { name: "Level Slider", unified: "1F39A", sheet_x: 9, sheet_y: 11, short_names: ["level_slider"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "level,slider,scale" }, "flag-bw": { name: "Regional Indicator Symbol Letters BW", unified: "1F1E7-1F1FC", sheet_x: 33, sheet_y: 27, short_names: ["flag-bw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bw,regional,indicator,symbol,letters" }, unicorn_face: { name: "Unicorn Face", unified: "1F984", sheet_x: 32, sheet_y: 19, short_names: ["unicorn_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "unicorn,face,animal,nature,mystical" }, mountain_railway: { name: "Mountain Railway", unified: "1F69E", sheet_x: 30, sheet_y: 1, short_names: ["mountain_railway"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mountain,railway,transportation,vehicle" }, spaghetti: { name: "Spaghetti", unified: "1F35D", sheet_x: 7, sheet_y: 30, short_names: ["spaghetti"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "spaghetti,food,italian,noodle" }, no_mouth: { name: "Face Without Mouth", unified: "1F636", sheet_x: 27, sheet_y: 28, short_names: ["no_mouth"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "no,mouth,face,without,hellokitty" }, "flag-br": { name: "Regional Indicator Symbol Letters BR", unified: "1F1E7-1F1F7", sheet_x: 33, sheet_y: 23, short_names: ["flag-br"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,br,regional,indicator,symbol,letters" }, man_in_business_suit_levitating: { name: "Man in Business Suit Levitating", unified: "1F574", sheet_x: 24, sheet_y: 38, short_names: ["man_in_business_suit_levitating"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,in,business,suit,levitating" }, control_knobs: { name: "Control Knobs", unified: "1F39B", sheet_x: 9, sheet_y: 12, short_names: ["control_knobs"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "control,knobs,dial" }, bee: { name: "Honeybee", unified: "1F41D", sheet_x: 12, sheet_y: 34, short_names: ["bee", "honeybee"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bee,honeybee,animal,insect,nature,bug,spring,honey" }, neutral_face: { name: "Neutral Face", unified: "1F610", sheet_x: 26, sheet_y: 31, short_names: ["neutral_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":|", ":-|"], search: "neutral,face,indifference,meh,:|,:-|" }, steam_locomotive: { name: "Steam Locomotive", unified: "1F682", sheet_x: 29, sheet_y: 14, short_names: ["steam_locomotive"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "steam,locomotive,transportation,vehicle,train" }, cancer: { name: "Cancer", unified: "264B", variations: ["264B-FE0F"], sheet_x: 1, sheet_y: 29, short_names: ["cancer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cancer,sign,zodiac,purple-square,astrology" }, taco: { name: "Taco", unified: "1F32E", sheet_x: 6, sheet_y: 24, short_names: ["taco"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "taco,food,mexican" }, burrito: { name: "Burrito", unified: "1F32F", sheet_x: 6, sheet_y: 25, short_names: ["burrito"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "burrito,food,mexican" }, expressionless: { name: "Expressionless Face", unified: "1F611", sheet_x: 26, sheet_y: 32, short_names: ["expressionless"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "expressionless,face,indifferent,-_-,meh" }, trophy: { name: "Trophy", unified: "1F3C6", sheet_x: 10, sheet_y: 22, short_names: ["trophy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "trophy,win,award,contest,place,ftw,ceremony" }, "train2": { name: "Train", unified: "1F686", sheet_x: 29, sheet_y: 18, short_names: ["train2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "train2,train,transportation,vehicle" }, "flag-io": { name: "Regional Indicator Symbol Letters IO", unified: "1F1EE-1F1F4", sheet_x: 35, sheet_y: 21, short_names: ["flag-io"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,io,regional,indicator,symbol,letters" }, bug: { name: "Bug", unified: "1F41B", sheet_x: 12, sheet_y: 32, short_names: ["bug"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bug,animal,insect,nature,worm" }, stopwatch: { name: "Stopwatch", unified: "23F1", sheet_x: 0, sheet_y: 26, short_names: ["stopwatch"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "stopwatch,time,deadline" }, leo: { name: "Leo", unified: "264C", variations: ["264C-FE0F"], sheet_x: 1, sheet_y: 30, short_names: ["leo"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "leo,sign,purple-square,zodiac,astrology" }, virgo: { name: "Virgo", unified: "264D", variations: ["264D-FE0F"], sheet_x: 1, sheet_y: 31, short_names: ["virgo"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "virgo,sign,zodiac,purple-square,astrology" }, running_shirt_with_sash: { name: "Running Shirt with Sash", unified: "1F3BD", sheet_x: 10, sheet_y: 3, short_names: ["running_shirt_with_sash"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "running,shirt,with,sash,play,pageant" }, "flag-vg": { name: "Regional Indicator Symbol Letters VG", unified: "1F1FB-1F1EC", sheet_x: 38, sheet_y: 32, short_names: ["flag-vg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,vg,regional,indicator,symbol,letters" }, metro: { name: "Metro", unified: "1F687", sheet_x: 29, sheet_y: 19, short_names: ["metro"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "metro,transportation,blue-square,mrt,underground,tube" }, unamused: { name: "Unamused Face", unified: "1F612", sheet_x: 26, sheet_y: 33, short_names: ["unamused"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":("], search: "unamused,face,indifference,bored,straight face,serious,:(" }, snail: { name: "Snail", unified: "1F40C", sheet_x: 12, sheet_y: 17, short_names: ["snail"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "snail,slow,animal,shell" }, timer_clock: { name: "Timer Clock", unified: "23F2", sheet_x: 0, sheet_y: 27, short_names: ["timer_clock"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "timer,clock,alarm" }, ramen: { name: "Steaming Bowl", unified: "1F35C", sheet_x: 7, sheet_y: 29, short_names: ["ramen"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ramen,steaming,bowl,food,japanese,noodle,chipsticks" }, beetle: { name: "Lady Beetle", unified: "1F41E", sheet_x: 12, sheet_y: 35, short_names: ["beetle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "beetle,lady,animal,insect,nature,ladybug" }, face_with_rolling_eyes: { name: "Face with Rolling Eyes", unified: "1F644", sheet_x: 28, sheet_y: 1, short_names: ["face_with_rolling_eyes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "face,with,rolling,eyes" }, libra: { name: "Libra", unified: "264E", variations: ["264E-FE0F"], sheet_x: 1, sheet_y: 32, short_names: ["libra"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "libra,sign,purple-square,zodiac,astrology" }, stew: { name: "Pot of Food", unified: "1F372", sheet_x: 8, sheet_y: 10, short_names: ["stew"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "stew,pot,of,food,meat,soup" }, sports_medal: { name: "Sports Medal", unified: "1F3C5", sheet_x: 10, sheet_y: 21, short_names: ["sports_medal"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sports,medal,award,winning" }, "flag-bn": { name: "Regional Indicator Symbol Letters BN", unified: "1F1E7-1F1F3", sheet_x: 33, sheet_y: 20, short_names: ["flag-bn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bn,regional,indicator,symbol,letters" }, alarm_clock: { name: "Alarm Clock", unified: "23F0", sheet_x: 0, sheet_y: 25, short_names: ["alarm_clock"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "alarm,clock,time,wake" }, tram: { name: "Tram", unified: "1F68A", sheet_x: 29, sheet_y: 22, short_names: ["tram"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tram,transportation,vehicle" }, fish_cake: { name: "Fish Cake with Swirl Design", unified: "1F365", sheet_x: 7, sheet_y: 38, short_names: ["fish_cake"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fish,cake,with,swirl,design,food,japan,sea,beach" }, thinking_face: { name: "Thinking Face", unified: "1F914", sheet_x: 32, sheet_y: 5, short_names: ["thinking_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "thinking,face" }, medal: { name: "Military Medal", unified: "1F396", sheet_x: 9, sheet_y: 8, short_names: ["medal"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "medal,military" }, mantelpiece_clock: { name: "Mantelpiece Clock", unified: "1F570", sheet_x: 24, sheet_y: 36, short_names: ["mantelpiece_clock"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mantelpiece,clock,time" }, station: { name: "Station", unified: "1F689", sheet_x: 29, sheet_y: 21, short_names: ["station"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "station,transportation,vehicle,public" }, "flag-bg": { name: "Regional Indicator Symbol Letters BG", unified: "1F1E7-1F1EC", sheet_x: 33, sheet_y: 14, short_names: ["flag-bg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bg,regional,indicator,symbol,letters" }, ant: { name: "Ant", unified: "1F41C", sheet_x: 12, sheet_y: 33, short_names: ["ant"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ant,animal,insect,nature,bug" }, scorpius: { name: "Scorpius", unified: "264F", variations: ["264F-FE0F"], sheet_x: 1, sheet_y: 33, short_names: ["scorpius"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "scorpius,sign,zodiac,purple-square,astrology,scorpio" }, sushi: { name: "Sushi", unified: "1F363", sheet_x: 7, sheet_y: 36, short_names: ["sushi"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sushi,food,fish,japanese,rice" }, flushed: { name: "Flushed Face", unified: "1F633", sheet_x: 27, sheet_y: 25, short_names: ["flushed"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flushed,face,blush,shy,flattered" }, spider: { name: "Spider", unified: "1F577", sheet_x: 25, sheet_y: 5, short_names: ["spider"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "spider,animal,arachnid" }, reminder_ribbon: { name: "Reminder Ribbon", unified: "1F397", sheet_x: 9, sheet_y: 9, short_names: ["reminder_ribbon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "reminder,ribbon,sports,cause,supprt,awareness" }, helicopter: { name: "Helicopter", unified: "1F681", sheet_x: 29, sheet_y: 13, short_names: ["helicopter"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "helicopter,transportation,vehicle,fly" }, sagittarius: { name: "Sagittarius", unified: "2650", variations: ["2650-FE0F"], sheet_x: 1, sheet_y: 34, short_names: ["sagittarius"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sagittarius,sign,zodiac,purple-square,astrology" }, "flag-bf": { name: "Regional Indicator Symbol Letters BF", unified: "1F1E7-1F1EB", sheet_x: 33, sheet_y: 13, short_names: ["flag-bf"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bf,regional,indicator,symbol,letters" }, hourglass_flowing_sand: { name: "Hourglass with Flowing Sand", unified: "23F3", sheet_x: 0, sheet_y: 28, short_names: ["hourglass_flowing_sand"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hourglass,flowing,sand,with,oldschool,time,countdown" }, small_airplane: { name: "Small Airplane", unified: "1F6E9", sheet_x: 31, sheet_y: 37, short_names: ["small_airplane"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "small,airplane,flight,transportation,fly,vehicle" }, rosette: { name: "Rosette", unified: "1F3F5", sheet_x: 11, sheet_y: 36, short_names: ["rosette"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rosette,flower,decoration,military" }, bento: { name: "Bento Box", unified: "1F371", sheet_x: 8, sheet_y: 9, short_names: ["bento"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bento,box,food,japanese" }, capricorn: { name: "Capricorn", unified: "2651", variations: ["2651-FE0F"], sheet_x: 1, sheet_y: 35, short_names: ["capricorn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "capricorn,sign,zodiac,purple-square,astrology" }, "flag-bi": { name: "Regional Indicator Symbol Letters BI", unified: "1F1E7-1F1EE", sheet_x: 33, sheet_y: 16, short_names: ["flag-bi"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,bi,regional,indicator,symbol,letters" }, disappointed: { name: "Disappointed Face", unified: "1F61E", sheet_x: 27, sheet_y: 4, short_names: ["disappointed"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["):", ":(", ":-("], search: "disappointed,face,sad,upset,depressed,:(,):,:-(" }, scorpion: { name: "Scorpion", unified: "1F982", sheet_x: 32, sheet_y: 17, short_names: ["scorpion"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "scorpion,animal,arachnid" }, hourglass: { name: "Hourglass", unified: "231B", variations: ["231B-FE0F"], sheet_x: 0, sheet_y: 15, short_names: ["hourglass"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hourglass,time,clock,oldschool,limit,exam,quiz,test" }, crab: { name: "Crab", unified: "1F980", sheet_x: 32, sheet_y: 15, short_names: ["crab"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "crab,animal,crustacean" }, satellite_antenna: { name: "Satellite Antenna", unified: "1F4E1", sheet_x: 21, sheet_y: 36, short_names: ["satellite_antenna"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "satellite,antenna" }, airplane: { name: "Airplane", unified: "2708", variations: ["2708-FE0F"], sheet_x: 3, sheet_y: 7, short_names: ["airplane"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "airplane,vehicle,transportation,flight,fly" }, aquarius: { name: "Aquarius", unified: "2652", variations: ["2652-FE0F"], sheet_x: 1, sheet_y: 36, short_names: ["aquarius"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "aquarius,sign,purple-square,zodiac,astrology" }, ticket: { name: "Ticket", unified: "1F3AB", sheet_x: 9, sheet_y: 26, short_names: ["ticket"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ticket,event,concert,pass" }, worried: { name: "Worried Face", unified: "1F61F", sheet_x: 27, sheet_y: 5, short_names: ["worried"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "worried,face,concern,nervous,:(" }, "flag-cv": { name: "Regional Indicator Symbol Letters CV", unified: "1F1E8-1F1FB", sheet_x: 34, sheet_y: 4, short_names: ["flag-cv"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cv,regional,indicator,symbol,letters" }, curry: { name: "Curry and Rice", unified: "1F35B", sheet_x: 7, sheet_y: 28, short_names: ["curry"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "curry,and,rice,food,spicy,hot,indian" }, pisces: { name: "Pisces", unified: "2653", variations: ["2653-FE0F"], sheet_x: 1, sheet_y: 37, short_names: ["pisces"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pisces,purple-square,sign,zodiac,astrology" }, airplane_departure: { name: "Airplane Departure", unified: "1F6EB", sheet_x: 31, sheet_y: 38, short_names: ["airplane_departure"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "airplane,departure,airport,flight,landing" }, "flag-kh": { name: "Regional Indicator Symbol Letters KH", unified: "1F1F0-1F1ED", sheet_x: 35, sheet_y: 32, short_names: ["flag-kh"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,kh,regional,indicator,symbol,letters" }, battery: { name: "Battery", unified: "1F50B", sheet_x: 22, sheet_y: 36, short_names: ["battery"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "battery,power,energy,sustain" }, snake: { name: "Snake", unified: "1F40D", sheet_x: 12, sheet_y: 18, short_names: ["snake"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "snake,animal,evil,nature,hiss,python" }, angry: { name: "Angry Face", unified: "1F620", sheet_x: 27, sheet_y: 6, short_names: ["angry"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [">:(", ">:-("], search: "angry,face,mad,annoyed,frustrated,>:(,>:-(" }, rice_ball: { name: "Rice Ball", unified: "1F359", sheet_x: 7, sheet_y: 26, short_names: ["rice_ball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rice,ball,food,japanese" }, admission_tickets: { name: "Admission Tickets", unified: "1F39F", sheet_x: 9, sheet_y: 14, short_names: ["admission_tickets"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "admission,tickets" }, performing_arts: { name: "Performing Arts", unified: "1F3AD", sheet_x: 9, sheet_y: 28, short_names: ["performing_arts"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "performing,arts,acting,theater,drama" }, rage: { name: "Pouting Face", unified: "1F621", sheet_x: 27, sheet_y: 7, short_names: ["rage"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rage,pouting,face,angry,mad,hate,despise" }, rice: { name: "Cooked Rice", unified: "1F35A", sheet_x: 7, sheet_y: 27, short_names: ["rice"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rice,cooked,food,china,asian" }, airplane_arriving: { name: "Airplane Arriving", unified: "1F6EC", sheet_x: 31, sheet_y: 39, short_names: ["airplane_arriving"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "airplane,arriving" }, id: { name: "Squared Id", unified: "1F194", sheet_x: 4, sheet_y: 40, short_names: ["id"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "id,squared,purple-square,words" }, "flag-cm": { name: "Regional Indicator Symbol Letters CM", unified: "1F1E8-1F1F2", sheet_x: 33, sheet_y: 39, short_names: ["flag-cm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cm,regional,indicator,symbol,letters" }, turtle: { name: "Turtle", unified: "1F422", sheet_x: 12, sheet_y: 39, short_names: ["turtle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "turtle,animal,slow,nature,tortoise" }, electric_plug: { name: "Electric Plug", unified: "1F50C", sheet_x: 22, sheet_y: 37, short_names: ["electric_plug"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "electric,plug,charger,power" }, tropical_fish: { name: "Tropical Fish", unified: "1F420", sheet_x: 12, sheet_y: 37, short_names: ["tropical_fish"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tropical,fish,animal,swim,ocean,beach,nemo" }, bulb: { name: "Electric Light Bulb", unified: "1F4A1", sheet_x: 20, sheet_y: 8, short_names: ["bulb"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bulb,electric,light,electricity,idea" }, pensive: { name: "Pensive Face", unified: "1F614", sheet_x: 26, sheet_y: 35, short_names: ["pensive"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pensive,face,sad,depressed,okay,upset" }, rice_cracker: { name: "Rice Cracker", unified: "1F358", sheet_x: 7, sheet_y: 25, short_names: ["rice_cracker"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rice,cracker,food,japanese" }, art: { name: "Artist Palette", unified: "1F3A8", sheet_x: 9, sheet_y: 23, short_names: ["art"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "art,artist,palette,design,paint,draw,colors" }, boat: { name: "Sailboat", unified: "26F5", variations: ["26F5-FE0F"], sheet_x: 2, sheet_y: 35, short_names: ["boat", "sailboat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "boat,sailboat,ship,summer,transportation,water,sailing" }, atom_symbol: { name: "Atom Symbol", unified: "269B", sheet_x: 2, sheet_y: 10, short_names: ["atom_symbol"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "atom,symbol,science" }, "flag-ca": { name: "Regional Indicator Symbol Letters CA", unified: "1F1E8-1F1E6", sheet_x: 33, sheet_y: 30, short_names: ["flag-ca"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ca,regional,indicator,symbol,letters" }, oden: { name: "Oden", unified: "1F362", sheet_x: 7, sheet_y: 35, short_names: ["oden"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "oden,food,japanese" }, flashlight: { name: "Electric Torch", unified: "1F526", sheet_x: 23, sheet_y: 22, short_names: ["flashlight"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flashlight,electric,torch,dark,camping,sight,night" }, confused: { name: "Confused Face", unified: "1F615", sheet_x: 26, sheet_y: 36, short_names: ["confused"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":\\", ":-\\", ":/", ":-/"], search: "confused,face,indifference,huh,weird,hmmm,:\\,:-\\,:/,:-/" }, "u7a7a": { name: "Squared Cjk Unified Ideograph-7a7a", unified: "1F233", sheet_x: 5, sheet_y: 11, short_names: ["u7a7a"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u7a7a,squared,cjk,unified,ideograph,7a7a,kanji,japanese,chinese,empty,sky,blue-square" }, circus_tent: { name: "Circus Tent", unified: "1F3AA", sheet_x: 9, sheet_y: 25, short_names: ["circus_tent"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "circus,tent,festival,carnival,party" }, motor_boat: { name: "Motor Boat", unified: "1F6E5", sheet_x: 31, sheet_y: 36, short_names: ["motor_boat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "motor,boat,ship" }, "flag-ic": { name: "Regional Indicator Symbol Letters IC", unified: "1F1EE-1F1E8", sheet_x: 35, sheet_y: 15, short_names: ["flag-ic"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,ic,regional,indicator,symbol,letters" }, fish: { name: "Fish", unified: "1F41F", sheet_x: 12, sheet_y: 36, short_names: ["fish"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fish,animal,food,nature" }, microphone: { name: "Microphone", unified: "1F3A4", sheet_x: 9, sheet_y: 19, short_names: ["microphone"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "microphone,sound,music,pa" }, "flag-ky": { name: "Regional Indicator Symbol Letters KY", unified: "1F1F0-1F1FE", sheet_x: 35, sheet_y: 39, short_names: ["flag-ky"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ky,regional,indicator,symbol,letters" }, candle: { name: "Candle", unified: "1F56F", sheet_x: 24, sheet_y: 35, short_names: ["candle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "candle,fire,wax" }, dango: { name: "Dango", unified: "1F361", sheet_x: 7, sheet_y: 34, short_names: ["dango"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dango,food,barbecue,meat" }, slightly_frowning_face: { name: "Slightly Frowning Face", unified: "1F641", sheet_x: 27, sheet_y: 39, short_names: ["slightly_frowning_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "slightly,frowning,face" }, blowfish: { name: "Blowfish", unified: "1F421", sheet_x: 12, sheet_y: 38, short_names: ["blowfish"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "blowfish,animal,nature,food,sea,ocean" }, "u5272": { name: "Squared Cjk Unified Ideograph-5272", unified: "1F239", sheet_x: 5, sheet_y: 17, short_names: ["u5272"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u5272,squared,cjk,unified,ideograph,5272,cut,divide,chinese,kanji,pink-square" }, speedboat: { name: "Speedboat", unified: "1F6A4", sheet_x: 30, sheet_y: 12, short_names: ["speedboat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "speedboat,ship,transportation,vehicle,summer" }, white_frowning_face: { name: "White Frowning Face", unified: "2639", variations: ["2639-FE0F"], sheet_x: 1, sheet_y: 24, short_names: ["white_frowning_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,frowning,face" }, dolphin: { name: "Dolphin", unified: "1F42C", sheet_x: 13, sheet_y: 8, short_names: ["dolphin", "flipper"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dolphin,flipper,animal,nature,fish,sea,ocean,fins,beach" }, radioactive_sign: { name: "Radioactive Sign", unified: "2622", variations: ["2622-FE0F"], sheet_x: 1, sheet_y: 17, short_names: ["radioactive_sign"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "radioactive,sign,nuclear,danger" }, headphones: { name: "Headphone", unified: "1F3A7", sheet_x: 9, sheet_y: 22, short_names: ["headphones"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "headphones,headphone,music,score,gadgets" }, "flag-cf": { name: "Regional Indicator Symbol Letters CF", unified: "1F1E8-1F1EB", sheet_x: 33, sheet_y: 33, short_names: ["flag-cf"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cf,regional,indicator,symbol,letters" }, ferry: { name: "Ferry", unified: "26F4", sheet_x: 2, sheet_y: 34, short_names: ["ferry"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ferry,boat,ship,yacht" }, wastebasket: { name: "Wastebasket", unified: "1F5D1", sheet_x: 25, sheet_y: 39, short_names: ["wastebasket"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wastebasket,bin,trash,rubbish,garbage,toss" }, shaved_ice: { name: "Shaved Ice", unified: "1F367", sheet_x: 7, sheet_y: 40, short_names: ["shaved_ice"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "shaved,ice,hot,dessert,summer" }, whale: { name: "Spouting Whale", unified: "1F433", sheet_x: 13, sheet_y: 15, short_names: ["whale"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "whale,spouting,animal,nature,sea,ocean" }, oil_drum: { name: "Oil Drum", unified: "1F6E2", sheet_x: 31, sheet_y: 33, short_names: ["oil_drum"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "oil,drum,barrell" }, ice_cream: { name: "Ice Cream", unified: "1F368", sheet_x: 8, sheet_y: 0, short_names: ["ice_cream"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ice,cream,food,hot,dessert" }, passenger_ship: { name: "Passenger Ship", unified: "1F6F3", sheet_x: 32, sheet_y: 0, short_names: ["passenger_ship"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "passenger,ship,yacht,cruise,ferry" }, biohazard_sign: { name: "Biohazard Sign", unified: "2623", variations: ["2623-FE0F"], sheet_x: 1, sheet_y: 18, short_names: ["biohazard_sign"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "biohazard,sign,danger" }, musical_score: { name: "Musical Score", unified: "1F3BC", sheet_x: 10, sheet_y: 2, short_names: ["musical_score"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "musical,score,treble,clef" }, persevere: { name: "Persevering Face", unified: "1F623", sheet_x: 27, sheet_y: 9, short_names: ["persevere"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "persevere,persevering,face,sick,no,upset,oops" }, "flag-td": { name: "Regional Indicator Symbol Letters TD", unified: "1F1F9-1F1E9", sheet_x: 38, sheet_y: 8, short_names: ["flag-td"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,td,regional,indicator,symbol,letters" }, icecream: { name: "Soft Ice Cream", unified: "1F366", sheet_x: 7, sheet_y: 39, short_names: ["icecream"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "icecream,soft,ice,cream,food,hot,dessert,summer" }, "whale2": { name: "Whale", unified: "1F40B", sheet_x: 12, sheet_y: 16, short_names: ["whale2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "whale2,whale,animal,nature,sea,ocean" }, musical_keyboard: { name: "Musical Keyboard", unified: "1F3B9", sheet_x: 9, sheet_y: 40, short_names: ["musical_keyboard"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "musical,keyboard,piano,instrument" }, money_with_wings: { name: "Money with Wings", unified: "1F4B8", sheet_x: 20, sheet_y: 36, short_names: ["money_with_wings"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "money,with,wings,dollar,bills,payment,sale" }, confounded: { name: "Confounded Face", unified: "1F616", sheet_x: 26, sheet_y: 37, short_names: ["confounded"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "confounded,face,confused,sick,unwell,oops" }, rocket: { name: "Rocket", unified: "1F680", sheet_x: 29, sheet_y: 12, short_names: ["rocket"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rocket,launch,ship,staffmode,nasa,outer space,outer_space,fly" }, mobile_phone_off: { name: "Mobile Phone off", unified: "1F4F4", sheet_x: 22, sheet_y: 14, short_names: ["mobile_phone_off"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mobile,phone,off,mute,orange-square,silence,quiet" }, "flag-cl": { name: "Regional Indicator Symbol Letters CL", unified: "1F1E8-1F1F1", sheet_x: 33, sheet_y: 38, short_names: ["flag-cl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cl,regional,indicator,symbol,letters" }, satellite: { name: "Satellite", unified: "1F6F0", sheet_x: 31, sheet_y: 40, short_names: ["satellite"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "satellite,communication,future,radio,space" }, "flag-cn": { name: "Regional Indicator Symbol Letters CN", unified: "1F1E8-1F1F3", sheet_x: 33, sheet_y: 40, short_names: ["flag-cn", "cn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cn,regional,indicator,symbol,letters" }, crocodile: { name: "Crocodile", unified: "1F40A", sheet_x: 12, sheet_y: 15, short_names: ["crocodile"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "crocodile,animal,nature,reptile" }, cake: { name: "Shortcake", unified: "1F370", sheet_x: 8, sheet_y: 8, short_names: ["cake"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cake,shortcake,food,dessert" }, dollar: { name: "Banknote with Dollar Sign", unified: "1F4B5", sheet_x: 20, sheet_y: 33, short_names: ["dollar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dollar,banknote,with,sign,money,sales,bill,currency" }, vibration_mode: { name: "Vibration Mode", unified: "1F4F3", sheet_x: 22, sheet_y: 13, short_names: ["vibration_mode"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "vibration,mode,orange-square,phone" }, tired_face: { name: "Tired Face", unified: "1F62B", sheet_x: 27, sheet_y: 17, short_names: ["tired_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tired,face,sick,whine,upset,frustrated" }, saxophone: { name: "Saxophone", unified: "1F3B7", sheet_x: 9, sheet_y: 38, short_names: ["saxophone"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "saxophone,music,instrument,jazz,blues" }, "flag-cx": { name: "Regional Indicator Symbol Letters CX", unified: "1F1E8-1F1FD", sheet_x: 34, sheet_y: 6, short_names: ["flag-cx"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cx,regional,indicator,symbol,letters" }, seat: { name: "Seat", unified: "1F4BA", sheet_x: 20, sheet_y: 38, short_names: ["seat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "seat,sit,airplane,transport,bus,flight,fly" }, trumpet: { name: "Trumpet", unified: "1F3BA", sheet_x: 10, sheet_y: 0, short_names: ["trumpet"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "trumpet,music,brass" }, yen: { name: "Banknote with Yen Sign", unified: "1F4B4", sheet_x: 20, sheet_y: 32, short_names: ["yen"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "yen,banknote,with,sign,money,sales,japanese,dollar,currency" }, leopard: { name: "Leopard", unified: "1F406", sheet_x: 12, sheet_y: 11, short_names: ["leopard"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "leopard,animal,nature" }, "u6709": { name: "Squared Cjk Unified Ideograph-6709", unified: "1F236", sheet_x: 5, sheet_y: 14, short_names: ["u6709"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u6709,squared,cjk,unified,ideograph,6709,orange-square,chinese,have,kanji" }, birthday: { name: "Birthday Cake", unified: "1F382", sheet_x: 8, sheet_y: 26, short_names: ["birthday"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "birthday,cake,food,dessert" }, weary: { name: "Weary Face", unified: "1F629", sheet_x: 27, sheet_y: 15, short_names: ["weary"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "weary,face,tired,sleepy,sad,frustrated,upset" }, "tiger2": { name: "Tiger", unified: "1F405", sheet_x: 12, sheet_y: 10, short_names: ["tiger2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tiger2,tiger,animal,nature,roar" }, "flag-cc": { name: "Regional Indicator Symbol Letters CC", unified: "1F1E8-1F1E8", sheet_x: 33, sheet_y: 31, short_names: ["flag-cc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cc,regional,indicator,symbol,letters" }, "u7121": { name: "Squared Cjk Unified Ideograph-7121", unified: "1F21A", variations: ["1F21A-FE0F"], sheet_x: 5, sheet_y: 8, short_names: ["u7121"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u7121,squared,cjk,unified,ideograph,7121,nothing,chinese,kanji,japanese,orange-square" }, euro: { name: "Banknote with Euro Sign", unified: "1F4B6", sheet_x: 20, sheet_y: 34, short_names: ["euro"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "euro,banknote,with,sign,money,sales,dollar,currency" }, custard: { name: "Custard", unified: "1F36E", sheet_x: 8, sheet_y: 6, short_names: ["custard"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "custard,dessert,food" }, triumph: { name: "Face with Look of Triumph", unified: "1F624", sheet_x: 27, sheet_y: 10, short_names: ["triumph"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "triumph,face,with,look,of,gas,phew,proud,pride" }, anchor: { name: "Anchor", unified: "2693", variations: ["2693-FE0F"], sheet_x: 2, sheet_y: 5, short_names: ["anchor"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "anchor,ship,ferry,sea,boat" }, guitar: { name: "Guitar", unified: "1F3B8", sheet_x: 9, sheet_y: 39, short_names: ["guitar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "guitar,music,instrument" }, violin: { name: "Violin", unified: "1F3BB", sheet_x: 10, sheet_y: 1, short_names: ["violin"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "violin,music,instrument,orchestra,symphony" }, construction: { name: "Construction Sign", unified: "1F6A7", sheet_x: 30, sheet_y: 15, short_names: ["construction"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "construction,sign,wip,progress,caution,warning" }, water_buffalo: { name: "Water Buffalo", unified: "1F403", sheet_x: 12, sheet_y: 8, short_names: ["water_buffalo"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "water,buffalo,animal,nature,ox,cow" }, candy: { name: "Candy", unified: "1F36C", sheet_x: 8, sheet_y: 4, short_names: ["candy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "candy,snack,dessert,sweet" }, pound: { name: "Banknote with Pound Sign", unified: "1F4B7", sheet_x: 20, sheet_y: 35, short_names: ["pound"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pound,banknote,with,sign,british,sterling,money,sales,bills,uk,england,currency" }, "flag-co": { name: "Regional Indicator Symbol Letters CO", unified: "1F1E8-1F1F4", sheet_x: 34, sheet_y: 0, short_names: ["flag-co"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,co,regional,indicator,symbol,letters" }, open_mouth: { name: "Face with Open Mouth", unified: "1F62E", sheet_x: 27, sheet_y: 20, short_names: ["open_mouth"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":o", ":-o", ":O", ":-O"], search: "open,mouth,face,with,surprise,impressed,wow,:o,:-o" }, "u7533": { name: "Squared Cjk Unified Ideograph-7533", unified: "1F238", sheet_x: 5, sheet_y: 16, short_names: ["u7533"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u7533,squared,cjk,unified,ideograph,7533,chinese,japanese,kanji,orange-square" }, ox: { name: "Ox", unified: "1F402", sheet_x: 12, sheet_y: 7, short_names: ["ox"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ox,animal,cow,beef" }, scream: { name: "Face Screaming in Fear", unified: "1F631", sheet_x: 27, sheet_y: 23, short_names: ["scream"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "scream,face,screaming,in,fear,munch,scared,omg" }, "flag-km": { name: "Regional Indicator Symbol Letters KM", unified: "1F1F0-1F1F2", sheet_x: 35, sheet_y: 34, short_names: ["flag-km"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,km,regional,indicator,symbol,letters" }, clapper: { name: "Clapper Board", unified: "1F3AC", sheet_x: 9, sheet_y: 27, short_names: ["clapper"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clapper,board,movie,film,record" }, "u55b6": { name: "Squared Cjk Unified Ideograph-55b6", unified: "1F23A", sheet_x: 5, sheet_y: 18, short_names: ["u55b6"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u55b6,squared,cjk,unified,ideograph,55b6,japanese,opening hours,orange-square" }, fuelpump: { name: "Fuel Pump", unified: "26FD", variations: ["26FD-FE0F"], sheet_x: 3, sheet_y: 4, short_names: ["fuelpump"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fuelpump,fuel,pump,gas station,petroleum" }, moneybag: { name: "Money Bag", unified: "1F4B0", sheet_x: 20, sheet_y: 28, short_names: ["moneybag"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "moneybag,money,bag,dollar,payment,coins,sale" }, lollipop: { name: "Lollipop", unified: "1F36D", sheet_x: 8, sheet_y: 5, short_names: ["lollipop"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lollipop,food,snack,candy,sweet" }, credit_card: { name: "Credit Card", unified: "1F4B3", sheet_x: 20, sheet_y: 31, short_names: ["credit_card"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "credit,card,money,sales,dollar,bill,payment,shopping" }, "cow2": { name: "Cow", unified: "1F404", sheet_x: 12, sheet_y: 9, short_names: ["cow2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cow2,cow,beef,ox,animal,nature,moo,milk" }, video_game: { name: "Video Game", unified: "1F3AE", sheet_x: 9, sheet_y: 29, short_names: ["video_game"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "video,game,play,console,ps4,controller" }, busstop: { name: "Bus Stop", unified: "1F68F", sheet_x: 29, sheet_y: 27, short_names: ["busstop"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "busstop,bus,stop,transportation,wait" }, chocolate_bar: { name: "Chocolate Bar", unified: "1F36B", sheet_x: 8, sheet_y: 3, short_names: ["chocolate_bar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "chocolate,bar,food,snack,dessert,sweet" }, "u6708": { name: "Squared Cjk Unified Ideograph-6708", unified: "1F237", variations: ["1F237-FE0F"], sheet_x: 5, sheet_y: 15, short_names: ["u6708"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u6708,squared,cjk,unified,ideograph,6708,chinese,month,moon,japanese,orange-square,kanji" }, fearful: { name: "Fearful Face", unified: "1F628", sheet_x: 27, sheet_y: 14, short_names: ["fearful"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fearful,face,scared,terrified,nervous,oops,huh" }, "flag-cg": { name: "Regional Indicator Symbol Letters CG", unified: "1F1E8-1F1EC", sheet_x: 33, sheet_y: 34, short_names: ["flag-cg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cg,regional,indicator,symbol,letters" }, dromedary_camel: { name: "Dromedary Camel", unified: "1F42A", sheet_x: 13, sheet_y: 6, short_names: ["dromedary_camel"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dromedary,camel,animal,hot,desert,hump" }, popcorn: { name: "Popcorn", unified: "1F37F", sheet_x: 8, sheet_y: 23, short_names: ["popcorn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "popcorn,food,movie theater,films,snack" }, eight_pointed_black_star: { name: "Eight Pointed Black Star", unified: "2734", variations: ["2734-FE0F"], sheet_x: 4, sheet_y: 0, short_names: ["eight_pointed_black_star"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "eight,pointed,black,star,orange-square,shape,polygon" }, gem: { name: "Gem Stone", unified: "1F48E", sheet_x: 19, sheet_y: 30, short_names: ["gem"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "gem,stone,blue,ruby,diamond,jewelry" }, space_invader: { name: "Alien Monster", unified: "1F47E", sheet_x: 18, sheet_y: 25, short_names: ["space_invader"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "space,invader,alien,monster,game,arcade,play" }, vertical_traffic_light: { name: "Vertical Traffic Light", unified: "1F6A6", sheet_x: 30, sheet_y: 14, short_names: ["vertical_traffic_light"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "vertical,traffic,light,transportation,driving" }, cold_sweat: { name: "Face with Open Mouth and Cold Sweat", unified: "1F630", sheet_x: 27, sheet_y: 22, short_names: ["cold_sweat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cold,sweat,face,with,open,mouth,and,nervous" }, "flag-cd": { name: "Regional Indicator Symbol Letters CD", unified: "1F1E8-1F1E9", sheet_x: 33, sheet_y: 32, short_names: ["flag-cd"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cd,regional,indicator,symbol,letters" }, "flag-ck": { name: "Regional Indicator Symbol Letters CK", unified: "1F1E8-1F1F0", sheet_x: 33, sheet_y: 37, short_names: ["flag-ck"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ck,regional,indicator,symbol,letters" }, hushed: { name: "Hushed Face", unified: "1F62F", sheet_x: 27, sheet_y: 21, short_names: ["hushed"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hushed,face,woo,shh" }, traffic_light: { name: "Horizontal Traffic Light", unified: "1F6A5", sheet_x: 30, sheet_y: 13, short_names: ["traffic_light"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "traffic,light,horizontal,transportation,signal" }, doughnut: { name: "Doughnut", unified: "1F369", sheet_x: 8, sheet_y: 1, short_names: ["doughnut"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "doughnut,food,dessert,snack,sweet,donut" }, camel: { name: "Bactrian Camel", unified: "1F42B", sheet_x: 13, sheet_y: 7, short_names: ["camel"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "camel,bactrian,animal,nature,hot,desert,hump" }, dart: { name: "Direct Hit", unified: "1F3AF", sheet_x: 9, sheet_y: 30, short_names: ["dart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dart,direct,hit,game,play,bar" }, scales: { name: "Scales", unified: "2696", sheet_x: 2, sheet_y: 7, short_names: ["scales"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "scales,law,fairness,weight" }, vs: { name: "Squared Vs", unified: "1F19A", sheet_x: 5, sheet_y: 5, short_names: ["vs"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "vs,squared,words,orange-square" }, elephant: { name: "Elephant", unified: "1F418", sheet_x: 12, sheet_y: 29, short_names: ["elephant"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "elephant,animal,nature,nose,thailand,circus" }, wrench: { name: "Wrench", unified: "1F527", sheet_x: 23, sheet_y: 23, short_names: ["wrench"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wrench,tools,diy,ikea,fix,maintainer" }, game_die: { name: "Game Die", unified: "1F3B2", sheet_x: 9, sheet_y: 33, short_names: ["game_die"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "game,die,dice,random,tabbletop,play,luck" }, accept: { name: "Circled Ideograph Accept", unified: "1F251", sheet_x: 5, sheet_y: 20, short_names: ["accept"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "accept,circled,ideograph,ok,good,chinese,kanji,agree,yes,orange-circle" }, cookie: { name: "Cookie", unified: "1F36A", sheet_x: 8, sheet_y: 2, short_names: ["cookie"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cookie,food,snack,oreo,chocolate,sweet,dessert" }, "flag-cr": { name: "Regional Indicator Symbol Letters CR", unified: "1F1E8-1F1F7", sheet_x: 34, sheet_y: 2, short_names: ["flag-cr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cr,regional,indicator,symbol,letters" }, checkered_flag: { name: "Chequered Flag", unified: "1F3C1", sheet_x: 10, sheet_y: 7, short_names: ["checkered_flag"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "checkered,flag,chequered,contest,finishline,rase,gokart" }, frowning: { name: "Frowning Face with Open Mouth", unified: "1F626", sheet_x: 27, sheet_y: 12, short_names: ["frowning"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "frowning,face,with,open,mouth,aw,what" }, white_flower: { name: "White Flower", unified: "1F4AE", sheet_x: 20, sheet_y: 26, short_names: ["white_flower"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,flower,japanese,spring" }, ship: { name: "Ship", unified: "1F6A2", sheet_x: 30, sheet_y: 5, short_names: ["ship"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ship,transportation,titanic,deploy" }, hammer: { name: "Hammer", unified: "1F528", sheet_x: 23, sheet_y: 24, short_names: ["hammer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hammer,tools,build,create" }, "flag-hr": { name: "Regional Indicator Symbol Letters HR", unified: "1F1ED-1F1F7", sheet_x: 35, sheet_y: 12, short_names: ["flag-hr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,hr,regional,indicator,symbol,letters" }, anguished: { name: "Anguished Face", unified: "1F627", sheet_x: 27, sheet_y: 13, short_names: ["anguished"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: ["D:"], search: "anguished,face,stunned,nervous,d:" }, goat: { name: "Goat", unified: "1F410", sheet_x: 12, sheet_y: 21, short_names: ["goat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "goat,animal,nature" }, beer: { name: "Beer Mug", unified: "1F37A", sheet_x: 8, sheet_y: 18, short_names: ["beer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "beer,mug,relax,beverage,drink,drunk,party,pub,summer,alcohol,booze" }, slot_machine: { name: "Slot Machine", unified: "1F3B0", sheet_x: 9, sheet_y: 31, short_names: ["slot_machine"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "slot,machine,bet,gamble,vegas,fruit machine,luck,casino" }, "flag-cu": { name: "Regional Indicator Symbol Letters CU", unified: "1F1E8-1F1FA", sheet_x: 34, sheet_y: 3, short_names: ["flag-cu"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cu,regional,indicator,symbol,letters" }, hammer_and_pick: { name: "Hammer and Pick", unified: "2692", sheet_x: 2, sheet_y: 4, short_names: ["hammer_and_pick"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hammer,and,pick,tools,build,create" }, beers: { name: "Clinking Beer Mugs", unified: "1F37B", sheet_x: 8, sheet_y: 19, short_names: ["beers"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "beers,clinking,beer,mugs,relax,beverage,drink,drunk,party,pub,summer,alcohol,booze" }, ferris_wheel: { name: "Ferris Wheel", unified: "1F3A1", sheet_x: 9, sheet_y: 16, short_names: ["ferris_wheel"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ferris,wheel,photo,carnival,londoneye" }, ideograph_advantage: { name: "Circled Ideograph Advantage", unified: "1F250", sheet_x: 5, sheet_y: 19, short_names: ["ideograph_advantage"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ideograph,advantage,circled,chinese,kanji,obtain,get,circle" }, ram: { name: "Ram", unified: "1F40F", sheet_x: 12, sheet_y: 20, short_names: ["ram"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ram,animal,sheep,nature" }, cry: { name: "Crying Face", unified: "1F622", sheet_x: 27, sheet_y: 8, short_names: ["cry"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":'("], search: "cry,crying,face,tears,sad,depressed,upset,:'(" }, bowling: { name: "Bowling", unified: "1F3B3", sheet_x: 9, sheet_y: 34, short_names: ["bowling"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bowling,sports,fun,play" }, "flag-cw": { name: "Regional Indicator Symbol Letters CW", unified: "1F1E8-1F1FC", sheet_x: 34, sheet_y: 5, short_names: ["flag-cw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cw,regional,indicator,symbol,letters" }, secret: { name: "Circled Ideograph Secret", unified: "3299", variations: ["3299-FE0F"], sheet_x: 4, sheet_y: 29, short_names: ["secret"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "secret,circled,ideograph,privacy,chinese,sshh,kanji,red-circle" }, disappointed_relieved: { name: "Disappointed but Relieved Face", unified: "1F625", sheet_x: 27, sheet_y: 11, short_names: ["disappointed_relieved"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "disappointed,relieved,but,face,phew,sweat,nervous" }, hammer_and_wrench: { name: "Hammer and Wrench", unified: "1F6E0", sheet_x: 31, sheet_y: 31, short_names: ["hammer_and_wrench"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hammer,and,wrench,tools,build,create" }, roller_coaster: { name: "Roller Coaster", unified: "1F3A2", sheet_x: 9, sheet_y: 17, short_names: ["roller_coaster"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "roller,coaster,carnival,playground,photo,fun" }, sheep: { name: "Sheep", unified: "1F411", sheet_x: 12, sheet_y: 22, short_names: ["sheep"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sheep,animal,nature,wool,shipit" }, wine_glass: { name: "Wine Glass", unified: "1F377", sheet_x: 8, sheet_y: 15, short_names: ["wine_glass"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wine,glass,drink,beverage,drunk,alcohol,booze" }, congratulations: { name: "Circled Ideograph Congratulation", unified: "3297", variations: ["3297-FE0F"], sheet_x: 4, sheet_y: 28, short_names: ["congratulations"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "congratulations,circled,ideograph,congratulation,chinese,kanji,japanese,red-circle" }, sleepy: { name: "Sleepy Face", unified: "1F62A", sheet_x: 27, sheet_y: 16, short_names: ["sleepy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sleepy,face,tired,rest,nap" }, carousel_horse: { name: "Carousel Horse", unified: "1F3A0", sheet_x: 9, sheet_y: 15, short_names: ["carousel_horse"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "carousel,horse,photo,carnival" }, pick: { name: "Pick", unified: "26CF", sheet_x: 2, sheet_y: 24, short_names: ["pick"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pick,tools,dig" }, "flag-cy": { name: "Regional Indicator Symbol Letters CY", unified: "1F1E8-1F1FE", sheet_x: 34, sheet_y: 7, short_names: ["flag-cy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cy,regional,indicator,symbol,letters" }, cocktail: { name: "Cocktail Glass", unified: "1F378", sheet_x: 8, sheet_y: 16, short_names: ["cocktail"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cocktail,glass,drink,drunk,alcohol,beverage,booze" }, racehorse: { name: "Horse", unified: "1F40E", sheet_x: 12, sheet_y: 19, short_names: ["racehorse"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "racehorse,horse,animal,gamble,luck" }, "flag-cz": { name: "Regional Indicator Symbol Letters CZ", unified: "1F1E8-1F1FF", sheet_x: 34, sheet_y: 8, short_names: ["flag-cz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,cz,regional,indicator,symbol,letters" }, tropical_drink: { name: "Tropical Drink", unified: "1F379", sheet_x: 8, sheet_y: 17, short_names: ["tropical_drink"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tropical,drink,beverage,cocktail,summer,beach,alcohol,booze" }, "u5408": { name: "Squared Cjk Unified Ideograph-5408", unified: "1F234", sheet_x: 5, sheet_y: 12, short_names: ["u5408"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u5408,squared,cjk,unified,ideograph,5408,japanese,chinese,join,kanji,red-square" }, nut_and_bolt: { name: "Nut and Bolt", unified: "1F529", sheet_x: 23, sheet_y: 25, short_names: ["nut_and_bolt"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "nut,and,bolt,handy,tools,fix" }, sweat: { name: "Face with Cold Sweat", unified: "1F613", sheet_x: 26, sheet_y: 34, short_names: ["sweat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sweat,face,with,cold,hot,sad,tired,exercise" }, building_construction: { name: "Building Construction", unified: "1F3D7", sheet_x: 11, sheet_y: 8, short_names: ["building_construction"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "building,construction,wip,working,progress" }, "pig2": { name: "Pig", unified: "1F416", sheet_x: 12, sheet_y: 27, short_names: ["pig2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pig2,pig,animal,nature" }, sob: { name: "Loudly Crying Face", unified: "1F62D", sheet_x: 27, sheet_y: 19, short_names: ["sob"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":'("], search: "sob,loudly,crying,face,cry,tears,sad,upset,depressed,:'(" }, "u6e80": { name: "Squared Cjk Unified Ideograph-6e80", unified: "1F235", sheet_x: 5, sheet_y: 13, short_names: ["u6e80"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u6e80,squared,cjk,unified,ideograph,6e80,full,chinese,japanese,red-square,kanji" }, "flag-dk": { name: "Regional Indicator Symbol Letters DK", unified: "1F1E9-1F1F0", sheet_x: 34, sheet_y: 12, short_names: ["flag-dk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,dk,regional,indicator,symbol,letters" }, gear: { name: "Gear", unified: "2699", sheet_x: 2, sheet_y: 9, short_names: ["gear"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "gear,cog" }, rat: { name: "Rat", unified: "1F400", sheet_x: 12, sheet_y: 5, short_names: ["rat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rat,animal,mouse,rodent" }, champagne: { name: "Bottle with Popping Cork", unified: "1F37E", sheet_x: 8, sheet_y: 22, short_names: ["champagne"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "champagne,bottle,with,popping,cork" }, foggy: { name: "Foggy", unified: "1F301", sheet_x: 5, sheet_y: 22, short_names: ["foggy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "foggy,photo,mountain" }, tokyo_tower: { name: "Tokyo Tower", unified: "1F5FC", sheet_x: 26, sheet_y: 11, short_names: ["tokyo_tower"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tokyo,tower,photo,japanese" }, dizzy_face: { name: "Dizzy Face", unified: "1F635", sheet_x: 27, sheet_y: 27, short_names: ["dizzy_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dizzy,face,spent,unconscious,xox" }, sake: { name: "Sake Bottle and Cup", unified: "1F376", sheet_x: 8, sheet_y: 14, short_names: ["sake"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sake,bottle,and,cup,wine,drink,drunk,beverage,japanese,alcohol,booze" }, "u7981": { name: "Squared Cjk Unified Ideograph-7981", unified: "1F232", sheet_x: 5, sheet_y: 10, short_names: ["u7981"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u7981,squared,cjk,unified,ideograph,7981,kanji,japanese,chinese,forbidden,limit,restricted,red-square" }, "mouse2": { name: "Mouse", unified: "1F401", sheet_x: 12, sheet_y: 6, short_names: ["mouse2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mouse2,mouse,animal,nature,rodent" }, "flag-dj": { name: "Regional Indicator Symbol Letters DJ", unified: "1F1E9-1F1EF", sheet_x: 34, sheet_y: 11, short_names: ["flag-dj"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,dj,regional,indicator,symbol,letters" }, chains: { name: "Chains", unified: "26D3", sheet_x: 2, sheet_y: 26, short_names: ["chains"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "chains,lock,arrest" }, a: { name: "Negative Squared Latin Capital Letter a", unified: "1F170", variations: ["1F170-FE0F"], sheet_x: 4, sheet_y: 32, short_names: ["a"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "a,negative,squared,latin,capital,letter,red-square,alphabet" }, tea: { name: "Teacup Without Handle", unified: "1F375", sheet_x: 8, sheet_y: 13, short_names: ["tea"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tea,teacup,without,handle,drink,bowl,breakfast,green,british" }, gun: { name: "Pistol", unified: "1F52B", sheet_x: 23, sheet_y: 27, short_names: ["gun"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "gun,pistol,violence,weapon,revolver" }, astonished: { name: "Astonished Face", unified: "1F632", sheet_x: 27, sheet_y: 24, short_names: ["astonished"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "astonished,face,xox,surprised,poisoned" }, "flag-dm": { name: "Regional Indicator Symbol Letters DM", unified: "1F1E9-1F1F2", sheet_x: 34, sheet_y: 13, short_names: ["flag-dm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,dm,regional,indicator,symbol,letters" }, rooster: { name: "Rooster", unified: "1F413", sheet_x: 12, sheet_y: 24, short_names: ["rooster"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rooster,animal,nature,chicken" }, factory: { name: "Factory", unified: "1F3ED", sheet_x: 11, sheet_y: 30, short_names: ["factory"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "factory,building,industry,pollution,smoke" }, coffee: { name: "Hot Beverage", unified: "2615", variations: ["2615-FE0F"], sheet_x: 1, sheet_y: 8, short_names: ["coffee"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "coffee,hot,beverage,caffeine,latte,espresso" }, bomb: { name: "Bomb", unified: "1F4A3", sheet_x: 20, sheet_y: 10, short_names: ["bomb"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bomb,boom,explode,explosion,terrorism" }, "flag-do": { name: "Regional Indicator Symbol Letters DO", unified: "1F1E9-1F1F4", sheet_x: 34, sheet_y: 14, short_names: ["flag-do"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,do,regional,indicator,symbol,letters" }, fountain: { name: "Fountain", unified: "26F2", variations: ["26F2-FE0F"], sheet_x: 2, sheet_y: 32, short_names: ["fountain"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fountain,photo,summer,water,fresh" }, turkey: { name: "Turkey", unified: "1F983", sheet_x: 32, sheet_y: 18, short_names: ["turkey"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "turkey,animal,bird" }, zipper_mouth_face: { name: "Zipper-Mouth Face", unified: "1F910", sheet_x: 32, sheet_y: 1, short_names: ["zipper_mouth_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "zipper,mouth,face" }, b: { name: "Negative Squared Latin Capital Letter B", unified: "1F171", variations: ["1F171-FE0F"], sheet_x: 4, sheet_y: 33, short_names: ["b"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "b,negative,squared,latin,capital,letter,red-square,alphabet" }, mask: { name: "Face with Medical Mask", unified: "1F637", sheet_x: 27, sheet_y: 29, short_names: ["mask"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mask,face,with,medical,sick,ill,disease" }, "flag-ec": { name: "Regional Indicator Symbol Letters EC", unified: "1F1EA-1F1E8", sheet_x: 34, sheet_y: 17, short_names: ["flag-ec"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ec,regional,indicator,symbol,letters" }, ab: { name: "Negative Squared Ab", unified: "1F18E", sheet_x: 4, sheet_y: 36, short_names: ["ab"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ab,negative,squared,red-square,alphabet" }, rice_scene: { name: "Moon Viewing Ceremony", unified: "1F391", sheet_x: 9, sheet_y: 5, short_names: ["rice_scene"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rice,scene,moon,viewing,ceremony,photo,japan,asia,tsukimi" }, baby_bottle: { name: "Baby Bottle", unified: "1F37C", sheet_x: 8, sheet_y: 20, short_names: ["baby_bottle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "baby,bottle,food,container,milk" }, hocho: { name: "Hocho", unified: "1F52A", sheet_x: 23, sheet_y: 26, short_names: ["hocho", "knife"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hocho,knife,blade,cutlery,kitchen,weapon" }, dove_of_peace: { name: "Dove of Peace", unified: "1F54A", sheet_x: 24, sheet_y: 6, short_names: ["dove_of_peace"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dove,of,peace,animal,bird" }, cl: { name: "Squared Cl", unified: "1F191", sheet_x: 4, sheet_y: 37, short_names: ["cl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cl,squared,alphabet,words,red-square" }, "dog2": { name: "Dog", unified: "1F415", sheet_x: 12, sheet_y: 26, short_names: ["dog2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dog2,dog,animal,nature,friend,doge,pet,faithful" }, fork_and_knife: { name: "Fork and Knife", unified: "1F374", sheet_x: 8, sheet_y: 12, short_names: ["fork_and_knife"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fork,and,knife,cutlery,kitchen" }, dagger_knife: { name: "Dagger Knife", unified: "1F5E1", sheet_x: 26, sheet_y: 4, short_names: ["dagger_knife"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dagger,knife,weapon" }, mountain: { name: "Mountain", unified: "26F0", sheet_x: 2, sheet_y: 30, short_names: ["mountain"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mountain,photo,nature,environment" }, face_with_thermometer: { name: "Face with Thermometer", unified: "1F912", sheet_x: 32, sheet_y: 3, short_names: ["face_with_thermometer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "face,with,thermometer" }, "flag-eg": { name: "Regional Indicator Symbol Letters EG", unified: "1F1EA-1F1EC", sheet_x: 34, sheet_y: 19, short_names: ["flag-eg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,eg,regional,indicator,symbol,letters" }, poodle: { name: "Poodle", unified: "1F429", sheet_x: 13, sheet_y: 5, short_names: ["poodle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "poodle,dog,animal,101,nature,pet" }, "flag-sv": { name: "Regional Indicator Symbol Letters SV", unified: "1F1F8-1F1FB", sheet_x: 38, sheet_y: 2, short_names: ["flag-sv"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sv,regional,indicator,symbol,letters" }, snow_capped_mountain: { name: "Snow Capped Mountain", unified: "1F3D4", sheet_x: 11, sheet_y: 5, short_names: ["snow_capped_mountain"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "snow,capped,mountain,photo,nature,environment,winter,cold" }, face_with_head_bandage: { name: "Face with Head-Bandage", unified: "1F915", sheet_x: 32, sheet_y: 6, short_names: ["face_with_head_bandage"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "face,with,head,bandage" }, "o2": { name: "Negative Squared Latin Capital Letter O", unified: "1F17E", variations: ["1F17E-FE0F"], sheet_x: 4, sheet_y: 34, short_names: ["o2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "o2,negative,squared,latin,capital,letter,o,alphabet,red-square" }, knife_fork_plate: { name: "Fork and Knife with Plate", unified: "1F37D", sheet_x: 8, sheet_y: 21, short_names: ["knife_fork_plate"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "knife,fork,plate,and,with" }, crossed_swords: { name: "Crossed Swords", unified: "2694", sheet_x: 2, sheet_y: 6, short_names: ["crossed_swords"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "crossed,swords,weapon" }, sos: { name: "Squared Sos", unified: "1F198", sheet_x: 5, sheet_y: 3, short_names: ["sos"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sos,squared,help,red-square,words,emergency,911" }, "flag-gq": { name: "Regional Indicator Symbol Letters GQ", unified: "1F1EC-1F1F6", sheet_x: 35, sheet_y: 2, short_names: ["flag-gq"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gq,regional,indicator,symbol,letters" }, mount_fuji: { name: "Mount Fuji", unified: "1F5FB", sheet_x: 26, sheet_y: 10, short_names: ["mount_fuji"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mount,fuji,photo,mountain,nature,japanese" }, "cat2": { name: "Cat", unified: "1F408", sheet_x: 12, sheet_y: 13, short_names: ["cat2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cat2,cat,animal,meow,pet,cats" }, shield: { name: "Shield", unified: "1F6E1", sheet_x: 31, sheet_y: 32, short_names: ["shield"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "shield,protection,security" }, sleeping: { name: "Sleeping Face", unified: "1F634", sheet_x: 27, sheet_y: 26, short_names: ["sleeping"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sleeping,face,tired,sleepy,night,zzz" }, volcano: { name: "Volcano", unified: "1F30B", sheet_x: 5, sheet_y: 32, short_names: ["volcano"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "volcano,photo,nature,disaster" }, "rabbit2": { name: "Rabbit", unified: "1F407", sheet_x: 12, sheet_y: 12, short_names: ["rabbit2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rabbit2,rabbit,animal,nature,pet,magic,spring" }, smoking: { name: "Smoking Symbol", unified: "1F6AC", sheet_x: 30, sheet_y: 20, short_names: ["smoking"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "smoking,symbol,kills,tobacco,cigarette,joint" }, "flag-er": { name: "Regional Indicator Symbol Letters ER", unified: "1F1EA-1F1F7", sheet_x: 34, sheet_y: 21, short_names: ["flag-er"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,er,regional,indicator,symbol,letters" }, zzz: { name: "Sleeping Symbol", unified: "1F4A4", sheet_x: 20, sheet_y: 11, short_names: ["zzz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "zzz,sleeping,symbol,sleepy,tired" }, no_entry: { name: "No Entry", unified: "26D4", variations: ["26D4-FE0F"], sheet_x: 2, sheet_y: 27, short_names: ["no_entry"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "no,entry,limit,security,privacy,bad,denied,stop,circle" }, hankey: { name: "Pile of Poo", unified: "1F4A9", sheet_x: 20, sheet_y: 16, short_names: ["hankey", "poop", "shit"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hankey,poop,shit,pile,of,poo,shitface,fail,turd" }, "flag-ee": { name: "Regional Indicator Symbol Letters EE", unified: "1F1EA-1F1EA", sheet_x: 34, sheet_y: 18, short_names: ["flag-ee"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ee,regional,indicator,symbol,letters" }, skull_and_crossbones: { name: "Skull and Crossbones", unified: "2620", variations: ["2620-FE0F"], sheet_x: 1, sheet_y: 16, short_names: ["skull_and_crossbones"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "skull,and,crossbones,poison,danger,deadly,scary" }, chipmunk: { name: "Chipmunk", unified: "1F43F", sheet_x: 13, sheet_y: 27, short_names: ["chipmunk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "chipmunk,animal,nature,rodent" }, japan: { name: "Silhouette of Japan", unified: "1F5FE", sheet_x: 26, sheet_y: 13, short_names: ["japan"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "japan,silhouette,of,nation,country,japanese,asia" }, name_badge: { name: "Name Badge", unified: "1F4DB", sheet_x: 21, sheet_y: 30, short_names: ["name_badge"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "name,badge,fire,forbid" }, coffin: { name: "Coffin", unified: "26B0", sheet_x: 2, sheet_y: 16, short_names: ["coffin"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "coffin,vampire,dead,die,death,rip" }, camping: { name: "Camping", unified: "1F3D5", sheet_x: 11, sheet_y: 6, short_names: ["camping"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "camping,photo,outdoors,tent" }, feet: { name: "Paw Prints", unified: "1F43E", sheet_x: 13, sheet_y: 26, short_names: ["feet", "paw_prints"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "feet,paw,prints,animal,tracking,footprints,dog,cat,pet,paw_prints" }, "flag-et": { name: "Regional Indicator Symbol Letters ET", unified: "1F1EA-1F1F9", sheet_x: 34, sheet_y: 23, short_names: ["flag-et"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,et,regional,indicator,symbol,letters" }, no_entry_sign: { name: "No Entry Sign", unified: "1F6AB", sheet_x: 30, sheet_y: 19, short_names: ["no_entry_sign"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "no,entry,sign,forbid,stop,limit,denied,disallow,circle" }, smiling_imp: { name: "Smiling Face with Horns", unified: "1F608", sheet_x: 26, sheet_y: 23, short_names: ["smiling_imp"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "smiling,imp,face,with,horns,devil" }, imp: { name: "Imp", unified: "1F47F", sheet_x: 18, sheet_y: 26, short_names: ["imp"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "imp,devil,angry,horns" }, funeral_urn: { name: "Funeral Urn", unified: "26B1", sheet_x: 2, sheet_y: 17, short_names: ["funeral_urn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "funeral,urn,dead,die,death,rip,ashes" }, tent: { name: "Tent", unified: "26FA", variations: ["26FA-FE0F"], sheet_x: 3, sheet_y: 3, short_names: ["tent"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tent,photo,camping,outdoors" }, dragon: { name: "Dragon", unified: "1F409", sheet_x: 12, sheet_y: 14, short_names: ["dragon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dragon,animal,myth,nature,chinese,green" }, x: { name: "Cross Mark", unified: "274C", sheet_x: 4, sheet_y: 3, short_names: ["x"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "x,cross,mark,no,delete,remove,cancel" }, "flag-eu": { name: "Regional Indicator Symbol Letters EU", unified: "1F1EA-1F1FA", sheet_x: 34, sheet_y: 24, short_names: ["flag-eu"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,eu,regional,indicator,symbol,letters" }, amphora: { name: "Amphora", unified: "1F3FA", sheet_x: 11, sheet_y: 40, short_names: ["amphora"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "amphora,vase,jar" }, o: { name: "Heavy Large Circle", unified: "2B55", variations: ["2B55-FE0F"], sheet_x: 4, sheet_y: 25, short_names: ["o"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "o,heavy,large,circle,round" }, national_park: { name: "National Park", unified: "1F3DE", sheet_x: 11, sheet_y: 15, short_names: ["national_park"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "national,park,photo,environment,nature" }, dragon_face: { name: "Dragon Face", unified: "1F432", sheet_x: 13, sheet_y: 14, short_names: ["dragon_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dragon,face,animal,myth,nature,chinese,green" }, "flag-fk": { name: "Regional Indicator Symbol Letters FK", unified: "1F1EB-1F1F0", sheet_x: 34, sheet_y: 27, short_names: ["flag-fk"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,fk,regional,indicator,symbol,letters" }, japanese_ogre: { name: "Japanese Ogre", unified: "1F479", sheet_x: 18, sheet_y: 15, short_names: ["japanese_ogre"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "japanese,ogre,monster,red,mask,halloween,scary,creepy,devil,demon" }, japanese_goblin: { name: "Japanese Goblin", unified: "1F47A", sheet_x: 18, sheet_y: 16, short_names: ["japanese_goblin"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "japanese,goblin,red,evil,mask,monster,scary,creepy" }, "flag-fo": { name: "Regional Indicator Symbol Letters FO", unified: "1F1EB-1F1F4", sheet_x: 34, sheet_y: 29, short_names: ["flag-fo"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,fo,regional,indicator,symbol,letters" }, motorway: { name: "Motorway", unified: "1F6E3", sheet_x: 31, sheet_y: 34, short_names: ["motorway"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "motorway,road,cupertino,interstate,highway" }, cactus: { name: "Cactus", unified: "1F335", sheet_x: 6, sheet_y: 31, short_names: ["cactus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cactus,vegetable,plant,nature" }, anger: { name: "Anger Symbol", unified: "1F4A2", sheet_x: 20, sheet_y: 9, short_names: ["anger"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "anger,symbol,angry,mad" }, crystal_ball: { name: "Crystal Ball", unified: "1F52E", sheet_x: 23, sheet_y: 30, short_names: ["crystal_ball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "crystal,ball,disco,party,magic,circus,fortune_teller" }, skull: { name: "Skull", unified: "1F480", sheet_x: 18, sheet_y: 27, short_names: ["skull"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "skull,dead,skeleton,creepy" }, hotsprings: { name: "Hot Springs", unified: "2668", variations: ["2668-FE0F"], sheet_x: 2, sheet_y: 1, short_names: ["hotsprings"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hotsprings,hot,springs,bath,warm,relax" }, "flag-fj": { name: "Regional Indicator Symbol Letters FJ", unified: "1F1EB-1F1EF", sheet_x: 34, sheet_y: 26, short_names: ["flag-fj"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,fj,regional,indicator,symbol,letters" }, prayer_beads: { name: "Prayer Beads", unified: "1F4FF", sheet_x: 22, sheet_y: 24, short_names: ["prayer_beads"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "prayer,beads,dhikr,religious" }, christmas_tree: { name: "Christmas Tree", unified: "1F384", sheet_x: 8, sheet_y: 28, short_names: ["christmas_tree"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "christmas,tree,festival,vacation,december,xmas,celebration" }, railway_track: { name: "Railway Track", unified: "1F6E4", sheet_x: 31, sheet_y: 35, short_names: ["railway_track"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "railway,track,train,transportation" }, "flag-fi": { name: "Regional Indicator Symbol Letters FI", unified: "1F1EB-1F1EE", sheet_x: 34, sheet_y: 25, short_names: ["flag-fi"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,fi,regional,indicator,symbol,letters" }, barber: { name: "Barber Pole", unified: "1F488", sheet_x: 19, sheet_y: 24, short_names: ["barber"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "barber,pole,hair,salon,style" }, ghost: { name: "Ghost", unified: "1F47B", sheet_x: 18, sheet_y: 17, short_names: ["ghost"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ghost,halloween,spooky,scary" }, sunrise: { name: "Sunrise", unified: "1F305", sheet_x: 5, sheet_y: 26, short_names: ["sunrise"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sunrise,morning,view,vacation,photo" }, evergreen_tree: { name: "Evergreen Tree", unified: "1F332", sheet_x: 6, sheet_y: 28, short_names: ["evergreen_tree"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "evergreen,tree,plant,nature" }, no_pedestrians: { name: "No Pedestrians", unified: "1F6B7", sheet_x: 31, sheet_y: 5, short_names: ["no_pedestrians"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "no,pedestrians,rules,crossing,walking,circle" }, sunrise_over_mountains: { name: "Sunrise over Mountains", unified: "1F304", sheet_x: 5, sheet_y: 25, short_names: ["sunrise_over_mountains"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sunrise,over,mountains,view,vacation,photo" }, alembic: { name: "Alembic", unified: "2697", sheet_x: 2, sheet_y: 8, short_names: ["alembic"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "alembic,distilling,science,experiment" }, alien: { name: "Extraterrestrial Alien", unified: "1F47D", sheet_x: 18, sheet_y: 24, short_names: ["alien"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "alien,extraterrestrial,ufo,paul,weird,outer_space" }, deciduous_tree: { name: "Deciduous Tree", unified: "1F333", sheet_x: 6, sheet_y: 29, short_names: ["deciduous_tree"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "deciduous,tree,plant,nature" }, do_not_litter: { name: "Do Not Litter Symbol", unified: "1F6AF", sheet_x: 30, sheet_y: 23, short_names: ["do_not_litter"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "do,not,litter,symbol,trash,bin,garbage,circle" }, "flag-fr": { name: "Regional Indicator Symbol Letters FR", unified: "1F1EB-1F1F7", sheet_x: 34, sheet_y: 30, short_names: ["flag-fr", "fr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,fr,regional,indicator,symbol,letters" }, telescope: { name: "Telescope", unified: "1F52D", sheet_x: 23, sheet_y: 29, short_names: ["telescope"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "telescope,stars,space,zoom" }, palm_tree: { name: "Palm Tree", unified: "1F334", sheet_x: 6, sheet_y: 30, short_names: ["palm_tree"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "palm,tree,plant,vegetable,nature,summer,beach" }, no_bicycles: { name: "No Bicycles", unified: "1F6B3", sheet_x: 30, sheet_y: 27, short_names: ["no_bicycles"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "no,bicycles,cyclist,prohibited,circle" }, desert: { name: "Desert", unified: "1F3DC", sheet_x: 11, sheet_y: 13, short_names: ["desert"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "desert,photo,warm,saharah" }, robot_face: { name: "Robot Face", unified: "1F916", sheet_x: 32, sheet_y: 7, short_names: ["robot_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "robot,face" }, "flag-gf": { name: "Regional Indicator Symbol Letters GF", unified: "1F1EC-1F1EB", sheet_x: 34, sheet_y: 35, short_names: ["flag-gf"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,gf,regional,indicator,symbol,letters" }, "non-potable_water": { name: "Non-Potable Water Symbol", unified: "1F6B1", sheet_x: 30, sheet_y: 25, short_names: ["non-potable_water"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "non,potable,water,symbol,drink,faucet,tap,circle" }, beach_with_umbrella: { name: "Beach with Umbrella", unified: "1F3D6", sheet_x: 11, sheet_y: 7, short_names: ["beach_with_umbrella"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "beach,with,umbrella,weather,summer,sunny,sand" }, microscope: { name: "Microscope", unified: "1F52C", sheet_x: 23, sheet_y: 28, short_names: ["microscope"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "microscope,laboratory,experiment,zoomin,science,study" }, seedling: { name: "Seedling", unified: "1F331", sheet_x: 6, sheet_y: 27, short_names: ["seedling"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "seedling,plant,nature,grass,lawn,spring" }, smiley_cat: { name: "Smiling Cat Face with Open Mouth", unified: "1F63A", sheet_x: 27, sheet_y: 32, short_names: ["smiley_cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "smiley,cat,smiling,face,with,open,mouth,animal,cats,happy" }, "flag-pf": { name: "Regional Indicator Symbol Letters PF", unified: "1F1F5-1F1EB", sheet_x: 37, sheet_y: 8, short_names: ["flag-pf"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pf,regional,indicator,symbol,letters" }, herb: { name: "Herb", unified: "1F33F", sheet_x: 7, sheet_y: 0, short_names: ["herb"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "herb,vegetable,plant,medicine,weed,grass,lawn" }, underage: { name: "No One Under Eighteen Symbol", unified: "1F51E", sheet_x: 23, sheet_y: 14, short_names: ["underage"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "underage,no,one,under,eighteen,symbol,18,drink,pub,night,minor,circle" }, hole: { name: "Hole", unified: "1F573", sheet_x: 24, sheet_y: 37, short_names: ["hole"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hole,embarrassing" }, "flag-tf": { name: "Regional Indicator Symbol Letters TF", unified: "1F1F9-1F1EB", sheet_x: 38, sheet_y: 9, short_names: ["flag-tf"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,tf,regional,indicator,symbol,letters" }, desert_island: { name: "Desert Island", unified: "1F3DD", sheet_x: 11, sheet_y: 14, short_names: ["desert_island"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "desert,island,photo,tropical" }, smile_cat: { name: "Grinning Cat Face with Smiling Eyes", unified: "1F638", sheet_x: 27, sheet_y: 30, short_names: ["smile_cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "smile,cat,grinning,face,with,smiling,eyes,animal,cats" }, pill: { name: "Pill", unified: "1F48A", sheet_x: 19, sheet_y: 26, short_names: ["pill"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pill,health,medicine,doctor,pharmacy,drug" }, shamrock: { name: "Shamrock", unified: "2618", sheet_x: 1, sheet_y: 9, short_names: ["shamrock"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "shamrock,vegetable,plant,nature,irish" }, "flag-ga": { name: "Regional Indicator Symbol Letters GA", unified: "1F1EC-1F1E6", sheet_x: 34, sheet_y: 31, short_names: ["flag-ga"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ga,regional,indicator,symbol,letters" }, city_sunrise: { name: "Sunset over Buildings", unified: "1F307", sheet_x: 5, sheet_y: 28, short_names: ["city_sunrise"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "city,sunrise,sunset,over,buildings,photo,good morning,dawn" }, joy_cat: { name: "Cat Face with Tears of Joy", unified: "1F639", sheet_x: 27, sheet_y: 31, short_names: ["joy_cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "joy,cat,face,with,tears,of,animal,cats,haha,happy" }, no_mobile_phones: { name: "No Mobile Phones", unified: "1F4F5", sheet_x: 22, sheet_y: 15, short_names: ["no_mobile_phones"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "no,mobile,phones,iphone,mute,circle" }, heart_eyes_cat: { name: "Smiling Cat Face with Heart-Shaped Eyes", unified: "1F63B", sheet_x: 27, sheet_y: 33, short_names: ["heart_eyes_cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heart,eyes,cat,smiling,face,with,shaped,animal,love,like,affection,cats,valentines" }, syringe: { name: "Syringe", unified: "1F489", sheet_x: 19, sheet_y: 25, short_names: ["syringe"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "syringe,health,hospital,drugs,blood,medicine,needle,doctor,nurse" }, exclamation: { name: "Heavy Exclamation Mark Symbol", unified: "2757", variations: ["2757-FE0F"], sheet_x: 4, sheet_y: 8, short_names: ["exclamation", "heavy_exclamation_mark"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "exclamation,heavy,mark,symbol,heavy_exclamation_mark,danger,surprise,punctuation,wow,warning" }, city_sunset: { name: "Cityscape at Dusk", unified: "1F306", sheet_x: 5, sheet_y: 27, short_names: ["city_sunset"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "city,sunset,cityscape,at,dusk,photo,evening,sky,buildings" }, "flag-gm": { name: "Regional Indicator Symbol Letters GM", unified: "1F1EC-1F1F2", sheet_x: 34, sheet_y: 40, short_names: ["flag-gm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gm,regional,indicator,symbol,letters" }, four_leaf_clover: { name: "Four Leaf Clover", unified: "1F340", sheet_x: 7, sheet_y: 1, short_names: ["four_leaf_clover"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "four,leaf,clover,vegetable,plant,nature,lucky,irish" }, grey_exclamation: { name: "White Exclamation Mark Ornament", unified: "2755", sheet_x: 4, sheet_y: 7, short_names: ["grey_exclamation"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "grey,exclamation,white,mark,ornament,surprise,punctuation,gray,wow,warning" }, smirk_cat: { name: "Cat Face with Wry Smile", unified: "1F63C", sheet_x: 27, sheet_y: 34, short_names: ["smirk_cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "smirk,cat,face,with,wry,smile,animal,cats" }, thermometer: { name: "Thermometer", unified: "1F321", sheet_x: 6, sheet_y: 13, short_names: ["thermometer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "thermometer,weather,temperature,hot,cold" }, cityscape: { name: "Cityscape", unified: "1F3D9", sheet_x: 11, sheet_y: 10, short_names: ["cityscape"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cityscape,photo,night life,urban" }, "flag-ge": { name: "Regional Indicator Symbol Letters GE", unified: "1F1EC-1F1EA", sheet_x: 34, sheet_y: 34, short_names: ["flag-ge"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ge,regional,indicator,symbol,letters" }, bamboo: { name: "Pine Decoration", unified: "1F38D", sheet_x: 9, sheet_y: 1, short_names: ["bamboo"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bamboo,pine,decoration,plant,nature,vegetable,panda,pine_decoration" }, "flag-de": { name: "Regional Indicator Symbol Letters DE", unified: "1F1E9-1F1EA", sheet_x: 34, sheet_y: 9, short_names: ["flag-de", "de"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,de,regional,indicator,symbol,letters" }, night_with_stars: { name: "Night with Stars", unified: "1F303", sheet_x: 5, sheet_y: 24, short_names: ["night_with_stars"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "night,with,stars,evening,city,downtown" }, kissing_cat: { name: "Kissing Cat Face with Closed Eyes", unified: "1F63D", sheet_x: 27, sheet_y: 35, short_names: ["kissing_cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "kissing,cat,face,with,closed,eyes,animal,cats" }, tanabata_tree: { name: "Tanabata Tree", unified: "1F38B", sheet_x: 8, sheet_y: 40, short_names: ["tanabata_tree"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tanabata,tree,plant,nature,branch,summer" }, label: { name: "Label", unified: "1F3F7", sheet_x: 11, sheet_y: 37, short_names: ["label"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "label,sale,tag" }, question: { name: "Black Question Mark Ornament", unified: "2753", sheet_x: 4, sheet_y: 5, short_names: ["question"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "question,black,mark,ornament,doubt,confused" }, leaves: { name: "Leaf Fluttering in Wind", unified: "1F343", sheet_x: 7, sheet_y: 4, short_names: ["leaves"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "leaves,leaf,fluttering,in,wind,nature,plant,tree,vegetable,grass,lawn,spring" }, grey_question: { name: "White Question Mark Ornament", unified: "2754", sheet_x: 4, sheet_y: 6, short_names: ["grey_question"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "grey,question,white,mark,ornament,doubts,gray,huh,confused" }, scream_cat: { name: "Weary Cat Face", unified: "1F640", sheet_x: 27, sheet_y: 38, short_names: ["scream_cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "scream,cat,weary,face,animal,cats,munch,scared" }, bookmark: { name: "Bookmark", unified: "1F516", sheet_x: 23, sheet_y: 6, short_names: ["bookmark"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bookmark,favorite,label,save" }, bridge_at_night: { name: "Bridge at Night", unified: "1F309", sheet_x: 5, sheet_y: 30, short_names: ["bridge_at_night"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bridge,at,night,photo,sanfrancisco" }, "flag-gh": { name: "Regional Indicator Symbol Letters GH", unified: "1F1EC-1F1ED", sheet_x: 34, sheet_y: 37, short_names: ["flag-gh"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gh,regional,indicator,symbol,letters" }, milky_way: { name: "Milky Way", unified: "1F30C", sheet_x: 5, sheet_y: 33, short_names: ["milky_way"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "milky,way,photo,space,stars" }, toilet: { name: "Toilet", unified: "1F6BD", sheet_x: 31, sheet_y: 11, short_names: ["toilet"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "toilet,restroom,wc,washroom,bathroom,potty" }, crying_cat_face: { name: "Crying Cat Face", unified: "1F63F", sheet_x: 27, sheet_y: 37, short_names: ["crying_cat_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "crying,cat,face,animal,tears,weep,sad,cats,upset" }, bangbang: { name: "Double Exclamation Mark", unified: "203C", variations: ["203C-FE0F"], sheet_x: 0, sheet_y: 2, short_names: ["bangbang"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bangbang,double,exclamation,mark,surprise" }, fallen_leaf: { name: "Fallen Leaf", unified: "1F342", sheet_x: 7, sheet_y: 3, short_names: ["fallen_leaf"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fallen,leaf,nature,plant,vegetable,leaves" }, "flag-gi": { name: "Regional Indicator Symbol Letters GI", unified: "1F1EC-1F1EE", sheet_x: 34, sheet_y: 38, short_names: ["flag-gi"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gi,regional,indicator,symbol,letters" }, pouting_cat: { name: "Pouting Cat Face", unified: "1F63E", sheet_x: 27, sheet_y: 36, short_names: ["pouting_cat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pouting,cat,face,animal,cats" }, maple_leaf: { name: "Maple Leaf", unified: "1F341", sheet_x: 7, sheet_y: 2, short_names: ["maple_leaf"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "maple,leaf,nature,plant,vegetable,canada,fall" }, "flag-gr": { name: "Regional Indicator Symbol Letters GR", unified: "1F1EC-1F1F7", sheet_x: 35, sheet_y: 3, short_names: ["flag-gr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gr,regional,indicator,symbol,letters" }, interrobang: { name: "Exclamation Question Mark", unified: "2049", variations: ["2049-FE0F"], sheet_x: 0, sheet_y: 3, short_names: ["interrobang"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "interrobang,exclamation,question,mark,wat,punctuation,surprise" }, stars: { name: "Shooting Star", unified: "1F320", sheet_x: 6, sheet_y: 12, short_names: ["stars"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "stars,shooting,star,night,photo" }, shower: { name: "Shower", unified: "1F6BF", sheet_x: 31, sheet_y: 13, short_names: ["shower"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "shower,clean,water,bathroom" }, raised_hands: { name: "Person Raising Both Hands in Celebration", unified: "1F64C", sheet_x: 28, sheet_y: 29, short_names: ["raised_hands"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F64C-1F3FB": { unified: "1F64C-1F3FB", image: "1f64c-1f3fb.png", sheet_x: 28, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64C-1F3FC": { unified: "1F64C-1F3FC", image: "1f64c-1f3fc.png", sheet_x: 28, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64C-1F3FD": { unified: "1F64C-1F3FD", image: "1f64c-1f3fd.png", sheet_x: 28, sheet_y: 32, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64C-1F3FE": { unified: "1F64C-1F3FE", image: "1f64c-1f3fe.png", sheet_x: 28, sheet_y: 33, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64C-1F3FF": { unified: "1F64C-1F3FF", image: "1f64c-1f3ff.png", sheet_x: 28, sheet_y: 34, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "raised,hands,person,raising,both,in,celebration,gesture,hooray,yea" }, "flag-gl": { name: "Regional Indicator Symbol Letters GL", unified: "1F1EC-1F1F1", sheet_x: 34, sheet_y: 39, short_names: ["flag-gl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gl,regional,indicator,symbol,letters" }, ear_of_rice: { name: "Ear of Rice", unified: "1F33E", sheet_x: 6, sheet_y: 40, short_names: ["ear_of_rice"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ear,of,rice,nature,plant" }, sparkler: { name: "Firework Sparkler", unified: "1F387", sheet_x: 8, sheet_y: 36, short_names: ["sparkler"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sparkler,firework,stars,night,shine" }, bathtub: { name: "Bathtub", unified: "1F6C1", sheet_x: 31, sheet_y: 20, short_names: ["bathtub"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bathtub,clean,shower,bathroom" }, hibiscus: { name: "Hibiscus", unified: "1F33A", sheet_x: 6, sheet_y: 36, short_names: ["hibiscus"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hibiscus,plant,vegetable,flowers,beach" }, "flag-gd": { name: "Regional Indicator Symbol Letters GD", unified: "1F1EC-1F1E9", sheet_x: 34, sheet_y: 33, short_names: ["flag-gd"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gd,regional,indicator,symbol,letters" }, key: { name: "Key", unified: "1F511", sheet_x: 23, sheet_y: 1, short_names: ["key"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "key,lock,door,password" }, low_brightness: { name: "Low Brightness Symbol", unified: "1F505", sheet_x: 22, sheet_y: 30, short_names: ["low_brightness"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "low,brightness,symbol,sun,afternoon,warm,summer" }, fireworks: { name: "Fireworks", unified: "1F386", sheet_x: 8, sheet_y: 35, short_names: ["fireworks"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fireworks,photo,festival,carnival,congratulations" }, clap: { name: "Clapping Hands Sign", unified: "1F44F", sheet_x: 15, sheet_y: 16, short_names: ["clap"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F44F-1F3FB": { unified: "1F44F-1F3FB", image: "1f44f-1f3fb.png", sheet_x: 15, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44F-1F3FC": { unified: "1F44F-1F3FC", image: "1f44f-1f3fc.png", sheet_x: 15, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44F-1F3FD": { unified: "1F44F-1F3FD", image: "1f44f-1f3fd.png", sheet_x: 15, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44F-1F3FE": { unified: "1F44F-1F3FE", image: "1f44f-1f3fe.png", sheet_x: 15, sheet_y: 20, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44F-1F3FF": { unified: "1F44F-1F3FF", image: "1f44f-1f3ff.png", sheet_x: 15, sheet_y: 21, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "clap,clapping,hands,sign,praise,applause,congrats,yay" }, "flag-gp": { name: "Regional Indicator Symbol Letters GP", unified: "1F1EC-1F1F5", sheet_x: 35, sheet_y: 1, short_names: ["flag-gp"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,gp,regional,indicator,symbol,letters" }, old_key: { name: "Old Key", unified: "1F5DD", sheet_x: 26, sheet_y: 2, short_names: ["old_key"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "old,key,lock,door,password" }, high_brightness: { name: "High Brightness Symbol", unified: "1F506", sheet_x: 22, sheet_y: 31, short_names: ["high_brightness"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "high,brightness,symbol,sun,light" }, rainbow: { name: "Rainbow", unified: "1F308", sheet_x: 5, sheet_y: 29, short_names: ["rainbow"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rainbow,nature,happy,unicorn,photo,sky,spring" }, wave: { name: "Waving Hand Sign", unified: "1F44B", sheet_x: 14, sheet_y: 33, short_names: ["wave"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F44B-1F3FB": { unified: "1F44B-1F3FB", image: "1f44b-1f3fb.png", sheet_x: 14, sheet_y: 34, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44B-1F3FC": { unified: "1F44B-1F3FC", image: "1f44b-1f3fc.png", sheet_x: 14, sheet_y: 35, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44B-1F3FD": { unified: "1F44B-1F3FD", image: "1f44b-1f3fd.png", sheet_x: 14, sheet_y: 36, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44B-1F3FE": { unified: "1F44B-1F3FE", image: "1f44b-1f3fe.png", sheet_x: 14, sheet_y: 37, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44B-1F3FF": { unified: "1F44B-1F3FF", image: "1f44b-1f3ff.png", sheet_x: 14, sheet_y: 38, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "wave,waving,hand,sign,hands,gesture,goodbye,solong,farewell,hello,palm" }, sunflower: { name: "Sunflower", unified: "1F33B", sheet_x: 6, sheet_y: 37, short_names: ["sunflower"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sunflower,nature,plant,fall" }, "+1": { name: "Thumbs Up Sign", unified: "1F44D", sheet_x: 15, sheet_y: 4, short_names: ["+1", "thumbsup"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F44D-1F3FB": { unified: "1F44D-1F3FB", image: "1f44d-1f3fb.png", sheet_x: 15, sheet_y: 5, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44D-1F3FC": { unified: "1F44D-1F3FC", image: "1f44d-1f3fc.png", sheet_x: 15, sheet_y: 6, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44D-1F3FD": { unified: "1F44D-1F3FD", image: "1f44d-1f3fd.png", sheet_x: 15, sheet_y: 7, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44D-1F3FE": { unified: "1F44D-1F3FE", image: "1f44d-1f3fe.png", sheet_x: 15, sheet_y: 8, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44D-1F3FF": { unified: "1F44D-1F3FF", image: "1f44d-1f3ff.png", sheet_x: 15, sheet_y: 9, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "+1,thumbsup,thumbs,up,sign,yes,awesome,good,agree,accept,cool,hand,like" }, couch_and_lamp: { name: "Couch and Lamp", unified: "1F6CB", sheet_x: 31, sheet_y: 25, short_names: ["couch_and_lamp"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "couch,and,lamp,read,chill" }, house_buildings: { name: "House Buildings", unified: "1F3D8", sheet_x: 11, sheet_y: 9, short_names: ["house_buildings"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "house,buildings" }, rose: { name: "Rose", unified: "1F339", sheet_x: 6, sheet_y: 35, short_names: ["rose"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rose,flowers,valentines,love,spring" }, trident: { name: "Trident Emblem", unified: "1F531", sheet_x: 23, sheet_y: 33, short_names: ["trident"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "trident,emblem,weapon,spear" }, "flag-gu": { name: "Regional Indicator Symbol Letters GU", unified: "1F1EC-1F1FA", sheet_x: 35, sheet_y: 6, short_names: ["flag-gu"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gu,regional,indicator,symbol,letters" }, european_castle: { name: "European Castle", unified: "1F3F0", sheet_x: 11, sheet_y: 33, short_names: ["european_castle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "european,castle,building,royalty,history" }, "-1": { name: "Thumbs Down Sign", unified: "1F44E", sheet_x: 15, sheet_y: 10, short_names: ["-1", "thumbsdown"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F44E-1F3FB": { unified: "1F44E-1F3FB", image: "1f44e-1f3fb.png", sheet_x: 15, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44E-1F3FC": { unified: "1F44E-1F3FC", image: "1f44e-1f3fc.png", sheet_x: 15, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44E-1F3FD": { unified: "1F44E-1F3FD", image: "1f44e-1f3fd.png", sheet_x: 15, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44E-1F3FE": { unified: "1F44E-1F3FE", image: "1f44e-1f3fe.png", sheet_x: 15, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44E-1F3FF": { unified: "1F44E-1F3FF", image: "1f44e-1f3ff.png", sheet_x: 15, sheet_y: 15, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: ",1,thumbsdown,thumbs,down,sign,no,dislike,hand" }, fleur_de_lis: { name: "Fleur-De-Lis", unified: "269C", sheet_x: 2, sheet_y: 11, short_names: ["fleur_de_lis"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fleur,de,lis,decorative,scout" }, tulip: { name: "Tulip", unified: "1F337", sheet_x: 6, sheet_y: 33, short_names: ["tulip"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tulip,flowers,plant,nature,summer,spring" }, sleeping_accommodation: { name: "Sleeping Accommodation", unified: "1F6CC", sheet_x: 31, sheet_y: 26, short_names: ["sleeping_accommodation"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sleeping,accommodation,bed,rest" }, "flag-gt": { name: "Regional Indicator Symbol Letters GT", unified: "1F1EC-1F1F9", sheet_x: 35, sheet_y: 5, short_names: ["flag-gt"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gt,regional,indicator,symbol,letters" }, part_alternation_mark: { name: "Part Alternation Mark", unified: "303D", variations: ["303D-FE0F"], sheet_x: 4, sheet_y: 27, short_names: ["part_alternation_mark"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "part,alternation,mark,graph,presentation,stats,business,economics,bad" }, blossom: { name: "Blossom", unified: "1F33C", sheet_x: 6, sheet_y: 38, short_names: ["blossom"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "blossom,nature,flowers,yellow" }, bed: { name: "Bed", unified: "1F6CF", sheet_x: 31, sheet_y: 29, short_names: ["bed"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bed,sleep,rest" }, "flag-gg": { name: "Regional Indicator Symbol Letters GG", unified: "1F1EC-1F1EC", sheet_x: 34, sheet_y: 36, short_names: ["flag-gg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gg,regional,indicator,symbol,letters" }, japanese_castle: { name: "Japanese Castle", unified: "1F3EF", sheet_x: 11, sheet_y: 32, short_names: ["japanese_castle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "japanese,castle,photo,building" }, facepunch: { name: "Fisted Hand Sign", unified: "1F44A", sheet_x: 14, sheet_y: 27, short_names: ["facepunch", "punch"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F44A-1F3FB": { unified: "1F44A-1F3FB", image: "1f44a-1f3fb.png", sheet_x: 14, sheet_y: 28, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44A-1F3FC": { unified: "1F44A-1F3FC", image: "1f44a-1f3fc.png", sheet_x: 14, sheet_y: 29, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44A-1F3FD": { unified: "1F44A-1F3FD", image: "1f44a-1f3fd.png", sheet_x: 14, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44A-1F3FE": { unified: "1F44A-1F3FE", image: "1f44a-1f3fe.png", sheet_x: 14, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44A-1F3FF": { unified: "1F44A-1F3FF", image: "1f44a-1f3ff.png", sheet_x: 14, sheet_y: 32, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "facepunch,punch,fisted,hand,sign,angry,violence,fist,hit,attack" }, stadium: { name: "Stadium", unified: "1F3DF", sheet_x: 11, sheet_y: 16, short_names: ["stadium"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "stadium,photo,place,sports,concert,venue" }, "flag-gn": { name: "Regional Indicator Symbol Letters GN", unified: "1F1EC-1F1F3", sheet_x: 35, sheet_y: 0, short_names: ["flag-gn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gn,regional,indicator,symbol,letters" }, warning: { name: "Warning Sign", unified: "26A0", variations: ["26A0-FE0F"], sheet_x: 2, sheet_y: 12, short_names: ["warning"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "warning,sign,exclamation,wip,alert,error,problem,issue" }, door: { name: "Door", unified: "1F6AA", sheet_x: 30, sheet_y: 18, short_names: ["door"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "door,house,entry,exit" }, cherry_blossom: { name: "Cherry Blossom", unified: "1F338", sheet_x: 6, sheet_y: 34, short_names: ["cherry_blossom"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cherry,blossom,nature,plant,spring,flower" }, fist: { name: "Raised Fist", unified: "270A", sheet_x: 3, sheet_y: 9, short_names: ["fist"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "270A-1F3FB": { unified: "270A-1F3FB", image: "270a-1f3fb.png", sheet_x: 3, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270A-1F3FC": { unified: "270A-1F3FC", image: "270a-1f3fc.png", sheet_x: 3, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270A-1F3FD": { unified: "270A-1F3FD", image: "270a-1f3fd.png", sheet_x: 3, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270A-1F3FE": { unified: "270A-1F3FE", image: "270a-1f3fe.png", sheet_x: 3, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270A-1F3FF": { unified: "270A-1F3FF", image: "270a-1f3ff.png", sheet_x: 3, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "fist,raised,fingers,hand,grasp" }, statue_of_liberty: { name: "Statue of Liberty", unified: "1F5FD", sheet_x: 26, sheet_y: 12, short_names: ["statue_of_liberty"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "statue,of,liberty,american,newyork" }, v: { name: "Victory Hand", unified: "270C", variations: ["270C-FE0F"], sheet_x: 3, sheet_y: 21, short_names: ["v"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "270C-1F3FB": { unified: "270C-1F3FB", image: "270c-1f3fb.png", sheet_x: 3, sheet_y: 22, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270C-1F3FC": { unified: "270C-1F3FC", image: "270c-1f3fc.png", sheet_x: 3, sheet_y: 23, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270C-1F3FD": { unified: "270C-1F3FD", image: "270c-1f3fd.png", sheet_x: 3, sheet_y: 24, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270C-1F3FE": { unified: "270C-1F3FE", image: "270c-1f3fe.png", sheet_x: 3, sheet_y: 25, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270C-1F3FF": { unified: "270C-1F3FF", image: "270c-1f3ff.png", sheet_x: 3, sheet_y: 26, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "v,victory,hand,fingers,ohyeah,peace,two" }, children_crossing: { name: "Children Crossing", unified: "1F6B8", sheet_x: 31, sheet_y: 6, short_names: ["children_crossing"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "children,crossing,school,warning,danger,sign,driving,yellow-diamond" }, bouquet: { name: "Bouquet", unified: "1F490", sheet_x: 19, sheet_y: 32, short_names: ["bouquet"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bouquet,flowers,nature,spring" }, bellhop_bell: { name: "Bellhop Bell", unified: "1F6CE", sheet_x: 31, sheet_y: 28, short_names: ["bellhop_bell"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bellhop,bell,service" }, "flag-gw": { name: "Regional Indicator Symbol Letters GW", unified: "1F1EC-1F1FC", sheet_x: 35, sheet_y: 7, short_names: ["flag-gw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gw,regional,indicator,symbol,letters" }, beginner: { name: "Japanese Symbol for Beginner", unified: "1F530", sheet_x: 23, sheet_y: 32, short_names: ["beginner"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "beginner,japanese,symbol,for,badge,shield" }, house: { name: "House Building", unified: "1F3E0", sheet_x: 11, sheet_y: 17, short_names: ["house"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "house,building,home" }, mushroom: { name: "Mushroom", unified: "1F344", sheet_x: 7, sheet_y: 5, short_names: ["mushroom"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mushroom,plant,vegetable" }, frame_with_picture: { name: "Frame with Picture", unified: "1F5BC", sheet_x: 25, sheet_y: 35, short_names: ["frame_with_picture"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "frame,with,picture,photography" }, ok_hand: { name: "Ok Hand Sign", unified: "1F44C", sheet_x: 14, sheet_y: 39, short_names: ["ok_hand"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F44C-1F3FB": { unified: "1F44C-1F3FB", image: "1f44c-1f3fb.png", sheet_x: 14, sheet_y: 40, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44C-1F3FC": { unified: "1F44C-1F3FC", image: "1f44c-1f3fc.png", sheet_x: 15, sheet_y: 0, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44C-1F3FD": { unified: "1F44C-1F3FD", image: "1f44c-1f3fd.png", sheet_x: 15, sheet_y: 1, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44C-1F3FE": { unified: "1F44C-1F3FE", image: "1f44c-1f3fe.png", sheet_x: 15, sheet_y: 2, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F44C-1F3FF": { unified: "1F44C-1F3FF", image: "1f44c-1f3ff.png", sheet_x: 15, sheet_y: 3, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "ok,hand,sign,fingers,limbs,perfect" }, "flag-gy": { name: "Regional Indicator Symbol Letters GY", unified: "1F1EC-1F1FE", sheet_x: 35, sheet_y: 8, short_names: ["flag-gy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gy,regional,indicator,symbol,letters" }, "flag-ht": { name: "Regional Indicator Symbol Letters HT", unified: "1F1ED-1F1F9", sheet_x: 35, sheet_y: 13, short_names: ["flag-ht"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ht,regional,indicator,symbol,letters" }, house_with_garden: { name: "House with Garden", unified: "1F3E1", sheet_x: 11, sheet_y: 18, short_names: ["house_with_garden"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "house,with,garden,home,plant,nature" }, world_map: { name: "World Map", unified: "1F5FA", sheet_x: 26, sheet_y: 9, short_names: ["world_map"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "world,map,location,direction" }, chestnut: { name: "Chestnut", unified: "1F330", sheet_x: 6, sheet_y: 26, short_names: ["chestnut"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "chestnut,food,squirrel" }, hand: { name: "Raised Hand", unified: "270B", sheet_x: 3, sheet_y: 15, short_names: ["hand", "raised_hand"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "270B-1F3FB": { unified: "270B-1F3FB", image: "270b-1f3fb.png", sheet_x: 3, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270B-1F3FC": { unified: "270B-1F3FC", image: "270b-1f3fc.png", sheet_x: 3, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270B-1F3FD": { unified: "270B-1F3FD", image: "270b-1f3fd.png", sheet_x: 3, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270B-1F3FE": { unified: "270B-1F3FE", image: "270b-1f3fe.png", sheet_x: 3, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270B-1F3FF": { unified: "270B-1F3FF", image: "270b-1f3ff.png", sheet_x: 3, sheet_y: 20, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "hand,raised,fingers,stop,highfive,palm,ban,raised_hand" }, recycle: { name: "Black Universal Recycling Symbol", unified: "267B", variations: ["267B-FE0F"], sheet_x: 2, sheet_y: 2, short_names: ["recycle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "recycle,black,universal,recycling,symbol,arrow,environment,garbage,trash" }, umbrella_on_ground: { name: "Umbrella on Ground", unified: "26F1", sheet_x: 2, sheet_y: 31, short_names: ["umbrella_on_ground"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "umbrella,on,ground,weather,summer" }, jack_o_lantern: { name: "Jack-O-Lantern", unified: "1F383", sheet_x: 8, sheet_y: 27, short_names: ["jack_o_lantern"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "jack,o,lantern,halloween,light,pumpkin,creepy,fall" }, open_hands: { name: "Open Hands Sign", unified: "1F450", sheet_x: 15, sheet_y: 22, short_names: ["open_hands"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F450-1F3FB": { unified: "1F450-1F3FB", image: "1f450-1f3fb.png", sheet_x: 15, sheet_y: 23, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F450-1F3FC": { unified: "1F450-1F3FC", image: "1f450-1f3fc.png", sheet_x: 15, sheet_y: 24, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F450-1F3FD": { unified: "1F450-1F3FD", image: "1f450-1f3fd.png", sheet_x: 15, sheet_y: 25, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F450-1F3FE": { unified: "1F450-1F3FE", image: "1f450-1f3fe.png", sheet_x: 15, sheet_y: 26, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F450-1F3FF": { unified: "1F450-1F3FF", image: "1f450-1f3ff.png", sheet_x: 15, sheet_y: 27, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "open,hands,sign,fingers,butterfly" }, derelict_house_building: { name: "Derelict House Building", unified: "1F3DA", sheet_x: 11, sheet_y: 11, short_names: ["derelict_house_building"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "derelict,house,building" }, "u6307": { name: "Squared Cjk Unified Ideograph-6307", unified: "1F22F", variations: ["1F22F-FE0F"], sheet_x: 5, sheet_y: 9, short_names: ["u6307"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "u6307,squared,cjk,unified,ideograph,6307,chinese,point,green-square,kanji" }, "flag-hn": { name: "Regional Indicator Symbol Letters HN", unified: "1F1ED-1F1F3", sheet_x: 35, sheet_y: 11, short_names: ["flag-hn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,hn,regional,indicator,symbol,letters" }, shell: { name: "Spiral Shell", unified: "1F41A", sheet_x: 12, sheet_y: 31, short_names: ["shell"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "shell,spiral,nature,sea,beach" }, "flag-hk": { name: "Regional Indicator Symbol Letters HK", unified: "1F1ED-1F1F0", sheet_x: 35, sheet_y: 9, short_names: ["flag-hk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,hk,regional,indicator,symbol,letters" }, moyai: { name: "Moyai", unified: "1F5FF", sheet_x: 26, sheet_y: 14, short_names: ["moyai"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "moyai,rock,easter island,moai" }, muscle: { name: "Flexed Biceps", unified: "1F4AA", sheet_x: 20, sheet_y: 17, short_names: ["muscle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F4AA-1F3FB": { unified: "1F4AA-1F3FB", image: "1f4aa-1f3fb.png", sheet_x: 20, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F4AA-1F3FC": { unified: "1F4AA-1F3FC", image: "1f4aa-1f3fc.png", sheet_x: 20, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F4AA-1F3FD": { unified: "1F4AA-1F3FD", image: "1f4aa-1f3fd.png", sheet_x: 20, sheet_y: 20, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F4AA-1F3FE": { unified: "1F4AA-1F3FE", image: "1f4aa-1f3fe.png", sheet_x: 20, sheet_y: 21, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F4AA-1F3FF": { unified: "1F4AA-1F3FF", image: "1f4aa-1f3ff.png", sheet_x: 20, sheet_y: 22, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "muscle,flexed,biceps,arm,flex,hand,summer,strong" }, chart: { name: "Chart with Upwards Trend and Yen Sign", unified: "1F4B9", sheet_x: 20, sheet_y: 37, short_names: ["chart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "chart,with,upwards,trend,and,yen,sign,green-square,graph,presentation,stats" }, office: { name: "Office Building", unified: "1F3E2", sheet_x: 11, sheet_y: 19, short_names: ["office"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "office,building,bureau,work" }, shopping_bags: { name: "Shopping Bags", unified: "1F6CD", sheet_x: 31, sheet_y: 27, short_names: ["shopping_bags"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "shopping,bags,mall,buy,purchase" }, department_store: { name: "Department Store", unified: "1F3EC", sheet_x: 11, sheet_y: 29, short_names: ["department_store"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "department,store,building,shopping,mall" }, pray: { name: "Person with Folded Hands", unified: "1F64F", sheet_x: 29, sheet_y: 6, short_names: ["pray"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F64F-1F3FB": { unified: "1F64F-1F3FB", image: "1f64f-1f3fb.png", sheet_x: 29, sheet_y: 7, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64F-1F3FC": { unified: "1F64F-1F3FC", image: "1f64f-1f3fc.png", sheet_x: 29, sheet_y: 8, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64F-1F3FD": { unified: "1F64F-1F3FD", image: "1f64f-1f3fd.png", sheet_x: 29, sheet_y: 9, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64F-1F3FE": { unified: "1F64F-1F3FE", image: "1f64f-1f3fe.png", sheet_x: 29, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64F-1F3FF": { unified: "1F64F-1F3FF", image: "1f64f-1f3ff.png", sheet_x: 29, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "pray,person,with,folded,hands,please,hope,wish,namaste,highfive" }, "flag-hu": { name: "Regional Indicator Symbol Letters HU", unified: "1F1ED-1F1FA", sheet_x: 35, sheet_y: 14, short_names: ["flag-hu"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,hu,regional,indicator,symbol,letters" }, sparkle: { name: "Sparkle", unified: "2747", variations: ["2747-FE0F"], sheet_x: 4, sheet_y: 2, short_names: ["sparkle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sparkle,stars,green-square,awesome,good,fireworks" }, spider_web: { name: "Spider Web", unified: "1F578", sheet_x: 25, sheet_y: 6, short_names: ["spider_web"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "spider,web,animal,insect,arachnid,silk" }, point_up: { name: "White Up Pointing Index", unified: "261D", variations: ["261D-FE0F"], sheet_x: 1, sheet_y: 10, short_names: ["point_up"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "261D-1F3FB": { unified: "261D-1F3FB", image: "261d-1f3fb.png", sheet_x: 1, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "261D-1F3FC": { unified: "261D-1F3FC", image: "261d-1f3fc.png", sheet_x: 1, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "261D-1F3FD": { unified: "261D-1F3FD", image: "261d-1f3fd.png", sheet_x: 1, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "261D-1F3FE": { unified: "261D-1F3FE", image: "261d-1f3fe.png", sheet_x: 1, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "261D-1F3FF": { unified: "261D-1F3FF", image: "261d-1f3ff.png", sheet_x: 1, sheet_y: 15, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "point,up,white,pointing,index,hand,fingers,direction" }, eight_spoked_asterisk: { name: "Eight Spoked Asterisk", unified: "2733", variations: ["2733-FE0F"], sheet_x: 3, sheet_y: 40, short_names: ["eight_spoked_asterisk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "eight,spoked,asterisk,star,sparkle,green-square" }, "flag-is": { name: "Regional Indicator Symbol Letters IS", unified: "1F1EE-1F1F8", sheet_x: 35, sheet_y: 24, short_names: ["flag-is"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,is,regional,indicator,symbol,letters" }, post_office: { name: "Japanese Post Office", unified: "1F3E3", sheet_x: 11, sheet_y: 20, short_names: ["post_office"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "post,office,japanese,building,email,communication" }, earth_americas: { name: "Earth Globe Americas", unified: "1F30E", sheet_x: 5, sheet_y: 35, short_names: ["earth_americas"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "earth,americas,globe,world,usa,international" }, balloon: { name: "Balloon", unified: "1F388", sheet_x: 8, sheet_y: 37, short_names: ["balloon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "balloon,party,celebration,birthday,circus" }, european_post_office: { name: "European Post Office", unified: "1F3E4", sheet_x: 11, sheet_y: 21, short_names: ["european_post_office"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "european,post,office,building,email" }, "point_up_2": { name: "White Up Pointing Backhand Index", unified: "1F446", sheet_x: 14, sheet_y: 3, short_names: ["point_up_2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F446-1F3FB": { unified: "1F446-1F3FB", image: "1f446-1f3fb.png", sheet_x: 14, sheet_y: 4, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F446-1F3FC": { unified: "1F446-1F3FC", image: "1f446-1f3fc.png", sheet_x: 14, sheet_y: 5, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F446-1F3FD": { unified: "1F446-1F3FD", image: "1f446-1f3fd.png", sheet_x: 14, sheet_y: 6, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F446-1F3FE": { unified: "1F446-1F3FE", image: "1f446-1f3fe.png", sheet_x: 14, sheet_y: 7, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F446-1F3FF": { unified: "1F446-1F3FF", image: "1f446-1f3ff.png", sheet_x: 14, sheet_y: 8, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "point,up,2,white,pointing,backhand,index,fingers,hand,direction" }, earth_africa: { name: "Earth Globe Europe-Africa", unified: "1F30D", sheet_x: 5, sheet_y: 34, short_names: ["earth_africa"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "earth,africa,globe,europe,world,international" }, negative_squared_cross_mark: { name: "Negative Squared Cross Mark", unified: "274E", sheet_x: 4, sheet_y: 4, short_names: ["negative_squared_cross_mark"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "negative,squared,cross,mark,x,green-square,no,deny" }, flags: { name: "Carp Streamer", unified: "1F38F", sheet_x: 9, sheet_y: 3, short_names: ["flags"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flags,carp,streamer,fish,japanese,koinobori,banner" }, "flag-in": { name: "Regional Indicator Symbol Letters IN", unified: "1F1EE-1F1F3", sheet_x: 35, sheet_y: 20, short_names: ["flag-in"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,in,regional,indicator,symbol,letters" }, hospital: { name: "Hospital", unified: "1F3E5", sheet_x: 11, sheet_y: 22, short_names: ["hospital"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hospital,building,health,surgery,doctor" }, point_down: { name: "White Down Pointing Backhand Index", unified: "1F447", sheet_x: 14, sheet_y: 9, short_names: ["point_down"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F447-1F3FB": { unified: "1F447-1F3FB", image: "1f447-1f3fb.png", sheet_x: 14, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F447-1F3FC": { unified: "1F447-1F3FC", image: "1f447-1f3fc.png", sheet_x: 14, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F447-1F3FD": { unified: "1F447-1F3FD", image: "1f447-1f3fd.png", sheet_x: 14, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F447-1F3FE": { unified: "1F447-1F3FE", image: "1f447-1f3fe.png", sheet_x: 14, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F447-1F3FF": { unified: "1F447-1F3FF", image: "1f447-1f3ff.png", sheet_x: 14, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "point,down,white,pointing,backhand,index,fingers,hand,direction" }, white_check_mark: { name: "White Heavy Check Mark", unified: "2705", sheet_x: 3, sheet_y: 6, short_names: ["white_check_mark"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,check,mark,heavy,green-square,ok,agree,vote,election,answer" }, ribbon: { name: "Ribbon", unified: "1F380", sheet_x: 8, sheet_y: 24, short_names: ["ribbon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ribbon,decoration,pink,girl,bowtie" }, earth_asia: { name: "Earth Globe Asia-Australia", unified: "1F30F", sheet_x: 5, sheet_y: 36, short_names: ["earth_asia"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "earth,asia,globe,australia,world,east,international" }, "flag-id": { name: "Regional Indicator Symbol Letters ID", unified: "1F1EE-1F1E9", sheet_x: 35, sheet_y: 16, short_names: ["flag-id"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,id,regional,indicator,symbol,letters" }, full_moon: { name: "Full Moon Symbol", unified: "1F315", sheet_x: 6, sheet_y: 1, short_names: ["full_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "full,moon,symbol,nature,yellow,twilight,planet,space,night,evening,sleep" }, point_left: { name: "White Left Pointing Backhand Index", unified: "1F448", sheet_x: 14, sheet_y: 15, short_names: ["point_left"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F448-1F3FB": { unified: "1F448-1F3FB", image: "1f448-1f3fb.png", sheet_x: 14, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F448-1F3FC": { unified: "1F448-1F3FC", image: "1f448-1f3fc.png", sheet_x: 14, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F448-1F3FD": { unified: "1F448-1F3FD", image: "1f448-1f3fd.png", sheet_x: 14, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F448-1F3FE": { unified: "1F448-1F3FE", image: "1f448-1f3fe.png", sheet_x: 14, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F448-1F3FF": { unified: "1F448-1F3FF", image: "1f448-1f3ff.png", sheet_x: 14, sheet_y: 20, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "point,left,white,pointing,backhand,index,direction,fingers,hand" }, "flag-ir": { name: "Regional Indicator Symbol Letters IR", unified: "1F1EE-1F1F7", sheet_x: 35, sheet_y: 23, short_names: ["flag-ir"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ir,regional,indicator,symbol,letters" }, gift: { name: "Wrapped Present", unified: "1F381", sheet_x: 8, sheet_y: 25, short_names: ["gift"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "gift,wrapped,present,birthday,christmas,xmas" }, bank: { name: "Bank", unified: "1F3E6", sheet_x: 11, sheet_y: 23, short_names: ["bank"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bank,building,money,sales,cash,business,enterprise" }, diamond_shape_with_a_dot_inside: { name: "Diamond Shape with a Dot Inside", unified: "1F4A0", sheet_x: 20, sheet_y: 7, short_names: ["diamond_shape_with_a_dot_inside"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "diamond,shape,with,a,dot,inside,jewel,blue,gem,crystal,fancy" }, "flag-iq": { name: "Regional Indicator Symbol Letters IQ", unified: "1F1EE-1F1F6", sheet_x: 35, sheet_y: 22, short_names: ["flag-iq"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,iq,regional,indicator,symbol,letters" }, confetti_ball: { name: "Confetti Ball", unified: "1F38A", sheet_x: 8, sheet_y: 39, short_names: ["confetti_ball"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "confetti,ball,festival,party,birthday,circus" }, point_right: { name: "White Right Pointing Backhand Index", unified: "1F449", sheet_x: 14, sheet_y: 21, short_names: ["point_right"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F449-1F3FB": { unified: "1F449-1F3FB", image: "1f449-1f3fb.png", sheet_x: 14, sheet_y: 22, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F449-1F3FC": { unified: "1F449-1F3FC", image: "1f449-1f3fc.png", sheet_x: 14, sheet_y: 23, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F449-1F3FD": { unified: "1F449-1F3FD", image: "1f449-1f3fd.png", sheet_x: 14, sheet_y: 24, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F449-1F3FE": { unified: "1F449-1F3FE", image: "1f449-1f3fe.png", sheet_x: 14, sheet_y: 25, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F449-1F3FF": { unified: "1F449-1F3FF", image: "1f449-1f3ff.png", sheet_x: 14, sheet_y: 26, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "point,right,white,pointing,backhand,index,fingers,hand,direction" }, cyclone: { name: "Cyclone", unified: "1F300", sheet_x: 5, sheet_y: 21, short_names: ["cyclone"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cyclone,weather,swirl,blue,cloud" }, waning_gibbous_moon: { name: "Waning Gibbous Moon Symbol", unified: "1F316", sheet_x: 6, sheet_y: 2, short_names: ["waning_gibbous_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "waning,gibbous,moon,symbol,nature,twilight,planet,space,night,evening,sleep,waxing_gibbous_moon" }, hotel: { name: "Hotel", unified: "1F3E8", sheet_x: 11, sheet_y: 25, short_names: ["hotel"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hotel,building,whotel,accomodation,checkin" }, loop: { name: "Double Curly Loop", unified: "27BF", sheet_x: 4, sheet_y: 16, short_names: ["loop"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "loop,double,curly,tape,cassette" }, convenience_store: { name: "Convenience Store", unified: "1F3EA", sheet_x: 11, sheet_y: 27, short_names: ["convenience_store"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "convenience,store,building,shopping,groceries" }, last_quarter_moon: { name: "Last Quarter Moon Symbol", unified: "1F317", sheet_x: 6, sheet_y: 3, short_names: ["last_quarter_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "last,quarter,moon,symbol,nature,twilight,planet,space,night,evening,sleep" }, tada: { name: "Party Popper", unified: "1F389", sheet_x: 8, sheet_y: 38, short_names: ["tada"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tada,party,popper,contulations,birthday,magic,circus" }, middle_finger: { name: "Reversed Hand with Middle Finger Extended", unified: "1F595", sheet_x: 25, sheet_y: 19, short_names: ["middle_finger", "reversed_hand_with_middle_finger_extended"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F595-1F3FB": { unified: "1F595-1F3FB", image: "1f595-1f3fb.png", sheet_x: 25, sheet_y: 20, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F595-1F3FC": { unified: "1F595-1F3FC", image: "1f595-1f3fc.png", sheet_x: 25, sheet_y: 21, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F595-1F3FD": { unified: "1F595-1F3FD", image: "1f595-1f3fd.png", sheet_x: 25, sheet_y: 22, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F595-1F3FE": { unified: "1F595-1F3FE", image: "1f595-1f3fe.png", sheet_x: 25, sheet_y: 23, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F595-1F3FF": { unified: "1F595-1F3FF", image: "1f595-1f3ff.png", sheet_x: 25, sheet_y: 24, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "middle,finger,reversed,hand,with,extended,fingers,rude" }, "flag-ie": { name: "Regional Indicator Symbol Letters IE", unified: "1F1EE-1F1EA", sheet_x: 35, sheet_y: 17, short_names: ["flag-ie"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ie,regional,indicator,symbol,letters" }, dolls: { name: "Japanese Dolls", unified: "1F38E", sheet_x: 9, sheet_y: 2, short_names: ["dolls"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dolls,japanese,toy,kimono" }, globe_with_meridians: { name: "Globe with Meridians", unified: "1F310", sheet_x: 5, sheet_y: 37, short_names: ["globe_with_meridians"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "globe,with,meridians,earth,international,world,internet,interweb,i18n" }, "flag-im": { name: "Regional Indicator Symbol Letters IM", unified: "1F1EE-1F1F2", sheet_x: 35, sheet_y: 19, short_names: ["flag-im"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,im,regional,indicator,symbol,letters" }, waning_crescent_moon: { name: "Waning Crescent Moon Symbol", unified: "1F318", sheet_x: 6, sheet_y: 4, short_names: ["waning_crescent_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "waning,crescent,moon,symbol,nature,twilight,planet,space,night,evening,sleep" }, raised_hand_with_fingers_splayed: { name: "Raised Hand with Fingers Splayed", unified: "1F590", sheet_x: 25, sheet_y: 13, short_names: ["raised_hand_with_fingers_splayed"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F590-1F3FB": { unified: "1F590-1F3FB", image: "1f590-1f3fb.png", sheet_x: 25, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F590-1F3FC": { unified: "1F590-1F3FC", image: "1f590-1f3fc.png", sheet_x: 25, sheet_y: 15, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F590-1F3FD": { unified: "1F590-1F3FD", image: "1f590-1f3fd.png", sheet_x: 25, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F590-1F3FE": { unified: "1F590-1F3FE", image: "1f590-1f3fe.png", sheet_x: 25, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F590-1F3FF": { unified: "1F590-1F3FF", image: "1f590-1f3ff.png", sheet_x: 25, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "raised,hand,with,fingers,splayed" }, school: { name: "School", unified: "1F3EB", sheet_x: 11, sheet_y: 28, short_names: ["school"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "school,building,student,education,learn,teach" }, new_moon: { name: "New Moon Symbol", unified: "1F311", sheet_x: 5, sheet_y: 38, short_names: ["new_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "new,moon,symbol,nature,twilight,planet,space,night,evening,sleep" }, the_horns: { name: "Sign of the Horns", unified: "1F918", sheet_x: 32, sheet_y: 9, short_names: ["the_horns", "sign_of_the_horns"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F918-1F3FB": { unified: "1F918-1F3FB", image: "1f918-1f3fb.png", sheet_x: 32, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F918-1F3FC": { unified: "1F918-1F3FC", image: "1f918-1f3fc.png", sheet_x: 32, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F918-1F3FD": { unified: "1F918-1F3FD", image: "1f918-1f3fd.png", sheet_x: 32, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F918-1F3FE": { unified: "1F918-1F3FE", image: "1f918-1f3fe.png", sheet_x: 32, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F918-1F3FF": { unified: "1F918-1F3FF", image: "1f918-1f3ff.png", sheet_x: 32, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "the,horns,sign,of" }, love_hotel: { name: "Love Hotel", unified: "1F3E9", sheet_x: 11, sheet_y: 26, short_names: ["love_hotel"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "love,hotel,like,affection,dating" }, m: { name: "Circled Latin Capital Letter M", unified: "24C2", variations: ["24C2-FE0F"], sheet_x: 0, sheet_y: 32, short_names: ["m"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "m,circled,latin,capital,letter,alphabet,blue-circle" }, "flag-il": { name: "Regional Indicator Symbol Letters IL", unified: "1F1EE-1F1F1", sheet_x: 35, sheet_y: 18, short_names: ["flag-il"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,il,regional,indicator,symbol,letters" }, wind_chime: { name: "Wind Chime", unified: "1F390", sheet_x: 9, sheet_y: 4, short_names: ["wind_chime"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wind,chime,nature,ding,spring,bell" }, "spock-hand": { name: "Raised Hand with Part Between Middle and Ring Fingers", unified: "1F596", sheet_x: 25, sheet_y: 25, short_names: ["spock-hand"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F596-1F3FB": { unified: "1F596-1F3FB", image: "1f596-1f3fb.png", sheet_x: 25, sheet_y: 26, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F596-1F3FC": { unified: "1F596-1F3FC", image: "1f596-1f3fc.png", sheet_x: 25, sheet_y: 27, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F596-1F3FD": { unified: "1F596-1F3FD", image: "1f596-1f3fd.png", sheet_x: 25, sheet_y: 28, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F596-1F3FE": { unified: "1F596-1F3FE", image: "1f596-1f3fe.png", sheet_x: 25, sheet_y: 29, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F596-1F3FF": { unified: "1F596-1F3FF", image: "1f596-1f3ff.png", sheet_x: 25, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "spock,hand,raised,with,part,between,middle,and,ring,fingers" }, wedding: { name: "Wedding", unified: "1F492", sheet_x: 19, sheet_y: 34, short_names: ["wedding"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wedding,love,like,affection,couple,marriage,bride,groom" }, atm: { name: "Automated Teller Machine", unified: "1F3E7", sheet_x: 11, sheet_y: 24, short_names: ["atm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "atm,automated,teller,machine,money,sales,cash,blue-square,payment,bank" }, crossed_flags: { name: "Crossed Flags", unified: "1F38C", sheet_x: 9, sheet_y: 0, short_names: ["crossed_flags"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "crossed,flags,japanese,nation,country,border" }, "flag-it": { name: "Regional Indicator Symbol Letters IT", unified: "1F1EE-1F1F9", sheet_x: 35, sheet_y: 25, short_names: ["flag-it", "it"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,it,regional,indicator,symbol,letters" }, waxing_crescent_moon: { name: "Waxing Crescent Moon Symbol", unified: "1F312", sheet_x: 5, sheet_y: 39, short_names: ["waxing_crescent_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "waxing,crescent,moon,symbol,nature,twilight,planet,space,night,evening,sleep" }, izakaya_lantern: { name: "Izakaya Lantern", unified: "1F3EE", sheet_x: 11, sheet_y: 31, short_names: ["izakaya_lantern", "lantern"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "izakaya,lantern,light,paper,halloween,spooky" }, first_quarter_moon: { name: "First Quarter Moon Symbol", unified: "1F313", sheet_x: 5, sheet_y: 40, short_names: ["first_quarter_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "first,quarter,moon,symbol,nature,twilight,planet,space,night,evening,sleep" }, sa: { name: "Squared Katakana Sa", unified: "1F202", variations: ["1F202-FE0F"], sheet_x: 5, sheet_y: 7, short_names: ["sa"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sa,squared,katakana,japanese,blue-square" }, classical_building: { name: "Classical Building", unified: "1F3DB", sheet_x: 11, sheet_y: 12, short_names: ["classical_building"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "classical,building" }, writing_hand: { name: "Writing Hand", unified: "270D", variations: ["270D-FE0F"], sheet_x: 3, sheet_y: 27, short_names: ["writing_hand"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "270D-1F3FB": { unified: "270D-1F3FB", image: "270d-1f3fb.png", sheet_x: 3, sheet_y: 28, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270D-1F3FC": { unified: "270D-1F3FC", image: "270d-1f3fc.png", sheet_x: 3, sheet_y: 29, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270D-1F3FD": { unified: "270D-1F3FD", image: "270d-1f3fd.png", sheet_x: 3, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270D-1F3FE": { unified: "270D-1F3FE", image: "270d-1f3fe.png", sheet_x: 3, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "270D-1F3FF": { unified: "270D-1F3FF", image: "270d-1f3ff.png", sheet_x: 3, sheet_y: 32, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "writing,hand,pen,stationery" }, "flag-ci": { name: "Regional Indicator Symbol Letters CI", unified: "1F1E8-1F1EE", sheet_x: 33, sheet_y: 36, short_names: ["flag-ci"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ci,regional,indicator,symbol,letters" }, moon: { name: "Waxing Gibbous Moon Symbol", unified: "1F314", sheet_x: 6, sheet_y: 0, short_names: ["moon", "waxing_gibbous_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "moon,waxing,gibbous,symbol,nature,night,sky,gray,twilight,planet,space,evening,sleep" }, church: { name: "Church", unified: "26EA", variations: ["26EA-FE0F"], sheet_x: 2, sheet_y: 29, short_names: ["church"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "church,building,religion,christ" }, email: { name: "Envelope", unified: "2709", variations: ["2709-FE0F"], sheet_x: 3, sheet_y: 8, short_names: ["email", "envelope"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "email,envelope,communication,inbox" }, passport_control: { name: "Passport Control", unified: "1F6C2", sheet_x: 31, sheet_y: 21, short_names: ["passport_control"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "passport,control,custom,blue-square" }, nail_care: { name: "Nail Polish", unified: "1F485", sheet_x: 19, sheet_y: 6, short_names: ["nail_care"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F485-1F3FB": { unified: "1F485-1F3FB", image: "1f485-1f3fb.png", sheet_x: 19, sheet_y: 7, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F485-1F3FC": { unified: "1F485-1F3FC", image: "1f485-1f3fc.png", sheet_x: 19, sheet_y: 8, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F485-1F3FD": { unified: "1F485-1F3FD", image: "1f485-1f3fd.png", sheet_x: 19, sheet_y: 9, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F485-1F3FE": { unified: "1F485-1F3FE", image: "1f485-1f3fe.png", sheet_x: 19, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F485-1F3FF": { unified: "1F485-1F3FF", image: "1f485-1f3ff.png", sheet_x: 19, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "nail,care,polish,beauty,manicure,finger,fashion" }, "flag-jm": { name: "Regional Indicator Symbol Letters JM", unified: "1F1EF-1F1F2", sheet_x: 35, sheet_y: 27, short_names: ["flag-jm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,jm,regional,indicator,symbol,letters" }, lips: { name: "Mouth", unified: "1F444", sheet_x: 14, sheet_y: 1, short_names: ["lips"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lips,mouth,kiss" }, mosque: { name: "Mosque", unified: "1F54C", sheet_x: 24, sheet_y: 8, short_names: ["mosque"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mosque,islam,worship,minaret" }, "flag-jp": { name: "Regional Indicator Symbol Letters JP", unified: "1F1EF-1F1F5", sheet_x: 35, sheet_y: 29, short_names: ["flag-jp", "jp"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,jp,regional,indicator,symbol,letters" }, new_moon_with_face: { name: "New Moon with Face", unified: "1F31A", sheet_x: 6, sheet_y: 6, short_names: ["new_moon_with_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "new,moon,with,face,nature,twilight,planet,space,night,evening,sleep" }, customs: { name: "Customs", unified: "1F6C3", sheet_x: 31, sheet_y: 22, short_names: ["customs"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "customs,passport,border,blue-square" }, envelope_with_arrow: { name: "Envelope with Downwards Arrow Above", unified: "1F4E9", sheet_x: 22, sheet_y: 3, short_names: ["envelope_with_arrow"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "envelope,with,arrow,downwards,above,email,communication" }, full_moon_with_face: { name: "Full Moon with Face", unified: "1F31D", sheet_x: 6, sheet_y: 9, short_names: ["full_moon_with_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "full,moon,with,face,nature,twilight,planet,space,night,evening,sleep" }, "flag-je": { name: "Regional Indicator Symbol Letters JE", unified: "1F1EF-1F1EA", sheet_x: 35, sheet_y: 26, short_names: ["flag-je"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,je,regional,indicator,symbol,letters" }, synagogue: { name: "Synagogue", unified: "1F54D", sheet_x: 24, sheet_y: 9, short_names: ["synagogue"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "synagogue,judaism,worship,temple,jewish" }, baggage_claim: { name: "Baggage Claim", unified: "1F6C4", sheet_x: 31, sheet_y: 23, short_names: ["baggage_claim"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "baggage,claim,blue-square,airport,transport" }, tongue: { name: "Tongue", unified: "1F445", sheet_x: 14, sheet_y: 2, short_names: ["tongue"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tongue,mouth,playful" }, incoming_envelope: { name: "Incoming Envelope", unified: "1F4E8", sheet_x: 22, sheet_y: 2, short_names: ["incoming_envelope"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "incoming,envelope,email,inbox" }, "e-mail": { name: "E-Mail Symbol", unified: "1F4E7", sheet_x: 22, sheet_y: 1, short_names: ["e-mail"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "e,mail,symbol" }, ear: { name: "Ear", unified: "1F442", sheet_x: 13, sheet_y: 30, short_names: ["ear"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F442-1F3FB": { unified: "1F442-1F3FB", image: "1f442-1f3fb.png", sheet_x: 13, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F442-1F3FC": { unified: "1F442-1F3FC", image: "1f442-1f3fc.png", sheet_x: 13, sheet_y: 32, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F442-1F3FD": { unified: "1F442-1F3FD", image: "1f442-1f3fd.png", sheet_x: 13, sheet_y: 33, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F442-1F3FE": { unified: "1F442-1F3FE", image: "1f442-1f3fe.png", sheet_x: 13, sheet_y: 34, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F442-1F3FF": { unified: "1F442-1F3FF", image: "1f442-1f3ff.png", sheet_x: 13, sheet_y: 35, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "ear,face,hear,sound,listen" }, first_quarter_moon_with_face: { name: "First Quarter Moon with Face", unified: "1F31B", sheet_x: 6, sheet_y: 7, short_names: ["first_quarter_moon_with_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "first,quarter,moon,with,face,nature,twilight,planet,space,night,evening,sleep" }, left_luggage: { name: "Left Luggage", unified: "1F6C5", sheet_x: 31, sheet_y: 24, short_names: ["left_luggage"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "left,luggage,blue-square,travel" }, kaaba: { name: "Kaaba", unified: "1F54B", sheet_x: 24, sheet_y: 7, short_names: ["kaaba"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "kaaba,mecca,mosque,islam" }, "flag-jo": { name: "Regional Indicator Symbol Letters JO", unified: "1F1EF-1F1F4", sheet_x: 35, sheet_y: 28, short_names: ["flag-jo"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,jo,regional,indicator,symbol,letters" }, "flag-kz": { name: "Regional Indicator Symbol Letters KZ", unified: "1F1F0-1F1FF", sheet_x: 35, sheet_y: 40, short_names: ["flag-kz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,kz,regional,indicator,symbol,letters" }, wheelchair: { name: "Wheelchair Symbol", unified: "267F", variations: ["267F-FE0F"], sheet_x: 2, sheet_y: 3, short_names: ["wheelchair"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wheelchair,symbol,blue-square,disabled,a11y,accessibility" }, last_quarter_moon_with_face: { name: "Last Quarter Moon with Face", unified: "1F31C", sheet_x: 6, sheet_y: 8, short_names: ["last_quarter_moon_with_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "last,quarter,moon,with,face,nature,twilight,planet,space,night,evening,sleep" }, nose: { name: "Nose", unified: "1F443", sheet_x: 13, sheet_y: 36, short_names: ["nose"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F443-1F3FB": { unified: "1F443-1F3FB", image: "1f443-1f3fb.png", sheet_x: 13, sheet_y: 37, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F443-1F3FC": { unified: "1F443-1F3FC", image: "1f443-1f3fc.png", sheet_x: 13, sheet_y: 38, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F443-1F3FD": { unified: "1F443-1F3FD", image: "1f443-1f3fd.png", sheet_x: 13, sheet_y: 39, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F443-1F3FE": { unified: "1F443-1F3FE", image: "1f443-1f3fe.png", sheet_x: 13, sheet_y: 40, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F443-1F3FF": { unified: "1F443-1F3FF", image: "1f443-1f3ff.png", sheet_x: 14, sheet_y: 0, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "nose,smell,sniff" }, love_letter: { name: "Love Letter", unified: "1F48C", sheet_x: 19, sheet_y: 28, short_names: ["love_letter"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "love,letter,email,like,affection,envelope,valentines" }, shinto_shrine: { name: "Shinto Shrine", unified: "26E9", sheet_x: 2, sheet_y: 28, short_names: ["shinto_shrine"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "shinto,shrine,temple,japan,kyoto" }, no_smoking: { name: "No Smoking Symbol", unified: "1F6AD", sheet_x: 30, sheet_y: 21, short_names: ["no_smoking"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "no,smoking,symbol,cigarette,blue-square,smell,smoke" }, postbox: { name: "Postbox", unified: "1F4EE", sheet_x: 22, sheet_y: 8, short_names: ["postbox"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "postbox,email,letter,envelope" }, eye: { name: "Eye", unified: "1F441", sheet_x: 13, sheet_y: 29, short_names: ["eye"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "eye,face,look,see,watch,stare" }, sun_with_face: { name: "Sun with Face", unified: "1F31E", sheet_x: 6, sheet_y: 10, short_names: ["sun_with_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sun,with,face,nature,morning,sky" }, "flag-ke": { name: "Regional Indicator Symbol Letters KE", unified: "1F1F0-1F1EA", sheet_x: 35, sheet_y: 30, short_names: ["flag-ke"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ke,regional,indicator,symbol,letters" }, mailbox_closed: { name: "Closed Mailbox with Lowered Flag", unified: "1F4EA", sheet_x: 22, sheet_y: 4, short_names: ["mailbox_closed"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mailbox,closed,with,lowered,flag,email,communication,inbox" }, "flag-ki": { name: "Regional Indicator Symbol Letters KI", unified: "1F1F0-1F1EE", sheet_x: 35, sheet_y: 33, short_names: ["flag-ki"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ki,regional,indicator,symbol,letters" }, eyes: { name: "Eyes", unified: "1F440", sheet_x: 13, sheet_y: 28, short_names: ["eyes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "eyes,look,watch,stalk,peek,see" }, wc: { name: "Water Closet", unified: "1F6BE", sheet_x: 31, sheet_y: 12, short_names: ["wc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wc,water,closet,toilet,restroom,blue-square" }, crescent_moon: { name: "Crescent Moon", unified: "1F319", sheet_x: 6, sheet_y: 5, short_names: ["crescent_moon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "crescent,moon,night,sleep,sky,evening,magic" }, mailbox: { name: "Closed Mailbox with Raised Flag", unified: "1F4EB", sheet_x: 22, sheet_y: 5, short_names: ["mailbox"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mailbox,closed,with,raised,flag,email,inbox,communication" }, "flag-xk": { name: "Regional Indicator Symbol Letters XK", unified: "1F1FD-1F1F0", sheet_x: 38, sheet_y: 38, short_names: ["flag-xk"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,xk,regional,indicator,symbol,letters" }, parking: { name: "Negative Squared Latin Capital Letter P", unified: "1F17F", variations: ["1F17F-FE0F"], sheet_x: 4, sheet_y: 35, short_names: ["parking"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "parking,negative,squared,latin,capital,letter,p,cars,blue-square,alphabet" }, bust_in_silhouette: { name: "Bust in Silhouette", unified: "1F464", sheet_x: 16, sheet_y: 6, short_names: ["bust_in_silhouette"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bust,in,silhouette,user,person,human" }, star: { name: "White Medium Star", unified: "2B50", variations: ["2B50-FE0F"], sheet_x: 4, sheet_y: 24, short_names: ["star"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "star,white,medium,night,yellow" }, "star2": { name: "Glowing Star", unified: "1F31F", sheet_x: 6, sheet_y: 11, short_names: ["star2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "star2,glowing,star,night,sparkle,awesome,good,magic" }, mailbox_with_mail: { name: "Open Mailbox with Raised Flag", unified: "1F4EC", sheet_x: 22, sheet_y: 6, short_names: ["mailbox_with_mail"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mailbox,with,mail,open,raised,flag,email,inbox,communication" }, potable_water: { name: "Potable Water Symbol", unified: "1F6B0", sheet_x: 30, sheet_y: 24, short_names: ["potable_water"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "potable,water,symbol,blue-square,liquid,restroom,cleaning,faucet" }, busts_in_silhouette: { name: "Busts in Silhouette", unified: "1F465", sheet_x: 16, sheet_y: 7, short_names: ["busts_in_silhouette"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "busts,in,silhouette,user,person,human,group,team" }, "flag-kw": { name: "Regional Indicator Symbol Letters KW", unified: "1F1F0-1F1FC", sheet_x: 35, sheet_y: 38, short_names: ["flag-kw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,kw,regional,indicator,symbol,letters" }, mens: { name: "Mens Symbol", unified: "1F6B9", sheet_x: 31, sheet_y: 7, short_names: ["mens"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mens,symbol,toilet,restroom,wc,blue-square,gender,male" }, dizzy: { name: "Dizzy Symbol", unified: "1F4AB", sheet_x: 20, sheet_y: 23, short_names: ["dizzy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dizzy,symbol,star,sparkle,shoot,magic" }, speaking_head_in_silhouette: { name: "Speaking Head in Silhouette", unified: "1F5E3", sheet_x: 26, sheet_y: 5, short_names: ["speaking_head_in_silhouette"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "speaking,head,in,silhouette" }, "flag-kg": { name: "Regional Indicator Symbol Letters KG", unified: "1F1F0-1F1EC", sheet_x: 35, sheet_y: 31, short_names: ["flag-kg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,kg,regional,indicator,symbol,letters" }, mailbox_with_no_mail: { name: "Open Mailbox with Lowered Flag", unified: "1F4ED", sheet_x: 22, sheet_y: 7, short_names: ["mailbox_with_no_mail"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mailbox,with,no,mail,open,lowered,flag,email,inbox" }, sparkles: { name: "Sparkles", unified: "2728", sheet_x: 3, sheet_y: 39, short_names: ["sparkles"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sparkles,stars,shine,shiny,cool,awesome,good,magic" }, baby: { name: "Baby", unified: "1F476", sheet_x: 17, sheet_y: 38, short_names: ["baby"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F476-1F3FB": { unified: "1F476-1F3FB", image: "1f476-1f3fb.png", sheet_x: 17, sheet_y: 39, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F476-1F3FC": { unified: "1F476-1F3FC", image: "1f476-1f3fc.png", sheet_x: 17, sheet_y: 40, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F476-1F3FD": { unified: "1F476-1F3FD", image: "1f476-1f3fd.png", sheet_x: 18, sheet_y: 0, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F476-1F3FE": { unified: "1F476-1F3FE", image: "1f476-1f3fe.png", sheet_x: 18, sheet_y: 1, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F476-1F3FF": { unified: "1F476-1F3FF", image: "1f476-1f3ff.png", sheet_x: 18, sheet_y: 2, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "baby,child,boy,girl,toddler" }, package: { name: "Package", unified: "1F4E6", sheet_x: 22, sheet_y: 0, short_names: ["package"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "package,mail,gift,cardboard,box,moving" }, womens: { name: "Womens Symbol", unified: "1F6BA", sheet_x: 31, sheet_y: 8, short_names: ["womens"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "womens,symbol,purple-square,woman,female,toilet,loo,restroom,gender" }, "flag-la": { name: "Regional Indicator Symbol Letters LA", unified: "1F1F1-1F1E6", sheet_x: 36, sheet_y: 0, short_names: ["flag-la"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,la,regional,indicator,symbol,letters" }, baby_symbol: { name: "Baby Symbol", unified: "1F6BC", sheet_x: 31, sheet_y: 10, short_names: ["baby_symbol"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "baby,symbol,orange-square,child" }, "flag-lv": { name: "Regional Indicator Symbol Letters LV", unified: "1F1F1-1F1FB", sheet_x: 36, sheet_y: 9, short_names: ["flag-lv"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,lv,regional,indicator,symbol,letters" }, postal_horn: { name: "Postal Horn", unified: "1F4EF", sheet_x: 22, sheet_y: 9, short_names: ["postal_horn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "postal,horn,instrument,music" }, comet: { name: "Comet", unified: "2604", variations: ["2604-FE0F"], sheet_x: 1, sheet_y: 4, short_names: ["comet"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "comet,space" }, boy: { name: "Boy", unified: "1F466", sheet_x: 16, sheet_y: 8, short_names: ["boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F466-1F3FB": { unified: "1F466-1F3FB", image: "1f466-1f3fb.png", sheet_x: 16, sheet_y: 9, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F466-1F3FC": { unified: "1F466-1F3FC", image: "1f466-1f3fc.png", sheet_x: 16, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F466-1F3FD": { unified: "1F466-1F3FD", image: "1f466-1f3fd.png", sheet_x: 16, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F466-1F3FE": { unified: "1F466-1F3FE", image: "1f466-1f3fe.png", sheet_x: 16, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F466-1F3FF": { unified: "1F466-1F3FF", image: "1f466-1f3ff.png", sheet_x: 16, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "boy,man,male,guy,teenager" }, restroom: { name: "Restroom", unified: "1F6BB", sheet_x: 31, sheet_y: 9, short_names: ["restroom"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "restroom,blue-square,toilet,refresh,wc,gender" }, "flag-lb": { name: "Regional Indicator Symbol Letters LB", unified: "1F1F1-1F1E7", sheet_x: 36, sheet_y: 1, short_names: ["flag-lb"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,lb,regional,indicator,symbol,letters" }, inbox_tray: { name: "Inbox Tray", unified: "1F4E5", sheet_x: 21, sheet_y: 40, short_names: ["inbox_tray"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "inbox,tray,email,documents" }, sunny: { name: "Black Sun with Rays", unified: "2600", variations: ["2600-FE0F"], sheet_x: 1, sheet_y: 0, short_names: ["sunny"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sunny,black,sun,with,rays,weather,nature,brightness,summer,beach,spring" }, girl: { name: "Girl", unified: "1F467", sheet_x: 16, sheet_y: 14, short_names: ["girl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F467-1F3FB": { unified: "1F467-1F3FB", image: "1f467-1f3fb.png", sheet_x: 16, sheet_y: 15, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F467-1F3FC": { unified: "1F467-1F3FC", image: "1f467-1f3fc.png", sheet_x: 16, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F467-1F3FD": { unified: "1F467-1F3FD", image: "1f467-1f3fd.png", sheet_x: 16, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F467-1F3FE": { unified: "1F467-1F3FE", image: "1f467-1f3fe.png", sheet_x: 16, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F467-1F3FF": { unified: "1F467-1F3FF", image: "1f467-1f3ff.png", sheet_x: 16, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "girl,female,woman,teenager" }, man: { name: "Man", unified: "1F468", sheet_x: 16, sheet_y: 20, short_names: ["man"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F468-1F3FB": { unified: "1F468-1F3FB", image: "1f468-1f3fb.png", sheet_x: 16, sheet_y: 21, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F468-1F3FC": { unified: "1F468-1F3FC", image: "1f468-1f3fc.png", sheet_x: 16, sheet_y: 22, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F468-1F3FD": { unified: "1F468-1F3FD", image: "1f468-1f3fd.png", sheet_x: 16, sheet_y: 23, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F468-1F3FE": { unified: "1F468-1F3FE", image: "1f468-1f3fe.png", sheet_x: 16, sheet_y: 24, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F468-1F3FF": { unified: "1F468-1F3FF", image: "1f468-1f3ff.png", sheet_x: 16, sheet_y: 25, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "man,mustache,father,dad,guy,classy,sir,moustache" }, put_litter_in_its_place: { name: "Put Litter in Its Place Symbol", unified: "1F6AE", sheet_x: 30, sheet_y: 22, short_names: ["put_litter_in_its_place"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "put,litter,in,its,place,symbol,blue-square,sign,human,info" }, mostly_sunny: { name: "White Sun with Small Cloud", unified: "1F324", sheet_x: 6, sheet_y: 14, short_names: ["mostly_sunny", "sun_small_cloud"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mostly,sunny,sun,small,cloud,white,with" }, "flag-ls": { name: "Regional Indicator Symbol Letters LS", unified: "1F1F1-1F1F8", sheet_x: 36, sheet_y: 6, short_names: ["flag-ls"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ls,regional,indicator,symbol,letters" }, outbox_tray: { name: "Outbox Tray", unified: "1F4E4", sheet_x: 21, sheet_y: 39, short_names: ["outbox_tray"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "outbox,tray,inbox,email" }, cinema: { name: "Cinema", unified: "1F3A6", sheet_x: 9, sheet_y: 21, short_names: ["cinema"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cinema,blue-square,record,film,movie,curtain,stage,theater" }, "flag-lr": { name: "Regional Indicator Symbol Letters LR", unified: "1F1F1-1F1F7", sheet_x: 36, sheet_y: 5, short_names: ["flag-lr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,lr,regional,indicator,symbol,letters" }, scroll: { name: "Scroll", unified: "1F4DC", sheet_x: 21, sheet_y: 31, short_names: ["scroll"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "scroll,documents,ancient,history,paper" }, partly_sunny: { name: "Sun Behind Cloud", unified: "26C5", variations: ["26C5-FE0F"], sheet_x: 2, sheet_y: 21, short_names: ["partly_sunny"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "partly,sunny,sun,behind,cloud,weather,nature,cloudy,morning,fall,spring" }, woman: { name: "Woman", unified: "1F469", sheet_x: 16, sheet_y: 26, short_names: ["woman"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F469-1F3FB": { unified: "1F469-1F3FB", image: "1f469-1f3fb.png", sheet_x: 16, sheet_y: 27, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F469-1F3FC": { unified: "1F469-1F3FC", image: "1f469-1f3fc.png", sheet_x: 16, sheet_y: 28, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F469-1F3FD": { unified: "1F469-1F3FD", image: "1f469-1f3fd.png", sheet_x: 16, sheet_y: 29, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F469-1F3FE": { unified: "1F469-1F3FE", image: "1f469-1f3fe.png", sheet_x: 16, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F469-1F3FF": { unified: "1F469-1F3FF", image: "1f469-1f3ff.png", sheet_x: 16, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "woman,female,girls,lady" }, signal_strength: { name: "Antenna with Bars", unified: "1F4F6", sheet_x: 22, sheet_y: 16, short_names: ["signal_strength"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "signal,strength,antenna,with,bars,blue-square,reception,phone,internet,connection,wifi,bluetooth" }, person_with_blond_hair: { name: "Person with Blond Hair", unified: "1F471", sheet_x: 17, sheet_y: 8, short_names: ["person_with_blond_hair"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F471-1F3FB": { unified: "1F471-1F3FB", image: "1f471-1f3fb.png", sheet_x: 17, sheet_y: 9, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F471-1F3FC": { unified: "1F471-1F3FC", image: "1f471-1f3fc.png", sheet_x: 17, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F471-1F3FD": { unified: "1F471-1F3FD", image: "1f471-1f3fd.png", sheet_x: 17, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F471-1F3FE": { unified: "1F471-1F3FE", image: "1f471-1f3fe.png", sheet_x: 17, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F471-1F3FF": { unified: "1F471-1F3FF", image: "1f471-1f3ff.png", sheet_x: 17, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "person,with,blond,hair,man,male,boy,blonde,guy" }, barely_sunny: { name: "White Sun Behind Cloud", unified: "1F325", sheet_x: 6, sheet_y: 15, short_names: ["barely_sunny", "sun_behind_cloud"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "barely,sunny,sun,behind,cloud,white" }, page_with_curl: { name: "Page with Curl", unified: "1F4C3", sheet_x: 21, sheet_y: 6, short_names: ["page_with_curl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "page,with,curl,documents,office,paper" }, "flag-ly": { name: "Regional Indicator Symbol Letters LY", unified: "1F1F1-1F1FE", sheet_x: 36, sheet_y: 10, short_names: ["flag-ly"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ly,regional,indicator,symbol,letters" }, bookmark_tabs: { name: "Bookmark Tabs", unified: "1F4D1", sheet_x: 21, sheet_y: 20, short_names: ["bookmark_tabs"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bookmark,tabs,favorite,save,order,tidy" }, "flag-li": { name: "Regional Indicator Symbol Letters LI", unified: "1F1F1-1F1EE", sheet_x: 36, sheet_y: 3, short_names: ["flag-li"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,li,regional,indicator,symbol,letters" }, older_man: { name: "Older Man", unified: "1F474", sheet_x: 17, sheet_y: 26, short_names: ["older_man"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F474-1F3FB": { unified: "1F474-1F3FB", image: "1f474-1f3fb.png", sheet_x: 17, sheet_y: 27, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F474-1F3FC": { unified: "1F474-1F3FC", image: "1f474-1f3fc.png", sheet_x: 17, sheet_y: 28, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F474-1F3FD": { unified: "1F474-1F3FD", image: "1f474-1f3fd.png", sheet_x: 17, sheet_y: 29, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F474-1F3FE": { unified: "1F474-1F3FE", image: "1f474-1f3fe.png", sheet_x: 17, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F474-1F3FF": { unified: "1F474-1F3FF", image: "1f474-1f3ff.png", sheet_x: 17, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "older,man,human,male,men" }, partly_sunny_rain: { name: "White Sun Behind Cloud with Rain", unified: "1F326", sheet_x: 6, sheet_y: 16, short_names: ["partly_sunny_rain", "sun_behind_rain_cloud"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "partly,sunny,rain,sun,behind,cloud,white,with" }, koko: { name: "Squared Katakana Koko", unified: "1F201", sheet_x: 5, sheet_y: 6, short_names: ["koko"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "koko,squared,katakana,blue-square,here,japanese,destination" }, bar_chart: { name: "Bar Chart", unified: "1F4CA", sheet_x: 21, sheet_y: 13, short_names: ["bar_chart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bar,chart,graph,presentation,stats" }, cloud: { name: "Cloud", unified: "2601", variations: ["2601-FE0F"], sheet_x: 1, sheet_y: 1, short_names: ["cloud"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cloud,weather,sky" }, ng: { name: "Squared Ng", unified: "1F196", sheet_x: 5, sheet_y: 1, short_names: ["ng"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ng,squared,blue-square,words,shape,icon" }, "flag-lt": { name: "Regional Indicator Symbol Letters LT", unified: "1F1F1-1F1F9", sheet_x: 36, sheet_y: 7, short_names: ["flag-lt"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,lt,regional,indicator,symbol,letters" }, older_woman: { name: "Older Woman", unified: "1F475", sheet_x: 17, sheet_y: 32, short_names: ["older_woman"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F475-1F3FB": { unified: "1F475-1F3FB", image: "1f475-1f3fb.png", sheet_x: 17, sheet_y: 33, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F475-1F3FC": { unified: "1F475-1F3FC", image: "1f475-1f3fc.png", sheet_x: 17, sheet_y: 34, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F475-1F3FD": { unified: "1F475-1F3FD", image: "1f475-1f3fd.png", sheet_x: 17, sheet_y: 35, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F475-1F3FE": { unified: "1F475-1F3FE", image: "1f475-1f3fe.png", sheet_x: 17, sheet_y: 36, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F475-1F3FF": { unified: "1F475-1F3FF", image: "1f475-1f3ff.png", sheet_x: 17, sheet_y: 37, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "older,woman,female,women,girl,lady" }, rain_cloud: { name: "Cloud with Rain", unified: "1F327", sheet_x: 6, sheet_y: 17, short_names: ["rain_cloud"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rain,cloud,with" }, "flag-lu": { name: "Regional Indicator Symbol Letters LU", unified: "1F1F1-1F1FA", sheet_x: 36, sheet_y: 8, short_names: ["flag-lu"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,lu,regional,indicator,symbol,letters" }, chart_with_upwards_trend: { name: "Chart with Upwards Trend", unified: "1F4C8", sheet_x: 21, sheet_y: 11, short_names: ["chart_with_upwards_trend"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "chart,with,upwards,trend,graph,presentation,stats,recovery,business,economics,money,sales,good,success" }, ok: { name: "Squared Ok", unified: "1F197", sheet_x: 5, sheet_y: 2, short_names: ["ok"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ok,squared,good,agree,yes,blue-square" }, man_with_gua_pi_mao: { name: "Man with Gua Pi Mao", unified: "1F472", sheet_x: 17, sheet_y: 14, short_names: ["man_with_gua_pi_mao"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F472-1F3FB": { unified: "1F472-1F3FB", image: "1f472-1f3fb.png", sheet_x: 17, sheet_y: 15, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F472-1F3FC": { unified: "1F472-1F3FC", image: "1f472-1f3fc.png", sheet_x: 17, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F472-1F3FD": { unified: "1F472-1F3FD", image: "1f472-1f3fd.png", sheet_x: 17, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F472-1F3FE": { unified: "1F472-1F3FE", image: "1f472-1f3fe.png", sheet_x: 17, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F472-1F3FF": { unified: "1F472-1F3FF", image: "1f472-1f3ff.png", sheet_x: 17, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "man,with,gua,pi,mao,male,boy" }, thunder_cloud_and_rain: { name: "Thunder Cloud and Rain", unified: "26C8", sheet_x: 2, sheet_y: 22, short_names: ["thunder_cloud_and_rain"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "thunder,cloud,and,rain,weather,lightning" }, up: { name: "Squared Up with Exclamation Mark", unified: "1F199", sheet_x: 5, sheet_y: 4, short_names: ["up"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "up,squared,with,exclamation,mark,blue-square,above,high" }, man_with_turban: { name: "Man with Turban", unified: "1F473", sheet_x: 17, sheet_y: 20, short_names: ["man_with_turban"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F473-1F3FB": { unified: "1F473-1F3FB", image: "1f473-1f3fb.png", sheet_x: 17, sheet_y: 21, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F473-1F3FC": { unified: "1F473-1F3FC", image: "1f473-1f3fc.png", sheet_x: 17, sheet_y: 22, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F473-1F3FD": { unified: "1F473-1F3FD", image: "1f473-1f3fd.png", sheet_x: 17, sheet_y: 23, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F473-1F3FE": { unified: "1F473-1F3FE", image: "1f473-1f3fe.png", sheet_x: 17, sheet_y: 24, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F473-1F3FF": { unified: "1F473-1F3FF", image: "1f473-1f3ff.png", sheet_x: 17, sheet_y: 25, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "man,with,turban,male,indian,hinduism,arabs" }, chart_with_downwards_trend: { name: "Chart with Downwards Trend", unified: "1F4C9", sheet_x: 21, sheet_y: 12, short_names: ["chart_with_downwards_trend"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "chart,with,downwards,trend,graph,presentation,stats,recession,business,economics,money,sales,bad,failure" }, "flag-mo": { name: "Regional Indicator Symbol Letters MO", unified: "1F1F2-1F1F4", sheet_x: 36, sheet_y: 22, short_names: ["flag-mo"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mo,regional,indicator,symbol,letters" }, page_facing_up: { name: "Page Facing Up", unified: "1F4C4", sheet_x: 21, sheet_y: 7, short_names: ["page_facing_up"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "page,facing,up,documents,office,paper,information" }, cool: { name: "Squared Cool", unified: "1F192", sheet_x: 4, sheet_y: 38, short_names: ["cool"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "cool,squared,words,blue-square" }, lightning: { name: "Cloud with Lightning", unified: "1F329", sheet_x: 6, sheet_y: 19, short_names: ["lightning", "lightning_cloud"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lightning,cloud,with" }, "flag-mk": { name: "Regional Indicator Symbol Letters MK", unified: "1F1F2-1F1F0", sheet_x: 36, sheet_y: 18, short_names: ["flag-mk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mk,regional,indicator,symbol,letters" }, cop: { name: "Police Officer", unified: "1F46E", sheet_x: 16, sheet_y: 36, short_names: ["cop"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F46E-1F3FB": { unified: "1F46E-1F3FB", image: "1f46e-1f3fb.png", sheet_x: 16, sheet_y: 37, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F46E-1F3FC": { unified: "1F46E-1F3FC", image: "1f46e-1f3fc.png", sheet_x: 16, sheet_y: 38, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F46E-1F3FD": { unified: "1F46E-1F3FD", image: "1f46e-1f3fd.png", sheet_x: 16, sheet_y: 39, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F46E-1F3FE": { unified: "1F46E-1F3FE", image: "1f46e-1f3fe.png", sheet_x: 16, sheet_y: 40, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F46E-1F3FF": { unified: "1F46E-1F3FF", image: "1f46e-1f3ff.png", sheet_x: 17, sheet_y: 0, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "cop,police,officer,man,law,legal,enforcement,arrest,911" }, "flag-mg": { name: "Regional Indicator Symbol Letters MG", unified: "1F1F2-1F1EC", sheet_x: 36, sheet_y: 16, short_names: ["flag-mg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mg,regional,indicator,symbol,letters" }, date: { name: "Calendar", unified: "1F4C5", sheet_x: 21, sheet_y: 8, short_names: ["date"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "date,calendar,schedule" }, new: { name: "Squared New", unified: "1F195", sheet_x: 5, sheet_y: 0, short_names: ["new"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "new,squared,blue-square,words,start" }, zap: { name: "High Voltage Sign", unified: "26A1", variations: ["26A1-FE0F"], sheet_x: 2, sheet_y: 13, short_names: ["zap"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "zap,high,voltage,sign,thunder,weather,lightning bolt,fast" }, construction_worker: { name: "Construction Worker", unified: "1F477", sheet_x: 18, sheet_y: 3, short_names: ["construction_worker"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F477-1F3FB": { unified: "1F477-1F3FB", image: "1f477-1f3fb.png", sheet_x: 18, sheet_y: 4, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F477-1F3FC": { unified: "1F477-1F3FC", image: "1f477-1f3fc.png", sheet_x: 18, sheet_y: 5, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F477-1F3FD": { unified: "1F477-1F3FD", image: "1f477-1f3fd.png", sheet_x: 18, sheet_y: 6, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F477-1F3FE": { unified: "1F477-1F3FE", image: "1f477-1f3fe.png", sheet_x: 18, sheet_y: 7, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F477-1F3FF": { unified: "1F477-1F3FF", image: "1f477-1f3ff.png", sheet_x: 18, sheet_y: 8, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "construction,worker,male,human,wip,guy,build" }, guardsman: { name: "Guardsman", unified: "1F482", sheet_x: 18, sheet_y: 34, short_names: ["guardsman"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F482-1F3FB": { unified: "1F482-1F3FB", image: "1f482-1f3fb.png", sheet_x: 18, sheet_y: 35, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F482-1F3FC": { unified: "1F482-1F3FC", image: "1f482-1f3fc.png", sheet_x: 18, sheet_y: 36, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F482-1F3FD": { unified: "1F482-1F3FD", image: "1f482-1f3fd.png", sheet_x: 18, sheet_y: 37, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F482-1F3FE": { unified: "1F482-1F3FE", image: "1f482-1f3fe.png", sheet_x: 18, sheet_y: 38, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F482-1F3FF": { unified: "1F482-1F3FF", image: "1f482-1f3ff.png", sheet_x: 18, sheet_y: 39, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "guardsman,uk,gb,british,male,guy,royal" }, fire: { name: "Fire", unified: "1F525", sheet_x: 23, sheet_y: 21, short_names: ["fire"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fire,hot,cook,flame" }, free: { name: "Squared Free", unified: "1F193", sheet_x: 4, sheet_y: 39, short_names: ["free"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "free,squared,blue-square,words" }, "flag-mw": { name: "Regional Indicator Symbol Letters MW", unified: "1F1F2-1F1FC", sheet_x: 36, sheet_y: 30, short_names: ["flag-mw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mw,regional,indicator,symbol,letters" }, calendar: { name: "Tear-off Calendar", unified: "1F4C6", sheet_x: 21, sheet_y: 9, short_names: ["calendar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "calendar,tear,off,schedule,date,planning" }, spiral_calendar_pad: { name: "Spiral Calendar Pad", unified: "1F5D3", sheet_x: 26, sheet_y: 0, short_names: ["spiral_calendar_pad"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "spiral,calendar,pad,date,schedule,planning" }, boom: { name: "Collision Symbol", unified: "1F4A5", sheet_x: 20, sheet_y: 12, short_names: ["boom", "collision"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "boom,collision,symbol,bomb,explode,explosion,blown" }, "flag-my": { name: "Regional Indicator Symbol Letters MY", unified: "1F1F2-1F1FE", sheet_x: 36, sheet_y: 32, short_names: ["flag-my"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,my,regional,indicator,symbol,letters" }, zero: { name: "Keycap 0", unified: "0030-20E3", variations: ["0030-FE0F-20E3"], sheet_x: 32, sheet_y: 23, short_names: ["zero"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "zero,keycap,0,numbers,blue-square,null" }, sleuth_or_spy: { name: "Sleuth or Spy", unified: "1F575", sheet_x: 24, sheet_y: 39, short_names: ["sleuth_or_spy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F575-1F3FB": { unified: "1F575-1F3FB", image: "1f575-1f3fb.png", sheet_x: 24, sheet_y: 40, has_img_apple: true, has_img_google: false, has_img_twitter: false, has_img_emojione: true }, "1F575-1F3FC": { unified: "1F575-1F3FC", image: "1f575-1f3fc.png", sheet_x: 25, sheet_y: 0, has_img_apple: true, has_img_google: false, has_img_twitter: false, has_img_emojione: true }, "1F575-1F3FD": { unified: "1F575-1F3FD", image: "1f575-1f3fd.png", sheet_x: 25, sheet_y: 1, has_img_apple: true, has_img_google: false, has_img_twitter: false, has_img_emojione: true }, "1F575-1F3FE": { unified: "1F575-1F3FE", image: "1f575-1f3fe.png", sheet_x: 25, sheet_y: 2, has_img_apple: true, has_img_google: false, has_img_twitter: false, has_img_emojione: true }, "1F575-1F3FF": { unified: "1F575-1F3FF", image: "1f575-1f3ff.png", sheet_x: 25, sheet_y: 3, has_img_apple: true, has_img_google: false, has_img_twitter: false, has_img_emojione: true } }, search: "sleuth,or,spy" }, one: { name: "Keycap 1", unified: "0031-20E3", variations: ["0031-FE0F-20E3"], sheet_x: 32, sheet_y: 24, short_names: ["one"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "one,keycap,1,blue-square,numbers" }, santa: { name: "Father Christmas", unified: "1F385", sheet_x: 8, sheet_y: 29, short_names: ["santa"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F385-1F3FB": { unified: "1F385-1F3FB", image: "1f385-1f3fb.png", sheet_x: 8, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F385-1F3FC": { unified: "1F385-1F3FC", image: "1f385-1f3fc.png", sheet_x: 8, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F385-1F3FD": { unified: "1F385-1F3FD", image: "1f385-1f3fd.png", sheet_x: 8, sheet_y: 32, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F385-1F3FE": { unified: "1F385-1F3FE", image: "1f385-1f3fe.png", sheet_x: 8, sheet_y: 33, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F385-1F3FF": { unified: "1F385-1F3FF", image: "1f385-1f3ff.png", sheet_x: 8, sheet_y: 34, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "santa,father,christmas,festival,man,male,xmas,father christmas" }, card_index: { name: "Card Index", unified: "1F4C7", sheet_x: 21, sheet_y: 10, short_names: ["card_index"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "card,index,business,stationery" }, snowflake: { name: "Snowflake", unified: "2744", variations: ["2744-FE0F"], sheet_x: 4, sheet_y: 1, short_names: ["snowflake"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "snowflake,winter,season,cold,weather,christmas,xmas" }, "flag-mv": { name: "Regional Indicator Symbol Letters MV", unified: "1F1F2-1F1FB", sheet_x: 36, sheet_y: 29, short_names: ["flag-mv"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mv,regional,indicator,symbol,letters" }, snow_cloud: { name: "Cloud with Snow", unified: "1F328", sheet_x: 6, sheet_y: 18, short_names: ["snow_cloud"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "snow,cloud,with" }, angel: { name: "Baby Angel", unified: "1F47C", sheet_x: 18, sheet_y: 18, short_names: ["angel"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F47C-1F3FB": { unified: "1F47C-1F3FB", image: "1f47c-1f3fb.png", sheet_x: 18, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F47C-1F3FC": { unified: "1F47C-1F3FC", image: "1f47c-1f3fc.png", sheet_x: 18, sheet_y: 20, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F47C-1F3FD": { unified: "1F47C-1F3FD", image: "1f47c-1f3fd.png", sheet_x: 18, sheet_y: 21, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F47C-1F3FE": { unified: "1F47C-1F3FE", image: "1f47c-1f3fe.png", sheet_x: 18, sheet_y: 22, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F47C-1F3FF": { unified: "1F47C-1F3FF", image: "1f47c-1f3ff.png", sheet_x: 18, sheet_y: 23, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "angel,baby,heaven,wings,halo" }, two: { name: "Keycap 2", unified: "0032-20E3", variations: ["0032-FE0F-20E3"], sheet_x: 32, sheet_y: 25, short_names: ["two"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "two,keycap,2,numbers,prime,blue-square" }, card_file_box: { name: "Card File Box", unified: "1F5C3", sheet_x: 25, sheet_y: 37, short_names: ["card_file_box"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "card,file,box,business,stationery" }, "flag-ml": { name: "Regional Indicator Symbol Letters ML", unified: "1F1F2-1F1F1", sheet_x: 36, sheet_y: 19, short_names: ["flag-ml"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ml,regional,indicator,symbol,letters" }, three: { name: "Keycap 3", unified: "0033-20E3", variations: ["0033-FE0F-20E3"], sheet_x: 32, sheet_y: 26, short_names: ["three"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "three,keycap,3,numbers,prime,blue-square" }, princess: { name: "Princess", unified: "1F478", sheet_x: 18, sheet_y: 9, short_names: ["princess"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F478-1F3FB": { unified: "1F478-1F3FB", image: "1f478-1f3fb.png", sheet_x: 18, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F478-1F3FC": { unified: "1F478-1F3FC", image: "1f478-1f3fc.png", sheet_x: 18, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F478-1F3FD": { unified: "1F478-1F3FD", image: "1f478-1f3fd.png", sheet_x: 18, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F478-1F3FE": { unified: "1F478-1F3FE", image: "1f478-1f3fe.png", sheet_x: 18, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F478-1F3FF": { unified: "1F478-1F3FF", image: "1f478-1f3ff.png", sheet_x: 18, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "princess,girl,woman,female,blond,crown,royal,queen" }, snowman: { name: "Snowman", unified: "2603", variations: ["2603-FE0F"], sheet_x: 1, sheet_y: 3, short_names: ["snowman"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "snowman,winter,season,cold,weather,christmas,xmas,frozen,without_snow" }, ballot_box_with_ballot: { name: "Ballot Box with Ballot", unified: "1F5F3", sheet_x: 26, sheet_y: 8, short_names: ["ballot_box_with_ballot"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ballot,box,with,election,vote" }, "flag-mt": { name: "Regional Indicator Symbol Letters MT", unified: "1F1F2-1F1F9", sheet_x: 36, sheet_y: 27, short_names: ["flag-mt"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mt,regional,indicator,symbol,letters" }, file_cabinet: { name: "File Cabinet", unified: "1F5C4", sheet_x: 25, sheet_y: 38, short_names: ["file_cabinet"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "file,cabinet,filing,organizing" }, bride_with_veil: { name: "Bride with Veil", unified: "1F470", sheet_x: 17, sheet_y: 2, short_names: ["bride_with_veil"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F470-1F3FB": { unified: "1F470-1F3FB", image: "1f470-1f3fb.png", sheet_x: 17, sheet_y: 3, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F470-1F3FC": { unified: "1F470-1F3FC", image: "1f470-1f3fc.png", sheet_x: 17, sheet_y: 4, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F470-1F3FD": { unified: "1F470-1F3FD", image: "1f470-1f3fd.png", sheet_x: 17, sheet_y: 5, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F470-1F3FE": { unified: "1F470-1F3FE", image: "1f470-1f3fe.png", sheet_x: 17, sheet_y: 6, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F470-1F3FF": { unified: "1F470-1F3FF", image: "1f470-1f3ff.png", sheet_x: 17, sheet_y: 7, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "bride,with,veil,couple,marriage,wedding" }, "flag-mh": { name: "Regional Indicator Symbol Letters MH", unified: "1F1F2-1F1ED", sheet_x: 36, sheet_y: 17, short_names: ["flag-mh"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mh,regional,indicator,symbol,letters" }, snowman_without_snow: { name: "Snowman Without Snow", unified: "26C4", variations: ["26C4-FE0F"], sheet_x: 2, sheet_y: 20, short_names: ["snowman_without_snow"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "snowman,without,snow" }, four: { name: "Keycap 4", unified: "0034-20E3", variations: ["0034-FE0F-20E3"], sheet_x: 32, sheet_y: 27, short_names: ["four"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "four,keycap,4,numbers,blue-square" }, clipboard: { name: "Clipboard", unified: "1F4CB", sheet_x: 21, sheet_y: 14, short_names: ["clipboard"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clipboard,stationery,documents" }, wind_blowing_face: { name: "Wind Blowing Face", unified: "1F32C", sheet_x: 6, sheet_y: 22, short_names: ["wind_blowing_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wind,blowing,face,gust,air" }, five: { name: "Keycap 5", unified: "0035-20E3", variations: ["0035-FE0F-20E3"], sheet_x: 32, sheet_y: 28, short_names: ["five"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "five,keycap,5,numbers,blue-square,prime" }, walking: { name: "Pedestrian", unified: "1F6B6", sheet_x: 30, sheet_y: 40, short_names: ["walking"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F6B6-1F3FB": { unified: "1F6B6-1F3FB", image: "1f6b6-1f3fb.png", sheet_x: 31, sheet_y: 0, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B6-1F3FC": { unified: "1F6B6-1F3FC", image: "1f6b6-1f3fc.png", sheet_x: 31, sheet_y: 1, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B6-1F3FD": { unified: "1F6B6-1F3FD", image: "1f6b6-1f3fd.png", sheet_x: 31, sheet_y: 2, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B6-1F3FE": { unified: "1F6B6-1F3FE", image: "1f6b6-1f3fe.png", sheet_x: 31, sheet_y: 3, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F6B6-1F3FF": { unified: "1F6B6-1F3FF", image: "1f6b6-1f3ff.png", sheet_x: 31, sheet_y: 4, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "walking,pedestrian,human,feet,steps" }, "flag-mq": { name: "Regional Indicator Symbol Letters MQ", unified: "1F1F2-1F1F6", sheet_x: 36, sheet_y: 24, short_names: ["flag-mq"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,mq,regional,indicator,symbol,letters" }, six: { name: "Keycap 6", unified: "0036-20E3", variations: ["0036-FE0F-20E3"], sheet_x: 32, sheet_y: 29, short_names: ["six"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "six,keycap,6,numbers,blue-square" }, dash: { name: "Dash Symbol", unified: "1F4A8", sheet_x: 20, sheet_y: 15, short_names: ["dash"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dash,symbol,wind,air,fast,shoo,fart,smoke,puff" }, "flag-mr": { name: "Regional Indicator Symbol Letters MR", unified: "1F1F2-1F1F7", sheet_x: 36, sheet_y: 25, short_names: ["flag-mr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mr,regional,indicator,symbol,letters" }, runner: { name: "Runner", unified: "1F3C3", sheet_x: 10, sheet_y: 9, short_names: ["runner", "running"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F3C3-1F3FB": { unified: "1F3C3-1F3FB", image: "1f3c3-1f3fb.png", sheet_x: 10, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3C3-1F3FC": { unified: "1F3C3-1F3FC", image: "1f3c3-1f3fc.png", sheet_x: 10, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3C3-1F3FD": { unified: "1F3C3-1F3FD", image: "1f3c3-1f3fd.png", sheet_x: 10, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3C3-1F3FE": { unified: "1F3C3-1F3FE", image: "1f3c3-1f3fe.png", sheet_x: 10, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F3C3-1F3FF": { unified: "1F3C3-1F3FF", image: "1f3c3-1f3ff.png", sheet_x: 10, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "runner,running,man,walking,exercise,race" }, spiral_note_pad: { name: "Spiral Note Pad", unified: "1F5D2", sheet_x: 25, sheet_y: 40, short_names: ["spiral_note_pad"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "spiral,note,pad,memo,stationery" }, seven: { name: "Keycap 7", unified: "0037-20E3", variations: ["0037-FE0F-20E3"], sheet_x: 32, sheet_y: 30, short_names: ["seven"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "seven,keycap,7,numbers,blue-square,prime" }, tornado: { name: "Cloud with Tornado", unified: "1F32A", sheet_x: 6, sheet_y: 20, short_names: ["tornado", "tornado_cloud"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tornado,cloud,with" }, file_folder: { name: "File Folder", unified: "1F4C1", sheet_x: 21, sheet_y: 4, short_names: ["file_folder"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "file,folder,documents,business,office" }, "flag-mu": { name: "Regional Indicator Symbol Letters MU", unified: "1F1F2-1F1FA", sheet_x: 36, sheet_y: 28, short_names: ["flag-mu"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mu,regional,indicator,symbol,letters" }, dancer: { name: "Dancer", unified: "1F483", sheet_x: 18, sheet_y: 40, short_names: ["dancer"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F483-1F3FB": { unified: "1F483-1F3FB", image: "1f483-1f3fb.png", sheet_x: 19, sheet_y: 0, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F483-1F3FC": { unified: "1F483-1F3FC", image: "1f483-1f3fc.png", sheet_x: 19, sheet_y: 1, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F483-1F3FD": { unified: "1F483-1F3FD", image: "1f483-1f3fd.png", sheet_x: 19, sheet_y: 2, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F483-1F3FE": { unified: "1F483-1F3FE", image: "1f483-1f3fe.png", sheet_x: 19, sheet_y: 3, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F483-1F3FF": { unified: "1F483-1F3FF", image: "1f483-1f3ff.png", sheet_x: 19, sheet_y: 4, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "dancer,female,girl,woman,fun" }, open_file_folder: { name: "Open File Folder", unified: "1F4C2", sheet_x: 21, sheet_y: 5, short_names: ["open_file_folder"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "open,file,folder,documents,load" }, eight: { name: "Keycap 8", unified: "0038-20E3", variations: ["0038-FE0F-20E3"], sheet_x: 32, sheet_y: 31, short_names: ["eight"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "eight,keycap,8,blue-square,numbers" }, fog: { name: "Fog", unified: "1F32B", sheet_x: 6, sheet_y: 21, short_names: ["fog"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fog,weather" }, dancers: { name: "Woman with Bunny Ears", unified: "1F46F", sheet_x: 17, sheet_y: 1, short_names: ["dancers"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dancers,woman,with,bunny,ears,female,women,girls" }, "flag-yt": { name: "Regional Indicator Symbol Letters YT", unified: "1F1FE-1F1F9", sheet_x: 38, sheet_y: 40, short_names: ["flag-yt"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,yt,regional,indicator,symbol,letters" }, "flag-mx": { name: "Regional Indicator Symbol Letters MX", unified: "1F1F2-1F1FD", sheet_x: 36, sheet_y: 31, short_names: ["flag-mx"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mx,regional,indicator,symbol,letters" }, card_index_dividers: { name: "Card Index Dividers", unified: "1F5C2", sheet_x: 25, sheet_y: 36, short_names: ["card_index_dividers"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "card,index,dividers,organizing,business,stationery" }, couple: { name: "Man and Woman Holding Hands", unified: "1F46B", sheet_x: 16, sheet_y: 33, short_names: ["couple", "man_and_woman_holding_hands"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "couple,man,and,woman,holding,hands,pair,people,human,love,date,dating,like,affection,valentines,marriage" }, umbrella: { name: "Umbrella", unified: "2602", variations: ["2602-FE0F"], sheet_x: 1, sheet_y: 2, short_names: ["umbrella"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "umbrella,rainy,weather,spring" }, nine: { name: "Keycap 9", unified: "0039-20E3", variations: ["0039-FE0F-20E3"], sheet_x: 32, sheet_y: 32, short_names: ["nine"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "nine,keycap,9,blue-square,numbers" }, rolled_up_newspaper: { name: "Rolled-Up Newspaper", unified: "1F5DE", sheet_x: 26, sheet_y: 3, short_names: ["rolled_up_newspaper"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rolled,up,newspaper,press,headline" }, "flag-fm": { name: "Regional Indicator Symbol Letters FM", unified: "1F1EB-1F1F2", sheet_x: 34, sheet_y: 28, short_names: ["flag-fm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,fm,regional,indicator,symbol,letters" }, umbrella_with_rain_drops: { name: "Umbrella with Rain Drops", unified: "2614", variations: ["2614-FE0F"], sheet_x: 1, sheet_y: 7, short_names: ["umbrella_with_rain_drops"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "umbrella,with,rain,drops" }, two_men_holding_hands: { name: "Two Men Holding Hands", unified: "1F46C", sheet_x: 16, sheet_y: 34, short_names: ["two_men_holding_hands"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "two,men,holding,hands,pair,couple,love,like,bromance,friendship,people,human" }, keycap_ten: { name: "Keycap Ten", unified: "1F51F", sheet_x: 23, sheet_y: 15, short_names: ["keycap_ten"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "keycap,ten,numbers,10,blue-square" }, newspaper: { name: "Newspaper", unified: "1F4F0", sheet_x: 22, sheet_y: 10, short_names: ["newspaper"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "newspaper,press,headline" }, keycap_star: { name: "Keycap Star", unified: "002A-20E3", sheet_x: 32, sheet_y: 22, short_names: ["keycap_star"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "keycap,star,asterisk" }, "flag-md": { name: "Regional Indicator Symbol Letters MD", unified: "1F1F2-1F1E9", sheet_x: 36, sheet_y: 13, short_names: ["flag-md"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,md,regional,indicator,symbol,letters" }, two_women_holding_hands: { name: "Two Women Holding Hands", unified: "1F46D", sheet_x: 16, sheet_y: 35, short_names: ["two_women_holding_hands"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "two,women,holding,hands,pair,friendship,couple,love,like,female,people,human" }, droplet: { name: "Droplet", unified: "1F4A7", sheet_x: 20, sheet_y: 14, short_names: ["droplet"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "droplet,water,drip,faucet,spring" }, bow: { name: "Person Bowing Deeply", unified: "1F647", sheet_x: 28, sheet_y: 14, short_names: ["bow"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F647-1F3FB": { unified: "1F647-1F3FB", image: "1f647-1f3fb.png", sheet_x: 28, sheet_y: 15, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F647-1F3FC": { unified: "1F647-1F3FC", image: "1f647-1f3fc.png", sheet_x: 28, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F647-1F3FD": { unified: "1F647-1F3FD", image: "1f647-1f3fd.png", sheet_x: 28, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F647-1F3FE": { unified: "1F647-1F3FE", image: "1f647-1f3fe.png", sheet_x: 28, sheet_y: 18, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F647-1F3FF": { unified: "1F647-1F3FF", image: "1f647-1f3ff.png", sheet_x: 28, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "bow,person,bowing,deeply,man,male,boy" }, notebook: { name: "Notebook", unified: "1F4D3", sheet_x: 21, sheet_y: 22, short_names: ["notebook"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "notebook,stationery,record,notes,paper,study" }, sweat_drops: { name: "Splashing Sweat Symbol", unified: "1F4A6", sheet_x: 20, sheet_y: 13, short_names: ["sweat_drops"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sweat,drops,splashing,symbol,water,drip,oops" }, "flag-mc": { name: "Regional Indicator Symbol Letters MC", unified: "1F1F2-1F1E8", sheet_x: 36, sheet_y: 12, short_names: ["flag-mc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mc,regional,indicator,symbol,letters" }, closed_book: { name: "Closed Book", unified: "1F4D5", sheet_x: 21, sheet_y: 24, short_names: ["closed_book"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "closed,book,read,library,knowledge,textbook,learn" }, "flag-mn": { name: "Regional Indicator Symbol Letters MN", unified: "1F1F2-1F1F3", sheet_x: 36, sheet_y: 21, short_names: ["flag-mn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mn,regional,indicator,symbol,letters" }, arrow_forward: { name: "Black Right-Pointing Triangle", unified: "25B6", variations: ["25B6-FE0F"], sheet_x: 0, sheet_y: 35, short_names: ["arrow_forward"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,forward,black,right,pointing,triangle,blue-square,direction,play" }, information_desk_person: { name: "Information Desk Person", unified: "1F481", sheet_x: 18, sheet_y: 28, short_names: ["information_desk_person"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F481-1F3FB": { unified: "1F481-1F3FB", image: "1f481-1f3fb.png", sheet_x: 18, sheet_y: 29, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F481-1F3FC": { unified: "1F481-1F3FC", image: "1f481-1f3fc.png", sheet_x: 18, sheet_y: 30, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F481-1F3FD": { unified: "1F481-1F3FD", image: "1f481-1f3fd.png", sheet_x: 18, sheet_y: 31, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F481-1F3FE": { unified: "1F481-1F3FE", image: "1f481-1f3fe.png", sheet_x: 18, sheet_y: 32, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F481-1F3FF": { unified: "1F481-1F3FF", image: "1f481-1f3ff.png", sheet_x: 18, sheet_y: 33, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "information,desk,person,female,girl,woman,human" }, ocean: { name: "Water Wave", unified: "1F30A", sheet_x: 5, sheet_y: 31, short_names: ["ocean"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ocean,water,wave,sea,nature,tsunami,disaster" }, double_vertical_bar: { name: "Double Vertical Bar", unified: "23F8", sheet_x: 0, sheet_y: 29, short_names: ["double_vertical_bar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "double,vertical,bar,pause,blue-square" }, green_book: { name: "Green Book", unified: "1F4D7", sheet_x: 21, sheet_y: 26, short_names: ["green_book"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "green,book,read,library,knowledge,study" }, no_good: { name: "Face with No Good Gesture", unified: "1F645", sheet_x: 28, sheet_y: 2, short_names: ["no_good"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F645-1F3FB": { unified: "1F645-1F3FB", image: "1f645-1f3fb.png", sheet_x: 28, sheet_y: 3, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F645-1F3FC": { unified: "1F645-1F3FC", image: "1f645-1f3fc.png", sheet_x: 28, sheet_y: 4, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F645-1F3FD": { unified: "1F645-1F3FD", image: "1f645-1f3fd.png", sheet_x: 28, sheet_y: 5, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F645-1F3FE": { unified: "1F645-1F3FE", image: "1f645-1f3fe.png", sheet_x: 28, sheet_y: 6, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F645-1F3FF": { unified: "1F645-1F3FF", image: "1f645-1f3ff.png", sheet_x: 28, sheet_y: 7, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "no,good,face,with,gesture,female,girl,woman,nope" }, "flag-me": { name: "Regional Indicator Symbol Letters ME", unified: "1F1F2-1F1EA", sheet_x: 36, sheet_y: 14, short_names: ["flag-me"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,me,regional,indicator,symbol,letters" }, "flag-ms": { name: "Regional Indicator Symbol Letters MS", unified: "1F1F2-1F1F8", sheet_x: 36, sheet_y: 26, short_names: ["flag-ms"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ms,regional,indicator,symbol,letters" }, ok_woman: { name: "Face with Ok Gesture", unified: "1F646", sheet_x: 28, sheet_y: 8, short_names: ["ok_woman"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F646-1F3FB": { unified: "1F646-1F3FB", image: "1f646-1f3fb.png", sheet_x: 28, sheet_y: 9, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F646-1F3FC": { unified: "1F646-1F3FC", image: "1f646-1f3fc.png", sheet_x: 28, sheet_y: 10, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F646-1F3FD": { unified: "1F646-1F3FD", image: "1f646-1f3fd.png", sheet_x: 28, sheet_y: 11, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F646-1F3FE": { unified: "1F646-1F3FE", image: "1f646-1f3fe.png", sheet_x: 28, sheet_y: 12, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F646-1F3FF": { unified: "1F646-1F3FF", image: "1f646-1f3ff.png", sheet_x: 28, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "ok,woman,face,with,gesture,women,girl,female,pink,human" }, blue_book: { name: "Blue Book", unified: "1F4D8", sheet_x: 21, sheet_y: 27, short_names: ["blue_book"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "blue,book,read,library,knowledge,learn,study" }, black_right_pointing_triangle_with_double_vertical_bar: { name: "Black Right-Pointing Triangle with Double Vertical Bar", unified: "23EF", sheet_x: 0, sheet_y: 24, short_names: ["black_right_pointing_triangle_with_double_vertical_bar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,right,pointing,triangle,with,double,vertical,bar,forward,next,blue-square" }, raising_hand: { name: "Happy Person Raising One Hand", unified: "1F64B", sheet_x: 28, sheet_y: 23, short_names: ["raising_hand"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F64B-1F3FB": { unified: "1F64B-1F3FB", image: "1f64b-1f3fb.png", sheet_x: 28, sheet_y: 24, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64B-1F3FC": { unified: "1F64B-1F3FC", image: "1f64b-1f3fc.png", sheet_x: 28, sheet_y: 25, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64B-1F3FD": { unified: "1F64B-1F3FD", image: "1f64b-1f3fd.png", sheet_x: 28, sheet_y: 26, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64B-1F3FE": { unified: "1F64B-1F3FE", image: "1f64b-1f3fe.png", sheet_x: 28, sheet_y: 27, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64B-1F3FF": { unified: "1F64B-1F3FF", image: "1f64b-1f3ff.png", sheet_x: 28, sheet_y: 28, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "raising,hand,happy,person,one,female,girl,woman" }, black_square_for_stop: { name: "Black Square for Stop", unified: "23F9", sheet_x: 0, sheet_y: 30, short_names: ["black_square_for_stop"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,square,for,stop,blue-square" }, orange_book: { name: "Orange Book", unified: "1F4D9", sheet_x: 21, sheet_y: 28, short_names: ["orange_book"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "orange,book,read,library,knowledge,textbook,study" }, "flag-ma": { name: "Regional Indicator Symbol Letters MA", unified: "1F1F2-1F1E6", sheet_x: 36, sheet_y: 11, short_names: ["flag-ma"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ma,regional,indicator,symbol,letters" }, "flag-mz": { name: "Regional Indicator Symbol Letters MZ", unified: "1F1F2-1F1FF", sheet_x: 36, sheet_y: 33, short_names: ["flag-mz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mz,regional,indicator,symbol,letters" }, notebook_with_decorative_cover: { name: "Notebook with Decorative Cover", unified: "1F4D4", sheet_x: 21, sheet_y: 23, short_names: ["notebook_with_decorative_cover"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "notebook,with,decorative,cover,classroom,notes,record,paper,study" }, person_with_pouting_face: { name: "Person with Pouting Face", unified: "1F64E", sheet_x: 29, sheet_y: 0, short_names: ["person_with_pouting_face"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F64E-1F3FB": { unified: "1F64E-1F3FB", image: "1f64e-1f3fb.png", sheet_x: 29, sheet_y: 1, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64E-1F3FC": { unified: "1F64E-1F3FC", image: "1f64e-1f3fc.png", sheet_x: 29, sheet_y: 2, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64E-1F3FD": { unified: "1F64E-1F3FD", image: "1f64e-1f3fd.png", sheet_x: 29, sheet_y: 3, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64E-1F3FE": { unified: "1F64E-1F3FE", image: "1f64e-1f3fe.png", sheet_x: 29, sheet_y: 4, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64E-1F3FF": { unified: "1F64E-1F3FF", image: "1f64e-1f3ff.png", sheet_x: 29, sheet_y: 5, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "person,with,pouting,face,female,girl,woman" }, eject: { name: "Eject Symbol", unified: "23CF", sheet_x: 0, sheet_y: 17, short_names: ["eject"], has_img_apple: false, has_img_google: true, has_img_twitter: false, has_img_emojione: false, search: "eject,symbol" }, black_circle_for_record: { name: "Black Circle for Record", unified: "23FA", sheet_x: 0, sheet_y: 31, short_names: ["black_circle_for_record"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,circle,for,record,blue-square" }, "flag-mm": { name: "Regional Indicator Symbol Letters MM", unified: "1F1F2-1F1F2", sheet_x: 36, sheet_y: 20, short_names: ["flag-mm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mm,regional,indicator,symbol,letters" }, person_frowning: { name: "Person Frowning", unified: "1F64D", sheet_x: 28, sheet_y: 35, short_names: ["person_frowning"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F64D-1F3FB": { unified: "1F64D-1F3FB", image: "1f64d-1f3fb.png", sheet_x: 28, sheet_y: 36, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64D-1F3FC": { unified: "1F64D-1F3FC", image: "1f64d-1f3fc.png", sheet_x: 28, sheet_y: 37, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64D-1F3FD": { unified: "1F64D-1F3FD", image: "1f64d-1f3fd.png", sheet_x: 28, sheet_y: 38, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64D-1F3FE": { unified: "1F64D-1F3FE", image: "1f64d-1f3fe.png", sheet_x: 28, sheet_y: 39, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F64D-1F3FF": { unified: "1F64D-1F3FF", image: "1f64d-1f3ff.png", sheet_x: 28, sheet_y: 40, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "person,frowning,female,girl,woman,sad,depressed,discouraged,unhappy" }, ledger: { name: "Ledger", unified: "1F4D2", sheet_x: 21, sheet_y: 21, short_names: ["ledger"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ledger,notes,paper" }, "flag-na": { name: "Regional Indicator Symbol Letters NA", unified: "1F1F3-1F1E6", sheet_x: 36, sheet_y: 34, short_names: ["flag-na"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,na,regional,indicator,symbol,letters" }, haircut: { name: "Haircut", unified: "1F487", sheet_x: 19, sheet_y: 18, short_names: ["haircut"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F487-1F3FB": { unified: "1F487-1F3FB", image: "1f487-1f3fb.png", sheet_x: 19, sheet_y: 19, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F487-1F3FC": { unified: "1F487-1F3FC", image: "1f487-1f3fc.png", sheet_x: 19, sheet_y: 20, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F487-1F3FD": { unified: "1F487-1F3FD", image: "1f487-1f3fd.png", sheet_x: 19, sheet_y: 21, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F487-1F3FE": { unified: "1F487-1F3FE", image: "1f487-1f3fe.png", sheet_x: 19, sheet_y: 22, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F487-1F3FF": { unified: "1F487-1F3FF", image: "1f487-1f3ff.png", sheet_x: 19, sheet_y: 23, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "haircut,female,girl,woman" }, books: { name: "Books", unified: "1F4DA", sheet_x: 21, sheet_y: 29, short_names: ["books"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "books,literature,library,study" }, black_right_pointing_double_triangle_with_vertical_bar: { name: "Black Right-Pointing Double Triangle with Vertical Bar", unified: "23ED", sheet_x: 0, sheet_y: 22, short_names: ["black_right_pointing_double_triangle_with_vertical_bar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,right,pointing,double,triangle,with,vertical,bar,blue-square,play,pause" }, book: { name: "Open Book", unified: "1F4D6", sheet_x: 21, sheet_y: 25, short_names: ["book", "open_book"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "book,open,open_book,read,library,knowledge,literature,learn,study" }, "flag-nr": { name: "Regional Indicator Symbol Letters NR", unified: "1F1F3-1F1F7", sheet_x: 37, sheet_y: 2, short_names: ["flag-nr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,nr,regional,indicator,symbol,letters" }, black_left_pointing_double_triangle_with_vertical_bar: { name: "Black Left-Pointing Double Triangle with Vertical Bar", unified: "23EE", sheet_x: 0, sheet_y: 23, short_names: ["black_left_pointing_double_triangle_with_vertical_bar"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,left,pointing,double,triangle,with,vertical,bar,backward" }, massage: { name: "Face Massage", unified: "1F486", sheet_x: 19, sheet_y: 12, short_names: ["massage"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, skin_variations: { "1F486-1F3FB": { unified: "1F486-1F3FB", image: "1f486-1f3fb.png", sheet_x: 19, sheet_y: 13, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F486-1F3FC": { unified: "1F486-1F3FC", image: "1f486-1f3fc.png", sheet_x: 19, sheet_y: 14, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F486-1F3FD": { unified: "1F486-1F3FD", image: "1f486-1f3fd.png", sheet_x: 19, sheet_y: 15, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F486-1F3FE": { unified: "1F486-1F3FE", image: "1f486-1f3fe.png", sheet_x: 19, sheet_y: 16, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true }, "1F486-1F3FF": { unified: "1F486-1F3FF", image: "1f486-1f3ff.png", sheet_x: 19, sheet_y: 17, has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true } }, search: "massage,face,female,girl,woman,head" }, couple_with_heart: { name: "Couple with Heart", unified: "1F491", sheet_x: 19, sheet_y: 33, short_names: ["couple_with_heart"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "couple,with,heart,pair,love,like,affection,human,dating,valentines,marriage" }, fast_forward: { name: "Black Right-Pointing Double Triangle", unified: "23E9", sheet_x: 0, sheet_y: 18, short_names: ["fast_forward"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "fast,forward,black,right,pointing,double,triangle,blue-square,play,speed,continue" }, "flag-np": { name: "Regional Indicator Symbol Letters NP", unified: "1F1F3-1F1F5", sheet_x: 37, sheet_y: 1, short_names: ["flag-np"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,np,regional,indicator,symbol,letters" }, link: { name: "Link Symbol", unified: "1F517", sheet_x: 23, sheet_y: 7, short_names: ["link"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "link,symbol,rings,url" }, paperclip: { name: "Paperclip", unified: "1F4CE", sheet_x: 21, sheet_y: 17, short_names: ["paperclip"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "paperclip,documents,stationery" }, rewind: { name: "Black Left-Pointing Double Triangle", unified: "23EA", sheet_x: 0, sheet_y: 19, short_names: ["rewind"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "rewind,black,left,pointing,double,triangle,play,blue-square" }, "woman-heart-woman": { name: "Woman Heart Woman", unified: "1F469-200D-2764-FE0F-200D-1F469", sheet_x: 39, sheet_y: 19, short_names: ["woman-heart-woman"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: false, search: "woman,heart" }, "flag-nl": { name: "Regional Indicator Symbol Letters NL", unified: "1F1F3-1F1F1", sheet_x: 36, sheet_y: 40, short_names: ["flag-nl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,nl,regional,indicator,symbol,letters" }, linked_paperclips: { name: "Linked Paperclips", unified: "1F587", sheet_x: 25, sheet_y: 8, short_names: ["linked_paperclips"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "linked,paperclips,documents,stationery" }, "man-heart-man": { name: "Man Heart Man", unified: "1F468-200D-2764-FE0F-200D-1F468", sheet_x: 39, sheet_y: 12, short_names: ["man-heart-man"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: false, search: "man,heart" }, "flag-nc": { name: "Regional Indicator Symbol Letters NC", unified: "1F1F3-1F1E8", sheet_x: 36, sheet_y: 35, short_names: ["flag-nc"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,nc,regional,indicator,symbol,letters" }, twisted_rightwards_arrows: { name: "Twisted Rightwards Arrows", unified: "1F500", sheet_x: 22, sheet_y: 25, short_names: ["twisted_rightwards_arrows"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "twisted,rightwards,arrows,blue-square,shuffle,music,random" }, couplekiss: { name: "Kiss", unified: "1F48F", sheet_x: 19, sheet_y: 31, short_names: ["couplekiss"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "couplekiss,kiss,pair,valentines,love,like,dating,marriage" }, "flag-nz": { name: "Regional Indicator Symbol Letters NZ", unified: "1F1F3-1F1FF", sheet_x: 37, sheet_y: 4, short_names: ["flag-nz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,nz,regional,indicator,symbol,letters" }, scissors: { name: "Black Scissors", unified: "2702", variations: ["2702-FE0F"], sheet_x: 3, sheet_y: 5, short_names: ["scissors"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "scissors,black,stationery,cut" }, repeat: { name: "Clockwise Rightwards and Leftwards Open Circle Arrows", unified: "1F501", sheet_x: 22, sheet_y: 26, short_names: ["repeat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "repeat,clockwise,rightwards,and,leftwards,open,circle,arrows,loop,record" }, repeat_one: { name: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay", unified: "1F502", sheet_x: 22, sheet_y: 27, short_names: ["repeat_one"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "repeat,one,clockwise,rightwards,and,leftwards,open,circle,arrows,with,circled,overlay,blue-square,loop" }, "flag-ni": { name: "Regional Indicator Symbol Letters NI", unified: "1F1F3-1F1EE", sheet_x: 36, sheet_y: 39, short_names: ["flag-ni"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ni,regional,indicator,symbol,letters" }, "woman-kiss-woman": { name: "Woman Kiss Woman", unified: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469", sheet_x: 39, sheet_y: 20, short_names: ["woman-kiss-woman"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: false, search: "woman,kiss" }, triangular_ruler: { name: "Triangular Ruler", unified: "1F4D0", sheet_x: 21, sheet_y: 19, short_names: ["triangular_ruler"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "triangular,ruler,stationery,math,architect,sketch" }, straight_ruler: { name: "Straight Ruler", unified: "1F4CF", sheet_x: 21, sheet_y: 18, short_names: ["straight_ruler"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "straight,ruler,stationery,calculate,length,math,school,drawing,architect,sketch" }, "flag-ne": { name: "Regional Indicator Symbol Letters NE", unified: "1F1F3-1F1EA", sheet_x: 36, sheet_y: 36, short_names: ["flag-ne"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ne,regional,indicator,symbol,letters" }, "man-kiss-man": { name: "Man Kiss Man", unified: "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468", sheet_x: 39, sheet_y: 13, short_names: ["man-kiss-man"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: false, search: "man,kiss" }, arrow_backward: { name: "Black Left-Pointing Triangle", unified: "25C0", variations: ["25C0-FE0F"], sheet_x: 0, sheet_y: 36, short_names: ["arrow_backward"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,backward,black,left,pointing,triangle,blue-square,direction" }, arrow_up_small: { name: "Up-Pointing Small Red Triangle", unified: "1F53C", sheet_x: 24, sheet_y: 3, short_names: ["arrow_up_small"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,up,small,pointing,red,triangle,blue-square,direction,point,forward,top" }, "flag-ng": { name: "Regional Indicator Symbol Letters NG", unified: "1F1F3-1F1EC", sheet_x: 36, sheet_y: 38, short_names: ["flag-ng"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ng,regional,indicator,symbol,letters" }, family: { name: "Family", unified: "1F46A", variations: ["1F468-200D-1F469-200D-1F466"], sheet_x: 16, sheet_y: 32, short_names: ["family", "man-woman-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "family,man,woman,boy,home,parents,child,mom,dad,father,mother,people,human" }, pushpin: { name: "Pushpin", unified: "1F4CC", sheet_x: 21, sheet_y: 15, short_names: ["pushpin"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pushpin,stationery,mark,here" }, "man-woman-girl": { name: "Man Woman Girl", unified: "1F468-200D-1F469-200D-1F467", sheet_x: 39, sheet_y: 9, short_names: ["man-woman-girl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,woman,girl" }, round_pushpin: { name: "Round Pushpin", unified: "1F4CD", sheet_x: 21, sheet_y: 16, short_names: ["round_pushpin"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "round,pushpin,stationery,location,map,here" }, arrow_down_small: { name: "Down-Pointing Small Red Triangle", unified: "1F53D", sheet_x: 24, sheet_y: 4, short_names: ["arrow_down_small"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,down,small,pointing,red,triangle,blue-square,direction,bottom" }, "flag-nu": { name: "Regional Indicator Symbol Letters NU", unified: "1F1F3-1F1FA", sheet_x: 37, sheet_y: 3, short_names: ["flag-nu"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,nu,regional,indicator,symbol,letters" }, "flag-nf": { name: "Regional Indicator Symbol Letters NF", unified: "1F1F3-1F1EB", sheet_x: 36, sheet_y: 37, short_names: ["flag-nf"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,nf,regional,indicator,symbol,letters" }, triangular_flag_on_post: { name: "Triangular Flag on Post", unified: "1F6A9", sheet_x: 30, sheet_y: 17, short_names: ["triangular_flag_on_post"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "triangular,flag,on,post,mark,milestone,place" }, "man-woman-girl-boy": { name: "Man Woman Girl Boy", unified: "1F468-200D-1F469-200D-1F467-200D-1F466", sheet_x: 39, sheet_y: 10, short_names: ["man-woman-girl-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,woman,girl,boy" }, arrow_double_up: { name: "Black Up-Pointing Double Triangle", unified: "23EB", sheet_x: 0, sheet_y: 20, short_names: ["arrow_double_up"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,double,up,black,pointing,triangle,blue-square,direction,top" }, "man-woman-boy-boy": { name: "Man Woman Boy Boy", unified: "1F468-200D-1F469-200D-1F466-200D-1F466", sheet_x: 39, sheet_y: 8, short_names: ["man-woman-boy-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,woman,boy" }, "flag-mp": { name: "Regional Indicator Symbol Letters MP", unified: "1F1F2-1F1F5", sheet_x: 36, sheet_y: 23, short_names: ["flag-mp"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,mp,regional,indicator,symbol,letters" }, waving_white_flag: { name: "Waving White Flag", unified: "1F3F3", sheet_x: 11, sheet_y: 34, short_names: ["waving_white_flag"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "waving,white,flag,losing,loser,lost,surrender,give up,fail" }, arrow_double_down: { name: "Black Down-Pointing Double Triangle", unified: "23EC", sheet_x: 0, sheet_y: 21, short_names: ["arrow_double_down"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,double,down,black,pointing,triangle,blue-square,direction,bottom" }, "man-woman-girl-girl": { name: "Man Woman Girl Girl", unified: "1F468-200D-1F469-200D-1F467-200D-1F467", sheet_x: 39, sheet_y: 11, short_names: ["man-woman-girl-girl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,woman,girl" }, "flag-kp": { name: "Regional Indicator Symbol Letters KP", unified: "1F1F0-1F1F5", sheet_x: 35, sheet_y: 36, short_names: ["flag-kp"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,kp,regional,indicator,symbol,letters" }, waving_black_flag: { name: "Waving Black Flag", unified: "1F3F4", sheet_x: 11, sheet_y: 35, short_names: ["waving_black_flag"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "waving,black,flag,pirate" }, arrow_right: { name: "Black Rightwards Arrow", unified: "27A1", variations: ["27A1-FE0F"], sheet_x: 4, sheet_y: 14, short_names: ["arrow_right"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,right,black,rightwards,blue-square,next" }, "flag-no": { name: "Regional Indicator Symbol Letters NO", unified: "1F1F3-1F1F4", sheet_x: 37, sheet_y: 0, short_names: ["flag-no"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,no,regional,indicator,symbol,letters" }, "woman-woman-boy": { name: "Woman Woman Boy", unified: "1F469-200D-1F469-200D-1F466", sheet_x: 39, sheet_y: 14, short_names: ["woman-woman-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "woman,boy" }, arrow_left: { name: "Leftwards Black Arrow", unified: "2B05", variations: ["2B05-FE0F"], sheet_x: 4, sheet_y: 19, short_names: ["arrow_left"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,left,leftwards,black,blue-square,previous,back" }, closed_lock_with_key: { name: "Closed Lock with Key", unified: "1F510", sheet_x: 23, sheet_y: 0, short_names: ["closed_lock_with_key"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "closed,lock,with,key,security,privacy" }, "flag-om": { name: "Regional Indicator Symbol Letters OM", unified: "1F1F4-1F1F2", sheet_x: 37, sheet_y: 5, short_names: ["flag-om"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,om,regional,indicator,symbol,letters" }, lock: { name: "Lock", unified: "1F512", sheet_x: 23, sheet_y: 2, short_names: ["lock"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lock,security,password,padlock" }, arrow_up: { name: "Upwards Black Arrow", unified: "2B06", variations: ["2B06-FE0F"], sheet_x: 4, sheet_y: 20, short_names: ["arrow_up"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,up,upwards,black,blue-square,continue,top,direction" }, "woman-woman-girl": { name: "Woman Woman Girl", unified: "1F469-200D-1F469-200D-1F467", sheet_x: 39, sheet_y: 16, short_names: ["woman-woman-girl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "woman,girl" }, arrow_down: { name: "Downwards Black Arrow", unified: "2B07", variations: ["2B07-FE0F"], sheet_x: 4, sheet_y: 21, short_names: ["arrow_down"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,down,downwards,black,blue-square,direction,bottom" }, "flag-pk": { name: "Regional Indicator Symbol Letters PK", unified: "1F1F5-1F1F0", sheet_x: 37, sheet_y: 11, short_names: ["flag-pk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pk,regional,indicator,symbol,letters" }, "woman-woman-girl-boy": { name: "Woman Woman Girl Boy", unified: "1F469-200D-1F469-200D-1F467-200D-1F466", sheet_x: 39, sheet_y: 17, short_names: ["woman-woman-girl-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "woman,girl,boy" }, unlock: { name: "Open Lock", unified: "1F513", sheet_x: 23, sheet_y: 3, short_names: ["unlock"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "unlock,open,lock,privacy,security" }, "woman-woman-boy-boy": { name: "Woman Woman Boy Boy", unified: "1F469-200D-1F469-200D-1F466-200D-1F466", sheet_x: 39, sheet_y: 15, short_names: ["woman-woman-boy-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "woman,boy" }, lock_with_ink_pen: { name: "Lock with Ink Pen", unified: "1F50F", sheet_x: 22, sheet_y: 40, short_names: ["lock_with_ink_pen"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lock,with,ink,pen,security,secret" }, "flag-pw": { name: "Regional Indicator Symbol Letters PW", unified: "1F1F5-1F1FC", sheet_x: 37, sheet_y: 18, short_names: ["flag-pw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pw,regional,indicator,symbol,letters" }, arrow_upper_right: { name: "North East Arrow", unified: "2197", variations: ["2197-FE0F"], sheet_x: 0, sheet_y: 9, short_names: ["arrow_upper_right"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,upper,right,north,east,blue-square,point,direction,diagonal,northeast" }, "woman-woman-girl-girl": { name: "Woman Woman Girl Girl", unified: "1F469-200D-1F469-200D-1F467-200D-1F467", sheet_x: 39, sheet_y: 18, short_names: ["woman-woman-girl-girl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "woman,girl" }, arrow_lower_right: { name: "South East Arrow", unified: "2198", variations: ["2198-FE0F"], sheet_x: 0, sheet_y: 10, short_names: ["arrow_lower_right"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,lower,right,south,east,blue-square,direction,diagonal,southeast" }, lower_left_ballpoint_pen: { name: "Lower Left Ballpoint Pen", unified: "1F58A", sheet_x: 25, sheet_y: 9, short_names: ["lower_left_ballpoint_pen"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lower,left,ballpoint,pen,stationery,writing,write" }, "flag-ps": { name: "Regional Indicator Symbol Letters PS", unified: "1F1F5-1F1F8", sheet_x: 37, sheet_y: 16, short_names: ["flag-ps"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ps,regional,indicator,symbol,letters" }, "flag-pa": { name: "Regional Indicator Symbol Letters PA", unified: "1F1F5-1F1E6", sheet_x: 37, sheet_y: 6, short_names: ["flag-pa"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pa,regional,indicator,symbol,letters" }, lower_left_fountain_pen: { name: "Lower Left Fountain Pen", unified: "1F58B", sheet_x: 25, sheet_y: 10, short_names: ["lower_left_fountain_pen"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lower,left,fountain,pen,stationery,writing,write" }, arrow_lower_left: { name: "South West Arrow", unified: "2199", variations: ["2199-FE0F"], sheet_x: 0, sheet_y: 11, short_names: ["arrow_lower_left"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,lower,left,south,west,blue-square,direction,diagonal,southwest" }, "man-man-boy": { name: "Man Man Boy", unified: "1F468-200D-1F468-200D-1F466", sheet_x: 39, sheet_y: 3, short_names: ["man-man-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,boy" }, black_nib: { name: "Black Nib", unified: "2712", variations: ["2712-FE0F"], sheet_x: 3, sheet_y: 34, short_names: ["black_nib"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,nib,pen,stationery,writing,write" }, "flag-pg": { name: "Regional Indicator Symbol Letters PG", unified: "1F1F5-1F1EC", sheet_x: 37, sheet_y: 9, short_names: ["flag-pg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pg,regional,indicator,symbol,letters" }, arrow_upper_left: { name: "North West Arrow", unified: "2196", variations: ["2196-FE0F"], sheet_x: 0, sheet_y: 8, short_names: ["arrow_upper_left"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,upper,left,north,west,blue-square,point,direction,diagonal,northwest" }, "man-man-girl": { name: "Man Man Girl", unified: "1F468-200D-1F468-200D-1F467", sheet_x: 39, sheet_y: 5, short_names: ["man-man-girl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,girl" }, "man-man-girl-boy": { name: "Man Man Girl Boy", unified: "1F468-200D-1F468-200D-1F467-200D-1F466", sheet_x: 39, sheet_y: 6, short_names: ["man-man-girl-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,girl,boy" }, arrow_up_down: { name: "Up Down Arrow", unified: "2195", variations: ["2195-FE0F"], sheet_x: 0, sheet_y: 7, short_names: ["arrow_up_down"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,up,down,blue-square,direction,way,vertical" }, memo: { name: "Memo", unified: "1F4DD", sheet_x: 21, sheet_y: 32, short_names: ["memo", "pencil"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "memo,pencil,write,documents,stationery,paper,writing,legal,exam,quiz,test,study" }, "flag-py": { name: "Regional Indicator Symbol Letters PY", unified: "1F1F5-1F1FE", sheet_x: 37, sheet_y: 19, short_names: ["flag-py"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,py,regional,indicator,symbol,letters" }, "flag-pe": { name: "Regional Indicator Symbol Letters PE", unified: "1F1F5-1F1EA", sheet_x: 37, sheet_y: 7, short_names: ["flag-pe"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pe,regional,indicator,symbol,letters" }, "pencil2": { name: "Pencil", unified: "270F", variations: ["270F-FE0F"], sheet_x: 3, sheet_y: 33, short_names: ["pencil2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pencil2,pencil,stationery,write,paper,writing,school,study" }, "man-man-boy-boy": { name: "Man Man Boy Boy", unified: "1F468-200D-1F468-200D-1F466-200D-1F466", sheet_x: 39, sheet_y: 4, short_names: ["man-man-boy-boy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,boy" }, left_right_arrow: { name: "Left Right Arrow", unified: "2194", variations: ["2194-FE0F"], sheet_x: 0, sheet_y: 6, short_names: ["left_right_arrow"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "left,right,arrow,shape,direction,horizontal,sideways" }, "man-man-girl-girl": { name: "Man Man Girl Girl", unified: "1F468-200D-1F468-200D-1F467-200D-1F467", sheet_x: 39, sheet_y: 7, short_names: ["man-man-girl-girl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "man,girl" }, arrows_counterclockwise: { name: "Anticlockwise Downwards and Upwards Open Circle Arrows", unified: "1F504", sheet_x: 22, sheet_y: 29, short_names: ["arrows_counterclockwise"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrows,counterclockwise,anticlockwise,downwards,and,upwards,open,circle,blue-square,sync,cycle" }, "flag-ph": { name: "Regional Indicator Symbol Letters PH", unified: "1F1F5-1F1ED", sheet_x: 37, sheet_y: 10, short_names: ["flag-ph"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ph,regional,indicator,symbol,letters" }, lower_left_crayon: { name: "Lower Left Crayon", unified: "1F58D", sheet_x: 25, sheet_y: 12, short_names: ["lower_left_crayon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lower,left,crayon,drawing,creativity" }, womans_clothes: { name: "Womans Clothes", unified: "1F45A", sheet_x: 15, sheet_y: 37, short_names: ["womans_clothes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "womans,clothes,fashion,shopping,female" }, lower_left_paintbrush: { name: "Lower Left Paintbrush", unified: "1F58C", sheet_x: 25, sheet_y: 11, short_names: ["lower_left_paintbrush"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lower,left,paintbrush,drawing,creativity,art" }, "flag-pn": { name: "Regional Indicator Symbol Letters PN", unified: "1F1F5-1F1F3", sheet_x: 37, sheet_y: 14, short_names: ["flag-pn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pn,regional,indicator,symbol,letters" }, arrow_right_hook: { name: "Rightwards Arrow with Hook", unified: "21AA", variations: ["21AA-FE0F"], sheet_x: 0, sheet_y: 13, short_names: ["arrow_right_hook"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,right,hook,rightwards,with,blue-square,return,rotade,direction" }, leftwards_arrow_with_hook: { name: "Leftwards Arrow with Hook", unified: "21A9", variations: ["21A9-FE0F"], sheet_x: 0, sheet_y: 12, short_names: ["leftwards_arrow_with_hook"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "leftwards,arrow,with,hook,back,return,blue-square,undo,enter" }, mag: { name: "Left-Pointing Magnifying Glass", unified: "1F50D", sheet_x: 22, sheet_y: 38, short_names: ["mag"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mag,left,pointing,magnifying,glass,search,zoom,find,detective" }, "flag-pl": { name: "Regional Indicator Symbol Letters PL", unified: "1F1F5-1F1F1", sheet_x: 37, sheet_y: 12, short_names: ["flag-pl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pl,regional,indicator,symbol,letters" }, shirt: { name: "T-Shirt", unified: "1F455", sheet_x: 15, sheet_y: 32, short_names: ["shirt", "tshirt"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "shirt,tshirt,t,fashion,cloth,casual,tee" }, "flag-pt": { name: "Regional Indicator Symbol Letters PT", unified: "1F1F5-1F1F9", sheet_x: 37, sheet_y: 17, short_names: ["flag-pt"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pt,regional,indicator,symbol,letters" }, jeans: { name: "Jeans", unified: "1F456", sheet_x: 15, sheet_y: 33, short_names: ["jeans"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "jeans,fashion,shopping" }, mag_right: { name: "Right-Pointing Magnifying Glass", unified: "1F50E", sheet_x: 22, sheet_y: 39, short_names: ["mag_right"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mag,right,pointing,magnifying,glass,search,zoom,find,detective" }, arrow_heading_up: { name: "Arrow Pointing Rightwards Then Curving Upwards", unified: "2934", variations: ["2934-FE0F"], sheet_x: 4, sheet_y: 17, short_names: ["arrow_heading_up"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,heading,up,pointing,rightwards,then,curving,upwards,blue-square,direction,top" }, necktie: { name: "Necktie", unified: "1F454", sheet_x: 15, sheet_y: 31, short_names: ["necktie"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "necktie,shirt,suitup,formal,fashion,cloth,business" }, "flag-pr": { name: "Regional Indicator Symbol Letters PR", unified: "1F1F5-1F1F7", sheet_x: 37, sheet_y: 15, short_names: ["flag-pr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,pr,regional,indicator,symbol,letters" }, arrow_heading_down: { name: "Arrow Pointing Rightwards Then Curving Downwards", unified: "2935", variations: ["2935-FE0F"], sheet_x: 4, sheet_y: 18, short_names: ["arrow_heading_down"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrow,heading,down,pointing,rightwards,then,curving,downwards,blue-square,direction,bottom" }, dress: { name: "Dress", unified: "1F457", sheet_x: 15, sheet_y: 34, short_names: ["dress"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dress,clothes,fashion,shopping" }, "flag-qa": { name: "Regional Indicator Symbol Letters QA", unified: "1F1F6-1F1E6", sheet_x: 37, sheet_y: 20, short_names: ["flag-qa"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,qa,regional,indicator,symbol,letters" }, hash: { name: "Hash Key", unified: "0023-20E3", variations: ["0023-FE0F-20E3"], sheet_x: 32, sheet_y: 21, short_names: ["hash"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hash,key,symbol,blue-square,twitter" }, "flag-re": { name: "Regional Indicator Symbol Letters RE", unified: "1F1F7-1F1EA", sheet_x: 37, sheet_y: 21, short_names: ["flag-re"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,re,regional,indicator,symbol,letters" }, bikini: { name: "Bikini", unified: "1F459", sheet_x: 15, sheet_y: 36, short_names: ["bikini"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bikini,swimming,female,woman,girl,fashion,beach,summer" }, information_source: { name: "Information Source", unified: "2139", variations: ["2139-FE0F"], sheet_x: 0, sheet_y: 5, short_names: ["information_source"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "information,source,blue-square,alphabet,letter" }, kimono: { name: "Kimono", unified: "1F458", sheet_x: 15, sheet_y: 35, short_names: ["kimono"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "kimono,dress,fashion,women,female,japanese" }, abc: { name: "Input Symbol for Latin Letters", unified: "1F524", sheet_x: 23, sheet_y: 20, short_names: ["abc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "abc,input,symbol,for,latin,letters,blue-square,alphabet" }, "flag-ro": { name: "Regional Indicator Symbol Letters RO", unified: "1F1F7-1F1F4", sheet_x: 37, sheet_y: 22, short_names: ["flag-ro"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ro,regional,indicator,symbol,letters" }, lipstick: { name: "Lipstick", unified: "1F484", sheet_x: 19, sheet_y: 5, short_names: ["lipstick"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "lipstick,female,girl,fashion,woman" }, "flag-ru": { name: "Regional Indicator Symbol Letters RU", unified: "1F1F7-1F1FA", sheet_x: 37, sheet_y: 24, short_names: ["flag-ru", "ru"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ru,regional,indicator,symbol,letters" }, abcd: { name: "Input Symbol for Latin Small Letters", unified: "1F521", sheet_x: 23, sheet_y: 17, short_names: ["abcd"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "abcd,input,symbol,for,latin,small,letters,blue-square,alphabet" }, kiss: { name: "Kiss Mark", unified: "1F48B", sheet_x: 19, sheet_y: 27, short_names: ["kiss"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, emoticons: [":*", ":-*"], search: "kiss,mark,face,lips,love,like,affection,valentines,:*,:-*" }, capital_abcd: { name: "Input Symbol for Latin Capital Letters", unified: "1F520", sheet_x: 23, sheet_y: 16, short_names: ["capital_abcd"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "capital,abcd,input,symbol,for,latin,letters,alphabet,words,blue-square" }, "flag-rw": { name: "Regional Indicator Symbol Letters RW", unified: "1F1F7-1F1FC", sheet_x: 37, sheet_y: 25, short_names: ["flag-rw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,rw,regional,indicator,symbol,letters" }, footprints: { name: "Footprints", unified: "1F463", sheet_x: 16, sheet_y: 5, short_names: ["footprints"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "footprints,feet,tracking,walking,beach" }, "flag-bl": { name: "Regional Indicator Symbol Letters BL", unified: "1F1E7-1F1F1", sheet_x: 33, sheet_y: 18, short_names: ["flag-bl"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,bl,regional,indicator,symbol,letters" }, symbols: { name: "Input Symbol for Symbols", unified: "1F523", sheet_x: 23, sheet_y: 19, short_names: ["symbols"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "symbols,input,symbol,for,blue-square,music,note,ampersand,percent,glyphs,characters" }, high_heel: { name: "High-Heeled Shoe", unified: "1F460", sheet_x: 16, sheet_y: 2, short_names: ["high_heel"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "high,heel,heeled,shoe,fashion,shoes,female,pumps,stiletto" }, musical_note: { name: "Musical Note", unified: "1F3B5", sheet_x: 9, sheet_y: 36, short_names: ["musical_note"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "musical,note,score,tone,sound" }, "flag-sh": { name: "Regional Indicator Symbol Letters SH", unified: "1F1F8-1F1ED", sheet_x: 37, sheet_y: 32, short_names: ["flag-sh"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,sh,regional,indicator,symbol,letters" }, "flag-kn": { name: "Regional Indicator Symbol Letters KN", unified: "1F1F0-1F1F3", sheet_x: 35, sheet_y: 35, short_names: ["flag-kn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,kn,regional,indicator,symbol,letters" }, notes: { name: "Multiple Musical Notes", unified: "1F3B6", sheet_x: 9, sheet_y: 37, short_names: ["notes"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "notes,multiple,musical,music,score" }, sandal: { name: "Womans Sandal", unified: "1F461", sheet_x: 16, sheet_y: 3, short_names: ["sandal"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sandal,womans,shoes,fashion,flip flops" }, boot: { name: "Womans Boots", unified: "1F462", sheet_x: 16, sheet_y: 4, short_names: ["boot"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "boot,womans,boots,shoes,fashion" }, wavy_dash: { name: "Wavy Dash", unified: "3030", variations: ["3030-FE0F"], sheet_x: 4, sheet_y: 26, short_names: ["wavy_dash"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "wavy,dash,draw,line,moustache,mustache,squiggle,scribble" }, "flag-lc": { name: "Regional Indicator Symbol Letters LC", unified: "1F1F1-1F1E8", sheet_x: 36, sheet_y: 2, short_names: ["flag-lc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,lc,regional,indicator,symbol,letters" }, "flag-pm": { name: "Regional Indicator Symbol Letters PM", unified: "1F1F5-1F1F2", sheet_x: 37, sheet_y: 13, short_names: ["flag-pm"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,pm,regional,indicator,symbol,letters" }, mans_shoe: { name: "Mans Shoe", unified: "1F45E", sheet_x: 16, sheet_y: 0, short_names: ["mans_shoe", "shoe"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mans,shoe,fashion,male" }, curly_loop: { name: "Curly Loop", unified: "27B0", sheet_x: 4, sheet_y: 15, short_names: ["curly_loop"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "curly,loop,scribble,draw,shape,squiggle" }, "flag-vc": { name: "Regional Indicator Symbol Letters VC", unified: "1F1FB-1F1E8", sheet_x: 38, sheet_y: 30, short_names: ["flag-vc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,vc,regional,indicator,symbol,letters" }, heavy_check_mark: { name: "Heavy Check Mark", unified: "2714", variations: ["2714-FE0F"], sheet_x: 3, sheet_y: 35, short_names: ["heavy_check_mark"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heavy,check,mark,ok,nike,answer,yes,tick" }, athletic_shoe: { name: "Athletic Shoe", unified: "1F45F", sheet_x: 16, sheet_y: 1, short_names: ["athletic_shoe"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "athletic,shoe,shoes,sports,sneakers" }, womans_hat: { name: "Womans Hat", unified: "1F452", sheet_x: 15, sheet_y: 29, short_names: ["womans_hat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "womans,hat,fashion,accessories,female,lady,spring" }, "flag-ws": { name: "Regional Indicator Symbol Letters WS", unified: "1F1FC-1F1F8", sheet_x: 38, sheet_y: 37, short_names: ["flag-ws"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ws,regional,indicator,symbol,letters" }, arrows_clockwise: { name: "Clockwise Downwards and Upwards Open Circle Arrows", unified: "1F503", sheet_x: 22, sheet_y: 28, short_names: ["arrows_clockwise"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "arrows,clockwise,downwards,and,upwards,open,circle,sync,cycle,round,repeat" }, heavy_plus_sign: { name: "Heavy Plus Sign", unified: "2795", sheet_x: 4, sheet_y: 11, short_names: ["heavy_plus_sign"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heavy,plus,sign,math,calculation,addition,more,increase" }, tophat: { name: "Top Hat", unified: "1F3A9", sheet_x: 9, sheet_y: 24, short_names: ["tophat"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "tophat,top,hat,magic,gentleman,classy,circus" }, "flag-sm": { name: "Regional Indicator Symbol Letters SM", unified: "1F1F8-1F1F2", sheet_x: 37, sheet_y: 37, short_names: ["flag-sm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sm,regional,indicator,symbol,letters" }, helmet_with_white_cross: { name: "Helmet with White Cross", unified: "26D1", sheet_x: 2, sheet_y: 25, short_names: ["helmet_with_white_cross"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "helmet,with,white,cross" }, heavy_minus_sign: { name: "Heavy Minus Sign", unified: "2796", sheet_x: 4, sheet_y: 12, short_names: ["heavy_minus_sign"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heavy,minus,sign,math,calculation,subtract,less" }, "flag-st": { name: "Regional Indicator Symbol Letters ST", unified: "1F1F8-1F1F9", sheet_x: 38, sheet_y: 1, short_names: ["flag-st"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,st,regional,indicator,symbol,letters" }, "flag-sa": { name: "Regional Indicator Symbol Letters SA", unified: "1F1F8-1F1E6", sheet_x: 37, sheet_y: 26, short_names: ["flag-sa"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sa,regional,indicator,symbol,letters" }, heavy_division_sign: { name: "Heavy Division Sign", unified: "2797", sheet_x: 4, sheet_y: 13, short_names: ["heavy_division_sign"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heavy,division,sign,divide,math,calculation" }, mortar_board: { name: "Graduation Cap", unified: "1F393", sheet_x: 9, sheet_y: 7, short_names: ["mortar_board"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mortar,board,graduation,cap,school,college,degree,university,hat,legal,learn,education" }, "flag-sn": { name: "Regional Indicator Symbol Letters SN", unified: "1F1F8-1F1F3", sheet_x: 37, sheet_y: 38, short_names: ["flag-sn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sn,regional,indicator,symbol,letters" }, heavy_multiplication_x: { name: "Heavy Multiplication X", unified: "2716", variations: ["2716-FE0F"], sheet_x: 3, sheet_y: 36, short_names: ["heavy_multiplication_x"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heavy,multiplication,x,math,calculation" }, crown: { name: "Crown", unified: "1F451", sheet_x: 15, sheet_y: 28, short_names: ["crown"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "crown,king,kod,leader,royalty,lord" }, school_satchel: { name: "School Satchel", unified: "1F392", sheet_x: 9, sheet_y: 6, short_names: ["school_satchel"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "school,satchel,student,education,bag" }, "flag-rs": { name: "Regional Indicator Symbol Letters RS", unified: "1F1F7-1F1F8", sheet_x: 37, sheet_y: 23, short_names: ["flag-rs"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,rs,regional,indicator,symbol,letters" }, heavy_dollar_sign: { name: "Heavy Dollar Sign", unified: "1F4B2", sheet_x: 20, sheet_y: 30, short_names: ["heavy_dollar_sign"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "heavy,dollar,sign,money,sales,payment,currency,buck" }, "flag-sc": { name: "Regional Indicator Symbol Letters SC", unified: "1F1F8-1F1E8", sheet_x: 37, sheet_y: 28, short_names: ["flag-sc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sc,regional,indicator,symbol,letters" }, currency_exchange: { name: "Currency Exchange", unified: "1F4B1", sheet_x: 20, sheet_y: 29, short_names: ["currency_exchange"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "currency,exchange,money,sales,dollar,travel" }, pouch: { name: "Pouch", unified: "1F45D", sheet_x: 15, sheet_y: 40, short_names: ["pouch"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "pouch,bag,accessories,shopping" }, purse: { name: "Purse", unified: "1F45B", sheet_x: 15, sheet_y: 38, short_names: ["purse"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "purse,fashion,accessories,money,sales,shopping" }, "flag-sl": { name: "Regional Indicator Symbol Letters SL", unified: "1F1F8-1F1F1", sheet_x: 37, sheet_y: 36, short_names: ["flag-sl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sl,regional,indicator,symbol,letters" }, copyright: { name: "Copyright Sign", unified: "00A9", variations: ["00A9-FE0F"], sheet_x: 0, sheet_y: 0, short_names: ["copyright"], has_img_apple: true, has_img_google: true, has_img_twitter: false, has_img_emojione: true, search: "copyright,sign,ip,license,circle,law,legal" }, handbag: { name: "Handbag", unified: "1F45C", sheet_x: 15, sheet_y: 39, short_names: ["handbag"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "handbag,fashion,accessory,accessories,shopping" }, "flag-sg": { name: "Regional Indicator Symbol Letters SG", unified: "1F1F8-1F1EC", sheet_x: 37, sheet_y: 31, short_names: ["flag-sg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sg,regional,indicator,symbol,letters" }, registered: { name: "Registered Sign", unified: "00AE", variations: ["00AE-FE0F"], sheet_x: 0, sheet_y: 1, short_names: ["registered"], has_img_apple: true, has_img_google: true, has_img_twitter: false, has_img_emojione: true, search: "registered,sign,alphabet,circle" }, briefcase: { name: "Briefcase", unified: "1F4BC", sheet_x: 20, sheet_y: 40, short_names: ["briefcase"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "briefcase,business,documents,work,law,legal" }, "flag-sx": { name: "Regional Indicator Symbol Letters SX", unified: "1F1F8-1F1FD", sheet_x: 38, sheet_y: 3, short_names: ["flag-sx"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sx,regional,indicator,symbol,letters" }, tm: { name: "Trade Mark Sign", unified: "2122", variations: ["2122-FE0F"], sheet_x: 0, sheet_y: 4, short_names: ["tm"], has_img_apple: true, has_img_google: true, has_img_twitter: false, has_img_emojione: true, search: "tm,trade,mark,sign,trademark,brand,law,legal" }, "flag-sk": { name: "Regional Indicator Symbol Letters SK", unified: "1F1F8-1F1F0", sheet_x: 37, sheet_y: 35, short_names: ["flag-sk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sk,regional,indicator,symbol,letters" }, eyeglasses: { name: "Eyeglasses", unified: "1F453", sheet_x: 15, sheet_y: 30, short_names: ["eyeglasses"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "eyeglasses,fashion,accessories,eyesight,nerdy,dork,geek" }, end: { name: "End with Leftwards Arrow Above", unified: "1F51A", sheet_x: 23, sheet_y: 10, short_names: ["end"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "end,with,leftwards,arrow,above,words" }, dark_sunglasses: { name: "Dark Sunglasses", unified: "1F576", sheet_x: 25, sheet_y: 4, short_names: ["dark_sunglasses"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "dark,sunglasses,face,cool,accessories" }, "flag-si": { name: "Regional Indicator Symbol Letters SI", unified: "1F1F8-1F1EE", sheet_x: 37, sheet_y: 33, short_names: ["flag-si"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,si,regional,indicator,symbol,letters" }, back: { name: "Back with Leftwards Arrow Above", unified: "1F519", sheet_x: 23, sheet_y: 9, short_names: ["back"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "back,with,leftwards,arrow,above,words,return" }, ring: { name: "Ring", unified: "1F48D", sheet_x: 19, sheet_y: 29, short_names: ["ring"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ring,wedding,propose,marriage,valentines,diamond,fashion,jewelry,gem" }, "flag-sb": { name: "Regional Indicator Symbol Letters SB", unified: "1F1F8-1F1E7", sheet_x: 37, sheet_y: 27, short_names: ["flag-sb"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sb,regional,indicator,symbol,letters" }, on: { name: "On with Exclamation Mark with Left Right Arrow Above", unified: "1F51B", sheet_x: 23, sheet_y: 11, short_names: ["on"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "on,with,exclamation,mark,left,right,arrow,above,words" }, top: { name: "Top with Upwards Arrow Above", unified: "1F51D", sheet_x: 23, sheet_y: 13, short_names: ["top"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "top,with,upwards,arrow,above,words,blue-square" }, "flag-so": { name: "Regional Indicator Symbol Letters SO", unified: "1F1F8-1F1F4", sheet_x: 37, sheet_y: 39, short_names: ["flag-so"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,so,regional,indicator,symbol,letters" }, closed_umbrella: { name: "Closed Umbrella", unified: "1F302", sheet_x: 5, sheet_y: 23, short_names: ["closed_umbrella"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "closed,umbrella,weather,rain,drizzle" }, "flag-za": { name: "Regional Indicator Symbol Letters ZA", unified: "1F1FF-1F1E6", sheet_x: 39, sheet_y: 0, short_names: ["flag-za"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,za,regional,indicator,symbol,letters" }, soon: { name: "Soon with Rightwards Arrow Above", unified: "1F51C", sheet_x: 23, sheet_y: 12, short_names: ["soon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "soon,with,rightwards,arrow,above,words" }, "flag-gs": { name: "Regional Indicator Symbol Letters GS", unified: "1F1EC-1F1F8", sheet_x: 35, sheet_y: 4, short_names: ["flag-gs"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,gs,regional,indicator,symbol,letters" }, ballot_box_with_check: { name: "Ballot Box with Check", unified: "2611", variations: ["2611-FE0F"], sheet_x: 1, sheet_y: 6, short_names: ["ballot_box_with_check"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "ballot,box,with,check,ok,agree,confirm,black-square,vote,election,yes" }, radio_button: { name: "Radio Button", unified: "1F518", sheet_x: 23, sheet_y: 8, short_names: ["radio_button"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "radio,button,input,old,music,circle" }, "flag-kr": { name: "Regional Indicator Symbol Letters KR", unified: "1F1F0-1F1F7", sheet_x: 35, sheet_y: 37, short_names: ["flag-kr", "kr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,kr,regional,indicator,symbol,letters" }, "flag-ss": { name: "Regional Indicator Symbol Letters SS", unified: "1F1F8-1F1F8", sheet_x: 38, sheet_y: 0, short_names: ["flag-ss"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ss,regional,indicator,symbol,letters" }, white_circle: { name: "Medium White Circle", unified: "26AA", variations: ["26AA-FE0F"], sheet_x: 2, sheet_y: 14, short_names: ["white_circle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,circle,medium,shape,round" }, "flag-es": { name: "Regional Indicator Symbol Letters ES", unified: "1F1EA-1F1F8", sheet_x: 34, sheet_y: 22, short_names: ["flag-es", "es"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,es,regional,indicator,symbol,letters" }, black_circle: { name: "Medium Black Circle", unified: "26AB", variations: ["26AB-FE0F"], sheet_x: 2, sheet_y: 15, short_names: ["black_circle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,circle,medium,shape,button,round" }, "flag-lk": { name: "Regional Indicator Symbol Letters LK", unified: "1F1F1-1F1F0", sheet_x: 36, sheet_y: 4, short_names: ["flag-lk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,lk,regional,indicator,symbol,letters" }, red_circle: { name: "Large Red Circle", unified: "1F534", sheet_x: 23, sheet_y: 36, short_names: ["red_circle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "red,circle,large,shape,error,danger" }, "flag-sd": { name: "Regional Indicator Symbol Letters SD", unified: "1F1F8-1F1E9", sheet_x: 37, sheet_y: 29, short_names: ["flag-sd"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sd,regional,indicator,symbol,letters" }, large_blue_circle: { name: "Large Blue Circle", unified: "1F535", sheet_x: 23, sheet_y: 37, short_names: ["large_blue_circle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "large,blue,circle,shape,icon,button" }, small_orange_diamond: { name: "Small Orange Diamond", unified: "1F538", sheet_x: 23, sheet_y: 40, short_names: ["small_orange_diamond"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "small,orange,diamond,shape,jewel,gem" }, "flag-sr": { name: "Regional Indicator Symbol Letters SR", unified: "1F1F8-1F1F7", sheet_x: 37, sheet_y: 40, short_names: ["flag-sr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sr,regional,indicator,symbol,letters" }, small_blue_diamond: { name: "Small Blue Diamond", unified: "1F539", sheet_x: 24, sheet_y: 0, short_names: ["small_blue_diamond"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "small,blue,diamond,shape,jewel,gem" }, "flag-sz": { name: "Regional Indicator Symbol Letters SZ", unified: "1F1F8-1F1FF", sheet_x: 38, sheet_y: 5, short_names: ["flag-sz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sz,regional,indicator,symbol,letters" }, large_orange_diamond: { name: "Large Orange Diamond", unified: "1F536", sheet_x: 23, sheet_y: 38, short_names: ["large_orange_diamond"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "large,orange,diamond,shape,jewel,gem" }, "flag-se": { name: "Regional Indicator Symbol Letters SE", unified: "1F1F8-1F1EA", sheet_x: 37, sheet_y: 30, short_names: ["flag-se"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,se,regional,indicator,symbol,letters" }, "flag-ch": { name: "Regional Indicator Symbol Letters CH", unified: "1F1E8-1F1ED", sheet_x: 33, sheet_y: 35, short_names: ["flag-ch"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ch,regional,indicator,symbol,letters" }, large_blue_diamond: { name: "Large Blue Diamond", unified: "1F537", sheet_x: 23, sheet_y: 39, short_names: ["large_blue_diamond"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "large,blue,diamond,shape,jewel,gem" }, "flag-sy": { name: "Regional Indicator Symbol Letters SY", unified: "1F1F8-1F1FE", sheet_x: 38, sheet_y: 4, short_names: ["flag-sy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,sy,regional,indicator,symbol,letters" }, small_red_triangle: { name: "Up-Pointing Red Triangle", unified: "1F53A", sheet_x: 24, sheet_y: 1, short_names: ["small_red_triangle"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "small,red,triangle,up,pointing,shape,direction,top" }, "flag-tw": { name: "Regional Indicator Symbol Letters TW", unified: "1F1F9-1F1FC", sheet_x: 38, sheet_y: 21, short_names: ["flag-tw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tw,regional,indicator,symbol,letters" }, black_small_square: { name: "Black Small Square", unified: "25AA", variations: ["25AA-FE0F"], sheet_x: 0, sheet_y: 33, short_names: ["black_small_square"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,small,square,shape,icon" }, white_small_square: { name: "White Small Square", unified: "25AB", variations: ["25AB-FE0F"], sheet_x: 0, sheet_y: 34, short_names: ["white_small_square"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,small,square,shape,icon" }, "flag-tj": { name: "Regional Indicator Symbol Letters TJ", unified: "1F1F9-1F1EF", sheet_x: 38, sheet_y: 12, short_names: ["flag-tj"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tj,regional,indicator,symbol,letters" }, black_large_square: { name: "Black Large Square", unified: "2B1B", variations: ["2B1B-FE0F"], sheet_x: 4, sheet_y: 22, short_names: ["black_large_square"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,large,square,shape,icon,button" }, "flag-tz": { name: "Regional Indicator Symbol Letters TZ", unified: "1F1F9-1F1FF", sheet_x: 38, sheet_y: 22, short_names: ["flag-tz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tz,regional,indicator,symbol,letters" }, white_large_square: { name: "White Large Square", unified: "2B1C", variations: ["2B1C-FE0F"], sheet_x: 4, sheet_y: 23, short_names: ["white_large_square"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,large,square,shape,icon,stone,button" }, "flag-th": { name: "Regional Indicator Symbol Letters TH", unified: "1F1F9-1F1ED", sheet_x: 38, sheet_y: 11, short_names: ["flag-th"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,th,regional,indicator,symbol,letters" }, "flag-tl": { name: "Regional Indicator Symbol Letters TL", unified: "1F1F9-1F1F1", sheet_x: 38, sheet_y: 14, short_names: ["flag-tl"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tl,regional,indicator,symbol,letters" }, small_red_triangle_down: { name: "Down-Pointing Red Triangle", unified: "1F53B", sheet_x: 24, sheet_y: 2, short_names: ["small_red_triangle_down"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "small,red,triangle,down,pointing,shape,direction,bottom" }, "flag-tg": { name: "Regional Indicator Symbol Letters TG", unified: "1F1F9-1F1EC", sheet_x: 38, sheet_y: 10, short_names: ["flag-tg"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tg,regional,indicator,symbol,letters" }, black_medium_square: { name: "Black Medium Square", unified: "25FC", variations: ["25FC-FE0F"], sheet_x: 0, sheet_y: 38, short_names: ["black_medium_square"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,medium,square,shape,button,icon" }, "flag-tk": { name: "Regional Indicator Symbol Letters TK", unified: "1F1F9-1F1F0", sheet_x: 38, sheet_y: 13, short_names: ["flag-tk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tk,regional,indicator,symbol,letters" }, white_medium_square: { name: "White Medium Square", unified: "25FB", variations: ["25FB-FE0F"], sheet_x: 0, sheet_y: 37, short_names: ["white_medium_square"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,medium,square,shape,stone,icon" }, "flag-to": { name: "Regional Indicator Symbol Letters TO", unified: "1F1F9-1F1F4", sheet_x: 38, sheet_y: 17, short_names: ["flag-to"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,to,regional,indicator,symbol,letters" }, black_medium_small_square: { name: "Black Medium Small Square", unified: "25FE", variations: ["25FE-FE0F"], sheet_x: 0, sheet_y: 40, short_names: ["black_medium_small_square"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,medium,small,square,icon,shape,button" }, white_medium_small_square: { name: "White Medium Small Square", unified: "25FD", variations: ["25FD-FE0F"], sheet_x: 0, sheet_y: 39, short_names: ["white_medium_small_square"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,medium,small,square,shape,stone,icon,button" }, "flag-tt": { name: "Regional Indicator Symbol Letters TT", unified: "1F1F9-1F1F9", sheet_x: 38, sheet_y: 19, short_names: ["flag-tt"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tt,regional,indicator,symbol,letters" }, black_square_button: { name: "Black Square Button", unified: "1F532", sheet_x: 23, sheet_y: 34, short_names: ["black_square_button"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,square,button,shape,input,frame" }, "flag-tn": { name: "Regional Indicator Symbol Letters TN", unified: "1F1F9-1F1F3", sheet_x: 38, sheet_y: 16, short_names: ["flag-tn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tn,regional,indicator,symbol,letters" }, "flag-tr": { name: "Regional Indicator Symbol Letters TR", unified: "1F1F9-1F1F7", sheet_x: 38, sheet_y: 18, short_names: ["flag-tr"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tr,regional,indicator,symbol,letters" }, white_square_button: { name: "White Square Button", unified: "1F533", sheet_x: 23, sheet_y: 35, short_names: ["white_square_button"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "white,square,button,shape,input" }, "flag-tm": { name: "Regional Indicator Symbol Letters TM", unified: "1F1F9-1F1F2", sheet_x: 38, sheet_y: 15, short_names: ["flag-tm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tm,regional,indicator,symbol,letters" }, speaker: { name: "Speaker", unified: "1F508", sheet_x: 22, sheet_y: 33, short_names: ["speaker"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "speaker,sound,volume,silence,broadcast" }, "flag-tc": { name: "Regional Indicator Symbol Letters TC", unified: "1F1F9-1F1E8", sheet_x: 38, sheet_y: 7, short_names: ["flag-tc"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tc,regional,indicator,symbol,letters" }, sound: { name: "Speaker with One Sound Wave", unified: "1F509", sheet_x: 22, sheet_y: 34, short_names: ["sound"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "sound,speaker,with,one,wave,volume,broadcast" }, "flag-tv": { name: "Regional Indicator Symbol Letters TV", unified: "1F1F9-1F1FB", sheet_x: 38, sheet_y: 20, short_names: ["flag-tv"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,tv,regional,indicator,symbol,letters" }, loud_sound: { name: "Speaker with Three Sound Waves", unified: "1F50A", sheet_x: 22, sheet_y: 35, short_names: ["loud_sound"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "loud,sound,speaker,with,three,waves,volume,noise,noisy,broadcast" }, mute: { name: "Speaker with Cancellation Stroke", unified: "1F507", sheet_x: 22, sheet_y: 32, short_names: ["mute"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mute,speaker,with,cancellation,stroke,sound,volume,silence,quiet" }, "flag-ug": { name: "Regional Indicator Symbol Letters UG", unified: "1F1FA-1F1EC", sheet_x: 38, sheet_y: 24, short_names: ["flag-ug"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ug,regional,indicator,symbol,letters" }, "flag-ua": { name: "Regional Indicator Symbol Letters UA", unified: "1F1FA-1F1E6", sheet_x: 38, sheet_y: 23, short_names: ["flag-ua"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ua,regional,indicator,symbol,letters" }, mega: { name: "Cheering Megaphone", unified: "1F4E3", sheet_x: 21, sheet_y: 38, short_names: ["mega"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mega,cheering,megaphone,sound,speaker,volume" }, "flag-ae": { name: "Regional Indicator Symbol Letters AE", unified: "1F1E6-1F1EA", sheet_x: 32, sheet_y: 35, short_names: ["flag-ae"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ae,regional,indicator,symbol,letters" }, loudspeaker: { name: "Public Address Loudspeaker", unified: "1F4E2", sheet_x: 21, sheet_y: 37, short_names: ["loudspeaker"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "loudspeaker,public,address,volume,sound" }, bell: { name: "Bell", unified: "1F514", sheet_x: 23, sheet_y: 4, short_names: ["bell"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "bell,sound,notification,christmas,xmas,chime" }, "flag-gb": { name: "Regional Indicator Symbol Letters GB", unified: "1F1EC-1F1E7", sheet_x: 34, sheet_y: 32, short_names: ["flag-gb", "gb", "uk"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,gb,uk,regional,indicator,symbol,letters" }, "flag-us": { name: "Regional Indicator Symbol Letters US", unified: "1F1FA-1F1F8", sheet_x: 38, sheet_y: 26, short_names: ["flag-us", "us"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,us,regional,indicator,symbol,letters" }, no_bell: { name: "Bell with Cancellation Stroke", unified: "1F515", sheet_x: 23, sheet_y: 5, short_names: ["no_bell"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "no,bell,with,cancellation,stroke,sound,volume,mute,quiet,silent" }, "flag-vi": { name: "Regional Indicator Symbol Letters VI", unified: "1F1FB-1F1EE", sheet_x: 38, sheet_y: 33, short_names: ["flag-vi"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,vi,regional,indicator,symbol,letters" }, black_joker: { name: "Playing Card Black Joker", unified: "1F0CF", sheet_x: 4, sheet_y: 31, short_names: ["black_joker"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "black,joker,playing,card,poker,cards,game,play,magic" }, mahjong: { name: "Mahjong Tile Red Dragon", unified: "1F004", variations: ["1F004-FE0F"], sheet_x: 4, sheet_y: 30, short_names: ["mahjong"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "mahjong,tile,red,dragon,game,play,chinese,kanji" }, "flag-uy": { name: "Regional Indicator Symbol Letters UY", unified: "1F1FA-1F1FE", sheet_x: 38, sheet_y: 27, short_names: ["flag-uy"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,uy,regional,indicator,symbol,letters" }, spades: { name: "Black Spade Suit", unified: "2660", variations: ["2660-FE0F"], sheet_x: 1, sheet_y: 38, short_names: ["spades"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "spades,black,spade,suit,poker,cards,suits,magic" }, "flag-uz": { name: "Regional Indicator Symbol Letters UZ", unified: "1F1FA-1F1FF", sheet_x: 38, sheet_y: 28, short_names: ["flag-uz"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,uz,regional,indicator,symbol,letters" }, clubs: { name: "Black Club Suit", unified: "2663", variations: ["2663-FE0F"], sheet_x: 1, sheet_y: 39, short_names: ["clubs"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clubs,black,club,suit,poker,cards,magic,suits" }, "flag-vu": { name: "Regional Indicator Symbol Letters VU", unified: "1F1FB-1F1FA", sheet_x: 38, sheet_y: 35, short_names: ["flag-vu"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,vu,regional,indicator,symbol,letters" }, hearts: { name: "Black Heart Suit", unified: "2665", variations: ["2665-FE0F"], sheet_x: 1, sheet_y: 40, short_names: ["hearts"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "hearts,black,heart,suit,poker,cards,magic,suits" }, "flag-va": { name: "Regional Indicator Symbol Letters VA", unified: "1F1FB-1F1E6", sheet_x: 38, sheet_y: 29, short_names: ["flag-va"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,va,regional,indicator,symbol,letters" }, diamonds: { name: "Black Diamond Suit", unified: "2666", variations: ["2666-FE0F"], sheet_x: 2, sheet_y: 0, short_names: ["diamonds"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "diamonds,black,diamond,suit,poker,cards,magic,suits" }, "flag-ve": { name: "Regional Indicator Symbol Letters VE", unified: "1F1FB-1F1EA", sheet_x: 38, sheet_y: 31, short_names: ["flag-ve"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ve,regional,indicator,symbol,letters" }, "flag-vn": { name: "Regional Indicator Symbol Letters VN", unified: "1F1FB-1F1F3", sheet_x: 38, sheet_y: 34, short_names: ["flag-vn"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,vn,regional,indicator,symbol,letters" }, flower_playing_cards: { name: "Flower Playing Cards", unified: "1F3B4", sheet_x: 9, sheet_y: 35, short_names: ["flower_playing_cards"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flower,playing,cards,game,sunset,red" }, thought_balloon: { name: "Thought Balloon", unified: "1F4AD", sheet_x: 20, sheet_y: 25, short_names: ["thought_balloon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "thought,balloon,bubble,cloud,speech,thinking" }, "flag-wf": { name: "Regional Indicator Symbol Letters WF", unified: "1F1FC-1F1EB", sheet_x: 38, sheet_y: 36, short_names: ["flag-wf"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,wf,regional,indicator,symbol,letters" }, "flag-eh": { name: "Regional Indicator Symbol Letters EH", unified: "1F1EA-1F1ED", sheet_x: 34, sheet_y: 20, short_names: ["flag-eh"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,eh,regional,indicator,symbol,letters" }, right_anger_bubble: { name: "Right Anger Bubble", unified: "1F5EF", sheet_x: 26, sheet_y: 7, short_names: ["right_anger_bubble"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "right,anger,bubble,caption,speech,thinking,mad" }, speech_balloon: { name: "Speech Balloon", unified: "1F4AC", sheet_x: 20, sheet_y: 24, short_names: ["speech_balloon"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "speech,balloon,bubble,words,message,talk,chatting" }, "flag-ye": { name: "Regional Indicator Symbol Letters YE", unified: "1F1FE-1F1EA", sheet_x: 38, sheet_y: 39, short_names: ["flag-ye"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,ye,regional,indicator,symbol,letters" }, left_speech_bubble: { name: "Left Speech Bubble", unified: "1F5E8", sheet_x: 26, sheet_y: 6, short_names: ["left_speech_bubble"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: false, search: "left,speech,bubble,words,message,talk,chatting" }, "flag-zm": { name: "Regional Indicator Symbol Letters ZM", unified: "1F1FF-1F1F2", sheet_x: 39, sheet_y: 1, short_names: ["flag-zm"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,zm,regional,indicator,symbol,letters" }, "clock1": { name: "Clock Face One Oclock", unified: "1F550", sheet_x: 24, sheet_y: 11, short_names: ["clock1"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock1,clock,face,one,oclock,time,late,early,schedule" }, "flag-zw": { name: "Regional Indicator Symbol Letters ZW", unified: "1F1FF-1F1FC", sheet_x: 39, sheet_y: 2, short_names: ["flag-zw"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "flag,zw,regional,indicator,symbol,letters" }, "flag-ac": { name: "Regional Indicator Symbol Letters AC", unified: "1F1E6-1F1E8", sheet_x: 32, sheet_y: 33, short_names: ["flag-ac"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,ac,regional,indicator,symbol,letters" }, "clock2": { name: "Clock Face Two Oclock", unified: "1F551", sheet_x: 24, sheet_y: 12, short_names: ["clock2"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock2,clock,face,two,oclock,time,late,early,schedule" }, "flag-bv": { name: "Regional Indicator Symbol Letters BV", unified: "1F1E7-1F1FB", sheet_x: 33, sheet_y: 26, short_names: ["flag-bv"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,bv,regional,indicator,symbol,letters" }, "clock3": { name: "Clock Face Three Oclock", unified: "1F552", sheet_x: 24, sheet_y: 13, short_names: ["clock3"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock3,clock,face,three,oclock,time,late,early,schedule" }, "flag-cp": { name: "Regional Indicator Symbol Letters CP", unified: "1F1E8-1F1F5", sheet_x: 34, sheet_y: 1, short_names: ["flag-cp"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,cp,regional,indicator,symbol,letters" }, "clock4": { name: "Clock Face Four Oclock", unified: "1F553", sheet_x: 24, sheet_y: 14, short_names: ["clock4"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock4,clock,face,four,oclock,time,late,early,schedule" }, "clock5": { name: "Clock Face Five Oclock", unified: "1F554", sheet_x: 24, sheet_y: 15, short_names: ["clock5"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock5,clock,face,five,oclock,time,late,early,schedule" }, "flag-dg": { name: "Regional Indicator Symbol Letters DG", unified: "1F1E9-1F1EC", sheet_x: 34, sheet_y: 10, short_names: ["flag-dg"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,dg,regional,indicator,symbol,letters" }, "clock6": { name: "Clock Face Six Oclock", unified: "1F555", sheet_x: 24, sheet_y: 16, short_names: ["clock6"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock6,clock,face,six,oclock,time,late,early,schedule,dawn,dusk" }, "flag-ea": { name: "Regional Indicator Symbol Letters EA", unified: "1F1EA-1F1E6", sheet_x: 34, sheet_y: 16, short_names: ["flag-ea"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,ea,regional,indicator,symbol,letters" }, "flag-hm": { name: "Regional Indicator Symbol Letters HM", unified: "1F1ED-1F1F2", sheet_x: 35, sheet_y: 10, short_names: ["flag-hm"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,hm,regional,indicator,symbol,letters" }, "clock7": { name: "Clock Face Seven Oclock", unified: "1F556", sheet_x: 24, sheet_y: 17, short_names: ["clock7"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock7,clock,face,seven,oclock,time,late,early,schedule" }, "flag-mf": { name: "Regional Indicator Symbol Letters MF", unified: "1F1F2-1F1EB", sheet_x: 36, sheet_y: 15, short_names: ["flag-mf"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,mf,regional,indicator,symbol,letters" }, "clock8": { name: "Clock Face Eight Oclock", unified: "1F557", sheet_x: 24, sheet_y: 18, short_names: ["clock8"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock8,clock,face,eight,oclock,time,late,early,schedule" }, "clock9": { name: "Clock Face Nine Oclock", unified: "1F558", sheet_x: 24, sheet_y: 19, short_names: ["clock9"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock9,clock,face,nine,oclock,time,late,early,schedule" }, "flag-sj": { name: "Regional Indicator Symbol Letters SJ", unified: "1F1F8-1F1EF", sheet_x: 37, sheet_y: 34, short_names: ["flag-sj"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,sj,regional,indicator,symbol,letters" }, "flag-ta": { name: "Regional Indicator Symbol Letters TA", unified: "1F1F9-1F1E6", sheet_x: 38, sheet_y: 6, short_names: ["flag-ta"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,ta,regional,indicator,symbol,letters" }, "clock10": { name: "Clock Face Ten Oclock", unified: "1F559", sheet_x: 24, sheet_y: 20, short_names: ["clock10"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock10,clock,face,ten,oclock,time,late,early,schedule" }, "flag-um": { name: "Regional Indicator Symbol Letters UM", unified: "1F1FA-1F1F2", sheet_x: 38, sheet_y: 25, short_names: ["flag-um"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "flag,um,regional,indicator,symbol,letters" }, "clock11": { name: "Clock Face Eleven Oclock", unified: "1F55A", sheet_x: 24, sheet_y: 21, short_names: ["clock11"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock11,clock,face,eleven,oclock,time,late,early,schedule" }, "clock12": { name: "Clock Face Twelve Oclock", unified: "1F55B", sheet_x: 24, sheet_y: 22, short_names: ["clock12"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock12,clock,face,twelve,oclock,time,noon,midnight,midday,late,early,schedule" }, "clock130": { name: "Clock Face One-Thirty", unified: "1F55C", sheet_x: 24, sheet_y: 23, short_names: ["clock130"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock130,clock,face,one,thirty,time,late,early,schedule" }, "clock230": { name: "Clock Face Two-Thirty", unified: "1F55D", sheet_x: 24, sheet_y: 24, short_names: ["clock230"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock230,clock,face,two,thirty,time,late,early,schedule" }, "clock330": { name: "Clock Face Three-Thirty", unified: "1F55E", sheet_x: 24, sheet_y: 25, short_names: ["clock330"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock330,clock,face,three,thirty,time,late,early,schedule" }, "clock430": { name: "Clock Face Four-Thirty", unified: "1F55F", sheet_x: 24, sheet_y: 26, short_names: ["clock430"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock430,clock,face,four,thirty,time,late,early,schedule" }, "clock530": { name: "Clock Face Five-Thirty", unified: "1F560", sheet_x: 24, sheet_y: 27, short_names: ["clock530"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock530,clock,face,five,thirty,time,late,early,schedule" }, "clock630": { name: "Clock Face Six-Thirty", unified: "1F561", sheet_x: 24, sheet_y: 28, short_names: ["clock630"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock630,clock,face,six,thirty,time,late,early,schedule" }, "clock730": { name: "Clock Face Seven-Thirty", unified: "1F562", sheet_x: 24, sheet_y: 29, short_names: ["clock730"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock730,clock,face,seven,thirty,time,late,early,schedule" }, "clock830": { name: "Clock Face Eight-Thirty", unified: "1F563", sheet_x: 24, sheet_y: 30, short_names: ["clock830"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock830,clock,face,eight,thirty,time,late,early,schedule" }, "clock930": { name: "Clock Face Nine-Thirty", unified: "1F564", sheet_x: 24, sheet_y: 31, short_names: ["clock930"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock930,clock,face,nine,thirty,time,late,early,schedule" }, "clock1030": { name: "Clock Face Ten-Thirty", unified: "1F565", sheet_x: 24, sheet_y: 32, short_names: ["clock1030"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock1030,clock,face,ten,thirty,time,late,early,schedule" }, "clock1130": { name: "Clock Face Eleven-Thirty", unified: "1F566", sheet_x: 24, sheet_y: 33, short_names: ["clock1130"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock1130,clock,face,eleven,thirty,time,late,early,schedule" }, "clock1230": { name: "Clock Face Twelve-Thirty", unified: "1F567", sheet_x: 24, sheet_y: 34, short_names: ["clock1230"], has_img_apple: true, has_img_google: true, has_img_twitter: true, has_img_emojione: true, search: "clock1230,clock,face,twelve,thirty,time,late,early,schedule" } }, skins: { "skin-tone-2": { name: "Emoji Modifier Fitzpatrick Type-1-2", unified: "1F3FB", sheet_x: 12, sheet_y: 0, short_names: ["skin-tone-2"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "skin,tone,2,emoji,modifier,fitzpatrick,type,1" }, "skin-tone-3": { name: "Emoji Modifier Fitzpatrick Type-3", unified: "1F3FC", sheet_x: 12, sheet_y: 1, short_names: ["skin-tone-3"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "skin,tone,3,emoji,modifier,fitzpatrick,type" }, "skin-tone-4": { name: "Emoji Modifier Fitzpatrick Type-4", unified: "1F3FD", sheet_x: 12, sheet_y: 2, short_names: ["skin-tone-4"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "skin,tone,4,emoji,modifier,fitzpatrick,type" }, "skin-tone-5": { name: "Emoji Modifier Fitzpatrick Type-5", unified: "1F3FE", sheet_x: 12, sheet_y: 3, short_names: ["skin-tone-5"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "skin,tone,5,emoji,modifier,fitzpatrick,type" }, "skin-tone-6": { name: "Emoji Modifier Fitzpatrick Type-6", unified: "1F3FF", sheet_x: 12, sheet_y: 4, short_names: ["skin-tone-6"], has_img_apple: true, has_img_google: false, has_img_twitter: true, has_img_emojione: true, search: "skin,tone,6,emoji,modifier,fitzpatrick,type" } }, short_names: { red_car: "car", satisfied: "laughing", telephone: "phone", honeybee: "bee", sailboat: "boat", flipper: "dolphin", cn: "flag-cn", knife: "hocho", poop: "hankey", shit: "hankey", paw_prints: "feet", fr: "flag-fr", heavy_exclamation_mark: "exclamation", de: "flag-de", thumbsup: "+1", thumbsdown: "-1", punch: "facepunch", raised_hand: "hand", reversed_hand_with_middle_finger_extended: "middle_finger", sign_of_the_horns: "the_horns", it: "flag-it", lantern: "izakaya_lantern", waxing_gibbous_moon: "moon", envelope: "email", jp: "flag-jp", sun_small_cloud: "mostly_sunny", sun_behind_cloud: "barely_sunny", sun_behind_rain_cloud: "partly_sunny_rain", lightning_cloud: "lightning", collision: "boom", running: "runner", tornado_cloud: "tornado", man_and_woman_holding_hands: "couple", open_book: "book", "man-woman-boy": "family", pencil: "memo", tshirt: "shirt", ru: "flag-ru", shoe: "mans_shoe", kr: "flag-kr", es: "flag-es", gb: "flag-gb", uk: "flag-gb", us: "flag-us" } };
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.unifiedToNative = exports.deepMerge = exports.intersect = exports.getSanitizedData = exports.getData = undefined;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _data = __webpack_require__(19);
	
		var _data2 = _interopRequireDefault(_data);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
		var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
		var SKINS = ['1F3FA', '1F3FB', '1F3FC', '1F3FD', '1F3FE', '1F3FF'];
	
		function unifiedToNative(unified) {
		  var unicodes = unified.split('-'),
		      codePoints = unicodes.map(function (u) {
		    return '0x' + u;
		  });
	
		  return String.fromCodePoint.apply(String, _toConsumableArray(codePoints));
		}
	
		function sanitize(emoji) {
		  var name = emoji.name;
		  var short_names = emoji.short_names;
		  var skin_tone = emoji.skin_tone;
		  var skin_variations = emoji.skin_variations;
		  var emoticons = emoji.emoticons;
		  var unified = emoji.unified;
		  var id = short_names[0];
		  var colons = ':' + id + ':';
	
		  if (skin_tone) {
		    colons += ':skin-tone-' + skin_tone + ':';
		  }
	
		  return {
		    id: id,
		    name: name,
		    colons: colons,
		    emoticons: emoticons,
		    unified: unified.toLowerCase(),
		    skin: skin_tone || (skin_variations ? 1 : null),
		    native: unifiedToNative(unified)
		  };
		}
	
		function getSanitizedData() {
		  return sanitize(getData.apply(undefined, arguments));
		}
	
		function getData(emoji, skin, set) {
		  var emojiData = {};
	
		  if (typeof emoji == 'string') {
		    var matches = emoji.match(COLONS_REGEX);
	
		    if (matches) {
		      emoji = matches[1];
	
		      if (matches[2]) {
		        skin = parseInt(matches[2]);
		      }
		    }
	
		    if (_data2.default.short_names.hasOwnProperty(emoji)) {
		      emoji = _data2.default.short_names[emoji];
		    }
	
		    if (_data2.default.emojis.hasOwnProperty(emoji)) {
		      emojiData = _data2.default.emojis[emoji];
		    }
		  } else if (emoji.id) {
		    if (_data2.default.short_names.hasOwnProperty(emoji.id)) {
		      emoji.id = _data2.default.short_names[emoji.id];
		    }
	
		    if (_data2.default.emojis.hasOwnProperty(emoji.id)) {
		      emojiData = _data2.default.emojis[emoji.id];
		      skin || (skin = emoji.skin);
		    }
		  }
	
		  emojiData.emoticons || (emojiData.emoticons = []);
		  emojiData.variations || (emojiData.variations = []);
	
		  if (emojiData.skin_variations && skin > 1 && set) {
		    emojiData = JSON.parse(JSON.stringify(emojiData));
	
		    var skinKey = SKINS[skin - 1],
		        variationKey = emojiData.unified + '-' + skinKey,
		        variationData = emojiData.skin_variations[variationKey];
	
		    if (!variationData.variations && emojiData.variations) {
		      delete emojiData.variations;
		    }
	
		    if (variationData['has_img_' + set]) {
		      emojiData.skin_tone = skin;
	
		      for (var k in variationData) {
		        var v = variationData[k];
		        emojiData[k] = v;
		      }
		    }
		  }
	
		  if (emojiData.variations && emojiData.variations.length) {
		    emojiData = JSON.parse(JSON.stringify(emojiData));
		    emojiData.unified = emojiData.variations.shift();
		  }
	
		  return emojiData;
		}
	
		function intersect(a, b) {
		  var aSet = new Set(a),
		      bSet = new Set(b),
		      intersection = null;
	
		  intersection = new Set([].concat(_toConsumableArray(aSet)).filter(function (x) {
		    return bSet.has(x);
		  }));
	
		  return Array.from(intersection);
		}
	
		function deepMerge(a, b) {
		  var o = {};
	
		  for (var key in a) {
		    var originalValue = a[key],
		        value = originalValue;
	
		    if (b.hasOwnProperty(key)) {
		      value = b[key];
		    }
	
		    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
		      value = deepMerge(originalValue, value);
		    }
	
		    o[key] = value;
		  }
	
		  return o;
		}
	
		exports.getData = getData;
		exports.getSanitizedData = getSanitizedData;
		exports.intersect = intersect;
		exports.deepMerge = deepMerge;
		exports.unifiedToNative = unifiedToNative;
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		__webpack_require__(22);
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _data = __webpack_require__(19);
	
		var _data2 = _interopRequireDefault(_data);
	
		var _store = __webpack_require__(17);
	
		var _store2 = _interopRequireDefault(_store);
	
		var _frequently = __webpack_require__(16);
	
		var _frequently2 = _interopRequireDefault(_frequently);
	
		var _utils = __webpack_require__(20);
	
		var _ = __webpack_require__(1);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var RECENT_CATEGORY = { name: 'Recent', emojis: null };
		var SEARCH_CATEGORY = { name: 'Search', emojis: null, anchor: RECENT_CATEGORY };
	
		var CATEGORIES = [];
	
		var I18N = {
		  search: 'Search',
		  categories: {
		    search: 'Search Results',
		    recent: 'Frequently Used',
		    people: 'Smileys & People',
		    nature: 'Animals & Nature',
		    foods: 'Food & Drink',
		    activity: 'Activity',
		    places: 'Travel & Places',
		    objects: 'Objects',
		    symbols: 'Symbols',
		    flags: 'Flags'
		  }
		};
	
		var Picker = function (_React$Component) {
		  _inherits(Picker, _React$Component);
	
		  function Picker(props) {
		    _classCallCheck(this, Picker);
	
		    var _this = _possibleConstructorReturn(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));
	
		    _this.i18n = (0, _utils.deepMerge)(I18N, props.i18n);
		    _this.state = {
		      skin: _store2.default.get('skin') || props.skin,
		      firstRender: true
		    };
	
		    var filteredCategories = [];
	
		    var _iteratorNormalCompletion = true;
		    var _didIteratorError = false;
		    var _iteratorError = undefined;
	
		    try {
		      for (var _iterator = _data2.default.categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		        var hash = _step.value;
	
		        var new_emojis = [];
		        var _iteratorNormalCompletion2 = true;
		        var _didIteratorError2 = false;
		        var _iteratorError2 = undefined;
	
		        try {
		          for (var _iterator2 = hash.emojis[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
		            var emoji = _step2.value;
	
		            var unified = _data2.default.emojis[emoji].unified;
		            if (props.emojisToShowFilter(unified)) {
		              new_emojis.push(emoji);
		            }
		          }
		        } catch (err) {
		          _didIteratorError2 = true;
		          _iteratorError2 = err;
		        } finally {
		          try {
		            if (!_iteratorNormalCompletion2 && _iterator2.return) {
		              _iterator2.return();
		            }
		          } finally {
		            if (_didIteratorError2) {
		              throw _iteratorError2;
		            }
		          }
		        }
	
		        if (new_emojis.length) {
		          var new_hash = {
		            emojis: new_emojis,
		            name: hash.name
		          };
		          filteredCategories.push(new_hash);
		        }
		      }
		    } catch (err) {
		      _didIteratorError = true;
		      _iteratorError = err;
		    } finally {
		      try {
		        if (!_iteratorNormalCompletion && _iterator.return) {
		          _iterator.return();
		        }
		      } finally {
		        if (_didIteratorError) {
		          throw _iteratorError;
		        }
		      }
		    }
	
		    CATEGORIES = [SEARCH_CATEGORY, RECENT_CATEGORY].concat(filteredCategories);
	
		    _this.categories = CATEGORIES;
		    return _this;
		  }
	
		  _createClass(Picker, [{
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(props) {
		      if (props.skin && !_store2.default.get('skin')) {
		        this.setState({ skin: props.skin });
		      }
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      var _this2 = this;
	
		      if (this.state.firstRender) {
		        this.testStickyPosition();
		        this.firstRenderTimeout = setTimeout(function () {
		          _this2.setState({ firstRender: false });
		        }, 60);
		      }
		    }
		  }, {
		    key: 'componentDidUpdate',
		    value: function componentDidUpdate() {
		      this.updateCategoriesSize();
		      this.handleScroll();
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      SEARCH_CATEGORY.emojis = null;
	
		      clearTimeout(this.leaveTimeout);
		      clearTimeout(this.firstRenderTimeout);
		    }
		  }, {
		    key: 'testStickyPosition',
		    value: function testStickyPosition() {
		      var stickyTestElement = document.createElement('div');
		      var _arr = ['', '-webkit-', '-ms-', '-moz-', '-o-'];
		      for (var _i = 0; _i < _arr.length; _i++) {
		        var prefix = _arr[_i];
		        stickyTestElement.style.position = prefix + 'sticky';
		      }
	
		      this.hasStickyPosition = !!stickyTestElement.style.position.length;
		    }
		  }, {
		    key: 'handleEmojiOver',
		    value: function handleEmojiOver(emoji) {
		      var preview = this.refs.preview;
	
		      preview.setState({ emoji: emoji });
		      clearTimeout(this.leaveTimeout);
		    }
		  }, {
		    key: 'handleEmojiLeave',
		    value: function handleEmojiLeave(emoji) {
		      var _this3 = this;
	
		      this.leaveTimeout = setTimeout(function () {
		        var preview = _this3.refs.preview;
	
		        preview.setState({ emoji: null });
		      }, 16);
		    }
		  }, {
		    key: 'handleEmojiClick',
		    value: function handleEmojiClick(emoji, e) {
		      var _this4 = this;
	
		      this.props.onClick(emoji, e);
		      _frequently2.default.add(emoji);
	
		      var component = this.refs['category-1'];
		      if (component) {
		        var maxMargin = component.maxMargin;
		        component.forceUpdate();
	
		        window.requestAnimationFrame(function () {
		          component.memoizeSize();
		          if (maxMargin == component.maxMargin) return;
	
		          _this4.updateCategoriesSize();
		          _this4.handleScrollPaint();
	
		          if (SEARCH_CATEGORY.emojis) {
		            component.updateDisplay('none');
		          }
		        });
		      }
		    }
		  }, {
		    key: 'handleScroll',
		    value: function handleScroll() {
		      if (!this.waitingForPaint) {
		        this.waitingForPaint = true;
		        window.requestAnimationFrame(this.handleScrollPaint.bind(this));
		      }
		    }
		  }, {
		    key: 'handleScrollPaint',
		    value: function handleScrollPaint() {
		      this.waitingForPaint = false;
	
		      if (!this.refs.scroll) {
		        return;
		      }
	
		      var target = this.refs.scroll,
		          scrollTop = target.scrollTop,
		          scrollingDown = scrollTop > (this.scrollTop || 0),
		          activeCategory = null,
		          minTop = 0;
	
		      for (var i = 0, l = CATEGORIES.length; i < l; i++) {
		        var ii = scrollingDown ? CATEGORIES.length - 1 - i : i,
		            category = CATEGORIES[ii],
		            component = this.refs['category-' + ii];
	
		        if (component) {
		          var active = component.handleScroll(scrollTop);
	
		          if (!minTop || component.top < minTop) {
		            if (component.top > 0) {
		              minTop = component.top;
		            }
		          }
	
		          if (active && !activeCategory) {
		            if (category.anchor) category = category.anchor;
		            activeCategory = category;
		          }
		        }
		      }
	
		      if (scrollTop < minTop) {
		        activeCategory = RECENT_CATEGORY;
		      }
	
		      if (activeCategory) {
		        var anchors = this.refs.anchors;
		        var _activeCategory = activeCategory;
		        var categoryName = _activeCategory.name;
	
	
		        if (anchors.state.selected != categoryName) {
		          anchors.setState({ selected: categoryName });
		        }
		      }
	
		      this.scrollTop = scrollTop;
		    }
		  }, {
		    key: 'handleSearch',
		    value: function handleSearch(emojis) {
		      SEARCH_CATEGORY.emojis = emojis;
	
		      for (var i = 0, l = CATEGORIES.length; i < l; i++) {
		        var component = this.refs['category-' + i];
	
		        if (component && component.props.name != 'Search') {
		          var display = emojis ? 'none' : 'inherit';
		          component.updateDisplay(display);
		        }
		      }
	
		      this.forceUpdate();
		    }
		  }, {
		    key: 'handleAnchorClick',
		    value: function handleAnchorClick(category, i) {
		      var component = this.refs['category-' + i];
		      var _refs = this.refs;
		      var scroll = _refs.scroll;
		      var anchors = _refs.anchors;
		      var scrollToComponent = null;
	
		      scrollToComponent = function scrollToComponent() {
		        if (component) {
		          var top = component.top;
	
	
		          if (category.name == 'Recent') {
		            top = 0;
		          } else {
		            top += 1;
		          }
	
		          scroll.scrollTop = top;
		        }
		      };
	
		      if (SEARCH_CATEGORY.emojis) {
		        this.handleSearch(null);
		        this.refs.search.clear();
	
		        window.requestAnimationFrame(scrollToComponent);
		      } else {
		        scrollToComponent();
		      }
		    }
		  }, {
		    key: 'handleSkinChange',
		    value: function handleSkinChange(skin) {
		      var newState = { skin: skin };
	
		      this.setState(newState);
		      _store2.default.update(newState);
		    }
		  }, {
		    key: 'updateCategoriesSize',
		    value: function updateCategoriesSize() {
		      for (var i = 0, l = CATEGORIES.length; i < l; i++) {
		        var component = this.refs['category-' + i];
		        if (component) component.memoizeSize();
		      }
		    }
		  }, {
		    key: 'getCategories',
		    value: function getCategories() {
		      var categories = CATEGORIES;
	
		      return this.state.firstRender ? categories.slice(0, 3) : categories;
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _this5 = this;
	
		      var _props = this.props;
		      var perLine = _props.perLine;
		      var emojiSize = _props.emojiSize;
		      var set = _props.set;
		      var sheetSize = _props.sheetSize;
		      var style = _props.style;
		      var title = _props.title;
		      var emoji = _props.emoji;
		      var color = _props.color;
		      var native = _props.native;
		      var backgroundImageFn = _props.backgroundImageFn;
		      var emojisToShowFilter = _props.emojisToShowFilter;
		      var skin = this.state.skin;
		      var width = perLine * (emojiSize + 12) + 12 + 2;
	
		      return _react2.default.createElement(
		        'div',
		        { style: _extends({ width: width }, style), className: 'emoji-mart' },
		        _react2.default.createElement(
		          'div',
		          { className: 'emoji-mart-bar' },
		          _react2.default.createElement(_.Anchors, {
		            ref: 'anchors',
		            i18n: this.i18n,
		            color: color,
		            categories: CATEGORIES,
		            onAnchorClick: this.handleAnchorClick.bind(this)
		          })
		        ),
		        _react2.default.createElement(
		          'div',
		          { ref: 'scroll', className: 'emoji-mart-scroll', onScroll: this.handleScroll.bind(this) },
		          _react2.default.createElement(_.Search, {
		            ref: 'search',
		            onSearch: this.handleSearch.bind(this),
		            i18n: this.i18n,
		            emojisToShowFilter: emojisToShowFilter
		          }),
		          this.getCategories().map(function (category, i) {
		            return _react2.default.createElement(_.Category, {
		              ref: 'category-' + i,
		              key: category.name,
		              name: category.name,
		              emojis: category.emojis,
		              perLine: perLine,
		              native: native,
		              hasStickyPosition: _this5.hasStickyPosition,
		              i18n: _this5.i18n,
		              emojiProps: {
		                native: native,
		                skin: skin,
		                size: emojiSize,
		                set: set,
		                sheetSize: sheetSize,
		                forceSize: native,
		                backgroundImageFn: backgroundImageFn,
		                onOver: _this5.handleEmojiOver.bind(_this5),
		                onLeave: _this5.handleEmojiLeave.bind(_this5),
		                onClick: _this5.handleEmojiClick.bind(_this5)
		              }
		            });
		          })
		        ),
		        _react2.default.createElement(
		          'div',
		          { className: 'emoji-mart-bar' },
		          _react2.default.createElement(_.Preview, {
		            ref: 'preview',
		            title: title,
		            emoji: emoji,
		            emojiProps: {
		              native: native,
		              size: 38,
		              skin: skin,
		              set: set,
		              sheetSize: sheetSize,
		              backgroundImageFn: backgroundImageFn
		            },
		            skinsProps: {
		              skin: skin,
		              onChange: this.handleSkinChange.bind(this)
		            }
		          })
		        )
		      );
		    }
		  }]);
	
		  return Picker;
		}(_react2.default.Component);
	
		exports.default = Picker;
	
	
		Picker.propTypes = {
		  onClick: _react2.default.PropTypes.func,
		  perLine: _react2.default.PropTypes.number,
		  emojiSize: _react2.default.PropTypes.number,
		  i18n: _react2.default.PropTypes.object,
		  style: _react2.default.PropTypes.object,
		  title: _react2.default.PropTypes.string,
		  emoji: _react2.default.PropTypes.string,
		  color: _react2.default.PropTypes.string,
		  set: _.Emoji.propTypes.set,
		  skin: _.Emoji.propTypes.skin,
		  native: _react2.default.PropTypes.bool,
		  backgroundImageFn: _.Emoji.propTypes.backgroundImageFn,
		  sheetSize: _.Emoji.propTypes.sheetSize,
		  emojisToShowFilter: _react2.default.PropTypes.func
		};
	
		Picker.defaultProps = {
		  onClick: function onClick() {},
		  emojiSize: 24,
		  perLine: 9,
		  i18n: {},
		  style: {},
		  title: 'Emoji Mart™',
		  emoji: 'department_store',
		  color: '#ae65c5',
		  set: _.Emoji.defaultProps.set,
		  skin: _.Emoji.defaultProps.skin,
		  native: _.Emoji.defaultProps.native,
		  sheetSize: _.Emoji.defaultProps.sheetSize,
		  backgroundImageFn: _.Emoji.defaultProps.backgroundImageFn,
		  emojisToShowFilter: function emojisToShowFilter(codePoint) {
		    return true;
		  }
		};
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		'use strict';
	
		// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
		// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	
		// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
	
		// MIT license
	
		var isWindowAvailable = typeof window !== 'undefined';
	
		isWindowAvailable && function () {
		  var lastTime = 0;
		  var vendors = ['ms', 'moz', 'webkit', 'o'];
	
		  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
		  }
	
		  if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
		    var currTime = new Date().getTime();
		    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
		    var id = window.setTimeout(function () {
		      callback(currTime + timeToCall);
		    }, timeToCall);
	
		    lastTime = currTime + timeToCall;
		    return id;
		  };
	
		  if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
		    clearTimeout(id);
		  };
		}();
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _ = __webpack_require__(1);
	
		var _utils = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Preview = function (_React$Component) {
		  _inherits(Preview, _React$Component);
	
		  function Preview(props) {
		    _classCallCheck(this, Preview);
	
		    var _this = _possibleConstructorReturn(this, (Preview.__proto__ || Object.getPrototypeOf(Preview)).call(this, props));
	
		    _this.state = { emoji: null };
		    return _this;
		  }
	
		  _createClass(Preview, [{
		    key: 'render',
		    value: function render() {
		      var emoji = this.state.emoji;
		      var _props = this.props;
		      var emojiProps = _props.emojiProps;
		      var skinsProps = _props.skinsProps;
		      var title = _props.title;
		      var idleEmoji = _props.emoji;
	
	
		      if (emoji) {
		        var emojiData = (0, _utils.getData)(emoji);
		        var emoticons = emojiData.emoticons;
		        var knownEmoticons = [];
		        var listedEmoticons = [];
	
		        var _iteratorNormalCompletion = true;
		        var _didIteratorError = false;
		        var _iteratorError = undefined;
	
		        try {
		          for (var _iterator = emoticons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		            var emoticon = _step.value;
	
		            if (knownEmoticons.indexOf(emoticon.toLowerCase()) == -1) {
		              knownEmoticons.push(emoticon.toLowerCase());
		              listedEmoticons.push(emoticon);
		            }
		          }
		        } catch (err) {
		          _didIteratorError = true;
		          _iteratorError = err;
		        } finally {
		          try {
		            if (!_iteratorNormalCompletion && _iterator.return) {
		              _iterator.return();
		            }
		          } finally {
		            if (_didIteratorError) {
		              throw _iteratorError;
		            }
		          }
		        }
	
		        return _react2.default.createElement(
		          'div',
		          { className: 'emoji-mart-preview' },
		          _react2.default.createElement(
		            'div',
		            { className: 'emoji-mart-preview-emoji' },
		            _react2.default.createElement(_.Emoji, _extends({
		              key: emoji.id,
		              emoji: emoji
		            }, emojiProps))
		          ),
		          _react2.default.createElement(
		            'div',
		            { className: 'emoji-mart-preview-data' },
		            _react2.default.createElement(
		              'div',
		              { className: 'emoji-mart-preview-name' },
		              emoji.name
		            ),
		            _react2.default.createElement(
		              'div',
		              { className: 'emoji-mart-preview-shortnames' },
		              emojiData.short_names.map(function (short_name) {
		                return _react2.default.createElement(
		                  'span',
		                  { key: short_name, className: 'emoji-mart-preview-shortname' },
		                  ':',
		                  short_name,
		                  ':'
		                );
		              })
		            ),
		            _react2.default.createElement(
		              'div',
		              { className: 'emoji-mart-preview-emoticons' },
		              listedEmoticons.map(function (emoticon) {
		                return _react2.default.createElement(
		                  'span',
		                  { key: emoticon, className: 'emoji-mart-preview-emoticon' },
		                  emoticon
		                );
		              })
		            )
		          )
		        );
		      } else {
		        return _react2.default.createElement(
		          'div',
		          { className: 'emoji-mart-preview' },
		          _react2.default.createElement(
		            'div',
		            { className: 'emoji-mart-preview-emoji' },
		            _react2.default.createElement(_.Emoji, _extends({
		              emoji: idleEmoji
		            }, emojiProps))
		          ),
		          _react2.default.createElement(
		            'div',
		            { className: 'emoji-mart-preview-data' },
		            _react2.default.createElement(
		              'span',
		              { className: 'emoji-mart-title-label' },
		              title
		            )
		          ),
		          _react2.default.createElement(
		            'div',
		            { className: 'emoji-mart-preview-skins' },
		            _react2.default.createElement(_.Skins, skinsProps)
		          )
		        );
		      }
		    }
		  }]);
	
		  return Preview;
		}(_react2.default.Component);
	
		exports.default = Preview;
	
	
		Preview.propTypes = {
		  title: _react2.default.PropTypes.string.isRequired,
		  emoji: _react2.default.PropTypes.string.isRequired,
		  emojiProps: _react2.default.PropTypes.object.isRequired,
		  skinsProps: _react2.default.PropTypes.object.isRequired
		};
	
	/***/ },
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _emojiIndex = __webpack_require__(25);
	
		var _emojiIndex2 = _interopRequireDefault(_emojiIndex);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Search = function (_React$Component) {
		  _inherits(Search, _React$Component);
	
		  function Search() {
		    _classCallCheck(this, Search);
	
		    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
		  }
	
		  _createClass(Search, [{
		    key: 'handleChange',
		    value: function handleChange() {
		      var input = this.refs.input;
		      var value = input.value;
	
		      this.props.onSearch(_emojiIndex2.default.search(value, this.props.emojisToShowFilter, this.props.maxResults));
		    }
		  }, {
		    key: 'clear',
		    value: function clear() {
		      this.refs.input.value = '';
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var i18n = this.props.i18n;
	
	
		      return _react2.default.createElement('input', {
		        ref: 'input',
		        type: 'text',
		        onChange: this.handleChange.bind(this),
		        placeholder: i18n.search,
		        className: 'emoji-mart-search'
		      });
		    }
		  }]);
	
		  return Search;
		}(_react2.default.Component);
	
		exports.default = Search;
	
	
		Search.propTypes = {
		  onSearch: _react2.default.PropTypes.func,
		  maxResults: _react2.default.PropTypes.number,
		  emojisToShowFilter: _react2.default.PropTypes.func
		};
	
		Search.defaultProps = {
		  onSearch: function onSearch() {},
		  maxResults: 75,
		  emojisToShowFilter: function emojisToShowFilter() {
		    return true;
		  }
		};
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _data = __webpack_require__(19);
	
		var _data2 = _interopRequireDefault(_data);
	
		var _ = __webpack_require__(20);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
		var index = {};
		var emojisList = {};
		var emoticonsList = {};
	
		for (var emoji in _data2.default.emojis) {
		  var emojiData = _data2.default.emojis[emoji];
		  var short_names = emojiData.short_names;
		  var emoticons = emojiData.emoticons;
		  var id = short_names[0];
	
		  var _iteratorNormalCompletion = true;
		  var _didIteratorError = false;
		  var _iteratorError = undefined;
	
		  try {
		    for (var _iterator = (emoticons || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		      var emoticon = _step.value;
	
		      if (!emoticonsList[emoticon]) {
		        emoticonsList[emoticon] = id;
		      }
		    }
		  } catch (err) {
		    _didIteratorError = true;
		    _iteratorError = err;
		  } finally {
		    try {
		      if (!_iteratorNormalCompletion && _iterator.return) {
		        _iterator.return();
		      }
		    } finally {
		      if (_didIteratorError) {
		        throw _iteratorError;
		      }
		    }
		  }
	
		  emojisList[id] = (0, _.getSanitizedData)(id);
		}
	
		function search(value) {
		  var emojisToShowFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
		    return true;
		  };
		  var maxResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 75;
	
		  var results = null;
	
		  if (value.length) {
		    var values = value.toLowerCase().split(/[\s|,|\-|_]+/),
		        allResults = [];
	
		    if (values.length > 2) {
		      values = [values[0], values[1]];
		    }
	
		    allResults = values.map(function (value) {
		      var aPool = _data2.default.emojis,
		          aIndex = index,
		          length = 0;
	
		      if (value == '-' || value == '-1') {
		        return [emojisList['-1']];
		      }
	
		      var _iteratorNormalCompletion2 = true;
		      var _didIteratorError2 = false;
		      var _iteratorError2 = undefined;
	
		      try {
		        for (var _iterator2 = value.split('')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
		          var char = _step2.value;
	
		          length++;
	
		          aIndex[char] || (aIndex[char] = {});
		          aIndex = aIndex[char];
	
		          if (!aIndex.results) {
		            (function () {
		              var scores = {};
	
		              aIndex.results = [];
		              aIndex.pool = {};
	
		              for (var id in aPool) {
		                var _emoji = aPool[id];
		                var _search = _emoji.search;
		                var sub = value.substr(0, length);
		                var subIndex = _search.indexOf(sub);
	
		                if (subIndex != -1) {
		                  var score = subIndex + 1;
		                  if (sub == id) score = 0;
	
		                  aIndex.results.push(emojisList[id]);
		                  aIndex.pool[id] = _emoji;
	
		                  scores[id] = score;
		                }
		              }
	
		              aIndex.results.sort(function (a, b) {
		                var aScore = scores[a.id],
		                    bScore = scores[b.id];
	
		                return aScore - bScore;
		              });
		            })();
		          }
	
		          aPool = aIndex.pool;
		        }
		      } catch (err) {
		        _didIteratorError2 = true;
		        _iteratorError2 = err;
		      } finally {
		        try {
		          if (!_iteratorNormalCompletion2 && _iterator2.return) {
		            _iterator2.return();
		          }
		        } finally {
		          if (_didIteratorError2) {
		            throw _iteratorError2;
		          }
		        }
		      }
	
		      return aIndex.results;
		    }).filter(function (a) {
		      return a;
		    });
	
		    if (allResults.length > 1) {
		      results = _.intersect.apply(undefined, _toConsumableArray(allResults));
		    } else if (allResults.length) {
		      results = allResults[0];
		    } else {
		      results = [];
		    }
		  }
	
		  var filtered_results = null;
		  if (results) {
		    filtered_results = results.filter(function (result) {
		      return emojisToShowFilter(_data2.default.emojis[result.id].unified);
		    });
		    if (filtered_results && filtered_results.length) {
		      filtered_results = filtered_results.slice(0, maxResults);
		    }
		  }
	
		  return filtered_results;
		}
	
		exports.default = { search: search, emojis: emojisList, emoticons: emoticonsList };
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Skins = function (_React$Component) {
		  _inherits(Skins, _React$Component);
	
		  function Skins(props) {
		    _classCallCheck(this, Skins);
	
		    var _this = _possibleConstructorReturn(this, (Skins.__proto__ || Object.getPrototypeOf(Skins)).call(this, props));
	
		    _this.state = {
		      opened: false
		    };
		    return _this;
		  }
	
		  _createClass(Skins, [{
		    key: 'handleClick',
		    value: function handleClick(skin) {
		      var onChange = this.props.onChange;
	
	
		      if (!this.state.opened) {
		        this.setState({ opened: true });
		      } else {
		        onChange(skin);
		        this.setState({ opened: false });
		      }
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _this2 = this;
	
		      var skin = this.props.skin;
		      var opened = this.state.opened;
	
	
		      return _react2.default.createElement(
		        'div',
		        null,
		        _react2.default.createElement(
		          'div',
		          { className: 'emoji-mart-skin-swatches ' + (opened ? 'emoji-mart-skin-swatches-opened' : '') },
		          Array(6).fill().map(function (_, i) {
		            var skinTone = i + 1,
		                selected = skinTone == skin;
	
		            return _react2.default.createElement(
		              'span',
		              { key: 'skin-tone-' + skinTone, className: 'emoji-mart-skin-swatch ' + (selected ? 'emoji-mart-skin-swatch-selected' : '') },
		              _react2.default.createElement('span', {
		                onClick: function onClick() {
		                  return _this2.handleClick(skinTone);
		                },
		                className: 'emoji-mart-skin emoji-mart-skin-tone-' + skinTone })
		            );
		          })
		        )
		      );
		    }
		  }]);
	
		  return Skins;
		}(_react2.default.Component);
	
		exports.default = Skins;
	
	
		Skins.propTypes = {
		  onChange: _react2.default.PropTypes.func,
		  skin: _react2.default.PropTypes.number.isRequired
		};
	
		Skins.defaultProps = {
		  onChange: function onChange() {}
		};
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 136 */
12,
/* 137 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(137);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(147);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(7);
	
	var createArrayFromMixed = __webpack_require__(140);
	var getMarkupWrap = __webpack_require__(142);
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(7);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 143 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(144);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(146);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 149 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(48);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(21);
	
	var _DOMUtils = __webpack_require__(40);
	
	var _DOMStateStorage = __webpack_require__(77);
	
	var _PathUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state;
	  var key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(48);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(21);
	
	var _PathUtils = __webpack_require__(17);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(49);
	
	var _BrowserProtocol = __webpack_require__(48);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(151);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(40);
	
	var _createHistory = __webpack_require__(50);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation;
	  var getCurrentLocation = Protocol.getCurrentLocation;
	  var pushLocation = Protocol.pushLocation;
	  var replaceLocation = Protocol.replaceLocation;
	  var go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(49);
	
	var _DOMUtils = __webpack_require__(40);
	
	var _HashProtocol = __webpack_require__(150);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(50);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey;
	  var hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(21);
	
	var _PathUtils = __webpack_require__(17);
	
	var _createHistory = __webpack_require__(50);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(81);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(81);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var ReactPropTypesSecret = __webpack_require__(160);
	var checkPropTypes = __webpack_require__(158);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 160 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(262);
	var objectAssign = __webpack_require__(5);
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (ret[key] === undefined) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
		});
	
		return ret;
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true
		};
	
		opts = objectAssign(defaults, opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					if (val2 === null) {
						result.push(encode(key, opts));
					} else {
						result.push(encode(key, opts) + '=' + encode(val2, opts));
					}
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(176);


/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var focusNode = __webpack_require__(75);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(35);
	var ExecutionEnvironment = __webpack_require__(7);
	var FallbackCompositionState = __webpack_require__(171);
	var SyntheticCompositionEvent = __webpack_require__(208);
	var SyntheticInputEvent = __webpack_require__(211);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(83);
	var ExecutionEnvironment = __webpack_require__(7);
	var ReactInstrumentation = __webpack_require__(10);
	
	var camelizeStyleName = __webpack_require__(138);
	var dangerousStyleValue = __webpack_require__(217);
	var hyphenateStyleName = __webpack_require__(145);
	var memoizeStringOnly = __webpack_require__(148);
	var warning = __webpack_require__(3);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(34);
	var EventPropagators = __webpack_require__(35);
	var ExecutionEnvironment = __webpack_require__(7);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(11);
	var SyntheticEvent = __webpack_require__(15);
	
	var getEventTarget = __webpack_require__(64);
	var isEventSupported = __webpack_require__(65);
	var isTextInputElement = __webpack_require__(100);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(23);
	var ExecutionEnvironment = __webpack_require__(7);
	
	var createNodesFromMarkup = __webpack_require__(141);
	var emptyFunction = __webpack_require__(9);
	var invariant = __webpack_require__(1);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 169 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(6);
	var SyntheticMouseEvent = __webpack_require__(42);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var PooledClass = __webpack_require__(20);
	
	var getTextContentAccessor = __webpack_require__(98);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(25);
	
	var instantiateReactComponent = __webpack_require__(99);
	var KeyEscapeUtils = __webpack_require__(56);
	var shouldUpdateReactComponent = __webpack_require__(66);
	var traverseAllChildren = __webpack_require__(102);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(112);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(52);
	var ReactDOMIDOperations = __webpack_require__(181);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var React = __webpack_require__(30);
	var ReactComponentEnvironment = __webpack_require__(58);
	var ReactCurrentOwner = __webpack_require__(16);
	var ReactErrorUtils = __webpack_require__(59);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(10);
	var ReactNodeTypes = __webpack_require__(93);
	var ReactReconciler = __webpack_require__(25);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var shallowEqual = __webpack_require__(47);
	var shouldUpdateReactComponent = __webpack_require__(66);
	var warning = __webpack_require__(3);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDefaultInjection = __webpack_require__(189);
	var ReactMount = __webpack_require__(92);
	var ReactReconciler = __webpack_require__(25);
	var ReactUpdates = __webpack_require__(11);
	var ReactVersion = __webpack_require__(202);
	
	var findDOMNode = __webpack_require__(218);
	var getHostComponentFromComposite = __webpack_require__(97);
	var renderSubtreeIntoContainer = __webpack_require__(225);
	var warning = __webpack_require__(3);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var AutoFocusUtils = __webpack_require__(164);
	var CSSPropertyOperations = __webpack_require__(166);
	var DOMLazyTree = __webpack_require__(23);
	var DOMNamespaces = __webpack_require__(53);
	var DOMProperty = __webpack_require__(24);
	var DOMPropertyOperations = __webpack_require__(85);
	var EventPluginHub = __webpack_require__(34);
	var EventPluginRegistry = __webpack_require__(54);
	var ReactBrowserEventEmitter = __webpack_require__(41);
	var ReactDOMComponentFlags = __webpack_require__(86);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMInput = __webpack_require__(182);
	var ReactDOMOption = __webpack_require__(183);
	var ReactDOMSelect = __webpack_require__(87);
	var ReactDOMTextarea = __webpack_require__(186);
	var ReactInstrumentation = __webpack_require__(10);
	var ReactMultiChild = __webpack_require__(195);
	var ReactServerRenderingTransaction = __webpack_require__(200);
	
	var emptyFunction = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(44);
	var invariant = __webpack_require__(1);
	var isEventSupported = __webpack_require__(65);
	var shallowEqual = __webpack_require__(47);
	var validateDOMNesting = __webpack_require__(67);
	var warning = __webpack_require__(3);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(67);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(23);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(52);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var DOMPropertyOperations = __webpack_require__(85);
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(11);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var React = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMSelect = __webpack_require__(87);
	
	var warning = __webpack_require__(3);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(7);
	
	var getNodeForCharacterOffset = __webpack_require__(222);
	var getTextContentAccessor = __webpack_require__(98);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var DOMChildrenOperations = __webpack_require__(52);
	var DOMLazyTree = __webpack_require__(23);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var escapeTextContentForBrowser = __webpack_require__(44);
	var invariant = __webpack_require__(1);
	var validateDOMNesting = __webpack_require__(67);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(5);
	
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(11);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var ReactUpdates = __webpack_require__(11);
	var Transaction = __webpack_require__(43);
	
	var emptyFunction = __webpack_require__(9);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(163);
	var BeforeInputEventPlugin = __webpack_require__(165);
	var ChangeEventPlugin = __webpack_require__(167);
	var DefaultEventPluginOrder = __webpack_require__(169);
	var EnterLeaveEventPlugin = __webpack_require__(170);
	var HTMLDOMPropertyConfig = __webpack_require__(172);
	var ReactComponentBrowserEnvironment = __webpack_require__(174);
	var ReactDOMComponent = __webpack_require__(177);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMEmptyComponent = __webpack_require__(179);
	var ReactDOMTreeTraversal = __webpack_require__(187);
	var ReactDOMTextComponent = __webpack_require__(185);
	var ReactDefaultBatchingStrategy = __webpack_require__(188);
	var ReactEventListener = __webpack_require__(192);
	var ReactInjection = __webpack_require__(193);
	var ReactReconcileTransaction = __webpack_require__(198);
	var SVGDOMPropertyConfig = __webpack_require__(203);
	var SelectEventPlugin = __webpack_require__(204);
	var SimpleEventPlugin = __webpack_require__(205);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 190 */
113,
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(34);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var EventListener = __webpack_require__(74);
	var ExecutionEnvironment = __webpack_require__(7);
	var PooledClass = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(11);
	
	var getEventTarget = __webpack_require__(64);
	var getUnboundedScrollPosition = __webpack_require__(143);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	var EventPluginHub = __webpack_require__(34);
	var EventPluginUtils = __webpack_require__(55);
	var ReactComponentEnvironment = __webpack_require__(58);
	var ReactEmptyComponent = __webpack_require__(88);
	var ReactBrowserEventEmitter = __webpack_require__(41);
	var ReactHostComponent = __webpack_require__(90);
	var ReactUpdates = __webpack_require__(11);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(216);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactComponentEnvironment = __webpack_require__(58);
	var ReactInstanceMap = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(16);
	var ReactReconciler = __webpack_require__(25);
	var ReactChildReconciler = __webpack_require__(173);
	
	var emptyFunction = __webpack_require__(9);
	var flattenChildren = __webpack_require__(219);
	var invariant = __webpack_require__(1);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 197 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var CallbackQueue = __webpack_require__(84);
	var PooledClass = __webpack_require__(20);
	var ReactBrowserEventEmitter = __webpack_require__(41);
	var ReactInputSelection = __webpack_require__(91);
	var ReactInstrumentation = __webpack_require__(10);
	var Transaction = __webpack_require__(43);
	var ReactUpdateQueue = __webpack_require__(60);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(196);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var PooledClass = __webpack_require__(20);
	var Transaction = __webpack_require__(43);
	var ReactInstrumentation = __webpack_require__(10);
	var ReactServerUpdateQueue = __webpack_require__(201);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(60);
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ },
/* 203 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(35);
	var ExecutionEnvironment = __webpack_require__(7);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInputSelection = __webpack_require__(91);
	var SyntheticEvent = __webpack_require__(15);
	
	var getActiveElement = __webpack_require__(76);
	var isTextInputElement = __webpack_require__(100);
	var shallowEqual = __webpack_require__(47);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventListener = __webpack_require__(74);
	var EventPropagators = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(6);
	var SyntheticAnimationEvent = __webpack_require__(206);
	var SyntheticClipboardEvent = __webpack_require__(207);
	var SyntheticEvent = __webpack_require__(15);
	var SyntheticFocusEvent = __webpack_require__(210);
	var SyntheticKeyboardEvent = __webpack_require__(212);
	var SyntheticMouseEvent = __webpack_require__(42);
	var SyntheticDragEvent = __webpack_require__(209);
	var SyntheticTouchEvent = __webpack_require__(213);
	var SyntheticTransitionEvent = __webpack_require__(214);
	var SyntheticUIEvent = __webpack_require__(37);
	var SyntheticWheelEvent = __webpack_require__(215);
	
	var emptyFunction = __webpack_require__(9);
	var getEventCharCode = __webpack_require__(62);
	var invariant = __webpack_require__(1);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(15);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(15);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(15);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(42);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(37);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(15);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(37);
	
	var getEventCharCode = __webpack_require__(62);
	var getEventKey = __webpack_require__(220);
	var getEventModifierState = __webpack_require__(63);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(37);
	
	var getEventModifierState = __webpack_require__(63);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(15);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(42);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 216 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(83);
	var warning = __webpack_require__(3);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(16);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstanceMap = __webpack_require__(36);
	
	var getHostComponentFromComposite = __webpack_require__(97);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(56);
	var traverseAllChildren = __webpack_require__(102);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(112);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(62);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 221 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 222 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(7);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(44);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(92);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(103);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(105);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _InternalPropTypes = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _InternalPropTypes = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    string = _React$PropTypes.string,
	    func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager2 = __webpack_require__(109);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(38);
	
	var _RouterContext = __webpack_require__(71);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _RouterUtils = __webpack_require__(106);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes,
	    func = _React$PropTypes.func,
	    object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v2.x or ' + 'earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please upgrade to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(68);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	var enterHooks = new PendingHooks();
	var changeHooks = new PendingHooks();
	
	function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	  var isSync = hook.length < asyncArity;
	
	  var transitionHook = function transitionHook() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (isSync) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	
	  pendingHooks.add(transitionHook);
	
	  return transitionHook;
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location) {
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  enterHooks.clear();
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (enterHooks.has(hooks[index])) {
	        next();
	        enterHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  changeHooks.clear();
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    var wrappedNext = function wrappedNext() {
	      if (changeHooks.has(hooks[index])) {
	        next();
	        changeHooks.remove(hooks[index]);
	      }
	    };
	    hooks[index](state, nextState, replace, wrappedNext);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(71);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(152);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(108);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(26);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(68);
	
	var _PromiseUtils = __webpack_require__(104);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(26);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(153);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(108);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(26);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(39);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(107);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(109);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(18);
	
	var _RouterUtils = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(68);
	
	var _PromiseUtils = __webpack_require__(104);
	
	var _PatternUtils = __webpack_require__(26);
	
	var _routerWarning = __webpack_require__(27);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(155);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(69);
	
	var _PropTypes = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(157).enable();
	  window.Promise = __webpack_require__(156);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(263);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(5);


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbstractWidget = __webpack_require__(28);
	
	var _AbstractWidget2 = _interopRequireDefault(_AbstractWidget);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(29);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Follow = function (_React$Component) {
	  _inherits(Follow, _React$Component);
	
	  function Follow() {
	    _classCallCheck(this, Follow);
	
	    return _possibleConstructorReturn(this, (Follow.__proto__ || Object.getPrototypeOf(Follow)).apply(this, arguments));
	  }
	
	  _createClass(Follow, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var changed = function changed(name) {
	        return !(0, _lodash2.default)(_this2.props[name], nextProps[name]);
	      };
	      return changed('username') || changed('options');
	    }
	  }, {
	    key: 'ready',
	    value: function ready(tw, element, done) {
	      var _props = this.props,
	          username = _props.username,
	          options = _props.options,
	          onLoad = _props.onLoad;
	
	      // Options must be cloned since Twitter Widgets modifies it directly
	
	      tw.widgets.createFollowButton(username, element, (0, _lodash4.default)(options)).then(function () {
	        // Widget is loaded
	        done();
	        onLoad();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AbstractWidget2.default, { ready: this.ready.bind(this) });
	    }
	  }]);
	
	  return Follow;
	}(_react2.default.Component);
	
	Follow.propTypes = {
	  username: _react2.default.PropTypes.string.isRequired,
	  options: _react2.default.PropTypes.object,
	  onLoad: _react2.default.PropTypes.func
	};
	Follow.defaultProps = {
	  options: {},
	  onLoad: function onLoad() {}
	};
	exports.default = Follow;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbstractWidget = __webpack_require__(28);
	
	var _AbstractWidget2 = _interopRequireDefault(_AbstractWidget);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(29);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hashtag = function (_React$Component) {
	  _inherits(Hashtag, _React$Component);
	
	  function Hashtag() {
	    _classCallCheck(this, Hashtag);
	
	    return _possibleConstructorReturn(this, (Hashtag.__proto__ || Object.getPrototypeOf(Hashtag)).apply(this, arguments));
	  }
	
	  _createClass(Hashtag, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var changed = function changed(name) {
	        return !(0, _lodash2.default)(_this2.props[name], nextProps[name]);
	      };
	      return changed('hashtag') || changed('options');
	    }
	  }, {
	    key: 'ready',
	    value: function ready(tw, element, done) {
	      var _props = this.props,
	          hashtag = _props.hashtag,
	          options = _props.options,
	          onLoad = _props.onLoad;
	
	      // Options must be cloned since Twitter Widgets modifies it directly
	
	      tw.widgets.createHashtagButton(hashtag, element, (0, _lodash4.default)(options)).then(function () {
	        // Widget is loaded
	        done();
	        onLoad();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AbstractWidget2.default, { ready: this.ready.bind(this) });
	    }
	  }]);
	
	  return Hashtag;
	}(_react2.default.Component);
	
	Hashtag.propTypes = {
	  hashtag: _react2.default.PropTypes.string.isRequired,
	  options: _react2.default.PropTypes.object,
	  onLoad: _react2.default.PropTypes.func
	};
	Hashtag.defaultProps = {
	  options: {},
	  onLoad: function onLoad() {}
	};
	exports.default = Hashtag;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbstractWidget = __webpack_require__(28);
	
	var _AbstractWidget2 = _interopRequireDefault(_AbstractWidget);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(29);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mention = function (_React$Component) {
	  _inherits(Mention, _React$Component);
	
	  function Mention() {
	    _classCallCheck(this, Mention);
	
	    return _possibleConstructorReturn(this, (Mention.__proto__ || Object.getPrototypeOf(Mention)).apply(this, arguments));
	  }
	
	  _createClass(Mention, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var changed = function changed(name) {
	        return !(0, _lodash2.default)(_this2.props[name], nextProps[name]);
	      };
	      return changed('username') || changed('options');
	    }
	  }, {
	    key: 'ready',
	    value: function ready(tw, element, done) {
	      var _props = this.props,
	          username = _props.username,
	          options = _props.options,
	          onLoad = _props.onLoad;
	
	      // Options must be cloned since Twitter Widgets modifies it directly
	
	      tw.widgets.createMentionButton(username, element, (0, _lodash4.default)(options)).then(function () {
	        // Widget is loaded
	        done();
	        onLoad();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AbstractWidget2.default, { ready: this.ready.bind(this) });
	    }
	  }]);
	
	  return Mention;
	}(_react2.default.Component);
	
	Mention.propTypes = {
	  username: _react2.default.PropTypes.string.isRequired,
	  options: _react2.default.PropTypes.object,
	  onLoad: _react2.default.PropTypes.func
	};
	Mention.defaultProps = {
	  options: {},
	  onLoad: function onLoad() {}
	};
	exports.default = Mention;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbstractWidget = __webpack_require__(28);
	
	var _AbstractWidget2 = _interopRequireDefault(_AbstractWidget);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(29);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Share = function (_React$Component) {
	  _inherits(Share, _React$Component);
	
	  function Share() {
	    _classCallCheck(this, Share);
	
	    return _possibleConstructorReturn(this, (Share.__proto__ || Object.getPrototypeOf(Share)).apply(this, arguments));
	  }
	
	  _createClass(Share, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var changed = function changed(name) {
	        return !(0, _lodash2.default)(_this2.props[name], nextProps[name]);
	      };
	      return changed('url') || changed('options');
	    }
	  }, {
	    key: 'ready',
	    value: function ready(tw, element, done) {
	      var _props = this.props,
	          url = _props.url,
	          options = _props.options,
	          onLoad = _props.onLoad;
	
	      // Options must be cloned since Twitter Widgets modifies it directly
	
	      tw.widgets.createShareButton(url, element, (0, _lodash4.default)(options)).then(function () {
	        // Widget is loaded
	        done();
	        onLoad();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AbstractWidget2.default, { ready: this.ready.bind(this) });
	    }
	  }]);
	
	  return Share;
	}(_react2.default.Component);
	
	Share.propTypes = {
	  url: _react2.default.PropTypes.string.isRequired,
	  options: _react2.default.PropTypes.object,
	  onLoad: _react2.default.PropTypes.func
	};
	Share.defaultProps = {
	  options: {},
	  onLoad: function onLoad() {}
	};
	exports.default = Share;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbstractWidget = __webpack_require__(28);
	
	var _AbstractWidget2 = _interopRequireDefault(_AbstractWidget);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(29);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timeline = function (_React$Component) {
	  _inherits(Timeline, _React$Component);
	
	  function Timeline() {
	    _classCallCheck(this, Timeline);
	
	    return _possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).apply(this, arguments));
	  }
	
	  _createClass(Timeline, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var changed = function changed(name) {
	        return !(0, _lodash2.default)(_this2.props[name], nextProps[name]);
	      };
	      return changed('dataSource') || changed('options');
	    }
	  }, {
	    key: 'ready',
	    value: function ready(tw, element, done) {
	      var _props = this.props,
	          dataSource = _props.dataSource,
	          options = _props.options,
	          onLoad = _props.onLoad;
	
	      // Options must be cloned since Twitter Widgets modifies it directly
	
	      tw.widgets.createTimeline(dataSource, element, (0, _lodash4.default)(options)).then(function () {
	        // Widget is loaded
	        done();
	        onLoad();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AbstractWidget2.default, { ready: this.ready.bind(this) });
	    }
	  }]);
	
	  return Timeline;
	}(_react2.default.Component);
	
	Timeline.propTypes = {
	  dataSource: _react2.default.PropTypes.object.isRequired,
	  options: _react2.default.PropTypes.object,
	  onLoad: _react2.default.PropTypes.func
	};
	Timeline.defaultProps = {
	  options: {},
	  onLoad: function onLoad() {}
	};
	exports.default = Timeline;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbstractWidget = __webpack_require__(28);
	
	var _AbstractWidget2 = _interopRequireDefault(_AbstractWidget);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(29);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tweet = function (_React$Component) {
	  _inherits(Tweet, _React$Component);
	
	  function Tweet() {
	    _classCallCheck(this, Tweet);
	
	    return _possibleConstructorReturn(this, (Tweet.__proto__ || Object.getPrototypeOf(Tweet)).apply(this, arguments));
	  }
	
	  _createClass(Tweet, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var changed = function changed(name) {
	        return !(0, _lodash2.default)(_this2.props[name], nextProps[name]);
	      };
	      return changed('tweetId') || changed('options');
	    }
	  }, {
	    key: 'ready',
	    value: function ready(tw, element, done) {
	      var _props = this.props,
	          tweetId = _props.tweetId,
	          options = _props.options,
	          onLoad = _props.onLoad;
	
	      // Options must be cloned since Twitter Widgets modifies it directly
	
	      tw.widgets.createTweet(tweetId, element, (0, _lodash4.default)(options)).then(function () {
	        // Widget is loaded
	        done();
	        onLoad();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AbstractWidget2.default, { ready: this.ready.bind(this) });
	    }
	  }]);
	
	  return Tweet;
	}(_react2.default.Component);
	
	Tweet.propTypes = {
	  tweetId: _react2.default.PropTypes.string.isRequired,
	  options: _react2.default.PropTypes.object,
	  onLoad: _react2.default.PropTypes.func
	};
	Tweet.defaultProps = {
	  options: {},
	  onLoad: function onLoad() {}
	};
	exports.default = Tweet;

/***/ },
/* 249 */
56,
/* 250 */
[264, 32],
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(250);
	var ReactElement = __webpack_require__(31);
	
	var emptyFunction = __webpack_require__(9);
	var traverseAllChildren = __webpack_require__(261);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(5);
	
	var ReactComponent = __webpack_require__(72);
	var ReactElement = __webpack_require__(31);
	var ReactPropTypeLocationNames = __webpack_require__(254);
	var ReactNoopUpdateQueue = __webpack_require__(73);
	
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(31);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(31),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(82);
	
	module.exports = factory(isValidElement);

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var ReactComponent = __webpack_require__(72);
	var ReactNoopUpdateQueue = __webpack_require__(73);
	
	var emptyObject = __webpack_require__(33);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 257 */
202,
/* 258 */
221,
/* 259 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactElement = __webpack_require__(31);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(16);
	var REACT_ELEMENT_TYPE = __webpack_require__(113);
	
	var getIteratorFn = __webpack_require__(258);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(249);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 262 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 263 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.31a8c530.js